webpackJsonp([0],{

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(924)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-520a7422",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(818), __esModule: true };

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Multiselect__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiselectMixin__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pointerMixin__ = __webpack_require__(841);
/* unused harmony reexport Multiselect */
/* unused harmony reexport multiselectMixin */
/* unused harmony reexport pointerMixin */




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Multiselect___default.a);



/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-carousel-3d v0.1.23
 * (c) 2018 Vladimir Bujanovic
 * https://github.com/wlada/vue-carousel-3d#readme
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Carousel3d=e():t.Carousel3d=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={exports:{},id:i,loaded:!1};return t[i].call(r.exports,r,r.exports,e),r.loaded=!0,r.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.Slide=e.Carousel3d=void 0;var r=n(1),o=i(r),s=n(15),a=i(s),u=function(t){t.component("carousel3d",o.default),t.component("slide",a.default)};e.default={install:u},e.Carousel3d=o.default,e.Slide=a.default},function(t,e,n){n(2);var i=n(7)(n(8),n(62),"data-v-c06c963c",null);t.exports=i.exports},function(t,e,n){var i=n(3);"string"==typeof i&&(i=[[t.id,i,""]]),i.locals&&(t.exports=i.locals);n(5)("e749a8c4",i,!0)},function(t,e,n){e=t.exports=n(4)(),e.push([t.id,".carousel-3d-container[data-v-c06c963c]{min-height:1px;width:100%;position:relative;z-index:0;overflow:hidden;margin:20px auto;box-sizing:border-box}.carousel-3d-slider[data-v-c06c963c]{position:relative;margin:0 auto;transform-style:preserve-3d;-webkit-perspective:1000px;-moz-perspective:1000px;perspective:1000px}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var i={},r=0;r<this.length;r++){var o=this[r][0];"number"==typeof o&&(i[o]=!0)}for(r=0;r<e.length;r++){var s=e[r];"number"==typeof s[0]&&i[s[0]]||(n&&!s[2]?s[2]=n:n&&(s[2]="("+s[2]+") and ("+n+")"),t.push(s))}},t}},function(t,e,n){function i(t){for(var e=0;e<t.length;e++){var n=t[e],i=c[n.id];if(i){i.refs++;for(var r=0;r<i.parts.length;r++)i.parts[r](n.parts[r]);for(;r<n.parts.length;r++)i.parts.push(o(n.parts[r]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{for(var s=[],r=0;r<n.parts.length;r++)s.push(o(n.parts[r]));c[n.id]={id:n.id,refs:1,parts:s}}}}function r(){var t=document.createElement("style");return t.type="text/css",d.appendChild(t),t}function o(t){var e,n,i=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(i){if(p)return v;i.parentNode.removeChild(i)}if(x){var o=f++;i=h||(h=r()),e=s.bind(null,i,o,!1),n=s.bind(null,i,o,!0)}else i=r(),e=a.bind(null,i),n=function(){i.parentNode.removeChild(i)};return e(t),function(i){if(i){if(i.css===t.css&&i.media===t.media&&i.sourceMap===t.sourceMap)return;e(t=i)}else n()}}function s(t,e,n,i){var r=n?"":i.css;if(t.styleSheet)t.styleSheet.cssText=g(e,r);else{var o=document.createTextNode(r),s=t.childNodes;s[e]&&t.removeChild(s[e]),s.length?t.insertBefore(o,s[e]):t.appendChild(o)}}function a(t,e){var n=e.css,i=e.media,r=e.sourceMap;if(i&&t.setAttribute("media",i),r&&(n+="\n/*# sourceURL="+r.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var u="undefined"!=typeof document,l=n(6),c={},d=u&&(document.head||document.getElementsByTagName("head")[0]),h=null,f=0,p=!1,v=function(){},x="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,n){p=n;var r=l(t,e);return i(r),function(e){for(var n=[],o=0;o<r.length;o++){var s=r[o],a=c[s.id];a.refs--,n.push(a)}e?(r=l(t,e),i(r)):r=[];for(var o=0;o<n.length;o++){var a=n[o];if(0===a.refs){for(var u=0;u<a.parts.length;u++)a.parts[u]();delete c[a.id]}}}};var g=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var n=[],i={},r=0;r<e.length;r++){var o=e[r],s=o[0],a=o[1],u=o[2],l=o[3],c={id:t+":"+r,css:a,media:u,sourceMap:l};i[s]?i[s].parts.push(c):n.push(i[s]={id:s,parts:[c]})}return n}},function(t,e){t.exports=function(t,e,n,i){var r,o=t=t||{},s=typeof t.default;"object"!==s&&"function"!==s||(r=t,o=t.default);var a="function"==typeof o?o.options:o;if(e&&(a.render=e.render,a.staticRenderFns=e.staticRenderFns),n&&(a._scopeId=n),i){var u=a.computed||(a.computed={});Object.keys(i).forEach(function(t){var e=i[t];u[t]=function(){return e}})}return{esModule:r,exports:o,options:a}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var r=n(9),o=i(r),s=n(10),a=i(s),u=n(15),l=i(u),c=function(){};e.default={name:"carousel3d",components:{Controls:a.default,Slide:l.default},props:{count:{type:[Number,String],default:0},perspective:{type:[Number,String],default:35},display:{type:[Number,String],default:5},loop:{type:Boolean,default:!0},animationSpeed:{type:[Number,String],default:500},dir:{type:String,default:"rtl"},width:{type:[Number,String],default:360},height:{type:[Number,String],default:270},border:{type:[Number,String],default:1},space:{type:[Number,String],default:"auto"},startIndex:{type:[Number,String],default:0},clickable:{type:Boolean,default:!0},disable3d:{type:Boolean,default:!1},minSwipeDistance:{type:Number,default:10},inverseScaling:{type:[Number,String],default:300},controlsVisible:{type:Boolean,default:!1},controlsPrevHtml:{type:String,default:"&lsaquo;"},controlsNextHtml:{type:String,default:"&rsaquo;"},controlsWidth:{type:[String,Number],default:50},controlsHeight:{type:[String,Number],default:50},onLastSlide:{type:Function,default:c},onSlideChange:{type:Function,default:c},bias:{type:String,default:"left"},onMainSlideClick:{type:Function,default:c}},data:function(){return{viewport:0,currentIndex:0,total:0,dragOffset:0,dragStartX:0,mousedown:!1,zIndex:998}},mixins:[o.default],watch:{count:function(){this.computeData()}},computed:{isLastSlide:function(){return this.currentIndex===this.total-1},isFirstSlide:function(){return 0===this.currentIndex},isNextPossible:function(){return!(!this.loop&&this.isLastSlide)},isPrevPossible:function(){return!(!this.loop&&this.isFirstSlide)},slideWidth:function(){var t=this.viewport,e=parseInt(this.width)+2*parseInt(this.border,10);return t<e?t:e},slideHeight:function(){var t=parseInt(this.width,10)+2*parseInt(this.border,10),e=parseInt(parseInt(this.height)+2*this.border,10),n=this.calculateAspectRatio(t,e);return this.slideWidth/n},visible:function(){var t=this.display>this.total?this.total:this.display;return t},hasHiddenSlides:function(){return this.total>this.visible},leftIndices:function(){var t=(this.visible-1)/2;t="left"===this.bias.toLowerCase()?Math.ceil(t):Math.floor(t);for(var e=[],n=1;n<=t;n++)e.push("ltr"===this.dir?(this.currentIndex+n)%this.total:(this.currentIndex-n)%this.total);return e},rightIndices:function(){var t=(this.visible-1)/2;t="right"===this.bias.toLowerCase()?Math.ceil(t):Math.floor(t);for(var e=[],n=1;n<=t;n++)e.push("ltr"===this.dir?(this.currentIndex-n)%this.total:(this.currentIndex+n)%this.total);return e},leftOutIndex:function(){var t=(this.visible-1)/2;return t="left"===this.bias.toLowerCase()?Math.ceil(t):Math.floor(t),t++,"ltr"===this.dir?this.total-this.currentIndex-t<=0?-parseInt(this.total-this.currentIndex-t):this.currentIndex+t:this.currentIndex-t},rightOutIndex:function(){var t=(this.visible-1)/2;return t="right"===this.bias.toLowerCase()?Math.ceil(t):Math.floor(t),t++,"ltr"===this.dir?this.currentIndex-t:this.total-this.currentIndex-t<=0?-parseInt(this.total-this.currentIndex-t,10):this.currentIndex+t}},methods:{goNext:function(){this.isNextPossible&&(this.isLastSlide?this.goSlide(0):this.goSlide(this.currentIndex+1))},goPrev:function(){this.isPrevPossible&&(this.isFirstSlide?this.goSlide(this.total-1):this.goSlide(this.currentIndex-1))},goSlide:function(t){var e=this;this.currentIndex=t<0||t>this.total-1?0:t,this.isLastSlide&&(this.onLastSlide!==c&&console.warn("onLastSlide deprecated, please use @last-slide"),this.onLastSlide(this.currentIndex),this.$emit("last-slide",this.currentIndex)),this.$emit("before-slide-change",this.currentIndex),setTimeout(function(){return e.animationEnd()},this.animationSpeed)},goFar:function(t){var e=this,n=t===this.total-1&&this.isFirstSlide?-1:t-this.currentIndex;this.isLastSlide&&0===t&&(n=1);for(var i=n<0?-n:n,r=0,o=0;o<i;){o+=1;var s=1===i?0:r;setTimeout(function(){return n<0?e.goPrev(i):e.goNext(i)},s),r+=this.animationSpeed/i}},animationEnd:function(){this.onSlideChange!==c&&console.warn("onSlideChange deprecated, please use @after-slide-change"),this.onSlideChange(this.currentIndex),this.$emit("after-slide-change",this.currentIndex)},handleMouseup:function(){this.mousedown=!1,this.dragOffset=0},handleMousedown:function(t){t.touches||t.preventDefault(),this.mousedown=!0,this.dragStartX="ontouchstart"in window?t.touches[0].clientX:t.clientX},handleMousemove:function(t){if(this.mousedown){var e="ontouchstart"in window?t.touches[0].clientX:t.clientX,n=this.dragStartX-e;this.dragOffset=n,this.dragOffset>this.minSwipeDistance?(this.handleMouseup(),this.goNext()):this.dragOffset<-this.minSwipeDistance&&(this.handleMouseup(),this.goPrev())}},attachMutationObserver:function(){var t=this,e=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;if(e){var n={attributes:!0,childList:!0,characterData:!0};this.mutationObserver=new e(function(){t.$nextTick(function(){t.computeData()})}),this.$el&&this.mutationObserver.observe(this.$el,n)}},detachMutationObserver:function(){this.mutationObserver&&this.mutationObserver.disconnect()},getSlideCount:function(){return void 0!==this.$slots.default?this.$slots.default.filter(function(t){return void 0!==t.tag}).length:0},calculateAspectRatio:function(t,e){return Math.min(t/e)},computeData:function(t){this.total=this.getSlideCount(),(t||this.currentIndex>=this.total)&&(this.currentIndex=parseInt(this.startIndex)>this.total-1?this.total-1:parseInt(this.startIndex)),this.viewport=this.$el.clientWidth},setSize:function(){this.$el.style.cssText+="height:"+this.slideHeight+"px;",this.$el.childNodes[0].style.cssText+="width:"+this.slideWidth+"px; height:"+this.slideHeight+"px;"}},mounted:function(){this.computeData(!0),this.attachMutationObserver(),this.$isServer||(window.addEventListener("resize",this.setSize),"ontouchstart"in window?(this.$el.addEventListener("touchstart",this.handleMousedown),this.$el.addEventListener("touchend",this.handleMouseup),this.$el.addEventListener("touchmove",this.handleMousemove)):(this.$el.addEventListener("mousedown",this.handleMousedown),this.$el.addEventListener("mouseup",this.handleMouseup),this.$el.addEventListener("mousemove",this.handleMousemove)))},beforeDestroy:function(){this.$isServer||(this.detachMutationObserver(),"ontouchstart"in window?this.$el.removeEventListener("touchmove",this.handleMousemove):this.$el.removeEventListener("mousemove",this.handleMousemove),window.removeEventListener("resize",this.setSize))}}},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n={props:{autoplay:{type:Boolean,default:!1},autoplayTimeout:{type:Number,default:2e3},autoplayHoverPause:{type:Boolean,default:!0}},data:function(){return{autoplayInterval:null}},destroyed:function(){this.pauseAutoplay(),this.$isServer||(this.$el.removeEventListener("mouseenter",this.pauseAutoplay),this.$el.removeEventListener("mouseleave",this.startAutoplay))},methods:{pauseAutoplay:function(){this.autoplayInterval&&(this.autoplayInterval=clearInterval(this.autoplayInterval))},startAutoplay:function(){var t=this;this.autoplay&&(this.autoplayInterval=setInterval(function(){"ltr"===t.dir?t.goPrev():t.goNext()},this.autoplayTimeout))}},mounted:function(){!this.$isServer&&this.autoplayHoverPause&&(this.$el.addEventListener("mouseenter",this.pauseAutoplay),this.$el.addEventListener("mouseleave",this.startAutoplay)),this.startAutoplay()}};e.default=n},function(t,e,n){n(11);var i=n(7)(n(13),n(14),"data-v-43e93932",null);t.exports=i.exports},function(t,e,n){var i=n(12);"string"==typeof i&&(i=[[t.id,i,""]]),i.locals&&(t.exports=i.locals);n(5)("06c66230",i,!0)},function(t,e,n){e=t.exports=n(4)(),e.push([t.id,".carousel-3d-controls[data-v-43e93932]{position:absolute;top:50%;height:0;margin-top:-30px;left:0;width:100%;z-index:1000}.next[data-v-43e93932],.prev[data-v-43e93932]{width:60px;position:absolute;z-index:1010;font-size:60px;height:60px;line-height:60px;color:#333;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-decoration:none;top:0}.next[data-v-43e93932]:hover,.prev[data-v-43e93932]:hover{cursor:pointer;opacity:.7}.prev[data-v-43e93932]{left:10px;text-align:left}.next[data-v-43e93932]{right:10px;text-align:right}.disabled[data-v-43e93932],.disabled[data-v-43e93932]:hover{opacity:.2;cursor:default}",""])},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={name:"controls",props:{width:{type:[String,Number],default:50},height:{type:[String,Number],default:60},prevHtml:{type:String,default:"&lsaquo;"},nextHtml:{type:String,default:"&rsaquo;"}},data:function(){return{parent:this.$parent}}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"carousel-3d-controls"},[n("a",{staticClass:"prev",class:{disabled:!t.parent.isPrevPossible},style:"width: "+t.width+"px; height: "+t.height+"px; line-height: "+t.height+"px;",attrs:{href:"#"},on:{click:function(e){e.preventDefault(),t.parent.goPrev()}}},[n("span",{domProps:{innerHTML:t._s(t.prevHtml)}})]),t._v(" "),n("a",{staticClass:"next",class:{disabled:!t.parent.isNextPossible},style:"width: "+t.width+"px; height: "+t.height+"px; line-height: "+t.height+"px;",attrs:{href:"#"},on:{click:function(e){e.preventDefault(),t.parent.goNext()}}},[n("span",{domProps:{innerHTML:t._s(t.nextHtml)}})])])},staticRenderFns:[]}},function(t,e,n){n(16);var i=n(7)(n(18),n(61),null,null);t.exports=i.exports},function(t,e,n){var i=n(17);"string"==typeof i&&(i=[[t.id,i,""]]),i.locals&&(t.exports=i.locals);n(5)("1dbacf8a",i,!0)},function(t,e,n){e=t.exports=n(4)(),e.push([t.id,".carousel-3d-slide{position:absolute;opacity:0;visibility:hidden;overflow:hidden;top:0;border-radius:1px;border-color:#000;border-color:rgba(0,0,0,.4);border-style:solid;background-size:cover;background-color:#ccc;display:block;margin:0;box-sizing:border-box;text-align:left}.carousel-3d-slide img{width:100%}.carousel-3d-slide.current{opacity:1!important;visibility:visible!important;transform:none!important;z-index:999}",""])},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var r=n(19),o=i(r),s=n(39),a=i(s);e.default={name:"slide",props:{index:{type:Number}},data:function(){return{parent:this.$parent,styles:{},zIndex:999}},computed:{isCurrent:function(){return this.index===this.parent.currentIndex},leftIndex:function(){return this.getSideIndex(this.parent.leftIndices)},rightIndex:function(){return this.getSideIndex(this.parent.rightIndices)},slideStyle:function(){var t={};if(!this.isCurrent){var e=this.leftIndex,n=this.rightIndex;(e>=0||n>=0)&&(t=e>=0?this.calculatePosition(e,!0,this.zIndex):this.calculatePosition(n,!1,this.zIndex),t.opacity=1,t.visibility="visible"),this.parent.hasHiddenSlides&&(this.matchIndex(this.parent.leftOutIndex)?t=this.calculatePosition(this.parent.leftIndices.length-1,!1,this.zIndex):this.matchIndex(this.parent.rightOutIndex)&&(t=this.calculatePosition(this.parent.rightIndices.length-1,!0,this.zIndex)))}return(0,a.default)(t,{"border-width":this.parent.border+"px",width:this.parent.slideWidth+"px",height:this.parent.slideHeight+"px",transition:" transform "+this.parent.animationSpeed+"ms,                opacity "+this.parent.animationSpeed+"ms,                visibility "+this.parent.animationSpeed+"ms"})},computedClasses:function(){var t;return t={},(0,o.default)(t,"left-"+(this.leftIndex+1),this.leftIndex>=0),(0,o.default)(t,"right-"+(this.rightIndex+1),this.rightIndex>=0),(0,o.default)(t,"current",this.isCurrent),t}},methods:{getSideIndex:function(t){var e=this,n=-1;return t.forEach(function(t,i){e.matchIndex(t)&&(n=i)}),n},matchIndex:function(t){return t>=0?this.index===t:this.parent.total+t===this.index},calculatePosition:function(t,e,n){var i=this.parent.disable3d?0:parseInt(this.parent.inverseScaling)+100*(t+1),r=this.parent.disable3d?0:parseInt(this.parent.perspective),o="auto"===this.parent.space?parseInt((t+1)*(this.parent.width/1.5),10):parseInt((t+1)*this.parent.space,10),s=e?"translateX("+o+"px) translateZ(-"+i+"px) rotateY(-"+r+"deg)":"translateX(-"+o+"px) translateZ(-"+i+"px) rotateY("+r+"deg)",a="auto"===this.parent.space?0:parseInt((t+1)*this.parent.space);return{transform:s,top:a,zIndex:n-(Math.abs(t)+1)}},goTo:function(){this.isCurrent?this.parent.onMainSlideClick():this.parent.clickable===!0&&this.parent.goFar(this.index)}}}},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var r=n(20),o=i(r);e.default=function(t,e,n){return e in t?(0,o.default)(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e,n){t.exports={default:n(21),__esModule:!0}},function(t,e,n){n(22);var i=n(25).Object;t.exports=function(t,e,n){return i.defineProperty(t,e,n)}},function(t,e,n){var i=n(23);i(i.S+i.F*!n(33),"Object",{defineProperty:n(29).f})},function(t,e,n){var i=n(24),r=n(25),o=n(26),s=n(28),a=n(38),u="prototype",l=function(t,e,n){var c,d,h,f=t&l.F,p=t&l.G,v=t&l.S,x=t&l.P,g=t&l.B,m=t&l.W,y=p?r:r[e]||(r[e]={}),b=y[u],S=p?i:v?i[e]:(i[e]||{})[u];p&&(n=e);for(c in n)d=!f&&S&&void 0!==S[c],d&&a(y,c)||(h=d?S[c]:n[c],y[c]=p&&"function"!=typeof S[c]?n[c]:g&&d?o(h,i):m&&S[c]==h?function(t){var e=function(e,n,i){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,i)}return t.apply(this,arguments)};return e[u]=t[u],e}(h):x&&"function"==typeof h?o(Function.call,h):h,x&&((y.virtual||(y.virtual={}))[c]=h,t&l.R&&b&&!b[c]&&s(b,c,h)))};l.F=1,l.G=2,l.S=4,l.P=8,l.B=16,l.W=32,l.U=64,l.R=128,t.exports=l},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(27);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){var i=n(29),r=n(37);t.exports=n(33)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var i=n(30),r=n(32),o=n(36),s=Object.defineProperty;e.f=n(33)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var i=n(31);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){t.exports=!n(33)&&!n(34)(function(){return 7!=Object.defineProperty(n(35)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){t.exports=!n(34)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(31),r=n(24).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e,n){var i=n(31);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){t.exports={default:n(40),__esModule:!0}},function(t,e,n){n(41),t.exports=n(25).Object.assign},function(t,e,n){var i=n(23);i(i.S+i.F,"Object",{assign:n(42)})},function(t,e,n){"use strict";var i=n(43),r=n(58),o=n(59),s=n(60),a=n(46),u=Object.assign;t.exports=!u||n(34)(function(){var t={},e={},n=Symbol(),i="abcdefghijklmnopqrst";return t[n]=7,i.split("").forEach(function(t){e[t]=t}),7!=u({},t)[n]||Object.keys(u({},e)).join("")!=i})?function(t,e){for(var n=s(t),u=arguments.length,l=1,c=r.f,d=o.f;u>l;)for(var h,f=a(arguments[l++]),p=c?i(f).concat(c(f)):i(f),v=p.length,x=0;v>x;)d.call(f,h=p[x++])&&(n[h]=f[h]);return n}:u},function(t,e,n){var i=n(44),r=n(57);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(38),r=n(45),o=n(49)(!1),s=n(53)("IE_PROTO");t.exports=function(t,e){var n,a=r(t),u=0,l=[];for(n in a)n!=s&&i(a,n)&&l.push(n);for(;e.length>u;)i(a,n=e[u++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(48);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(47);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){var i=n(45),r=n(50),o=n(52);t.exports=function(t){return function(e,n,s){var a,u=i(e),l=r(u.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if(a=u[c++],a!=a)return!0}else for(;l>c;c++)if((t||c in u)&&u[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(51),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){var i=n(51),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(54)("keys"),r=n(56);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(25),r=n(24),o="__core-js_shared__",s=r[o]||(r[o]={});(t.exports=function(t,e){return s[t]||(s[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(55)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e){t.exports=!0},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var i=n(48);t.exports=function(t){return Object(i(t))}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"carousel-3d-slide",class:t.computedClasses,style:t.slideStyle,on:{click:function(e){t.goTo()}}},[t._t("default",null,{index:t.index,isCurrent:t.isCurrent,leftIndex:t.leftIndex,rightIndex:t.rightIndex})],2)},staticRenderFns:[]}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"carousel-3d-container",style:{height:this.slideHeight+"px"}},[n("div",{staticClass:"carousel-3d-slider",style:{width:this.slideWidth+"px",height:this.slideHeight+"px"}},[t._t("default")],2),t._v(" "),t.controlsVisible?n("controls",{attrs:{"next-html":t.controlsNextHtml,"prev-html":t.controlsPrevHtml,width:t.controlsWidth,height:t.controlsHeight}}):t._e()],1)},staticRenderFns:[]}}])});

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, process, global, module) {(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.async = global.async || {})));
}(this, (function (exports) { 'use strict';

function slice(arrayLike, start) {
    start = start|0;
    var newLen = Math.max(arrayLike.length - start, 0);
    var newArr = Array(newLen);
    for(var idx = 0; idx < newLen; idx++)  {
        newArr[idx] = arrayLike[start + idx];
    }
    return newArr;
}

/**
 * Creates a continuation function with some arguments already applied.
 *
 * Useful as a shorthand when combined with other control flow functions. Any
 * arguments passed to the returned function are added to the arguments
 * originally passed to apply.
 *
 * @name apply
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {Function} fn - The function you want to eventually apply all
 * arguments to. Invokes with (arguments...).
 * @param {...*} arguments... - Any number of arguments to automatically apply
 * when the continuation is called.
 * @returns {Function} the partially-applied function
 * @example
 *
 * // using apply
 * async.parallel([
 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
 *     async.apply(fs.writeFile, 'testfile2', 'test2')
 * ]);
 *
 *
 * // the same process without using apply
 * async.parallel([
 *     function(callback) {
 *         fs.writeFile('testfile1', 'test1', callback);
 *     },
 *     function(callback) {
 *         fs.writeFile('testfile2', 'test2', callback);
 *     }
 * ]);
 *
 * // It's possible to pass any number of additional arguments when calling the
 * // continuation:
 *
 * node> var fn = async.apply(sys.puts, 'one');
 * node> fn('two', 'three');
 * one
 * two
 * three
 */
var apply = function(fn/*, ...args*/) {
    var args = slice(arguments, 1);
    return function(/*callArgs*/) {
        var callArgs = slice(arguments);
        return fn.apply(null, args.concat(callArgs));
    };
};

var initialParams = function (fn) {
    return function (/*...args, callback*/) {
        var args = slice(arguments);
        var callback = args.pop();
        fn.call(this, args, callback);
    };
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

function fallback(fn) {
    setTimeout(fn, 0);
}

function wrap(defer) {
    return function (fn/*, ...args*/) {
        var args = slice(arguments, 1);
        defer(function () {
            fn.apply(null, args);
        });
    };
}

var _defer;

if (hasSetImmediate) {
    _defer = setImmediate;
} else if (hasNextTick) {
    _defer = process.nextTick;
} else {
    _defer = fallback;
}

var setImmediate$1 = wrap(_defer);

/**
 * Take a sync function and make it async, passing its return value to a
 * callback. This is useful for plugging sync functions into a waterfall,
 * series, or other async functions. Any arguments passed to the generated
 * function will be passed to the wrapped function (except for the final
 * callback argument). Errors thrown will be passed to the callback.
 *
 * If the function passed to `asyncify` returns a Promise, that promises's
 * resolved/rejected state will be used to call the callback, rather than simply
 * the synchronous return value.
 *
 * This also means you can asyncify ES2017 `async` functions.
 *
 * @name asyncify
 * @static
 * @memberOf module:Utils
 * @method
 * @alias wrapSync
 * @category Util
 * @param {Function} func - The synchronous function, or Promise-returning
 * function to convert to an {@link AsyncFunction}.
 * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
 * invoked with `(args..., callback)`.
 * @example
 *
 * // passing a regular synchronous function
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(JSON.parse),
 *     function (data, next) {
 *         // data is the result of parsing the text.
 *         // If there was a parsing error, it would have been caught.
 *     }
 * ], callback);
 *
 * // passing a function returning a promise
 * async.waterfall([
 *     async.apply(fs.readFile, filename, "utf8"),
 *     async.asyncify(function (contents) {
 *         return db.model.create(contents);
 *     }),
 *     function (model, next) {
 *         // `model` is the instantiated model object.
 *         // If there was an error, this function would be skipped.
 *     }
 * ], callback);
 *
 * // es2017 example, though `asyncify` is not needed if your JS environment
 * // supports async functions out of the box
 * var q = async.queue(async.asyncify(async function(file) {
 *     var intermediateStep = await processFile(file);
 *     return await somePromise(intermediateStep)
 * }));
 *
 * q.push(files);
 */
function asyncify(func) {
    return initialParams(function (args, callback) {
        var result;
        try {
            result = func.apply(this, args);
        } catch (e) {
            return callback(e);
        }
        // if result is Promise object
        if (isObject(result) && typeof result.then === 'function') {
            result.then(function(value) {
                invokeCallback(callback, null, value);
            }, function(err) {
                invokeCallback(callback, err.message ? err : new Error(err));
            });
        } else {
            callback(null, result);
        }
    });
}

function invokeCallback(callback, error, value) {
    try {
        callback(error, value);
    } catch (e) {
        setImmediate$1(rethrow, e);
    }
}

function rethrow(error) {
    throw error;
}

var supportsSymbol = typeof Symbol === 'function';

function isAsync(fn) {
    return supportsSymbol && fn[Symbol.toStringTag] === 'AsyncFunction';
}

function wrapAsync(asyncFn) {
    return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
}

function applyEach$1(eachfn) {
    return function(fns/*, ...args*/) {
        var args = slice(arguments, 1);
        var go = initialParams(function(args, callback) {
            var that = this;
            return eachfn(fns, function (fn, cb) {
                wrapAsync(fn).apply(that, args.concat(cb));
            }, callback);
        });
        if (args.length) {
            return go.apply(this, args);
        }
        else {
            return go;
        }
    };
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]';
var undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]';
var funcTag = '[object Function]';
var genTag = '[object GeneratorFunction]';
var proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

// A temporary value used to identify if the loop should be broken.
// See #1064, #1293
var breakLoop = {};

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

function once(fn) {
    return function () {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}

var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;

var getIterator = function (coll) {
    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
};

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]';
var arrayTag = '[object Array]';
var boolTag = '[object Boolean]';
var dateTag = '[object Date]';
var errorTag = '[object Error]';
var funcTag$1 = '[object Function]';
var mapTag = '[object Map]';
var numberTag = '[object Number]';
var objectTag = '[object Object]';
var regexpTag = '[object RegExp]';
var setTag = '[object Set]';
var stringTag = '[object String]';
var weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]';
var dataViewTag = '[object DataView]';
var float32Tag = '[object Float32Array]';
var float64Tag = '[object Float64Array]';
var int8Tag = '[object Int8Array]';
var int16Tag = '[object Int16Array]';
var int32Tag = '[object Int32Array]';
var uint8Tag = '[object Uint8Array]';
var uint8ClampedTag = '[object Uint8ClampedArray]';
var uint16Tag = '[object Uint16Array]';
var uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$1.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

function createArrayIterator(coll) {
    var i = -1;
    var len = coll.length;
    return function next() {
        return ++i < len ? {value: coll[i], key: i} : null;
    }
}

function createES2015Iterator(iterator) {
    var i = -1;
    return function next() {
        var item = iterator.next();
        if (item.done)
            return null;
        i++;
        return {value: item.value, key: i};
    }
}

function createObjectIterator(obj) {
    var okeys = keys(obj);
    var i = -1;
    var len = okeys.length;
    return function next() {
        var key = okeys[++i];
        return i < len ? {value: obj[key], key: key} : null;
    };
}

function iterator(coll) {
    if (isArrayLike(coll)) {
        return createArrayIterator(coll);
    }

    var iterator = getIterator(coll);
    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
}

function onlyOnce(fn) {
    return function() {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}

function _eachOfLimit(limit) {
    return function (obj, iteratee, callback) {
        callback = once(callback || noop);
        if (limit <= 0 || !obj) {
            return callback(null);
        }
        var nextElem = iterator(obj);
        var done = false;
        var running = 0;
        var looping = false;

        function iterateeCallback(err, value) {
            running -= 1;
            if (err) {
                done = true;
                callback(err);
            }
            else if (value === breakLoop || (done && running <= 0)) {
                done = true;
                return callback(null);
            }
            else if (!looping) {
                replenish();
            }
        }

        function replenish () {
            looping = true;
            while (running < limit && !done) {
                var elem = nextElem();
                if (elem === null) {
                    done = true;
                    if (running <= 0) {
                        callback(null);
                    }
                    return;
                }
                running += 1;
                iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
            }
            looping = false;
        }

        replenish();
    };
}

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name eachOfLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`. The `key` is the item's key, or index in the case of an
 * array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
function eachOfLimit(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, wrapAsync(iteratee), callback);
}

function doLimit(fn, limit) {
    return function (iterable, iteratee, callback) {
        return fn(iterable, limit, iteratee, callback);
    };
}

// eachOf implementation optimized for array-likes
function eachOfArrayLike(coll, iteratee, callback) {
    callback = once(callback || noop);
    var index = 0,
        completed = 0,
        length = coll.length;
    if (length === 0) {
        callback(null);
    }

    function iteratorCallback(err, value) {
        if (err) {
            callback(err);
        } else if ((++completed === length) || value === breakLoop) {
            callback(null);
        }
    }

    for (; index < length; index++) {
        iteratee(coll[index], index, onlyOnce(iteratorCallback));
    }
}

// a generic version of eachOf which can handle array, object, and iterator cases.
var eachOfGeneric = doLimit(eachOfLimit, Infinity);

/**
 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
 * to the iteratee.
 *
 * @name eachOf
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEachOf
 * @category Collection
 * @see [async.each]{@link module:Collections.each}
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each
 * item in `coll`.
 * The `key` is the item's key, or index in the case of an array.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @example
 *
 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
 * var configs = {};
 *
 * async.forEachOf(obj, function (value, key, callback) {
 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
 *         if (err) return callback(err);
 *         try {
 *             configs[key] = JSON.parse(data);
 *         } catch (e) {
 *             return callback(e);
 *         }
 *         callback();
 *     });
 * }, function (err) {
 *     if (err) console.error(err.message);
 *     // configs is now a map of JSON data
 *     doSomethingWith(configs);
 * });
 */
var eachOf = function(coll, iteratee, callback) {
    var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
    eachOfImplementation(coll, wrapAsync(iteratee), callback);
};

function doParallel(fn) {
    return function (obj, iteratee, callback) {
        return fn(eachOf, obj, wrapAsync(iteratee), callback);
    };
}

function _asyncMap(eachfn, arr, iteratee, callback) {
    callback = callback || noop;
    arr = arr || [];
    var results = [];
    var counter = 0;
    var _iteratee = wrapAsync(iteratee);

    eachfn(arr, function (value, _, callback) {
        var index = counter++;
        _iteratee(value, function (err, v) {
            results[index] = v;
            callback(err);
        });
    }, function (err) {
        callback(err, results);
    });
}

/**
 * Produces a new collection of values by mapping each value in `coll` through
 * the `iteratee` function. The `iteratee` is called with an item from `coll`
 * and a callback for when it has finished processing. Each of these callback
 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
 * `iteratee` passes an error to its callback, the main `callback` (for the
 * `map` function) is immediately called with the error.
 *
 * Note, that since this function applies the `iteratee` to each item in
 * parallel, there is no guarantee that the `iteratee` functions will complete
 * in order. However, the results array will be in the same order as the
 * original `coll`.
 *
 * If `map` is passed an Object, the results will be an Array.  The results
 * will roughly be in the order of the original Objects' keys (but this can
 * vary across JavaScript engines).
 *
 * @name map
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an Array of the
 * transformed items from the `coll`. Invoked with (err, results).
 * @example
 *
 * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
 *     // results is now an array of stats for each file
 * });
 */
var map = doParallel(_asyncMap);

/**
 * Applies the provided arguments to each function in the array, calling
 * `callback` after all functions have completed. If you only provide the first
 * argument, `fns`, then it will return a function which lets you pass in the
 * arguments as if it were a single function call. If more arguments are
 * provided, `callback` is required while `args` is still optional.
 *
 * @name applyEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s
 * to all call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {Function} - If only the first argument, `fns`, is provided, it will
 * return a function which lets you pass in the arguments as if it were a single
 * function call. The signature is `(..args, callback)`. If invoked with any
 * arguments, `callback` is required.
 * @example
 *
 * async.applyEach([enableSearch, updateSchema], 'bucket', callback);
 *
 * // partial application example:
 * async.each(
 *     buckets,
 *     async.applyEach([enableSearch, updateSchema]),
 *     callback
 * );
 */
var applyEach = applyEach$1(map);

function doParallelLimit(fn) {
    return function (obj, limit, iteratee, callback) {
        return fn(_eachOfLimit(limit), obj, wrapAsync(iteratee), callback);
    };
}

/**
 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
 *
 * @name mapLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 */
var mapLimit = doParallelLimit(_asyncMap);

/**
 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
 *
 * @name mapSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with the transformed item.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Results is an array of the
 * transformed items from the `coll`. Invoked with (err, results).
 */
var mapSeries = doLimit(mapLimit, 1);

/**
 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
 *
 * @name applyEachSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
 * @category Control Flow
 * @param {Array|Iterable|Object} fns - A collection of {@link AsyncFunction}s to all
 * call with the same arguments
 * @param {...*} [args] - any number of separate arguments to pass to the
 * function.
 * @param {Function} [callback] - the final argument should be the callback,
 * called when all functions have completed processing.
 * @returns {Function} - If only the first argument is provided, it will return
 * a function which lets you pass in the arguments as if it were a single
 * function call.
 */
var applyEachSeries = applyEach$1(mapSeries);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

/**
 * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
 * their requirements. Each function can optionally depend on other functions
 * being completed first, and each function is run as soon as its requirements
 * are satisfied.
 *
 * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
 * will stop. Further tasks will not execute (so any other functions depending
 * on it will not run), and the main `callback` is immediately called with the
 * error.
 *
 * {@link AsyncFunction}s also receive an object containing the results of functions which
 * have completed so far as the first argument, if they have dependencies. If a
 * task function has no dependencies, it will only be passed a callback.
 *
 * @name auto
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Object} tasks - An object. Each of its properties is either a
 * function or an array of requirements, with the {@link AsyncFunction} itself the last item
 * in the array. The object's key of a property serves as the name of the task
 * defined by that property, i.e. can be used when specifying requirements for
 * other tasks. The function receives one or two arguments:
 * * a `results` object, containing the results of the previously executed
 *   functions, only passed if the task has any dependencies,
 * * a `callback(err, result)` function, which must be called when finished,
 *   passing an `error` (which can be `null`) and the result of the function's
 *   execution.
 * @param {number} [concurrency=Infinity] - An optional `integer` for
 * determining the maximum number of tasks that can be run in parallel. By
 * default, as many as possible.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback. Results are always returned; however, if an
 * error occurs, no further `tasks` will be performed, and the results object
 * will only contain partial results. Invoked with (err, results).
 * @returns undefined
 * @example
 *
 * async.auto({
 *     // this function will just be passed a callback
 *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
 *     showData: ['readData', function(results, cb) {
 *         // results.readData is the file's contents
 *         // ...
 *     }]
 * }, callback);
 *
 * async.auto({
 *     get_data: function(callback) {
 *         console.log('in get_data');
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         console.log('in make_folder');
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: ['get_data', 'make_folder', function(results, callback) {
 *         console.log('in write_file', JSON.stringify(results));
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(results, callback) {
 *         console.log('in email_link', JSON.stringify(results));
 *         // once the file is written let's email a link to it...
 *         // results.write_file contains the filename returned by write_file.
 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
 *     }]
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('results = ', results);
 * });
 */
var auto = function (tasks, concurrency, callback) {
    if (typeof concurrency === 'function') {
        // concurrency is optional, shift the args.
        callback = concurrency;
        concurrency = null;
    }
    callback = once(callback || noop);
    var keys$$1 = keys(tasks);
    var numTasks = keys$$1.length;
    if (!numTasks) {
        return callback(null);
    }
    if (!concurrency) {
        concurrency = numTasks;
    }

    var results = {};
    var runningTasks = 0;
    var hasError = false;

    var listeners = Object.create(null);

    var readyTasks = [];

    // for cycle detection:
    var readyToCheck = []; // tasks that have been identified as reachable
    // without the possibility of returning to an ancestor task
    var uncheckedDependencies = {};

    baseForOwn(tasks, function (task, key) {
        if (!isArray(task)) {
            // no dependencies
            enqueueTask(key, [task]);
            readyToCheck.push(key);
            return;
        }

        var dependencies = task.slice(0, task.length - 1);
        var remainingDependencies = dependencies.length;
        if (remainingDependencies === 0) {
            enqueueTask(key, task);
            readyToCheck.push(key);
            return;
        }
        uncheckedDependencies[key] = remainingDependencies;

        arrayEach(dependencies, function (dependencyName) {
            if (!tasks[dependencyName]) {
                throw new Error('async.auto task `' + key +
                    '` has a non-existent dependency `' +
                    dependencyName + '` in ' +
                    dependencies.join(', '));
            }
            addListener(dependencyName, function () {
                remainingDependencies--;
                if (remainingDependencies === 0) {
                    enqueueTask(key, task);
                }
            });
        });
    });

    checkForDeadlocks();
    processQueue();

    function enqueueTask(key, task) {
        readyTasks.push(function () {
            runTask(key, task);
        });
    }

    function processQueue() {
        if (readyTasks.length === 0 && runningTasks === 0) {
            return callback(null, results);
        }
        while(readyTasks.length && runningTasks < concurrency) {
            var run = readyTasks.shift();
            run();
        }

    }

    function addListener(taskName, fn) {
        var taskListeners = listeners[taskName];
        if (!taskListeners) {
            taskListeners = listeners[taskName] = [];
        }

        taskListeners.push(fn);
    }

    function taskComplete(taskName) {
        var taskListeners = listeners[taskName] || [];
        arrayEach(taskListeners, function (fn) {
            fn();
        });
        processQueue();
    }


    function runTask(key, task) {
        if (hasError) return;

        var taskCallback = onlyOnce(function(err, result) {
            runningTasks--;
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            }
            if (err) {
                var safeResults = {};
                baseForOwn(results, function(val, rkey) {
                    safeResults[rkey] = val;
                });
                safeResults[key] = result;
                hasError = true;
                listeners = Object.create(null);

                callback(err, safeResults);
            } else {
                results[key] = result;
                taskComplete(key);
            }
        });

        runningTasks++;
        var taskFn = wrapAsync(task[task.length - 1]);
        if (task.length > 1) {
            taskFn(results, taskCallback);
        } else {
            taskFn(taskCallback);
        }
    }

    function checkForDeadlocks() {
        // Kahn's algorithm
        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
        var currentTask;
        var counter = 0;
        while (readyToCheck.length) {
            currentTask = readyToCheck.pop();
            counter++;
            arrayEach(getDependents(currentTask), function (dependent) {
                if (--uncheckedDependencies[dependent] === 0) {
                    readyToCheck.push(dependent);
                }
            });
        }

        if (counter !== numTasks) {
            throw new Error(
                'async.auto cannot execute tasks due to a recursive dependency'
            );
        }
    }

    function getDependents(taskName) {
        var result = [];
        baseForOwn(tasks, function (task, key) {
            if (isArray(task) && baseIndexOf(task, taskName, 0) >= 0) {
                result.push(key);
            }
        });
        return result;
    }
};

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
var symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff';
var rsComboMarksRange = '\\u0300-\\u036f';
var reComboHalfMarksRange = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange = '\\u20d0-\\u20ff';
var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
var rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff';
var rsComboMarksRange$1 = '\\u0300-\\u036f';
var reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f';
var rsComboSymbolsRange$1 = '\\u20d0-\\u20ff';
var rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange$1 + ']';
var rsCombo = '[' + rsComboRange$1 + ']';
var rsFitz = '\\ud83c[\\udffb-\\udfff]';
var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
var rsNonAstral = '[^' + rsAstralRange$1 + ']';
var rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
var rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
var rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?';
var rsOptVar = '[' + rsVarRange$1 + ']?';
var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
var rsSeq = rsOptVar + reOptMod + rsOptJoin;
var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

var FN_ARGS = /^(?:async\s+)?(function)?\s*[^\(]*\(\s*([^\)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /(=.+)?(\s*)$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;

function parseParams(func) {
    func = func.toString().replace(STRIP_COMMENTS, '');
    func = func.match(FN_ARGS)[2].replace(' ', '');
    func = func ? func.split(FN_ARG_SPLIT) : [];
    func = func.map(function (arg){
        return trim(arg.replace(FN_ARG, ''));
    });
    return func;
}

/**
 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
 * tasks are specified as parameters to the function, after the usual callback
 * parameter, with the parameter names matching the names of the tasks it
 * depends on. This can provide even more readable task graphs which can be
 * easier to maintain.
 *
 * If a final callback is specified, the task results are similarly injected,
 * specified as named parameters after the initial error parameter.
 *
 * The autoInject function is purely syntactic sugar and its semantics are
 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
 *
 * @name autoInject
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.auto]{@link module:ControlFlow.auto}
 * @category Control Flow
 * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
 * the form 'func([dependencies...], callback). The object's key of a property
 * serves as the name of the task defined by that property, i.e. can be used
 * when specifying requirements for other tasks.
 * * The `callback` parameter is a `callback(err, result)` which must be called
 *   when finished, passing an `error` (which can be `null`) and the result of
 *   the function's execution. The remaining parameters name other tasks on
 *   which the task is dependent, and the results from those tasks are the
 *   arguments of those parameters.
 * @param {Function} [callback] - An optional callback which is called when all
 * the tasks have been completed. It receives the `err` argument if any `tasks`
 * pass an error to their callback, and a `results` object with any completed
 * task results, similar to `auto`.
 * @example
 *
 * //  The example from `auto` can be rewritten as follows:
 * async.autoInject({
 *     get_data: function(callback) {
 *         // async code to get some data
 *         callback(null, 'data', 'converted to array');
 *     },
 *     make_folder: function(callback) {
 *         // async code to create a directory to store a file in
 *         // this is run at the same time as getting the data
 *         callback(null, 'folder');
 *     },
 *     write_file: function(get_data, make_folder, callback) {
 *         // once there is some data and the directory exists,
 *         // write the data to a file in the directory
 *         callback(null, 'filename');
 *     },
 *     email_link: function(write_file, callback) {
 *         // once the file is written let's email a link to it...
 *         // write_file contains the filename returned by write_file.
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 *
 * // If you are using a JS minifier that mangles parameter names, `autoInject`
 * // will not work with plain functions, since the parameter names will be
 * // collapsed to a single letter identifier.  To work around this, you can
 * // explicitly specify the names of the parameters your task function needs
 * // in an array, similar to Angular.js dependency injection.
 *
 * // This still has an advantage over plain `auto`, since the results a task
 * // depends on are still spread into arguments.
 * async.autoInject({
 *     //...
 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
 *         callback(null, 'filename');
 *     }],
 *     email_link: ['write_file', function(write_file, callback) {
 *         callback(null, {'file':write_file, 'email':'user@example.com'});
 *     }]
 *     //...
 * }, function(err, results) {
 *     console.log('err = ', err);
 *     console.log('email_link = ', results.email_link);
 * });
 */
function autoInject(tasks, callback) {
    var newTasks = {};

    baseForOwn(tasks, function (taskFn, key) {
        var params;
        var fnIsAsync = isAsync(taskFn);
        var hasNoDeps =
            (!fnIsAsync && taskFn.length === 1) ||
            (fnIsAsync && taskFn.length === 0);

        if (isArray(taskFn)) {
            params = taskFn.slice(0, -1);
            taskFn = taskFn[taskFn.length - 1];

            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
        } else if (hasNoDeps) {
            // no dependencies, use the function as-is
            newTasks[key] = taskFn;
        } else {
            params = parseParams(taskFn);
            if (taskFn.length === 0 && !fnIsAsync && params.length === 0) {
                throw new Error("autoInject task functions require explicit parameters.");
            }

            // remove callback param
            if (!fnIsAsync) params.pop();

            newTasks[key] = params.concat(newTask);
        }

        function newTask(results, taskCb) {
            var newArgs = arrayMap(params, function (name) {
                return results[name];
            });
            newArgs.push(taskCb);
            wrapAsync(taskFn).apply(null, newArgs);
        }
    });

    auto(newTasks, callback);
}

// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
// used for queues. This implementation assumes that the node provided by the user can be modified
// to adjust the next and last properties. We implement only the minimal functionality
// for queue support.
function DLL() {
    this.head = this.tail = null;
    this.length = 0;
}

function setInitial(dll, node) {
    dll.length = 1;
    dll.head = dll.tail = node;
}

DLL.prototype.removeLink = function(node) {
    if (node.prev) node.prev.next = node.next;
    else this.head = node.next;
    if (node.next) node.next.prev = node.prev;
    else this.tail = node.prev;

    node.prev = node.next = null;
    this.length -= 1;
    return node;
};

DLL.prototype.empty = function () {
    while(this.head) this.shift();
    return this;
};

DLL.prototype.insertAfter = function(node, newNode) {
    newNode.prev = node;
    newNode.next = node.next;
    if (node.next) node.next.prev = newNode;
    else this.tail = newNode;
    node.next = newNode;
    this.length += 1;
};

DLL.prototype.insertBefore = function(node, newNode) {
    newNode.prev = node.prev;
    newNode.next = node;
    if (node.prev) node.prev.next = newNode;
    else this.head = newNode;
    node.prev = newNode;
    this.length += 1;
};

DLL.prototype.unshift = function(node) {
    if (this.head) this.insertBefore(this.head, node);
    else setInitial(this, node);
};

DLL.prototype.push = function(node) {
    if (this.tail) this.insertAfter(this.tail, node);
    else setInitial(this, node);
};

DLL.prototype.shift = function() {
    return this.head && this.removeLink(this.head);
};

DLL.prototype.pop = function() {
    return this.tail && this.removeLink(this.tail);
};

DLL.prototype.toArray = function () {
    var arr = Array(this.length);
    var curr = this.head;
    for(var idx = 0; idx < this.length; idx++) {
        arr[idx] = curr.data;
        curr = curr.next;
    }
    return arr;
};

DLL.prototype.remove = function (testFn) {
    var curr = this.head;
    while(!!curr) {
        var next = curr.next;
        if (testFn(curr)) {
            this.removeLink(curr);
        }
        curr = next;
    }
    return this;
};

function queue(worker, concurrency, payload) {
    if (concurrency == null) {
        concurrency = 1;
    }
    else if(concurrency === 0) {
        throw new Error('Concurrency must not be zero');
    }

    var _worker = wrapAsync(worker);
    var numRunning = 0;
    var workersList = [];

    var processingScheduled = false;
    function _insert(data, insertAtFront, callback) {
        if (callback != null && typeof callback !== 'function') {
            throw new Error('task callback must be a function');
        }
        q.started = true;
        if (!isArray(data)) {
            data = [data];
        }
        if (data.length === 0 && q.idle()) {
            // call drain immediately if there are no tasks
            return setImmediate$1(function() {
                q.drain();
            });
        }

        for (var i = 0, l = data.length; i < l; i++) {
            var item = {
                data: data[i],
                callback: callback || noop
            };

            if (insertAtFront) {
                q._tasks.unshift(item);
            } else {
                q._tasks.push(item);
            }
        }

        if (!processingScheduled) {
            processingScheduled = true;
            setImmediate$1(function() {
                processingScheduled = false;
                q.process();
            });
        }
    }

    function _next(tasks) {
        return function(err){
            numRunning -= 1;

            for (var i = 0, l = tasks.length; i < l; i++) {
                var task = tasks[i];

                var index = baseIndexOf(workersList, task, 0);
                if (index === 0) {
                    workersList.shift();
                } else if (index > 0) {
                    workersList.splice(index, 1);
                }

                task.callback.apply(task, arguments);

                if (err != null) {
                    q.error(err, task.data);
                }
            }

            if (numRunning <= (q.concurrency - q.buffer) ) {
                q.unsaturated();
            }

            if (q.idle()) {
                q.drain();
            }
            q.process();
        };
    }

    var isProcessing = false;
    var q = {
        _tasks: new DLL(),
        concurrency: concurrency,
        payload: payload,
        saturated: noop,
        unsaturated:noop,
        buffer: concurrency / 4,
        empty: noop,
        drain: noop,
        error: noop,
        started: false,
        paused: false,
        push: function (data, callback) {
            _insert(data, false, callback);
        },
        kill: function () {
            q.drain = noop;
            q._tasks.empty();
        },
        unshift: function (data, callback) {
            _insert(data, true, callback);
        },
        remove: function (testFn) {
            q._tasks.remove(testFn);
        },
        process: function () {
            // Avoid trying to start too many processing operations. This can occur
            // when callbacks resolve synchronously (#1267).
            if (isProcessing) {
                return;
            }
            isProcessing = true;
            while(!q.paused && numRunning < q.concurrency && q._tasks.length){
                var tasks = [], data = [];
                var l = q._tasks.length;
                if (q.payload) l = Math.min(l, q.payload);
                for (var i = 0; i < l; i++) {
                    var node = q._tasks.shift();
                    tasks.push(node);
                    workersList.push(node);
                    data.push(node.data);
                }

                numRunning += 1;

                if (q._tasks.length === 0) {
                    q.empty();
                }

                if (numRunning === q.concurrency) {
                    q.saturated();
                }

                var cb = onlyOnce(_next(tasks));
                _worker(data, cb);
            }
            isProcessing = false;
        },
        length: function () {
            return q._tasks.length;
        },
        running: function () {
            return numRunning;
        },
        workersList: function () {
            return workersList;
        },
        idle: function() {
            return q._tasks.length + numRunning === 0;
        },
        pause: function () {
            q.paused = true;
        },
        resume: function () {
            if (q.paused === false) { return; }
            q.paused = false;
            setImmediate$1(q.process);
        }
    };
    return q;
}

/**
 * A cargo of tasks for the worker function to complete. Cargo inherits all of
 * the same methods and event callbacks as [`queue`]{@link module:ControlFlow.queue}.
 * @typedef {Object} CargoObject
 * @memberOf module:ControlFlow
 * @property {Function} length - A function returning the number of items
 * waiting to be processed. Invoke like `cargo.length()`.
 * @property {number} payload - An `integer` for determining how many tasks
 * should be process per round. This property can be changed after a `cargo` is
 * created to alter the payload on-the-fly.
 * @property {Function} push - Adds `task` to the `queue`. The callback is
 * called once the `worker` has finished processing the task. Instead of a
 * single task, an array of `tasks` can be submitted. The respective callback is
 * used for every task in the list. Invoke like `cargo.push(task, [callback])`.
 * @property {Function} saturated - A callback that is called when the
 * `queue.length()` hits the concurrency and further tasks will be queued.
 * @property {Function} empty - A callback that is called when the last item
 * from the `queue` is given to a `worker`.
 * @property {Function} drain - A callback that is called when the last item
 * from the `queue` has returned from the `worker`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke like `cargo.idle()`.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke like `cargo.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke like `cargo.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. Invoke like `cargo.kill()`.
 */

/**
 * Creates a `cargo` object with the specified payload. Tasks added to the
 * cargo will be processed altogether (up to the `payload` limit). If the
 * `worker` is in progress, the task is queued until it becomes available. Once
 * the `worker` has completed some tasks, each callback of those tasks is
 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
 * for how `cargo` and `queue` work.
 *
 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
 * at a time, cargo passes an array of tasks to a single worker, repeating
 * when the worker is finished.
 *
 * @name cargo
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An asynchronous function for processing an array
 * of queued tasks. Invoked with `(tasks, callback)`.
 * @param {number} [payload=Infinity] - An optional `integer` for determining
 * how many tasks should be processed per round; if omitted, the default is
 * unlimited.
 * @returns {module:ControlFlow.CargoObject} A cargo object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the cargo and inner queue.
 * @example
 *
 * // create a cargo object with payload 2
 * var cargo = async.cargo(function(tasks, callback) {
 *     for (var i=0; i<tasks.length; i++) {
 *         console.log('hello ' + tasks[i].name);
 *     }
 *     callback();
 * }, 2);
 *
 * // add some items
 * cargo.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * cargo.push({name: 'bar'}, function(err) {
 *     console.log('finished processing bar');
 * });
 * cargo.push({name: 'baz'}, function(err) {
 *     console.log('finished processing baz');
 * });
 */
function cargo(worker, payload) {
    return queue(worker, 1, payload);
}

/**
 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
 *
 * @name eachOfSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.eachOf]{@link module:Collections.eachOf}
 * @alias forEachOfSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * Invoked with (item, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Invoked with (err).
 */
var eachOfSeries = doLimit(eachOfLimit, 1);

/**
 * Reduces `coll` into a single value using an async `iteratee` to return each
 * successive step. `memo` is the initial state of the reduction. This function
 * only operates in series.
 *
 * For performance reasons, it may make sense to split a call to this function
 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
 * results. This function is for situations where each step in the reduction
 * needs to be async; if you can get the data before reducing it, then it's
 * probably a good idea to do so.
 *
 * @name reduce
 * @static
 * @memberOf module:Collections
 * @method
 * @alias inject
 * @alias foldl
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee complete with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 * @example
 *
 * async.reduce([1,2,3], 0, function(memo, item, callback) {
 *     // pointless async:
 *     process.nextTick(function() {
 *         callback(null, memo + item)
 *     });
 * }, function(err, result) {
 *     // result is now equal to the last value of memo, which is 6
 * });
 */
function reduce(coll, memo, iteratee, callback) {
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    eachOfSeries(coll, function(x, i, callback) {
        _iteratee(memo, x, function(err, v) {
            memo = v;
            callback(err);
        });
    }, function(err) {
        callback(err, memo);
    });
}

/**
 * Version of the compose function that is more natural to read. Each function
 * consumes the return value of the previous function. It is the equivalent of
 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name seq
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.compose]{@link module:ControlFlow.compose}
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} a function that composes the `functions` in order
 * @example
 *
 * // Requires lodash (or underscore), express3 and dresende's orm2.
 * // Part of an app, that fetches cats of the logged user.
 * // This example uses `seq` function to avoid overnesting and error
 * // handling clutter.
 * app.get('/cats', function(request, response) {
 *     var User = request.models.User;
 *     async.seq(
 *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
 *         function(user, fn) {
 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
 *         }
 *     )(req.session.user_id, function (err, cats) {
 *         if (err) {
 *             console.error(err);
 *             response.json({ status: 'error', message: err.message });
 *         } else {
 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
 *         }
 *     });
 * });
 */
function seq(/*...functions*/) {
    var _functions = arrayMap(arguments, wrapAsync);
    return function(/*...args*/) {
        var args = slice(arguments);
        var that = this;

        var cb = args[args.length - 1];
        if (typeof cb == 'function') {
            args.pop();
        } else {
            cb = noop;
        }

        reduce(_functions, args, function(newargs, fn, cb) {
            fn.apply(that, newargs.concat(function(err/*, ...nextargs*/) {
                var nextargs = slice(arguments, 1);
                cb(err, nextargs);
            }));
        },
        function(err, results) {
            cb.apply(that, [err].concat(results));
        });
    };
}

/**
 * Creates a function which is a composition of the passed asynchronous
 * functions. Each function consumes the return value of the function that
 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
 *
 * Each function is executed with the `this` binding of the composed function.
 *
 * @name compose
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {...AsyncFunction} functions - the asynchronous functions to compose
 * @returns {Function} an asynchronous function that is the composed
 * asynchronous `functions`
 * @example
 *
 * function add1(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n + 1);
 *     }, 10);
 * }
 *
 * function mul3(n, callback) {
 *     setTimeout(function () {
 *         callback(null, n * 3);
 *     }, 10);
 * }
 *
 * var add1mul3 = async.compose(mul3, add1);
 * add1mul3(4, function (err, result) {
 *     // result now equals 15
 * });
 */
var compose = function(/*...args*/) {
    return seq.apply(null, slice(arguments).reverse());
};

var _concat = Array.prototype.concat;

/**
 * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
 *
 * @name concatLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 */
var concatLimit = function(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function(val, callback) {
        _iteratee(val, function(err /*, ...args*/) {
            if (err) return callback(err);
            return callback(null, slice(arguments, 1));
        });
    }, function(err, mapResults) {
        var result = [];
        for (var i = 0; i < mapResults.length; i++) {
            if (mapResults[i]) {
                result = _concat.apply(result, mapResults[i]);
            }
        }

        return callback(err, result);
    });
};

/**
 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
 * the concatenated list. The `iteratee`s are called in parallel, and the
 * results are concatenated as they return. There is no guarantee that the
 * results array will be returned in the original order of `coll` passed to the
 * `iteratee` function.
 *
 * @name concat
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
 * which should use an array as its result. Invoked with (item, callback).
 * @param {Function} [callback(err)] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 * @example
 *
 * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
 *     // files is now a list of filenames that exist in the 3 directories
 * });
 */
var concat = doLimit(concatLimit, Infinity);

/**
 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
 *
 * @name concatSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.concat]{@link module:Collections.concat}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
 * The iteratee should complete with an array an array of results.
 * Invoked with (item, callback).
 * @param {Function} [callback(err)] - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is an array
 * containing the concatenated results of the `iteratee` function. Invoked with
 * (err, results).
 */
var concatSeries = doLimit(concatLimit, 1);

/**
 * Returns a function that when called, calls-back with the values provided.
 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
 * [`auto`]{@link module:ControlFlow.auto}.
 *
 * @name constant
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {...*} arguments... - Any number of arguments to automatically invoke
 * callback with.
 * @returns {AsyncFunction} Returns a function that when invoked, automatically
 * invokes the callback with the previous given arguments.
 * @example
 *
 * async.waterfall([
 *     async.constant(42),
 *     function (value, next) {
 *         // value === 42
 *     },
 *     //...
 * ], callback);
 *
 * async.waterfall([
 *     async.constant(filename, "utf8"),
 *     fs.readFile,
 *     function (fileData, next) {
 *         //...
 *     }
 *     //...
 * ], callback);
 *
 * async.auto({
 *     hostname: async.constant("https://server.net/"),
 *     port: findFreePort,
 *     launchServer: ["hostname", "port", function (options, cb) {
 *         startServer(options, cb);
 *     }],
 *     //...
 * }, callback);
 */
var constant = function(/*...values*/) {
    var values = slice(arguments);
    var args = [null].concat(values);
    return function (/*...ignoredArgs, callback*/) {
        var callback = arguments[arguments.length - 1];
        return callback.apply(this, args);
    };
};

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

function _createTester(check, getResult) {
    return function(eachfn, arr, iteratee, cb) {
        cb = cb || noop;
        var testPassed = false;
        var testResult;
        eachfn(arr, function(value, _, callback) {
            iteratee(value, function(err, result) {
                if (err) {
                    callback(err);
                } else if (check(result) && !testResult) {
                    testPassed = true;
                    testResult = getResult(true, value);
                    callback(null, breakLoop);
                } else {
                    callback();
                }
            });
        }, function(err) {
            if (err) {
                cb(err);
            } else {
                cb(null, testPassed ? testResult : getResult(false));
            }
        });
    };
}

function _findGetResult(v, x) {
    return x;
}

/**
 * Returns the first value in `coll` that passes an async truth test. The
 * `iteratee` is applied in parallel, meaning the first iteratee to return
 * `true` will fire the detect `callback` with that result. That means the
 * result might not be the first item in the original `coll` (in terms of order)
 * that passes the test.

 * If order within the original `coll` is important, then look at
 * [`detectSeries`]{@link module:Collections.detectSeries}.
 *
 * @name detect
 * @static
 * @memberOf module:Collections
 * @method
 * @alias find
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 * @example
 *
 * async.detect(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // result now equals the first file in the list that exists
 * });
 */
var detect = doParallel(_createTester(identity, _findGetResult));

/**
 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name detectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findLimit
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 */
var detectLimit = doParallelLimit(_createTester(identity, _findGetResult));

/**
 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
 *
 * @name detectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.detect]{@link module:Collections.detect}
 * @alias findSeries
 * @category Collections
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
 * The iteratee must complete with a boolean value as its result.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the `iteratee` functions have finished.
 * Result will be the first item in the array that passes the truth test
 * (iteratee) or the value `undefined` if none passed. Invoked with
 * (err, result).
 */
var detectSeries = doLimit(detectLimit, 1);

function consoleFunc(name) {
    return function (fn/*, ...args*/) {
        var args = slice(arguments, 1);
        args.push(function (err/*, ...args*/) {
            var args = slice(arguments, 1);
            if (typeof console === 'object') {
                if (err) {
                    if (console.error) {
                        console.error(err);
                    }
                } else if (console[name]) {
                    arrayEach(args, function (x) {
                        console[name](x);
                    });
                }
            }
        });
        wrapAsync(fn).apply(null, args);
    };
}

/**
 * Logs the result of an [`async` function]{@link AsyncFunction} to the
 * `console` using `console.dir` to display the properties of the resulting object.
 * Only works in Node.js or in browsers that support `console.dir` and
 * `console.error` (such as FF and Chrome).
 * If multiple arguments are returned from the async function,
 * `console.dir` is called on each argument in order.
 *
 * @name dir
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, {hello: name});
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.dir(hello, 'world');
 * {hello: 'world'}
 */
var dir = consoleFunc('dir');

/**
 * The post-check version of [`during`]{@link module:ControlFlow.during}. To reflect the difference in
 * the order of operations, the arguments `test` and `fn` are switched.
 *
 * Also a version of [`doWhilst`]{@link module:ControlFlow.doWhilst} with asynchronous `test` function.
 * @name doDuring
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.during]{@link module:ControlFlow.during}
 * @category Control Flow
 * @param {AsyncFunction} fn - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `fn`. Invoked with (...args, callback), where `...args` are the
 * non-error args from the previous callback of `fn`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `fn` has stopped. `callback`
 * will be passed an error if one occurred, otherwise `null`.
 */
function doDuring(fn, test, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);

    function next(err/*, ...args*/) {
        if (err) return callback(err);
        var args = slice(arguments, 1);
        args.push(check);
        _test.apply(this, args);
    }

    function check(err, truth) {
        if (err) return callback(err);
        if (!truth) return callback(null);
        _fn(next);
    }

    check(null, true);

}

/**
 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
 * the order of operations, the arguments `test` and `iteratee` are switched.
 *
 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
 *
 * @name doWhilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - A function which is called each time `test`
 * passes. Invoked with (callback).
 * @param {Function} test - synchronous truth test to perform after each
 * execution of `iteratee`. Invoked with any non-error callback results of
 * `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped.
 * `callback` will be passed an error and any arguments passed to the final
 * `iteratee`'s callback. Invoked with (err, [results]);
 */
function doWhilst(iteratee, test, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    var next = function(err/*, ...args*/) {
        if (err) return callback(err);
        var args = slice(arguments, 1);
        if (test.apply(this, args)) return _iteratee(next);
        callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
}

/**
 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
 * argument ordering differs from `until`.
 *
 * @name doUntil
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
 * @category Control Flow
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} test - synchronous truth test to perform after each
 * execution of `iteratee`. Invoked with any non-error callback results of
 * `iteratee`.
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 */
function doUntil(iteratee, test, callback) {
    doWhilst(iteratee, function() {
        return !test.apply(this, arguments);
    }, callback);
}

/**
 * Like [`whilst`]{@link module:ControlFlow.whilst}, except the `test` is an asynchronous function that
 * is passed a callback in the form of `function (err, truth)`. If error is
 * passed to `test` or `fn`, the main callback is immediately called with the
 * value of the error.
 *
 * @name during
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {AsyncFunction} test - asynchronous truth test to perform before each
 * execution of `fn`. Invoked with (callback).
 * @param {AsyncFunction} fn - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `fn` has stopped. `callback`
 * will be passed an error, if one occurred, otherwise `null`.
 * @example
 *
 * var count = 0;
 *
 * async.during(
 *     function (callback) {
 *         return callback(null, count < 5);
 *     },
 *     function (callback) {
 *         count++;
 *         setTimeout(callback, 1000);
 *     },
 *     function (err) {
 *         // 5 seconds have passed
 *     }
 * );
 */
function during(test, fn, callback) {
    callback = onlyOnce(callback || noop);
    var _fn = wrapAsync(fn);
    var _test = wrapAsync(test);

    function next(err) {
        if (err) return callback(err);
        _test(check);
    }

    function check(err, truth) {
        if (err) return callback(err);
        if (!truth) return callback(null);
        _fn(next);
    }

    _test(check);
}

function _withoutIndex(iteratee) {
    return function (value, index, callback) {
        return iteratee(value, callback);
    };
}

/**
 * Applies the function `iteratee` to each item in `coll`, in parallel.
 * The `iteratee` is called with an item from the list, and a callback for when
 * it has finished. If the `iteratee` passes an error to its `callback`, the
 * main `callback` (for the `each` function) is immediately called with the
 * error.
 *
 * Note, that since this function applies `iteratee` to each item in parallel,
 * there is no guarantee that the iteratee functions will complete in order.
 *
 * @name each
 * @static
 * @memberOf module:Collections
 * @method
 * @alias forEach
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to
 * each item in `coll`. Invoked with (item, callback).
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOf`.
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 * @example
 *
 * // assuming openFiles is an array of file names and saveFile is a function
 * // to save the modified contents of that file:
 *
 * async.each(openFiles, saveFile, function(err){
 *   // if any of the saves produced an error, err would equal that error
 * });
 *
 * // assuming openFiles is an array of file names
 * async.each(openFiles, function(file, callback) {
 *
 *     // Perform operation on file here.
 *     console.log('Processing file ' + file);
 *
 *     if( file.length > 32 ) {
 *       console.log('This file name is too long');
 *       callback('File name too long');
 *     } else {
 *       // Do work to process file here
 *       console.log('File processed');
 *       callback();
 *     }
 * }, function(err) {
 *     // if any of the file processing produced an error, err would equal that error
 *     if( err ) {
 *       // One of the iterations produced an error.
 *       // All processing will now stop.
 *       console.log('A file failed to process');
 *     } else {
 *       console.log('All files have been processed successfully');
 *     }
 * });
 */
function eachLimit(coll, iteratee, callback) {
    eachOf(coll, _withoutIndex(wrapAsync(iteratee)), callback);
}

/**
 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
 *
 * @name eachLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfLimit`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
function eachLimit$1(coll, limit, iteratee, callback) {
    _eachOfLimit(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
}

/**
 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
 *
 * @name eachSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.each]{@link module:Collections.each}
 * @alias forEachSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each
 * item in `coll`.
 * The array index is not passed to the iteratee.
 * If you need the index, use `eachOfSeries`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called when all
 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
 */
var eachSeries = doLimit(eachLimit$1, 1);

/**
 * Wrap an async function and ensure it calls its callback on a later tick of
 * the event loop.  If the function already calls its callback on a next tick,
 * no extra deferral is added. This is useful for preventing stack overflows
 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
 * contained. ES2017 `async` functions are returned as-is -- they are immune
 * to Zalgo's corrupting influences, as they always resolve on a later tick.
 *
 * @name ensureAsync
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - an async function, one that expects a node-style
 * callback as its last argument.
 * @returns {AsyncFunction} Returns a wrapped function with the exact same call
 * signature as the function passed in.
 * @example
 *
 * function sometimesAsync(arg, callback) {
 *     if (cache[arg]) {
 *         return callback(null, cache[arg]); // this would be synchronous!!
 *     } else {
 *         doSomeIO(arg, callback); // this IO would be asynchronous
 *     }
 * }
 *
 * // this has a risk of stack overflows if many results are cached in a row
 * async.mapSeries(args, sometimesAsync, done);
 *
 * // this will defer sometimesAsync's callback if necessary,
 * // preventing stack overflows
 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
 */
function ensureAsync(fn) {
    if (isAsync(fn)) return fn;
    return initialParams(function (args, callback) {
        var sync = true;
        args.push(function () {
            var innerArgs = arguments;
            if (sync) {
                setImmediate$1(function () {
                    callback.apply(null, innerArgs);
                });
            } else {
                callback.apply(null, innerArgs);
            }
        });
        fn.apply(this, args);
        sync = false;
    });
}

function notId(v) {
    return !v;
}

/**
 * Returns `true` if every element in `coll` satisfies an async test. If any
 * iteratee call returns `false`, the main `callback` is immediately called.
 *
 * @name every
 * @static
 * @memberOf module:Collections
 * @method
 * @alias all
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 * @example
 *
 * async.every(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // if result is true then every file exists
 * });
 */
var every = doParallel(_createTester(notId, notId));

/**
 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
 *
 * @name everyLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in parallel.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 */
var everyLimit = doParallelLimit(_createTester(notId, notId));

/**
 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
 *
 * @name everySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.every]{@link module:Collections.every}
 * @alias allSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collection in series.
 * The iteratee must complete with a boolean result value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result will be either `true` or `false`
 * depending on the values of the async tests. Invoked with (err, result).
 */
var everySeries = doLimit(everyLimit, 1);

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

function filterArray(eachfn, arr, iteratee, callback) {
    var truthValues = new Array(arr.length);
    eachfn(arr, function (x, index, callback) {
        iteratee(x, function (err, v) {
            truthValues[index] = !!v;
            callback(err);
        });
    }, function (err) {
        if (err) return callback(err);
        var results = [];
        for (var i = 0; i < arr.length; i++) {
            if (truthValues[i]) results.push(arr[i]);
        }
        callback(null, results);
    });
}

function filterGeneric(eachfn, coll, iteratee, callback) {
    var results = [];
    eachfn(coll, function (x, index, callback) {
        iteratee(x, function (err, v) {
            if (err) {
                callback(err);
            } else {
                if (v) {
                    results.push({index: index, value: x});
                }
                callback();
            }
        });
    }, function (err) {
        if (err) {
            callback(err);
        } else {
            callback(null, arrayMap(results.sort(function (a, b) {
                return a.index - b.index;
            }), baseProperty('value')));
        }
    });
}

function _filter(eachfn, coll, iteratee, callback) {
    var filter = isArrayLike(coll) ? filterArray : filterGeneric;
    filter(eachfn, coll, wrapAsync(iteratee), callback || noop);
}

/**
 * Returns a new array of all the values in `coll` which pass an async truth
 * test. This operation is performed in parallel, but the results array will be
 * in the same order as the original.
 *
 * @name filter
 * @static
 * @memberOf module:Collections
 * @method
 * @alias select
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @example
 *
 * async.filter(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, results) {
 *     // results now equals an array of the existing files
 * });
 */
var filter = doParallel(_filter);

/**
 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name filterLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var filterLimit = doParallelLimit(_filter);

/**
 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
 *
 * @name filterSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @alias selectSeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
 * with a boolean argument once it has completed. Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results)
 */
var filterSeries = doLimit(filterLimit, 1);

/**
 * Calls the asynchronous function `fn` with a callback parameter that allows it
 * to call itself again, in series, indefinitely.

 * If an error is passed to the callback then `errback` is called with the
 * error, and execution stops, otherwise it will never be called.
 *
 * @name forever
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} fn - an async function to call repeatedly.
 * Invoked with (next).
 * @param {Function} [errback] - when `fn` passes an error to it's callback,
 * this function will be called, and execution stops. Invoked with (err).
 * @example
 *
 * async.forever(
 *     function(next) {
 *         // next is suitable for passing to things that need a callback(err [, whatever]);
 *         // it will result in this function being called again.
 *     },
 *     function(err) {
 *         // if next is called with a value in its first parameter, it will appear
 *         // in here as 'err', and execution will stop.
 *     }
 * );
 */
function forever(fn, errback) {
    var done = onlyOnce(errback || noop);
    var task = wrapAsync(ensureAsync(fn));

    function next(err) {
        if (err) return done(err);
        task(next);
    }
    next();
}

/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
 *
 * @name groupByLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 */
var groupByLimit = function(coll, limit, iteratee, callback) {
    callback = callback || noop;
    var _iteratee = wrapAsync(iteratee);
    mapLimit(coll, limit, function(val, callback) {
        _iteratee(val, function(err, key) {
            if (err) return callback(err);
            return callback(null, {key: key, val: val});
        });
    }, function(err, mapResults) {
        var result = {};
        // from MDN, handle object having an `hasOwnProperty` prop
        var hasOwnProperty = Object.prototype.hasOwnProperty;

        for (var i = 0; i < mapResults.length; i++) {
            if (mapResults[i]) {
                var key = mapResults[i].key;
                var val = mapResults[i].val;

                if (hasOwnProperty.call(result, key)) {
                    result[key].push(val);
                } else {
                    result[key] = [val];
                }
            }
        }

        return callback(err, result);
    });
};

/**
 * Returns a new object, where each value corresponds to an array of items, from
 * `coll`, that returned the corresponding key. That is, the keys of the object
 * correspond to the values passed to the `iteratee` callback.
 *
 * Note: Since this function applies the `iteratee` to each item in parallel,
 * there is no guarantee that the `iteratee` functions will complete in order.
 * However, the values for each key in the `result` will be in the same order as
 * the original `coll`. For Objects, the values will roughly be in the order of
 * the original Objects' keys (but this can vary across JavaScript engines).
 *
 * @name groupBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 * @example
 *
 * async.groupBy(['userId1', 'userId2', 'userId3'], function(userId, callback) {
 *     db.findById(userId, function(err, user) {
 *         if (err) return callback(err);
 *         return callback(null, user.age);
 *     });
 * }, function(err, result) {
 *     // result is object containing the userIds grouped by age
 *     // e.g. { 30: ['userId1', 'userId3'], 42: ['userId2']};
 * });
 */
var groupBy = doLimit(groupByLimit, Infinity);

/**
 * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
 *
 * @name groupBySeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.groupBy]{@link module:Collections.groupBy}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a `key` to group the value under.
 * Invoked with (value, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. Result is an `Object` whoses
 * properties are arrays of values which returned the corresponding key.
 */
var groupBySeries = doLimit(groupByLimit, 1);

/**
 * Logs the result of an `async` function to the `console`. Only works in
 * Node.js or in browsers that support `console.log` and `console.error` (such
 * as FF and Chrome). If multiple arguments are returned from the async
 * function, `console.log` is called on each argument in order.
 *
 * @name log
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} function - The function you want to eventually apply
 * all arguments to.
 * @param {...*} arguments... - Any number of arguments to apply to the function.
 * @example
 *
 * // in a module
 * var hello = function(name, callback) {
 *     setTimeout(function() {
 *         callback(null, 'hello ' + name);
 *     }, 1000);
 * };
 *
 * // in the node repl
 * node> async.log(hello, 'world');
 * 'hello world'
 */
var log = consoleFunc('log');

/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name mapValuesLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 */
function mapValuesLimit(obj, limit, iteratee, callback) {
    callback = once(callback || noop);
    var newObj = {};
    var _iteratee = wrapAsync(iteratee);
    eachOfLimit(obj, limit, function(val, key, next) {
        _iteratee(val, key, function (err, result) {
            if (err) return next(err);
            newObj[key] = result;
            next();
        });
    }, function (err) {
        callback(err, newObj);
    });
}

/**
 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
 *
 * Produces a new Object by mapping each value of `obj` through the `iteratee`
 * function. The `iteratee` is called each `value` and `key` from `obj` and a
 * callback for when it has finished processing. Each of these callbacks takes
 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
 * passes an error to its callback, the main `callback` (for the `mapValues`
 * function) is immediately called with the error.
 *
 * Note, the order of the keys in the result is not guaranteed.  The keys will
 * be roughly in the order they complete, (but this is very engine-specific)
 *
 * @name mapValues
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 * @example
 *
 * async.mapValues({
 *     f1: 'file1',
 *     f2: 'file2',
 *     f3: 'file3'
 * }, function (file, key, callback) {
 *   fs.stat(file, callback);
 * }, function(err, result) {
 *     // result is now a map of stats for each file, e.g.
 *     // {
 *     //     f1: [stats for file1],
 *     //     f2: [stats for file2],
 *     //     f3: [stats for file3]
 *     // }
 * });
 */

var mapValues = doLimit(mapValuesLimit, Infinity);

/**
 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
 *
 * @name mapValuesSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.mapValues]{@link module:Collections.mapValues}
 * @category Collection
 * @param {Object} obj - A collection to iterate over.
 * @param {AsyncFunction} iteratee - A function to apply to each value and key
 * in `coll`.
 * The iteratee should complete with the transformed value as its result.
 * Invoked with (value, key, callback).
 * @param {Function} [callback] - A callback which is called when all `iteratee`
 * functions have finished, or an error occurs. `result` is a new object consisting
 * of each key from `obj`, with each transformed value on the right-hand side.
 * Invoked with (err, result).
 */
var mapValuesSeries = doLimit(mapValuesLimit, 1);

function has(obj, key) {
    return key in obj;
}

/**
 * Caches the results of an async function. When creating a hash to store
 * function results against, the callback is omitted from the hash and an
 * optional hash function can be used.
 *
 * If no hash function is specified, the first argument is used as a hash key,
 * which may work reasonably if it is a string or a data type that converts to a
 * distinct string. Note that objects and arrays will not behave reasonably.
 * Neither will cases where the other arguments are significant. In such cases,
 * specify your own hash function.
 *
 * The cache of results is exposed as the `memo` property of the function
 * returned by `memoize`.
 *
 * @name memoize
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function to proxy and cache results from.
 * @param {Function} hasher - An optional function for generating a custom hash
 * for storing results. It has all the arguments applied to it apart from the
 * callback, and must be synchronous.
 * @returns {AsyncFunction} a memoized version of `fn`
 * @example
 *
 * var slow_fn = function(name, callback) {
 *     // do something
 *     callback(null, result);
 * };
 * var fn = async.memoize(slow_fn);
 *
 * // fn can now be used as if it were slow_fn
 * fn('some name', function() {
 *     // callback
 * });
 */
function memoize(fn, hasher) {
    var memo = Object.create(null);
    var queues = Object.create(null);
    hasher = hasher || identity;
    var _fn = wrapAsync(fn);
    var memoized = initialParams(function memoized(args, callback) {
        var key = hasher.apply(null, args);
        if (has(memo, key)) {
            setImmediate$1(function() {
                callback.apply(null, memo[key]);
            });
        } else if (has(queues, key)) {
            queues[key].push(callback);
        } else {
            queues[key] = [callback];
            _fn.apply(null, args.concat(function(/*args*/) {
                var args = slice(arguments);
                memo[key] = args;
                var q = queues[key];
                delete queues[key];
                for (var i = 0, l = q.length; i < l; i++) {
                    q[i].apply(null, args);
                }
            }));
        }
    });
    memoized.memo = memo;
    memoized.unmemoized = fn;
    return memoized;
}

/**
 * Calls `callback` on a later loop around the event loop. In Node.js this just
 * calls `process.nextTick`.  In the browser it will use `setImmediate` if
 * available, otherwise `setTimeout(callback, 0)`, which means other higher
 * priority events may precede the execution of `callback`.
 *
 * This is used internally for browser-compatibility purposes.
 *
 * @name nextTick
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.setImmediate]{@link module:Utils.setImmediate}
 * @category Util
 * @param {Function} callback - The function to call on a later loop around
 * the event loop. Invoked with (args...).
 * @param {...*} args... - any number of additional arguments to pass to the
 * callback on the next tick.
 * @example
 *
 * var call_order = [];
 * async.nextTick(function() {
 *     call_order.push('two');
 *     // call_order now equals ['one','two']
 * });
 * call_order.push('one');
 *
 * async.setImmediate(function (a, b, c) {
 *     // a, b, and c equal 1, 2, and 3
 * }, 1, 2, 3);
 */
var _defer$1;

if (hasNextTick) {
    _defer$1 = process.nextTick;
} else if (hasSetImmediate) {
    _defer$1 = setImmediate;
} else {
    _defer$1 = fallback;
}

var nextTick = wrap(_defer$1);

function _parallel(eachfn, tasks, callback) {
    callback = callback || noop;
    var results = isArrayLike(tasks) ? [] : {};

    eachfn(tasks, function (task, key, callback) {
        wrapAsync(task)(function (err, result) {
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            }
            results[key] = result;
            callback(err);
        });
    }, function (err) {
        callback(err, results);
    });
}

/**
 * Run the `tasks` collection of functions in parallel, without waiting until
 * the previous function has completed. If any of the functions pass an error to
 * its callback, the main `callback` is immediately called with the value of the
 * error. Once the `tasks` have completed, the results are passed to the final
 * `callback` as an array.
 *
 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
 * parallel execution of code.  If your tasks do not use any timers or perform
 * any I/O, they will actually be executed in series.  Any synchronous setup
 * sections for each task will happen one after the other.  JavaScript remains
 * single-threaded.
 *
 * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
 * execution of other tasks when a task fails.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 * results from {@link async.parallel}.
 *
 * @name parallel
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 *
 * @example
 * async.parallel([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     // the results array will equal ['one','two'] even though
 *     // the second function had a shorter timeout.
 * });
 *
 * // an example using an object instead of an array
 * async.parallel({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     // results is now equals to: {one: 1, two: 2}
 * });
 */
function parallelLimit(tasks, callback) {
    _parallel(eachOf, tasks, callback);
}

/**
 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name parallelLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.parallel]{@link module:ControlFlow.parallel}
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection of
 * [async functions]{@link AsyncFunction} to run.
 * Each async function can complete with any number of optional `result` values.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed successfully. This function gets a results array
 * (or object) containing all the result arguments passed to the task callbacks.
 * Invoked with (err, results).
 */
function parallelLimit$1(tasks, limit, callback) {
    _parallel(_eachOfLimit(limit), tasks, callback);
}

/**
 * A queue of tasks for the worker function to complete.
 * @typedef {Object} QueueObject
 * @memberOf module:ControlFlow
 * @property {Function} length - a function returning the number of items
 * waiting to be processed. Invoke with `queue.length()`.
 * @property {boolean} started - a boolean indicating whether or not any
 * items have been pushed and processed by the queue.
 * @property {Function} running - a function returning the number of items
 * currently being processed. Invoke with `queue.running()`.
 * @property {Function} workersList - a function returning the array of items
 * currently being processed. Invoke with `queue.workersList()`.
 * @property {Function} idle - a function returning false if there are items
 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
 * @property {number} concurrency - an integer for determining how many `worker`
 * functions should be run in parallel. This property can be changed after a
 * `queue` is created to alter the concurrency on-the-fly.
 * @property {Function} push - add a new task to the `queue`. Calls `callback`
 * once the `worker` has finished processing the task. Instead of a single task,
 * a `tasks` array can be submitted. The respective callback is used for every
 * task in the list. Invoke with `queue.push(task, [callback])`,
 * @property {Function} unshift - add a new task to the front of the `queue`.
 * Invoke with `queue.unshift(task, [callback])`.
 * @property {Function} remove - remove items from the queue that match a test
 * function.  The test function will be passed an object with a `data` property,
 * and a `priority` property, if this is a
 * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
 * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
 * `function ({data, priority}) {}` and returns a Boolean.
 * @property {Function} saturated - a callback that is called when the number of
 * running workers hits the `concurrency` limit, and further tasks will be
 * queued.
 * @property {Function} unsaturated - a callback that is called when the number
 * of running workers is less than the `concurrency` & `buffer` limits, and
 * further tasks will not be queued.
 * @property {number} buffer - A minimum threshold buffer in order to say that
 * the `queue` is `unsaturated`.
 * @property {Function} empty - a callback that is called when the last item
 * from the `queue` is given to a `worker`.
 * @property {Function} drain - a callback that is called when the last item
 * from the `queue` has returned from the `worker`.
 * @property {Function} error - a callback that is called when a task errors.
 * Has the signature `function(error, task)`.
 * @property {boolean} paused - a boolean for determining whether the queue is
 * in a paused state.
 * @property {Function} pause - a function that pauses the processing of tasks
 * until `resume()` is called. Invoke with `queue.pause()`.
 * @property {Function} resume - a function that resumes the processing of
 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
 * @property {Function} kill - a function that removes the `drain` callback and
 * empties remaining tasks from the queue forcing it to go idle. No more tasks
 * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
 */

/**
 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
 * `queue` are processed in parallel (up to the `concurrency` limit). If all
 * `worker`s are in progress, the task is queued until one becomes available.
 * Once a `worker` completes a `task`, that `task`'s callback is called.
 *
 * @name queue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`. Invoked with (task, callback).
 * @param {number} [concurrency=1] - An `integer` for determining how many
 * `worker` functions should be run in parallel.  If omitted, the concurrency
 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can
 * attached as certain properties to listen for specific events during the
 * lifecycle of the queue.
 * @example
 *
 * // create a queue object with concurrency 2
 * var q = async.queue(function(task, callback) {
 *     console.log('hello ' + task.name);
 *     callback();
 * }, 2);
 *
 * // assign a callback
 * q.drain = function() {
 *     console.log('all items have been processed');
 * };
 *
 * // add some items to the queue
 * q.push({name: 'foo'}, function(err) {
 *     console.log('finished processing foo');
 * });
 * q.push({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 *
 * // add some items to the queue (batch-wise)
 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
 *     console.log('finished processing item');
 * });
 *
 * // add some items to the front of the queue
 * q.unshift({name: 'bar'}, function (err) {
 *     console.log('finished processing bar');
 * });
 */
var queue$1 = function (worker, concurrency) {
    var _worker = wrapAsync(worker);
    return queue(function (items, cb) {
        _worker(items[0], cb);
    }, concurrency, 1);
};

/**
 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
 * completed in ascending priority order.
 *
 * @name priorityQueue
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.queue]{@link module:ControlFlow.queue}
 * @category Control Flow
 * @param {AsyncFunction} worker - An async function for processing a queued task.
 * If you want to handle errors from an individual task, pass a callback to
 * `q.push()`.
 * Invoked with (task, callback).
 * @param {number} concurrency - An `integer` for determining how many `worker`
 * functions should be run in parallel.  If omitted, the concurrency defaults to
 * `1`.  If the concurrency is `0`, an error is thrown.
 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
 * differences between `queue` and `priorityQueue` objects:
 * * `push(task, priority, [callback])` - `priority` should be a number. If an
 *   array of `tasks` is given, all tasks will be assigned the same priority.
 * * The `unshift` method was removed.
 */
var priorityQueue = function(worker, concurrency) {
    // Start with a normal queue
    var q = queue$1(worker, concurrency);

    // Override push to accept second parameter representing priority
    q.push = function(data, priority, callback) {
        if (callback == null) callback = noop;
        if (typeof callback !== 'function') {
            throw new Error('task callback must be a function');
        }
        q.started = true;
        if (!isArray(data)) {
            data = [data];
        }
        if (data.length === 0) {
            // call drain immediately if there are no tasks
            return setImmediate$1(function() {
                q.drain();
            });
        }

        priority = priority || 0;
        var nextNode = q._tasks.head;
        while (nextNode && priority >= nextNode.priority) {
            nextNode = nextNode.next;
        }

        for (var i = 0, l = data.length; i < l; i++) {
            var item = {
                data: data[i],
                priority: priority,
                callback: callback
            };

            if (nextNode) {
                q._tasks.insertBefore(nextNode, item);
            } else {
                q._tasks.push(item);
            }
        }
        setImmediate$1(q.process);
    };

    // Remove unshift function
    delete q.unshift;

    return q;
};

/**
 * Runs the `tasks` array of functions in parallel, without waiting until the
 * previous function has completed. Once any of the `tasks` complete or pass an
 * error to its callback, the main `callback` is immediately called. It's
 * equivalent to `Promise.race()`.
 *
 * @name race
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
 * to run. Each function can complete with an optional `result` value.
 * @param {Function} callback - A callback to run once any of the functions have
 * completed. This function gets an error or result from the first function that
 * completed. Invoked with (err, result).
 * @returns undefined
 * @example
 *
 * async.race([
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ],
 * // main callback
 * function(err, result) {
 *     // the result will be equal to 'two' as it finishes earlier
 * });
 */
function race(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
    if (!tasks.length) return callback();
    for (var i = 0, l = tasks.length; i < l; i++) {
        wrapAsync(tasks[i])(callback);
    }
}

/**
 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
 *
 * @name reduceRight
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reduce]{@link module:Collections.reduce}
 * @alias foldr
 * @category Collection
 * @param {Array} array - A collection to iterate over.
 * @param {*} memo - The initial state of the reduction.
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * array to produce the next step in the reduction.
 * The `iteratee` should complete with the next state of the reduction.
 * If the iteratee complete with an error, the reduction is stopped and the
 * main `callback` is immediately called with the error.
 * Invoked with (memo, item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the reduced value. Invoked with
 * (err, result).
 */
function reduceRight (array, memo, iteratee, callback) {
    var reversed = slice(array).reverse();
    reduce(reversed, memo, iteratee, callback);
}

/**
 * Wraps the async function in another function that always completes with a
 * result object, even when it errors.
 *
 * The result object has either the property `error` or `value`.
 *
 * @name reflect
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} fn - The async function you want to wrap
 * @returns {Function} - A function that always passes null to it's callback as
 * the error. The second argument to the callback will be an `object` with
 * either an `error` or a `value` property.
 * @example
 *
 * async.parallel([
 *     async.reflect(function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff but error ...
 *         callback('bad stuff happened');
 *     }),
 *     async.reflect(function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     })
 * ],
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = 'bad stuff happened'
 *     // results[2].value = 'two'
 * });
 */
function reflect(fn) {
    var _fn = wrapAsync(fn);
    return initialParams(function reflectOn(args, reflectCallback) {
        args.push(function callback(error, cbArg) {
            if (error) {
                reflectCallback(null, { error: error });
            } else {
                var value;
                if (arguments.length <= 2) {
                    value = cbArg;
                } else {
                    value = slice(arguments, 1);
                }
                reflectCallback(null, { value: value });
            }
        });

        return _fn.apply(this, args);
    });
}

/**
 * A helper function that wraps an array or an object of functions with `reflect`.
 *
 * @name reflectAll
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.reflect]{@link module:Utils.reflect}
 * @category Util
 * @param {Array|Object|Iterable} tasks - The collection of
 * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
 * @returns {Array} Returns an array of async functions, each wrapped in
 * `async.reflect`
 * @example
 *
 * let tasks = [
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     function(callback) {
 *         // do some more stuff but error ...
 *         callback(new Error('bad stuff happened'));
 *     },
 *     function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'two');
 *         }, 100);
 *     }
 * ];
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results[0].value = 'one'
 *     // results[1].error = Error('bad stuff happened')
 *     // results[2].value = 'two'
 * });
 *
 * // an example using an object instead of an array
 * let tasks = {
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'one');
 *         }, 200);
 *     },
 *     two: function(callback) {
 *         callback('two');
 *     },
 *     three: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 'three');
 *         }, 100);
 *     }
 * };
 *
 * async.parallel(async.reflectAll(tasks),
 * // optional callback
 * function(err, results) {
 *     // values
 *     // results.one.value = 'one'
 *     // results.two.error = 'two'
 *     // results.three.value = 'three'
 * });
 */
function reflectAll(tasks) {
    var results;
    if (isArray(tasks)) {
        results = arrayMap(tasks, reflect);
    } else {
        results = {};
        baseForOwn(tasks, function(task, key) {
            results[key] = reflect.call(this, task);
        });
    }
    return results;
}

function reject$1(eachfn, arr, iteratee, callback) {
    _filter(eachfn, arr, function(value, cb) {
        iteratee(value, function(err, v) {
            cb(err, !v);
        });
    }, callback);
}

/**
 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
 *
 * @name reject
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.filter]{@link module:Collections.filter}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 * @example
 *
 * async.reject(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, results) {
 *     // results now equals an array of missing files
 *     createFiles(results);
 * });
 */
var reject = doParallel(reject$1);

/**
 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name rejectLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var rejectLimit = doParallelLimit(reject$1);

/**
 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
 *
 * @name rejectSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.reject]{@link module:Collections.reject}
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {Function} iteratee - An async truth test to apply to each item in
 * `coll`.
 * The should complete with a boolean value as its `result`.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Invoked with (err, results).
 */
var rejectSeries = doLimit(rejectLimit, 1);

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function() {
    return value;
  };
}

/**
 * Attempts to get a successful response from `task` no more than `times` times
 * before returning an error. If the task is successful, the `callback` will be
 * passed the result of the successful task. If all attempts fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name retry
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @see [async.retryable]{@link module:ControlFlow.retryable}
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
 * object with `times` and `interval` or a number.
 * * `times` - The number of attempts to make before giving up.  The default
 *   is `5`.
 * * `interval` - The time to wait between retries, in milliseconds.  The
 *   default is `0`. The interval may also be specified as a function of the
 *   retry count (see example).
 * * `errorFilter` - An optional synchronous function that is invoked on
 *   erroneous result. If it returns `true` the retry attempts will continue;
 *   if the function returns `false` the retry flow is aborted with the current
 *   attempt's error and result being returned to the final callback.
 *   Invoked with (err).
 * * If `opts` is a number, the number specifies the number of times to retry,
 *   with the default interval of `0`.
 * @param {AsyncFunction} task - An async function to retry.
 * Invoked with (callback).
 * @param {Function} [callback] - An optional callback which is called when the
 * task has succeeded, or after the final failed attempt. It receives the `err`
 * and `result` arguments of the last attempt at completing the `task`. Invoked
 * with (err, results).
 *
 * @example
 *
 * // The `retry` function can be used as a stand-alone control flow by passing
 * // a callback, as shown below:
 *
 * // try calling apiMethod 3 times
 * async.retry(3, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 3 times, waiting 200 ms between each retry
 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod 10 times with exponential backoff
 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
 * async.retry({
 *   times: 10,
 *   interval: function(retryCount) {
 *     return 50 * Math.pow(2, retryCount);
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod the default 5 times no delay between each retry
 * async.retry(apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // try calling apiMethod only when error condition satisfies, all other
 * // errors will abort the retry control flow and return to final callback
 * async.retry({
 *   errorFilter: function(err) {
 *     return err.message === 'Temporary error'; // only retry on a specific error
 *   }
 * }, apiMethod, function(err, result) {
 *     // do something with the result
 * });
 *
 * // to retry individual methods that are not as reliable within other
 * // control flow functions, use the `retryable` wrapper:
 * async.auto({
 *     users: api.getUsers.bind(api),
 *     payments: async.retryable(3, api.getPayments.bind(api))
 * }, function(err, results) {
 *     // do something with the results
 * });
 *
 */
function retry(opts, task, callback) {
    var DEFAULT_TIMES = 5;
    var DEFAULT_INTERVAL = 0;

    var options = {
        times: DEFAULT_TIMES,
        intervalFunc: constant$1(DEFAULT_INTERVAL)
    };

    function parseTimes(acc, t) {
        if (typeof t === 'object') {
            acc.times = +t.times || DEFAULT_TIMES;

            acc.intervalFunc = typeof t.interval === 'function' ?
                t.interval :
                constant$1(+t.interval || DEFAULT_INTERVAL);

            acc.errorFilter = t.errorFilter;
        } else if (typeof t === 'number' || typeof t === 'string') {
            acc.times = +t || DEFAULT_TIMES;
        } else {
            throw new Error("Invalid arguments for async.retry");
        }
    }

    if (arguments.length < 3 && typeof opts === 'function') {
        callback = task || noop;
        task = opts;
    } else {
        parseTimes(options, opts);
        callback = callback || noop;
    }

    if (typeof task !== 'function') {
        throw new Error("Invalid arguments for async.retry");
    }

    var _task = wrapAsync(task);

    var attempt = 1;
    function retryAttempt() {
        _task(function(err) {
            if (err && attempt++ < options.times &&
                (typeof options.errorFilter != 'function' ||
                    options.errorFilter(err))) {
                setTimeout(retryAttempt, options.intervalFunc(attempt));
            } else {
                callback.apply(null, arguments);
            }
        });
    }

    retryAttempt();
}

/**
 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
 * wraps a task and makes it retryable, rather than immediately calling it
 * with retries.
 *
 * @name retryable
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.retry]{@link module:ControlFlow.retry}
 * @category Control Flow
 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
 * options, exactly the same as from `retry`
 * @param {AsyncFunction} task - the asynchronous function to wrap.
 * This function will be passed any arguments passed to the returned wrapper.
 * Invoked with (...args, callback).
 * @returns {AsyncFunction} The wrapped function, which when invoked, will
 * retry on an error, based on the parameters specified in `opts`.
 * This function will accept the same parameters as `task`.
 * @example
 *
 * async.auto({
 *     dep1: async.retryable(3, getFromFlakyService),
 *     process: ["dep1", async.retryable(3, function (results, cb) {
 *         maybeProcessData(results.dep1, cb);
 *     })]
 * }, callback);
 */
var retryable = function (opts, task) {
    if (!task) {
        task = opts;
        opts = null;
    }
    var _task = wrapAsync(task);
    return initialParams(function (args, callback) {
        function taskFn(cb) {
            _task.apply(null, args.concat(cb));
        }

        if (opts) retry(opts, taskFn, callback);
        else retry(taskFn, callback);

    });
};

/**
 * Run the functions in the `tasks` collection in series, each one running once
 * the previous function has completed. If any functions in the series pass an
 * error to its callback, no more functions are run, and `callback` is
 * immediately called with the value of the error. Otherwise, `callback`
 * receives an array of results when `tasks` have completed.
 *
 * It is also possible to use an object instead of an array. Each property will
 * be run as a function, and the results will be passed to the final `callback`
 * as an object instead of an array. This can be a more readable way of handling
 *  results from {@link async.series}.
 *
 * **Note** that while many implementations preserve the order of object
 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
 * explicitly states that
 *
 * > The mechanics and order of enumerating the properties is not specified.
 *
 * So if you rely on the order in which your series of functions are executed,
 * and want this to work on all platforms, consider using an array.
 *
 * @name series
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection containing
 * [async functions]{@link AsyncFunction} to run in series.
 * Each function can complete with any number of optional `result` values.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This function gets a results array (or object)
 * containing all the result arguments passed to the `task` callbacks. Invoked
 * with (err, result).
 * @example
 * async.series([
 *     function(callback) {
 *         // do some stuff ...
 *         callback(null, 'one');
 *     },
 *     function(callback) {
 *         // do some more stuff ...
 *         callback(null, 'two');
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     // results is now equal to ['one', 'two']
 * });
 *
 * async.series({
 *     one: function(callback) {
 *         setTimeout(function() {
 *             callback(null, 1);
 *         }, 200);
 *     },
 *     two: function(callback){
 *         setTimeout(function() {
 *             callback(null, 2);
 *         }, 100);
 *     }
 * }, function(err, results) {
 *     // results is now equal to: {one: 1, two: 2}
 * });
 */
function series(tasks, callback) {
    _parallel(eachOfSeries, tasks, callback);
}

/**
 * Returns `true` if at least one element in the `coll` satisfies an async test.
 * If any iteratee call returns `true`, the main `callback` is immediately
 * called.
 *
 * @name some
 * @static
 * @memberOf module:Collections
 * @method
 * @alias any
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 * @example
 *
 * async.some(['file1','file2','file3'], function(filePath, callback) {
 *     fs.access(filePath, function(err) {
 *         callback(null, !err)
 *     });
 * }, function(err, result) {
 *     // if result is true then at least one of the files exists
 * });
 */
var some = doParallel(_createTester(Boolean, identity));

/**
 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
 *
 * @name someLimit
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anyLimit
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in parallel.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 */
var someLimit = doParallelLimit(_createTester(Boolean, identity));

/**
 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
 *
 * @name someSeries
 * @static
 * @memberOf module:Collections
 * @method
 * @see [async.some]{@link module:Collections.some}
 * @alias anySeries
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async truth test to apply to each item
 * in the collections in series.
 * The iteratee should complete with a boolean `result` value.
 * Invoked with (item, callback).
 * @param {Function} [callback] - A callback which is called as soon as any
 * iteratee returns `true`, or after all the iteratee functions have finished.
 * Result will be either `true` or `false` depending on the values of the async
 * tests. Invoked with (err, result).
 */
var someSeries = doLimit(someLimit, 1);

/**
 * Sorts a list by the results of running each `coll` value through an async
 * `iteratee`.
 *
 * @name sortBy
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {AsyncFunction} iteratee - An async function to apply to each item in
 * `coll`.
 * The iteratee should complete with a value to use as the sort criteria as
 * its `result`.
 * Invoked with (item, callback).
 * @param {Function} callback - A callback which is called after all the
 * `iteratee` functions have finished, or an error occurs. Results is the items
 * from the original `coll` sorted by the values returned by the `iteratee`
 * calls. Invoked with (err, results).
 * @example
 *
 * async.sortBy(['file1','file2','file3'], function(file, callback) {
 *     fs.stat(file, function(err, stats) {
 *         callback(err, stats.mtime);
 *     });
 * }, function(err, results) {
 *     // results is now the original array of files sorted by
 *     // modified date
 * });
 *
 * // By modifying the callback parameter the
 * // sorting order can be influenced:
 *
 * // ascending order
 * async.sortBy([1,9,3,5], function(x, callback) {
 *     callback(null, x);
 * }, function(err,result) {
 *     // result callback
 * });
 *
 * // descending order
 * async.sortBy([1,9,3,5], function(x, callback) {
 *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
 * }, function(err,result) {
 *     // result callback
 * });
 */
function sortBy (coll, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    map(coll, function (x, callback) {
        _iteratee(x, function (err, criteria) {
            if (err) return callback(err);
            callback(null, {value: x, criteria: criteria});
        });
    }, function (err, results) {
        if (err) return callback(err);
        callback(null, arrayMap(results.sort(comparator), baseProperty('value')));
    });

    function comparator(left, right) {
        var a = left.criteria, b = right.criteria;
        return a < b ? -1 : a > b ? 1 : 0;
    }
}

/**
 * Sets a time limit on an asynchronous function. If the function does not call
 * its callback within the specified milliseconds, it will be called with a
 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
 *
 * @name timeout
 * @static
 * @memberOf module:Utils
 * @method
 * @category Util
 * @param {AsyncFunction} asyncFn - The async function to limit in time.
 * @param {number} milliseconds - The specified time limit.
 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
 * to timeout Error for more information..
 * @returns {AsyncFunction} Returns a wrapped function that can be used with any
 * of the control flow functions.
 * Invoke this function with the same parameters as you would `asyncFunc`.
 * @example
 *
 * function myFunction(foo, callback) {
 *     doAsyncTask(foo, function(err, data) {
 *         // handle errors
 *         if (err) return callback(err);
 *
 *         // do some stuff ...
 *
 *         // return processed data
 *         return callback(null, data);
 *     });
 * }
 *
 * var wrapped = async.timeout(myFunction, 1000);
 *
 * // call `wrapped` as you would `myFunction`
 * wrapped({ bar: 'bar' }, function(err, data) {
 *     // if `myFunction` takes < 1000 ms to execute, `err`
 *     // and `data` will have their expected values
 *
 *     // else `err` will be an Error with the code 'ETIMEDOUT'
 * });
 */
function timeout(asyncFn, milliseconds, info) {
    var fn = wrapAsync(asyncFn);

    return initialParams(function (args, callback) {
        var timedOut = false;
        var timer;

        function timeoutCallback() {
            var name = asyncFn.name || 'anonymous';
            var error  = new Error('Callback function "' + name + '" timed out.');
            error.code = 'ETIMEDOUT';
            if (info) {
                error.info = info;
            }
            timedOut = true;
            callback(error);
        }

        args.push(function () {
            if (!timedOut) {
                callback.apply(null, arguments);
                clearTimeout(timer);
            }
        });

        // setup timer and call original function
        timer = setTimeout(timeoutCallback, milliseconds);
        fn.apply(null, args);
    });
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;
var nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/**
 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
 * time.
 *
 * @name timesLimit
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} count - The number of times to run the function.
 * @param {number} limit - The maximum number of async operations at a time.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
 */
function timeLimit(count, limit, iteratee, callback) {
    var _iteratee = wrapAsync(iteratee);
    mapLimit(baseRange(0, count, 1), limit, _iteratee, callback);
}

/**
 * Calls the `iteratee` function `n` times, and accumulates results in the same
 * manner you would use with [map]{@link module:Collections.map}.
 *
 * @name times
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.map]{@link module:Collections.map}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 * @example
 *
 * // Pretend this is some complicated async factory
 * var createUser = function(id, callback) {
 *     callback(null, {
 *         id: 'user' + id
 *     });
 * };
 *
 * // generate 5 users
 * async.times(5, function(n, next) {
 *     createUser(n, function(err, user) {
 *         next(err, user);
 *     });
 * }, function(err, users) {
 *     // we should now have 5 users
 * });
 */
var times = doLimit(timeLimit, Infinity);

/**
 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
 *
 * @name timesSeries
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.times]{@link module:ControlFlow.times}
 * @category Control Flow
 * @param {number} n - The number of times to run the function.
 * @param {AsyncFunction} iteratee - The async function to call `n` times.
 * Invoked with the iteration index and a callback: (n, next).
 * @param {Function} callback - see {@link module:Collections.map}.
 */
var timesSeries = doLimit(timeLimit, 1);

/**
 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
 * element in series, each step potentially mutating an `accumulator` value.
 * The type of the accumulator defaults to the type of collection passed in.
 *
 * @name transform
 * @static
 * @memberOf module:Collections
 * @method
 * @category Collection
 * @param {Array|Iterable|Object} coll - A collection to iterate over.
 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
 * it will default to an empty Object or Array, depending on the type of `coll`
 * @param {AsyncFunction} iteratee - A function applied to each item in the
 * collection that potentially modifies the accumulator.
 * Invoked with (accumulator, item, key, callback).
 * @param {Function} [callback] - A callback which is called after all the
 * `iteratee` functions have finished. Result is the transformed accumulator.
 * Invoked with (err, result).
 * @example
 *
 * async.transform([1,2,3], function(acc, item, index, callback) {
 *     // pointless async:
 *     process.nextTick(function() {
 *         acc.push(item * 2)
 *         callback(null)
 *     });
 * }, function(err, result) {
 *     // result is now equal to [2, 4, 6]
 * });
 *
 * @example
 *
 * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
 *     setImmediate(function () {
 *         obj[key] = val * 2;
 *         callback();
 *     })
 * }, function (err, result) {
 *     // result is equal to {a: 2, b: 4, c: 6}
 * })
 */
function transform (coll, accumulator, iteratee, callback) {
    if (arguments.length <= 3) {
        callback = iteratee;
        iteratee = accumulator;
        accumulator = isArray(coll) ? [] : {};
    }
    callback = once(callback || noop);
    var _iteratee = wrapAsync(iteratee);

    eachOf(coll, function(v, k, cb) {
        _iteratee(accumulator, v, k, cb);
    }, function(err) {
        callback(err, accumulator);
    });
}

/**
 * It runs each task in series but stops whenever any of the functions were
 * successful. If one of the tasks were successful, the `callback` will be
 * passed the result of the successful task. If all tasks fail, the callback
 * will be passed the error and result (if any) of the final attempt.
 *
 * @name tryEach
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array|Iterable|Object} tasks - A collection containing functions to
 * run, each function is passed a `callback(err, result)` it must call on
 * completion with an error `err` (which can be `null`) and an optional `result`
 * value.
 * @param {Function} [callback] - An optional callback which is called when one
 * of the tasks has succeeded, or all have failed. It receives the `err` and
 * `result` arguments of the last attempt at completing the `task`. Invoked with
 * (err, results).
 * @example
 * async.tryEach([
 *     function getDataFromFirstWebsite(callback) {
 *         // Try getting the data from the first website
 *         callback(err, data);
 *     },
 *     function getDataFromSecondWebsite(callback) {
 *         // First website failed,
 *         // Try getting the data from the backup website
 *         callback(err, data);
 *     }
 * ],
 * // optional callback
 * function(err, results) {
 *     Now do something with the data.
 * });
 *
 */
function tryEach(tasks, callback) {
    var error = null;
    var result;
    callback = callback || noop;
    eachSeries(tasks, function(task, callback) {
        wrapAsync(task)(function (err, res/*, ...args*/) {
            if (arguments.length > 2) {
                result = slice(arguments, 1);
            } else {
                result = res;
            }
            error = err;
            callback(!err);
        });
    }, function () {
        callback(error, result);
    });
}

/**
 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
 * unmemoized form. Handy for testing.
 *
 * @name unmemoize
 * @static
 * @memberOf module:Utils
 * @method
 * @see [async.memoize]{@link module:Utils.memoize}
 * @category Util
 * @param {AsyncFunction} fn - the memoized function
 * @returns {AsyncFunction} a function that calls the original unmemoized function
 */
function unmemoize(fn) {
    return function () {
        return (fn.unmemoized || fn).apply(null, arguments);
    };
}

/**
 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs.
 *
 * @name whilst
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Function} test - synchronous truth test to perform before each
 * execution of `iteratee`. Invoked with ().
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` passes. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has failed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 * @returns undefined
 * @example
 *
 * var count = 0;
 * async.whilst(
 *     function() { return count < 5; },
 *     function(callback) {
 *         count++;
 *         setTimeout(function() {
 *             callback(null, count);
 *         }, 1000);
 *     },
 *     function (err, n) {
 *         // 5 seconds have passed, n = 5
 *     }
 * );
 */
function whilst(test, iteratee, callback) {
    callback = onlyOnce(callback || noop);
    var _iteratee = wrapAsync(iteratee);
    if (!test()) return callback(null);
    var next = function(err/*, ...args*/) {
        if (err) return callback(err);
        if (test()) return _iteratee(next);
        var args = slice(arguments, 1);
        callback.apply(null, [null].concat(args));
    };
    _iteratee(next);
}

/**
 * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
 * stopped, or an error occurs. `callback` will be passed an error and any
 * arguments passed to the final `iteratee`'s callback.
 *
 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
 *
 * @name until
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @see [async.whilst]{@link module:ControlFlow.whilst}
 * @category Control Flow
 * @param {Function} test - synchronous truth test to perform before each
 * execution of `iteratee`. Invoked with ().
 * @param {AsyncFunction} iteratee - An async function which is called each time
 * `test` fails. Invoked with (callback).
 * @param {Function} [callback] - A callback which is called after the test
 * function has passed and repeated execution of `iteratee` has stopped. `callback`
 * will be passed an error and any arguments passed to the final `iteratee`'s
 * callback. Invoked with (err, [results]);
 */
function until(test, iteratee, callback) {
    whilst(function() {
        return !test.apply(this, arguments);
    }, iteratee, callback);
}

/**
 * Runs the `tasks` array of functions in series, each passing their results to
 * the next in the array. However, if any of the `tasks` pass an error to their
 * own callback, the next function is not executed, and the main `callback` is
 * immediately called with the error.
 *
 * @name waterfall
 * @static
 * @memberOf module:ControlFlow
 * @method
 * @category Control Flow
 * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
 * to run.
 * Each function should complete with any number of `result` values.
 * The `result` values will be passed as arguments, in order, to the next task.
 * @param {Function} [callback] - An optional callback to run once all the
 * functions have completed. This will be passed the results of the last task's
 * callback. Invoked with (err, [results]).
 * @returns undefined
 * @example
 *
 * async.waterfall([
 *     function(callback) {
 *         callback(null, 'one', 'two');
 *     },
 *     function(arg1, arg2, callback) {
 *         // arg1 now equals 'one' and arg2 now equals 'two'
 *         callback(null, 'three');
 *     },
 *     function(arg1, callback) {
 *         // arg1 now equals 'three'
 *         callback(null, 'done');
 *     }
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 *
 * // Or, with named functions:
 * async.waterfall([
 *     myFirstFunction,
 *     mySecondFunction,
 *     myLastFunction,
 * ], function (err, result) {
 *     // result now equals 'done'
 * });
 * function myFirstFunction(callback) {
 *     callback(null, 'one', 'two');
 * }
 * function mySecondFunction(arg1, arg2, callback) {
 *     // arg1 now equals 'one' and arg2 now equals 'two'
 *     callback(null, 'three');
 * }
 * function myLastFunction(arg1, callback) {
 *     // arg1 now equals 'three'
 *     callback(null, 'done');
 * }
 */
var waterfall = function(tasks, callback) {
    callback = once(callback || noop);
    if (!isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
    if (!tasks.length) return callback();
    var taskIndex = 0;

    function nextTask(args) {
        var task = wrapAsync(tasks[taskIndex++]);
        args.push(onlyOnce(next));
        task.apply(null, args);
    }

    function next(err/*, ...args*/) {
        if (err || taskIndex === tasks.length) {
            return callback.apply(null, arguments);
        }
        nextTask(slice(arguments, 1));
    }

    nextTask([]);
};

/**
 * An "async function" in the context of Async is an asynchronous function with
 * a variable number of parameters, with the final parameter being a callback.
 * (`function (arg1, arg2, ..., callback) {}`)
 * The final callback is of the form `callback(err, results...)`, which must be
 * called once the function is completed.  The callback should be called with a
 * Error as its first argument to signal that an error occurred.
 * Otherwise, if no error occurred, it should be called with `null` as the first
 * argument, and any additional `result` arguments that may apply, to signal
 * successful completion.
 * The callback must be called exactly once, ideally on a later tick of the
 * JavaScript event loop.
 *
 * This type of function is also referred to as a "Node-style async function",
 * or a "continuation passing-style function" (CPS). Most of the methods of this
 * library are themselves CPS/Node-style async functions, or functions that
 * return CPS/Node-style async functions.
 *
 * Wherever we accept a Node-style async function, we also directly accept an
 * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
 * In this case, the `async` function will not be passed a final callback
 * argument, and any thrown error will be used as the `err` argument of the
 * implicit callback, and the return value will be used as the `result` value.
 * (i.e. a `rejected` of the returned Promise becomes the `err` callback
 * argument, and a `resolved` value becomes the `result`.)
 *
 * Note, due to JavaScript limitations, we can only detect native `async`
 * functions and not transpilied implementations.
 * Your environment must have `async`/`await` support for this to work.
 * (e.g. Node > v7.6, or a recent version of a modern browser).
 * If you are using `async` functions through a transpiler (e.g. Babel), you
 * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
 * because the `async function` will be compiled to an ordinary function that
 * returns a promise.
 *
 * @typedef {Function} AsyncFunction
 * @static
 */

/**
 * Async is a utility module which provides straight-forward, powerful functions
 * for working with asynchronous JavaScript. Although originally designed for
 * use with [Node.js](http://nodejs.org) and installable via
 * `npm install --save async`, it can also be used directly in the browser.
 * @module async
 * @see AsyncFunction
 */


/**
 * A collection of `async` functions for manipulating collections, such as
 * arrays and objects.
 * @module Collections
 */

/**
 * A collection of `async` functions for controlling the flow through a script.
 * @module ControlFlow
 */

/**
 * A collection of `async` utility functions.
 * @module Utils
 */

var index = {
    apply: apply,
    applyEach: applyEach,
    applyEachSeries: applyEachSeries,
    asyncify: asyncify,
    auto: auto,
    autoInject: autoInject,
    cargo: cargo,
    compose: compose,
    concat: concat,
    concatLimit: concatLimit,
    concatSeries: concatSeries,
    constant: constant,
    detect: detect,
    detectLimit: detectLimit,
    detectSeries: detectSeries,
    dir: dir,
    doDuring: doDuring,
    doUntil: doUntil,
    doWhilst: doWhilst,
    during: during,
    each: eachLimit,
    eachLimit: eachLimit$1,
    eachOf: eachOf,
    eachOfLimit: eachOfLimit,
    eachOfSeries: eachOfSeries,
    eachSeries: eachSeries,
    ensureAsync: ensureAsync,
    every: every,
    everyLimit: everyLimit,
    everySeries: everySeries,
    filter: filter,
    filterLimit: filterLimit,
    filterSeries: filterSeries,
    forever: forever,
    groupBy: groupBy,
    groupByLimit: groupByLimit,
    groupBySeries: groupBySeries,
    log: log,
    map: map,
    mapLimit: mapLimit,
    mapSeries: mapSeries,
    mapValues: mapValues,
    mapValuesLimit: mapValuesLimit,
    mapValuesSeries: mapValuesSeries,
    memoize: memoize,
    nextTick: nextTick,
    parallel: parallelLimit,
    parallelLimit: parallelLimit$1,
    priorityQueue: priorityQueue,
    queue: queue$1,
    race: race,
    reduce: reduce,
    reduceRight: reduceRight,
    reflect: reflect,
    reflectAll: reflectAll,
    reject: reject,
    rejectLimit: rejectLimit,
    rejectSeries: rejectSeries,
    retry: retry,
    retryable: retryable,
    seq: seq,
    series: series,
    setImmediate: setImmediate$1,
    some: some,
    someLimit: someLimit,
    someSeries: someSeries,
    sortBy: sortBy,
    timeout: timeout,
    times: times,
    timesLimit: timeLimit,
    timesSeries: timesSeries,
    transform: transform,
    tryEach: tryEach,
    unmemoize: unmemoize,
    until: until,
    waterfall: waterfall,
    whilst: whilst,

    // aliases
    all: every,
    allLimit: everyLimit,
    allSeries: everySeries,
    any: some,
    anyLimit: someLimit,
    anySeries: someSeries,
    find: detect,
    findLimit: detectLimit,
    findSeries: detectSeries,
    forEach: eachLimit,
    forEachSeries: eachSeries,
    forEachLimit: eachLimit$1,
    forEachOf: eachOf,
    forEachOfSeries: eachOfSeries,
    forEachOfLimit: eachOfLimit,
    inject: reduce,
    foldl: reduce,
    foldr: reduceRight,
    select: filter,
    selectLimit: filterLimit,
    selectSeries: filterSeries,
    wrapSync: asyncify
};

exports['default'] = index;
exports.apply = apply;
exports.applyEach = applyEach;
exports.applyEachSeries = applyEachSeries;
exports.asyncify = asyncify;
exports.auto = auto;
exports.autoInject = autoInject;
exports.cargo = cargo;
exports.compose = compose;
exports.concat = concat;
exports.concatLimit = concatLimit;
exports.concatSeries = concatSeries;
exports.constant = constant;
exports.detect = detect;
exports.detectLimit = detectLimit;
exports.detectSeries = detectSeries;
exports.dir = dir;
exports.doDuring = doDuring;
exports.doUntil = doUntil;
exports.doWhilst = doWhilst;
exports.during = during;
exports.each = eachLimit;
exports.eachLimit = eachLimit$1;
exports.eachOf = eachOf;
exports.eachOfLimit = eachOfLimit;
exports.eachOfSeries = eachOfSeries;
exports.eachSeries = eachSeries;
exports.ensureAsync = ensureAsync;
exports.every = every;
exports.everyLimit = everyLimit;
exports.everySeries = everySeries;
exports.filter = filter;
exports.filterLimit = filterLimit;
exports.filterSeries = filterSeries;
exports.forever = forever;
exports.groupBy = groupBy;
exports.groupByLimit = groupByLimit;
exports.groupBySeries = groupBySeries;
exports.log = log;
exports.map = map;
exports.mapLimit = mapLimit;
exports.mapSeries = mapSeries;
exports.mapValues = mapValues;
exports.mapValuesLimit = mapValuesLimit;
exports.mapValuesSeries = mapValuesSeries;
exports.memoize = memoize;
exports.nextTick = nextTick;
exports.parallel = parallelLimit;
exports.parallelLimit = parallelLimit$1;
exports.priorityQueue = priorityQueue;
exports.queue = queue$1;
exports.race = race;
exports.reduce = reduce;
exports.reduceRight = reduceRight;
exports.reflect = reflect;
exports.reflectAll = reflectAll;
exports.reject = reject;
exports.rejectLimit = rejectLimit;
exports.rejectSeries = rejectSeries;
exports.retry = retry;
exports.retryable = retryable;
exports.seq = seq;
exports.series = series;
exports.setImmediate = setImmediate$1;
exports.some = some;
exports.someLimit = someLimit;
exports.someSeries = someSeries;
exports.sortBy = sortBy;
exports.timeout = timeout;
exports.times = times;
exports.timesLimit = timeLimit;
exports.timesSeries = timesSeries;
exports.transform = transform;
exports.tryEach = tryEach;
exports.unmemoize = unmemoize;
exports.until = until;
exports.waterfall = waterfall;
exports.whilst = whilst;
exports.all = every;
exports.allLimit = everyLimit;
exports.allSeries = everySeries;
exports.any = some;
exports.anyLimit = someLimit;
exports.anySeries = someSeries;
exports.find = detect;
exports.findLimit = detectLimit;
exports.findSeries = detectSeries;
exports.forEach = eachLimit;
exports.forEachSeries = eachSeries;
exports.forEachLimit = eachLimit$1;
exports.forEachOf = eachOf;
exports.forEachOfSeries = eachOfSeries;
exports.forEachOfLimit = eachOfLimit;
exports.inject = reduce;
exports.foldl = reduce;
exports.foldr = reduceRight;
exports.select = filter;
exports.selectLimit = filterLimit;
exports.selectSeries = filterSeries;
exports.wrapSync = asyncify;

Object.defineProperty(exports, '__esModule', { value: true });

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66).setImmediate, __webpack_require__(11), __webpack_require__(6), __webpack_require__(42)(module)))

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(835);



var FIREBASE_CONFIG = {
  apiKey: "AIzaSyAN0IXHvhXGJ0Laahpn2Z32x3XxGh3pFKQ",
  authDomain: "car-dashboard-others.firebaseapp.com",
  databaseURL: "https://car-dashboard-others.firebaseio.com",
  projectId: "car-dashboard-others",
  storageBucket: "car-dashboard-others.appspot.com",
  messagingSenderId: "399290790798"
};

__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(FIREBASE_CONFIG);
var firestore = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();

// in the future, users will be able to edit their comments
// const auth = firebase.auth()
// const currentUser = auth.currentUser

// we will remove local storage soon and use offline persistence
// firestore.enablePersistence()
//   .then(function() {
//       // Initialize Cloud Firestore through firebase
//       var db = firestore;
//   })
//   .catch(function(err) {
//       if (err.code == 'failed-precondition') {
//           // Multiple tabs open, persistence can only be enabled
//           // in one tab at a a time.
//           // ...
//       } else if (err.code == 'unimplemented') {
//           // The current browser does not support all of the
//           // features required to enable persistence
//           // ...
//       }
//   });
var settings = { /* your settings... */timestampsInSnapshots: true };
firestore.settings(settings);

var db = firestore;

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

// function to sort an object by its value property
function sortData(dataObj) {
  var sortable = [];
  for (var value in dataObj) {
    if (dataObj.hasOwnProperty(value)) {
      sortable.push([value, dataObj[value]]);
    }
  }
  sortable.sort(function (a, b) {
    if (b[1] && !a[1]) {
      return 1;
    } else if (!b[1] && a[1]) {
      return -1;
    } else {
      return b[1] - a[1];
    }
  });
  return sortable;
}

// returns a sorted object
function sortObjects(objToSort) {
  var newObject = {};
  var sortedArray = sortData(objToSort);
  for (var i = 0; i < sortedArray.length; i++) {
    var key = sortedArray[i][0];
    var value = sortedArray[i][1];
    newObject[key] = value;
  }
  return newObject;
}

module.exports = sortObjects;

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(831), __esModule: true };

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("vue-slider-component",[],e):"object"==typeof exports?exports["vue-slider-component"]=e():t["vue-slider-component"]=e()}(this,function(){return function(t){function e(s){if(i[s])return i[s].exports;var r=i[s]={i:s,l:!1,exports:{}};return t[s].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var i={};return e.m=t,e.c=i,e.i=function(t){return t},e.d=function(t,i,s){e.o(t,i)||Object.defineProperty(t,i,{configurable:!1,enumerable:!0,get:s})},e.n=function(t){var i=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(i,"a",i),i},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=2)}([function(t,e,i){i(7);var s=i(5)(i(1),i(6),null,null);t.exports=s.exports},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var s=function(){var t="undefined"!=typeof window?window.devicePixelRatio||1:1;return function(e){return Math.round(e*t)/t}}();e.default={name:"VueSliderComponent",props:{width:{type:[Number,String],default:"auto"},height:{type:[Number,String],default:6},data:{type:Array,default:null},dotSize:{type:Number,default:16},dotWidth:{type:Number,required:!1},dotHeight:{type:Number,required:!1},min:{type:Number,default:0},max:{type:Number,default:100},interval:{type:Number,default:1},show:{type:Boolean,default:!0},disabled:{type:Boolean,default:!1},piecewise:{type:Boolean,default:!1},tooltip:{type:[String,Boolean],default:"always"},eventType:{type:String,default:"auto"},direction:{type:String,default:"horizontal"},reverse:{type:Boolean,default:!1},lazy:{type:Boolean,default:!1},clickable:{type:Boolean,default:!0},speed:{type:Number,default:.5},realTime:{type:Boolean,default:!1},stopPropagation:{type:Boolean,default:!1},value:{type:[String,Number,Array,Object],default:0},piecewiseLabel:{type:Boolean,default:!1},debug:{type:Boolean,default:!0},fixed:{type:Boolean,default:!1},processDragable:{type:Boolean,default:!1},useKeyboard:{type:Boolean,default:!1},actionsKeyboard:{type:Array,default:function(){return[function(t){return t-1},function(t){return t+1}]}},tooltipMerge:{type:Boolean,default:!0},sliderStyle:[Array,Object,Function],focusStyle:[Array,Object,Function],tooltipDir:[Array,String],formatter:[String,Function],mergeFormatter:[String,Function],piecewiseStyle:Object,piecewiseActiveStyle:Object,processStyle:Object,bgStyle:Object,tooltipStyle:[Array,Object,Function],labelStyle:Object,labelActiveStyle:Object},data:function(){return{flag:!1,keydownFlag:null,focusFlag:!1,processFlag:!1,processSign:null,size:0,fixedValue:0,focusSlider:0,currentValue:0,currentSlider:0,isComponentExists:!0,isMounted:!1}},computed:{dotWidthVal:function(){return"number"==typeof this.dotWidth?this.dotWidth:this.dotSize},dotHeightVal:function(){return"number"==typeof this.dotHeight?this.dotHeight:this.dotSize},flowDirection:function(){return"vue-slider-"+this.direction+(this.reverse?"-reverse":"")},tooltipMergedPosition:function(){if(!this.isMounted)return{};var t=this.tooltipDirection[0];if(this.$refs.dot0){if("vertical"===this.direction){var e={};return e[t]="-"+(this.dotHeightVal/2-this.width/2+9)+"px",e}var i={};return i[t]="-"+(this.dotWidthVal/2-this.height/2+9)+"px",i.left="50%",i}},tooltipDirection:function(){var t=this.tooltipDir||("vertical"===this.direction?"left":"top");return Array.isArray(t)?this.isRange?t:t[1]:this.isRange?[t,t]:t},tooltipStatus:function(){return"hover"===this.tooltip&&this.flag?"vue-slider-always":this.tooltip?"vue-slider-"+this.tooltip:""},tooltipClass:function(){return["vue-slider-tooltip-"+this.tooltipDirection,"vue-slider-tooltip"]},isDisabled:function(){return"none"===this.eventType||this.disabled},disabledClass:function(){return this.disabled?"vue-slider-disabled":""},stateClass:function(){return{"vue-slider-state-process-drag":this.processFlag,"vue-slider-state-drag":this.flag&&!this.processFlag&&!this.keydownFlag,"vue-slider-state-focus":this.focusFlag}},isRange:function(){return Array.isArray(this.value)},slider:function(){return this.isRange?[this.$refs.dot0,this.$refs.dot1]:this.$refs.dot},minimum:function(){return this.data?0:this.min},val:{get:function(){return this.data?this.isRange?[this.data[this.currentValue[0]],this.data[this.currentValue[1]]]:this.data[this.currentValue]:this.currentValue},set:function(t){if(this.data)if(this.isRange){var e=this.data.indexOf(t[0]),i=this.data.indexOf(t[1]);e>-1&&i>-1&&(this.currentValue=[e,i])}else{var s=this.data.indexOf(t);s>-1&&(this.currentValue=s)}else this.currentValue=t}},currentIndex:function(){return this.isRange?this.data?this.currentValue:[this.getIndexByValue(this.currentValue[0]),this.getIndexByValue(this.currentValue[1])]:this.getIndexByValue(this.currentValue)},indexRange:function(){return this.isRange?this.currentIndex:[0,this.currentIndex]},maximum:function(){return this.data?this.data.length-1:this.max},multiple:function(){var t=(""+this.interval).split(".")[1];return t?Math.pow(10,t.length):1},spacing:function(){return this.data?1:this.interval},total:function(){return this.data?this.data.length-1:(Math.floor((this.maximum-this.minimum)*this.multiple)%(this.interval*this.multiple)!=0&&this.printError("Prop[interval] is illegal, Please make sure that the interval can be divisible"),(this.maximum-this.minimum)/this.interval)},gap:function(){return this.size/this.total},position:function(){return this.isRange?[(this.currentValue[0]-this.minimum)/this.spacing*this.gap,(this.currentValue[1]-this.minimum)/this.spacing*this.gap]:(this.currentValue-this.minimum)/this.spacing*this.gap},limit:function(){return this.isRange?this.fixed?[[0,(this.maximum-this.fixedValue*this.spacing)/this.spacing*this.gap],[(this.minimum+this.fixedValue*this.spacing)/this.spacing*this.gap,this.size]]:[[0,this.position[1]],[this.position[0],this.size]]:[0,this.size]},valueLimit:function(){return this.isRange?this.fixed?[[this.minimum,this.maximum-this.fixedValue*this.spacing],[this.minimum+this.fixedValue*this.spacing,this.maximum]]:[[this.minimum,this.currentValue[1]],[this.currentValue[0],this.maximum]]:[this.minimum,this.maximum]},idleSlider:function(){return 0===this.currentSlider?1:0},wrapStyles:function(){return"vertical"===this.direction?{height:"number"==typeof this.height?this.height+"px":this.height,padding:this.dotHeightVal/2+"px "+this.dotWidthVal/2+"px"}:{width:"number"==typeof this.width?this.width+"px":this.width,padding:this.dotHeightVal/2+"px "+this.dotWidthVal/2+"px"}},sliderStyles:function(){return Array.isArray(this.sliderStyle)?this.isRange?this.sliderStyle:this.sliderStyle[1]:"function"==typeof this.sliderStyle?this.sliderStyle(this.val,this.currentIndex):this.isRange?[this.sliderStyle,this.sliderStyle]:this.sliderStyle},focusStyles:function(){return Array.isArray(this.focusStyle)?this.isRange?this.focusStyle:this.focusStyle[1]:"function"==typeof this.focusStyle?this.focusStyle(this.val,this.currentIndex):this.isRange?[this.focusStyle,this.focusStyle]:this.focusStyle},tooltipStyles:function(){return Array.isArray(this.tooltipStyle)?this.isRange?this.tooltipStyle:this.tooltipStyle[1]:"function"==typeof this.tooltipStyle?this.tooltipStyle(this.val,this.currentIndex):this.isRange?[this.tooltipStyle,this.tooltipStyle]:this.tooltipStyle},elemStyles:function(){return"vertical"===this.direction?{width:this.width+"px",height:"100%"}:{height:this.height+"px"}},dotStyles:function(){return"vertical"===this.direction?{width:this.dotWidthVal+"px",height:this.dotHeightVal+"px",left:-(this.dotWidthVal-this.width)/2+"px"}:{width:this.dotWidthVal+"px",height:this.dotHeightVal+"px",top:-(this.dotHeightVal-this.height)/2+"px"}},piecewiseDotStyle:function(){return"vertical"===this.direction?{width:this.width+"px",height:this.width+"px"}:{width:this.height+"px",height:this.height+"px"}},piecewiseDotWrap:function(){if(!this.piecewise&&!this.piecewiseLabel)return!1;for(var t=[],e=0;e<=this.total;e++){var i="vertical"===this.direction?{bottom:this.gap*e-this.width/2+"px",left:0}:{left:this.gap*e-this.height/2+"px",top:0},s=this.reverse?this.total-e:e,r=this.data?this.data[s]:this.spacing*s+this.min;t.push({style:i,label:this.formatter?this.formatting(r):r,inRange:s>=this.indexRange[0]&&s<=this.indexRange[1]})}return t}},watch:{value:function(t){this.flag||this.setValue(t,!0)},max:function(t){if(t<this.min)return this.printError("The maximum value can not be less than the minimum value.");var e=this.limitValue(this.val);this.setValue(e),this.refresh()},min:function(t){if(t>this.max)return this.printError("The minimum value can not be greater than the maximum value.");var e=this.limitValue(this.val);this.setValue(e),this.refresh()},show:function(t){var e=this;t&&!this.size&&this.$nextTick(function(){e.refresh()})},fixed:function(){this.computedFixedValue()}},methods:{bindEvents:function(){document.addEventListener("touchmove",this.moving,{passive:!1}),document.addEventListener("touchend",this.moveEnd,{passive:!1}),document.addEventListener("mousedown",this.blurSlider),document.addEventListener("mousemove",this.moving),document.addEventListener("mouseup",this.moveEnd),document.addEventListener("mouseleave",this.moveEnd),document.addEventListener("keydown",this.handleKeydown),document.addEventListener("keyup",this.handleKeyup),window.addEventListener("resize",this.refresh),this.isRange&&this.tooltipMerge&&(this.$refs.dot0.addEventListener("transitionend",this.handleOverlapTooltip),this.$refs.dot1.addEventListener("transitionend",this.handleOverlapTooltip))},unbindEvents:function(){document.removeEventListener("touchmove",this.moving),document.removeEventListener("touchend",this.moveEnd),document.removeEventListener("mousedown",this.blurSlider),document.removeEventListener("mousemove",this.moving),document.removeEventListener("mouseup",this.moveEnd),document.removeEventListener("mouseleave",this.moveEnd),document.removeEventListener("keydown",this.handleKeydown),document.removeEventListener("keyup",this.handleKeyup),window.removeEventListener("resize",this.refresh),this.isRange&&this.tooltipMerge&&(this.$refs.dot0.removeEventListener("transitionend",this.handleOverlapTooltip),this.$refs.dot1.removeEventListener("transitionend",this.handleOverlapTooltip))},handleKeydown:function(t){if(!this.useKeyboard||!this.focusFlag)return!1;switch(t.keyCode){case 37:case 40:t.preventDefault(),this.keydownFlag=!0,this.flag=!0,this.changeFocusSlider(this.actionsKeyboard[0]);break;case 38:case 39:t.preventDefault(),this.keydownFlag=!0,this.flag=!0,this.changeFocusSlider(this.actionsKeyboard[1])}},handleKeyup:function(){this.keydownFlag&&(this.keydownFlag=!1,this.flag=!1)},changeFocusSlider:function(t){var e=this;if(this.isRange){var i=this.currentIndex.map(function(i,s){if(s===e.focusSlider||e.fixed){var r=t(i),o=e.fixed?e.valueLimit[s]:[0,e.total];if(r<=o[1]&&r>=o[0])return r}return i});i[0]>i[1]&&(this.focusSlider=0===this.focusSlider?1:0,i=i.reverse()),this.setIndex(i)}else this.setIndex(t(this.currentIndex))},blurSlider:function(t){var e=this.isRange?this.$refs["dot"+this.focusSlider]:this.$refs.dot;if(!e||e===t.target)return!1;this.focusFlag=!1},formatting:function(t){return"string"==typeof this.formatter?this.formatter.replace(/\{value\}/,t):this.formatter(t)},mergeFormatting:function(t,e){return"string"==typeof this.mergeFormatter?this.mergeFormatter.replace(/\{(value1|value2)\}/g,function(i,s){return"value1"===s?t:e}):this.mergeFormatter(t,e)},getPos:function(t){return this.realTime&&this.getStaticData(),"vertical"===this.direction?this.reverse?t.pageY-this.offset:this.size-(t.pageY-this.offset):this.reverse?this.size-(t.clientX-this.offset):t.clientX-this.offset},processClick:function(t){this.fixed&&t.stopPropagation()},wrapClick:function(t){if(this.isDisabled||!this.clickable||this.processFlag)return!1;var e=this.getPos(t);this.isRange&&(this.currentSlider=e>(this.position[1]-this.position[0])/2+this.position[0]?1:0),this.setValueOnPos(e)},moveStart:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments[2];if(this.isDisabled)return!1;if(this.stopPropagation&&t.stopPropagation(),this.isRange&&(this.currentSlider=e,i)){if(!this.processDragable)return!1;this.processFlag=!0,this.processSign={pos:this.position,start:this.getPos(t.targetTouches&&t.targetTouches[0]?t.targetTouches[0]:t)}}!i&&this.useKeyboard&&(this.focusFlag=!0,this.focusSlider=e),this.flag=!0,this.$emit("drag-start",this)},moving:function(t){if(this.stopPropagation&&t.stopPropagation(),!this.flag)return!1;t.preventDefault(),t.targetTouches&&t.targetTouches[0]&&(t=t.targetTouches[0]),this.processFlag?(this.currentSlider=0,this.setValueOnPos(this.processSign.pos[0]+this.getPos(t)-this.processSign.start,!0),this.currentSlider=1,this.setValueOnPos(this.processSign.pos[1]+this.getPos(t)-this.processSign.start,!0)):this.setValueOnPos(this.getPos(t),!0),this.isRange&&this.tooltipMerge&&this.handleOverlapTooltip()},moveEnd:function(t){var e=this;if(this.stopPropagation&&t.stopPropagation(),!this.flag)return!1;this.$emit("drag-end",this),this.lazy&&this.isDiff(this.val,this.value)&&this.syncValue(),this.flag=!1,window.setTimeout(function(){e.processFlag=!1},0),this.setPosition()},setValueOnPos:function(t,e){var i=this.isRange?this.limit[this.currentSlider]:this.limit,s=this.isRange?this.valueLimit[this.currentSlider]:this.valueLimit;if(t>=i[0]&&t<=i[1]){this.setTransform(t);var r=this.getValueByIndex(Math.round(t/this.gap));this.setCurrentValue(r,e),this.isRange&&this.fixed&&(this.setTransform(t+this.fixedValue*this.gap*(0===this.currentSlider?1:-1),!0),this.setCurrentValue(r+this.fixedValue*this.spacing*(0===this.currentSlider?1:-1),e,!0))}else t<i[0]?(this.setTransform(i[0]),this.setCurrentValue(s[0]),this.isRange&&this.fixed?(this.setTransform(this.limit[this.idleSlider][0],!0),this.setCurrentValue(this.valueLimit[this.idleSlider][0],e,!0)):this.fixed||1!==this.currentSlider||(this.focusSlider=0,this.currentSlider=0)):(this.setTransform(i[1]),this.setCurrentValue(s[1]),this.isRange&&this.fixed?(this.setTransform(this.limit[this.idleSlider][1],!0),this.setCurrentValue(this.valueLimit[this.idleSlider][1],e,!0)):this.fixed||0!==this.currentSlider||(this.focusSlider=1,this.currentSlider=1))},isDiff:function(t,e){return Object.prototype.toString.call(t)!==Object.prototype.toString.call(e)||(Array.isArray(t)&&t.length===e.length?t.some(function(t,i){return t!==e[i]}):t!==e)},setCurrentValue:function(t,e,i){var s=i?this.idleSlider:this.currentSlider;if(t<this.minimum||t>this.maximum)return!1;this.isRange?this.isDiff(this.currentValue[s],t)&&(this.currentValue.splice(s,1,t),this.lazy&&this.flag||this.syncValue()):this.isDiff(this.currentValue,t)&&(this.currentValue=t,this.lazy&&this.flag||this.syncValue()),e||this.setPosition()},getValueByIndex:function(t){return(this.spacing*this.multiple*t+this.minimum*this.multiple)/this.multiple},getIndexByValue:function(t){return Math.round((t-this.minimum)*this.multiple)/(this.spacing*this.multiple)},setIndex:function(t){if(Array.isArray(t)&&this.isRange){var e=void 0;e=this.data?[this.data[t[0]],this.data[t[1]]]:[this.getValueByIndex(t[0]),this.getValueByIndex(t[1])],this.setValue(e)}else t=this.getValueByIndex(t),this.isRange&&(this.currentSlider=t>(this.currentValue[1]-this.currentValue[0])/2+this.currentValue[0]?1:0),this.setCurrentValue(t)},setValue:function(t,e,i){var s=this;if(this.isDiff(this.val,t)){var r=this.limitValue(t);this.val=this.isRange?r.concat():r,this.computedFixedValue(),this.syncValue(e)}this.$nextTick(function(){return s.setPosition(i)})},computedFixedValue:function(){if(!this.fixed)return this.fixedValue=0,!1;this.fixedValue=this.currentIndex[1]-this.currentIndex[0]},setPosition:function(t){this.flag||this.setTransitionTime(void 0===t?this.speed:t),this.isRange?(this.setTransform(this.position[0],1===this.currentSlider),this.setTransform(this.position[1],0===this.currentSlider)):this.setTransform(this.position),this.flag||this.setTransitionTime(0)},setTransform:function(t,e){var i=e?this.idleSlider:this.currentSlider,r=s(("vertical"===this.direction?this.dotHeightVal/2-t:t-this.dotWidthVal/2)*(this.reverse?-1:1)),o="vertical"===this.direction?"translateY("+r+"px)":"translateX("+r+"px)",n=this.fixed?this.fixedValue*this.gap+"px":(0===i?this.position[1]-t:t-this.position[0])+"px",l=this.fixed?(0===i?t:t-this.fixedValue*this.gap)+"px":(0===i?t:this.position[0])+"px";this.isRange?(this.slider[i].style.transform=o,this.slider[i].style.WebkitTransform=o,this.slider[i].style.msTransform=o,"vertical"===this.direction?(this.$refs.process.style.height=n,this.$refs.process.style[this.reverse?"top":"bottom"]=l):(this.$refs.process.style.width=n,this.$refs.process.style[this.reverse?"right":"left"]=l)):(this.slider.style.transform=o,this.slider.style.WebkitTransform=o,this.slider.style.msTransform=o,"vertical"===this.direction?(this.$refs.process.style.height=t+"px",this.$refs.process.style[this.reverse?"top":"bottom"]=0):(this.$refs.process.style.width=t+"px",this.$refs.process.style[this.reverse?"right":"left"]=0))},setTransitionTime:function(t){if(t||this.$refs.process.offsetWidth,this.isRange){for(var e=0;e<this.slider.length;e++)this.slider[e].style.transitionDuration=t+"s",this.slider[e].style.WebkitTransitionDuration=t+"s";this.$refs.process.style.transitionDuration=t+"s",this.$refs.process.style.WebkitTransitionDuration=t+"s"}else this.slider.style.transitionDuration=t+"s",this.slider.style.WebkitTransitionDuration=t+"s",this.$refs.process.style.transitionDuration=t+"s",this.$refs.process.style.WebkitTransitionDuration=t+"s"},limitValue:function(t){var e=this;if(this.data)return t;var i=function(i){return i<e.min?(e.printError("The value of the slider is "+t+", the minimum value is "+e.min+", the value of this slider can not be less than the minimum value"),e.min):i>e.max?(e.printError("The value of the slider is "+t+", the maximum value is "+e.max+", the value of this slider can not be greater than the maximum value"),e.max):i};return this.isRange?t.map(function(t){return i(t)}):i(t)},syncValue:function(t){var e=this.isRange?this.val.concat():this.val;this.$emit("input",e),t||this.$emit("callback",e)},getValue:function(){return this.val},getIndex:function(){return this.currentIndex},getStaticData:function(){this.$refs.elem&&(this.size="vertical"===this.direction?this.$refs.elem.offsetHeight:this.$refs.elem.offsetWidth,this.offset="vertical"===this.direction?this.$refs.elem.getBoundingClientRect().top+window.pageYOffset||document.documentElement.scrollTop:this.$refs.elem.getBoundingClientRect().left)},refresh:function(){this.$refs.elem&&(this.getStaticData(),this.computedFixedValue(),this.setPosition())},printError:function(t){this.debug&&console.error("[VueSlider error]: "+t)},handleOverlapTooltip:function(){var t=this.tooltipDirection[0]===this.tooltipDirection[1];if(this.isRange&&t){var e=this.$refs.tooltip0,i=this.$refs.tooltip1,s=e.getBoundingClientRect().right,r=i.getBoundingClientRect().left,o=e.getBoundingClientRect().y,n=i.getBoundingClientRect().y+i.getBoundingClientRect().height,l="horizontal"===this.direction&&s>r,a="vertical"===this.direction&&n>o;l||a?this.handleDisplayMergedTooltip(!0):this.handleDisplayMergedTooltip(!1)}},handleDisplayMergedTooltip:function(t){var e=this.$refs.tooltip0,i=this.$refs.tooltip1,s=this.$refs.process.getElementsByClassName("vue-merged-tooltip")[0];t?(e.style.visibility="hidden",i.style.visibility="hidden",s.style.visibility="visible"):(e.style.visibility="visible",i.style.visibility="visible",s.style.visibility="hidden")}},mounted:function(){var t=this;if(this.isComponentExists=!0,"undefined"==typeof window||"undefined"==typeof document)return this.printError("window or document is undefined, can not be initialization.");this.$nextTick(function(){t.isComponentExists&&(t.getStaticData(),t.setValue(t.limitValue(t.value),!0,0),t.bindEvents())}),this.isMounted=!0},beforeDestroy:function(){this.isComponentExists=!1,this.unbindEvents()}}},function(t,e,i){"use strict";var s=i(0);t.exports=s},function(t,e,i){e=t.exports=i(4)(),e.push([t.i,'.vue-slider-component{position:relative;box-sizing:border-box;-ms-user-select:none;user-select:none;-webkit-user-select:none;-moz-user-select:none;-o-user-select:none}.vue-slider-component.vue-slider-disabled{opacity:.5;cursor:not-allowed}.vue-slider-component.vue-slider-has-label{margin-bottom:15px}.vue-slider-component.vue-slider-disabled .vue-slider-dot{cursor:not-allowed}.vue-slider-component .vue-slider{position:relative;display:block;border-radius:15px;background-color:#ccc}.vue-slider-component .vue-slider:after{content:"";position:absolute;left:0;top:0;width:100%;height:100%;z-index:2}.vue-slider-component .vue-slider-process{position:absolute;border-radius:15px;background-color:#3498db;transition:all 0s;z-index:1}.vue-slider-component .vue-slider-process.vue-slider-process-dragable{cursor:pointer;z-index:3}.vue-slider-component.vue-slider-horizontal .vue-slider-process{width:0;height:100%;top:0;left:0;will-change:width}.vue-slider-component.vue-slider-vertical .vue-slider-process{width:100%;height:0;bottom:0;left:0;will-change:height}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-process{width:0;height:100%;top:0;right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-process{width:100%;height:0;top:0;left:0}.vue-slider-component .vue-slider-dot{position:absolute;border-radius:50%;background-color:#fff;box-shadow:.5px .5px 2px 1px rgba(0,0,0,.32);transition:all 0s;will-change:transform;cursor:pointer;z-index:4}.vue-slider-component .vue-slider-dot.vue-slider-dot-focus{box-shadow:0 0 2px 1px #3498db}.vue-slider-component .vue-slider-dot.vue-slider-dot-dragging{z-index:5}.vue-slider-component.vue-slider-horizontal .vue-slider-dot{left:0}.vue-slider-component.vue-slider-vertical .vue-slider-dot{bottom:0}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-dot{right:0}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-dot{top:0}.vue-slider-component .vue-slider-tooltip-wrap{display:none;position:absolute;z-index:9}.vue-slider-component .vue-slider-tooltip{display:block;font-size:14px;white-space:nowrap;padding:2px 5px;min-width:20px;text-align:center;color:#fff;border-radius:5px;border:1px solid #3498db;background-color:#3498db}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top{top:-9px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom{bottom:-9px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left{top:50%;left:-9px;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right{top:50%;right:-9px;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}.vue-slider-component .vue-slider-tooltip-top .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top .vue-slider-tooltip:before{content:"";position:absolute;bottom:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-top-color:inherit;-webkit-transform:translate(-50%);transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-wrap.vue-merged-tooltip{display:block;visibility:hidden}.vue-slider-component .vue-slider-tooltip-bottom .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-bottom .vue-slider-tooltip:before{content:"";position:absolute;top:-10px;left:50%;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-bottom-color:inherit;-webkit-transform:translate(-50%);transform:translate(-50%)}.vue-slider-component .vue-slider-tooltip-left .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-left .vue-slider-tooltip:before{content:"";position:absolute;top:50%;right:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-left-color:inherit;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-component .vue-slider-tooltip-right .vue-merged-tooltip .vue-slider-tooltip:before,.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-right .vue-slider-tooltip:before{content:"";position:absolute;top:50%;left:-10px;width:0;height:0;border:5px solid transparent;border:6px solid transparent\\0;border-right-color:inherit;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-component .vue-slider-dot.vue-slider-hover:hover .vue-slider-tooltip-wrap{display:block}.vue-slider-component .vue-slider-dot.vue-slider-always .vue-slider-tooltip-wrap{display:block!important}.vue-slider-component .vue-slider-piecewise{position:absolute;width:100%;padding:0;margin:0;left:0;top:0;height:100%;list-style:none}.vue-slider-component .vue-slider-piecewise-item{position:absolute;width:8px;height:8px}.vue-slider-component .vue-slider-piecewise-dot{position:absolute;left:50%;top:50%;width:100%;height:100%;display:inline-block;background-color:rgba(0,0,0,.16);border-radius:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2;transition:all .3s}.vue-slider-component .vue-slider-piecewise-item:first-child .vue-slider-piecewise-dot,.vue-slider-component .vue-slider-piecewise-item:last-child .vue-slider-piecewise-dot{visibility:hidden}.vue-slider-component.vue-slider-horizontal-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-horizontal .vue-slider-piecewise-label{position:absolute;display:inline-block;top:100%;left:50%;white-space:nowrap;font-size:12px;color:#333;-webkit-transform:translate(-50%,8px);transform:translate(-50%,8px);visibility:visible}.vue-slider-component.vue-slider-vertical-reverse .vue-slider-piecewise-label,.vue-slider-component.vue-slider-vertical .vue-slider-piecewise-label{position:absolute;display:inline-block;top:50%;left:100%;white-space:nowrap;font-size:12px;color:#333;-webkit-transform:translate(8px,-50%);transform:translate(8px,-50%);visibility:visible}.vue-slider-component .vue-slider-sr-only{clip:rect(1px,1px,1px,1px);height:1px;width:1px;overflow:hidden;position:absolute!important}',""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var i=this[e];i[2]?t.push("@media "+i[2]+"{"+i[1]+"}"):t.push(i[1])}return t.join("")},t.i=function(e,i){"string"==typeof e&&(e=[[null,e,""]]);for(var s={},r=0;r<this.length;r++){var o=this[r][0];"number"==typeof o&&(s[o]=!0)}for(r=0;r<e.length;r++){var n=e[r];"number"==typeof n[0]&&s[n[0]]||(i&&!n[2]?n[2]=i:i&&(n[2]="("+n[2]+") and ("+i+")"),t.push(n))}},t}},function(t,e){t.exports=function(t,e,i,s){var r,o=t=t||{},n=typeof t.default;"object"!==n&&"function"!==n||(r=t,o=t.default);var l="function"==typeof o?o.options:o;if(e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns),i&&(l._scopeId=i),s){var a=Object.create(l.computed||null);Object.keys(s).forEach(function(t){var e=s[t];a[t]=function(){return e}}),l.computed=a}return{esModule:r,exports:o,options:l}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{directives:[{name:"show",rawName:"v-show",value:t.show,expression:"show"}],ref:"wrap",class:["vue-slider-component",t.flowDirection,t.disabledClass,t.stateClass,{"vue-slider-has-label":t.piecewiseLabel}],style:t.wrapStyles,on:{click:t.wrapClick}},[i("div",{ref:"elem",staticClass:"vue-slider",style:[t.elemStyles,t.bgStyle],attrs:{"aria-hidden":"true"}},[t.isRange?[i("div",{key:"dot0",ref:"dot0",class:[t.tooltipStatus,"vue-slider-dot",{"vue-slider-dot-focus":t.focusFlag&&0===t.focusSlider,"vue-slider-dot-dragging":t.flag&&0===t.currentSlider}],style:[t.dotStyles,t.sliderStyles[0],t.focusFlag&&0===t.focusSlider?t.focusStyles[0]:null],on:{mousedown:function(e){t.moveStart(e,0)},touchstart:function(e){t.moveStart(e,0)}}},[i("div",{ref:"tooltip0",class:["vue-slider-tooltip-"+t.tooltipDirection[0],"vue-slider-tooltip-wrap"]},[t._t("tooltip",[i("span",{staticClass:"vue-slider-tooltip",style:t.tooltipStyles[0]},[t._v(t._s(t.formatter?t.formatting(t.val[0]):t.val[0]))])],{value:t.val[0],index:0})],2)]),t._v(" "),i("div",{key:"dot1",ref:"dot1",class:[t.tooltipStatus,"vue-slider-dot",{"vue-slider-dot-focus":t.focusFlag&&1===t.focusSlider,"vue-slider-dot-dragging":t.flag&&1===t.currentSlider}],style:[t.dotStyles,t.sliderStyles[1],t.focusFlag&&1===t.focusSlider?t.focusStyles[1]:null],on:{mousedown:function(e){t.moveStart(e,1)},touchstart:function(e){t.moveStart(e,1)}}},[i("div",{ref:"tooltip1",class:["vue-slider-tooltip-"+t.tooltipDirection[1],"vue-slider-tooltip-wrap"]},[t._t("tooltip",[i("span",{staticClass:"vue-slider-tooltip",style:t.tooltipStyles[1]},[t._v(t._s(t.formatter?t.formatting(t.val[1]):t.val[1]))])],{value:t.val[1],index:1})],2)])]:[i("div",{key:"dot",ref:"dot",class:[t.tooltipStatus,"vue-slider-dot",{"vue-slider-dot-focus":t.focusFlag&&0===t.focusSlider,"vue-slider-dot-dragging":t.flag&&0===t.currentSlider}],style:[t.dotStyles,t.sliderStyles,t.focusFlag&&0===t.focusSlider?t.focusStyles:null],on:{mousedown:t.moveStart,touchstart:t.moveStart}},[i("div",{class:["vue-slider-tooltip-"+t.tooltipDirection,"vue-slider-tooltip-wrap"]},[t._t("tooltip",[i("span",{staticClass:"vue-slider-tooltip",style:t.tooltipStyles},[t._v(t._s(t.formatter?t.formatting(t.val):t.val))])],{value:t.val})],2)])],t._v(" "),i("ul",{staticClass:"vue-slider-piecewise"},t._l(t.piecewiseDotWrap,function(e,s){return i("li",{key:s,staticClass:"vue-slider-piecewise-item",style:[t.piecewiseDotStyle,e.style]},[t._t("piecewise",[t.piecewise?i("span",{staticClass:"vue-slider-piecewise-dot",style:[t.piecewiseStyle,e.inRange?t.piecewiseActiveStyle:null]}):t._e()],{label:e.label,index:s,first:0===s,last:s===t.piecewiseDotWrap.length-1,active:e.inRange}),t._v(" "),t._t("label",[t.piecewiseLabel?i("span",{staticClass:"vue-slider-piecewise-label",style:[t.labelStyle,e.inRange?t.labelActiveStyle:null]},[t._v("\n            "+t._s(e.label)+"\n          ")]):t._e()],{label:e.label,index:s,first:0===s,last:s===t.piecewiseDotWrap.length-1,active:e.inRange})],2)})),t._v(" "),i("div",{ref:"process",class:["vue-slider-process",{"vue-slider-process-dragable":t.isRange&&t.processDragable}],style:t.processStyle,on:{click:t.processClick,mousedown:function(e){t.moveStart(e,0,!0)},touchstart:function(e){t.moveStart(e,0,!0)}}},[i("div",{ref:"mergedTooltip",staticClass:"vue-merged-tooltip",class:["vue-slider-tooltip-"+t.tooltipDirection[0],"vue-slider-tooltip-wrap"],style:t.tooltipMergedPosition},[t._t("tooltip",[i("span",{staticClass:"vue-slider-tooltip",style:t.tooltipStyles},[t._v("\n            "+t._s(t.mergeFormatter?t.mergeFormatting(t.val[0],t.val[1]):t.formatter?t.formatting(t.val[0])+" - "+t.formatting(t.val[1]):t.val[0]+" - "+t.val[1])+"\n          ")])])],2)]),t._v(" "),t.isRange||t.data?t._e():i("input",{directives:[{name:"model",rawName:"v-model",value:t.val,expression:"val"}],staticClass:"vue-slider-sr-only",attrs:{type:"range",min:t.min,max:t.max},domProps:{value:t.val},on:{__r:function(e){t.val=e.target.value}}})],2)])},staticRenderFns:[]}},function(t,e,i){var s=i(3);"string"==typeof s&&(s=[[t.i,s,""]]),s.locals&&(t.exports=s.locals);i(8)("743d98f5",s,!0)},function(t,e,i){function s(t){for(var e=0;e<t.length;e++){var i=t[e],s=d[i.id];if(s){s.refs++;for(var r=0;r<s.parts.length;r++)s.parts[r](i.parts[r]);for(;r<i.parts.length;r++)s.parts.push(o(i.parts[r]));s.parts.length>i.parts.length&&(s.parts.length=i.parts.length)}else{for(var n=[],r=0;r<i.parts.length;r++)n.push(o(i.parts[r]));d[i.id]={id:i.id,refs:1,parts:n}}}}function r(){var t=document.createElement("style");return t.type="text/css",h.appendChild(t),t}function o(t){var e,i,s=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(s){if(f)return v;s.parentNode.removeChild(s)}if(m){var o=p++;s=c||(c=r()),e=n.bind(null,s,o,!1),i=n.bind(null,s,o,!0)}else s=r(),e=l.bind(null,s),i=function(){s.parentNode.removeChild(s)};return e(t),function(s){if(s){if(s.css===t.css&&s.media===t.media&&s.sourceMap===t.sourceMap)return;e(t=s)}else i()}}function n(t,e,i,s){var r=i?"":s.css;if(t.styleSheet)t.styleSheet.cssText=g(e,r);else{var o=document.createTextNode(r),n=t.childNodes;n[e]&&t.removeChild(n[e]),n.length?t.insertBefore(o,n[e]):t.appendChild(o)}}function l(t,e){var i=e.css,s=e.media,r=e.sourceMap;if(s&&t.setAttribute("media",s),r&&(i+="\n/*# sourceURL="+r.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),t.styleSheet)t.styleSheet.cssText=i;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(i))}}var a="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!a)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var u=i(9),d={},h=a&&(document.head||document.getElementsByTagName("head")[0]),c=null,p=0,f=!1,v=function(){},m="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,i){f=i;var r=u(t,e);return s(r),function(e){for(var i=[],o=0;o<r.length;o++){var n=r[o],l=d[n.id];l.refs--,i.push(l)}e?(r=u(t,e),s(r)):r=[];for(var o=0;o<i.length;o++){var l=i[o];if(0===l.refs){for(var a=0;a<l.parts.length;a++)l.parts[a]();delete d[l.id]}}}};var g=function(){var t=[];return function(e,i){return t[e]=i,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var i=[],s={},r=0;r<e.length;r++){var o=e[r],n=o[0],l=o[1],a=o[2],u=o[3],d={id:t+":"+r,css:l,media:a,sourceMap:u};s[n]?s[n].parts.push(d):i.push(s[n]={id:n,parts:[d]})}return i}}])});

/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chart_options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chart_options2; });
/* unused harmony export chart_options3 */
/* unused harmony export chart_options4 */
/* unused harmony export chart_options5 */
var chart_options = {
    responsive: {
        rules: [{
            condition: {
                maxWidth: 380
            },
            chartOptions: {}
        }]
    },
    chart: {
        type: 'bar',
        zoomType: 'xy',
        borderColor: '#FFFFFF'
    },
    lang: {
        drillUpText: 'Back to states'
    },
    title: {
        margin: 25,
        text: 'Loading...',
        style: {
            fontSize: '16px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: '600'
        }
    },
    subtitle: {
        text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
    },
    credits: {
        enabled: false
    },
    xAxis: {
        type: 'category',
        //categories: null,
        title: {
            text: 'x-axis title'
        },
        labels: {
            style: {
                fontSize: '9px',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: '600',
                color: '#999999'
            }
        }
    },
    yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        plotLines: [],
        title: {
            text: 'y-axis title',
            style: {
                fontSize: '11px',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 'normal',
                color: '#888888'
            }
        },
        labels: {
            style: {
                fontSize: '10px',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 'normal',
                color: '#888888'
            }
        }
    },
    legend: {
        enabled: true,
        borderColor: 'black',
        //   borderRadius: 10,
        borderWidth: 3,
        title: {
            text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
            style: {
                fontSize: '12px',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: '600',
                color: '#666666'
            }
        }
    },
    plotOptions: {
        series: {
            events: {
                // legendItemClick: function (e) {
                //     this.visible = !this.visible;
                //     var visibility = this.visible ? 'visible' : 'hidden';
                //     // if (!confirm('The series is currently ' +
                //     //              visibility + '. Do you want to change that?')) {
                //     //     return true;
                //     // }
                // }
            },
            borderWidth: 0,
            point: {},
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '{point.y:.1f}',
                style: {
                    fontSize: '8px',
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 'normal',
                    color: '#555555'
                }
            },
            // states: {
            //     hover: {
            //         enabled: true,
            //         lineWidth: 4
            //     }
            // },
            zones: []
        }
    },
    tooltip: {
        // backgroundColor: '#FCFFC5',
        // borderColor: 'black',
        // borderRadius: 10,
        // borderWidth: 3,
        // crosshairs: [true, true],
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>'
    },
    // navigation: {
    //     menuItemStyle: {
    //         fontSize: '10px'
    //     }
    // },
    series: [],
    drilldown: {
        activeAxisLabelStyle: {
            color: 'black',
            textDecoration: 'none',
            fontWeight: 'normal'
        },
        activeDataLabelStyle: {
            color: 'black',
            textDecoration: 'none',
            fontWeight: 'normal'
        },
        series: [{
            name: "Anambra",
            id: "Anambra",
            "data": [["v65.0", 0.1], ["v64.0", 1.3], ["v63.0", 53.02], ["v62.0", 1.4], ["v61.0", 0.88], ["v60.0", 0.56], ["v59.0", 0.45], ["v58.0", 0.49], ["v57.0", 0.32], ["v56.0", 0.29], ["v55.0", 0.79], ["v54.0", 0.18], ["v51.0", 0.13], ["v49.0", 2.16], ["v48.0", 0.13], ["v47.0", 0.11], ["v43.0", 0.17], ["v29.0", 0.26]]
        }]
    }
};

var chart_options2 = {
    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                chart: {
                    height: 400
                }
            }
        }]
    },
    chart: {
        type: 'line',
        zoomType: 'xy',
        events: {
            load: ''
        }
    },
    colors: ["#2f7ed8", "orange", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
    title: {
        text: 'Loading...'
    },
    subtitle: {
        text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
    },
    credits: {
        enabled: false
    },
    xAxis: {
        type: 'category',
        categories: null,
        title: {
            text: 'x-axis title'
        },
        tickInterval: 1
    },
    yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        title: {
            text: 'y-axis title'
        },
        // minRange: 100,
        //softMax: 100,
        // pointStart: 100
        floor: 0,
        min: 0
    },
    legend: {
        enabled: true,
        backgroundColor: '#FCFFC5',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 3,
        layout: 'vertical',
        align: 'right',
        floating: true,
        title: {
            // text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
            // style: {
            //   fontWeight: 'normal'
            // }
        },
        itemStyle: {
            fontWeight: 'normal',
            fontSize: '13px'
        }
    },
    plotOptions: {
        series: {
            connectNulls: true,
            borderWidth: 0,
            dataLabels: {
                enabled: false,
                format: '{point.y:.1f}%'
            },
            cursor: 'pointer',
            dashStyle: "Solid",
            point: {},
            marker: {
                lineWidth: 1,
                radius: 3,
                symbol: "circle"
            },
            states: {
                hover: {
                    enabled: true,
                    lineWidth: 4
                    // lineWidthPlus: 5

                    // linkedTo: ':previous',
                    // pointWidth: 2
                    //   pointInterval: 2
                    // zones: []
                } } }
    },

    tooltip: {
        // backgroundColor: '#FCFFC5',
        // borderColor: 'black',
        // borderRadius: 10,
        // borderWidth: 3,
        // crosshairs: [true, true],
        // crosshairs: false,
        // shared: false,
        // followPointer: true,
        // positioner: function () {
        //     return { x: 80, y: 50 };
        // },
        useHTML: true,
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>'
        // pointFormat: '<span style="color:{point.color}">{point.key}</span>: <b>{point.y:.2f}</b> of total<br/>'
    },

    series: []
    //   drilldown: {
    //       series: [{
    //           name: 'Opera',
    //           id: 'Opera',
    //           data: [
    //             //  value
    //             // [
    //             //     'v12.x',
    //             //     0.34
    //             // ],
    //           ]
    //       }]
    //   }
};

var chart_options3 = {
    chart: {
        type: null
        // zoomType: 'xy'
    },
    title: {
        text: 'Loading...'
    },
    subtitle: {
        text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
    },
    credits: {
        enabled: false
    },
    xAxis: {
        type: 'category',
        categories: null,
        title: {
            text: 'x-axis title'
        }
    },
    yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        title: {
            text: 'y-axis title'
        }
    },
    legend: {
        enabled: true,
        backgroundColor: '#FCFFC5',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 3
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            dataLabels: {
                enabled: true,
                format: '{point.y:.1f}'
            },
            zones: []
        }
    },
    tooltip: {
        // backgroundColor: '#FCFFC5',
        // borderColor: 'black',
        // borderRadius: 10,
        // borderWidth: 3,
        // crosshairs: [true, true],
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}%</b> of total<br/>'
    },

    series: []
};
var chart_options4 = {
    chart: {
        type: null,
        // zoomType: 'xy'
        height: 300
    },
    title: {
        text: 'Loading...'
    },

    xAxis: {
        type: 'category',
        categories: ["Jan", "feb", "mar", "april", "may", "june", "july", "august", "sept", "oct", "nov", "dec"]
    },

    yAxis: {
        title: {
            text: null
        }
    },

    tooltip: {
        crosshairs: true,
        shared: true
    },

    plotOptions: {
        series: {
            fillOpacity: 0.1
        }
    },

    legend: {},

    series: []
};
var chart_options5 = {
    chart: {
        type: 'bar',
        zoomType: 'xy'
    },
    title: {
        text: 'Loading...'
    },
    subtitle: {
        text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
    },
    credits: {
        enabled: false
    },
    xAxis: {
        type: 'category',
        categories: null,
        title: {
            text: 'x-axis title'
        },
        labels: {
            style: {
                fontWeight: 'normal',
                color: '#686464'
            }
        }
    },
    yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        title: {
            text: 'y-axis title'
        }
    },
    legend: {
        enabled: true,
        backgroundColor: '#FCFFC5',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 3,
        title: {
            text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
            style: {
                fontWeight: 'normal'
            }
        }
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            point: {
                events: {
                    click: function click(e) {
                        // this.update({ pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>' }, true, false);
                        // this.tooltip.pointFormat = '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>'
                    }
                }
            },
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '{point.y:.1f}',
                style: {
                    fontWeight: 'normal'
                }
            },
            zones: []
        }
    },
    tooltip: {
        // backgroundColor: '#FCFFC5',
        // borderColor: 'black',
        // borderRadius: 10,
        // borderWidth: 3,
        // crosshairs: [true, true],
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>'
    },
    series: [],
    drilldown: {
        activeAxisLabelStyle: {
            color: 'black',
            textDecoration: 'none',
            fontWeight: 'normal'
        },
        activeDataLabelStyle: {
            color: 'black',
            textDecoration: 'none',
            fontWeight: 'normal'
        },
        series: [{
            name: "Anambra",
            id: "Anambra",
            "data": [["v65.0", 0.1], ["v64.0", 1.3], ["v63.0", 53.02], ["v62.0", 1.4], ["v61.0", 0.88], ["v60.0", 0.56], ["v59.0", 0.45], ["v58.0", 0.49], ["v57.0", 0.32], ["v56.0", 0.29], ["v55.0", 0.79], ["v54.0", 0.18], ["v51.0", 0.13], ["v49.0", 2.16], ["v48.0", 0.13], ["v47.0", 0.11], ["v43.0", 0.17], ["v29.0", 0.26]]
        }]
    }
};



/***/ }),

/***/ 827:
/***/ (function(module, exports) {

var map_data = [{
	"id": "NG.NE",
	"properties": { "hc-key": "ng-ne", "hasc": "NG.NE", "country": "Nigeria", "type-en": "Region", "type": "Region" },
	"name": "North-East",
	"path": "M707,-341C705,-344,702,-352,702,-358,702,-365,700,-368,693,-369,687,-369,686,-371,686,-377,685,-381,685,-382,675,-388,670,-391,665,-394,665,-394,664,-394,663,-391,663,-388,662,-385,661,-381,659,-379,657,-376,656,-376,646,-375,633,-374,629,-376,629,-383,629,-385,629,-387,628,-387,627,-387,622,-383,616,-378,610,-372,605,-370,602,-369,598,-368,598,-368,595,-358,592,-349,591,-347,588,-347,586,-346,586,-347,586,-348,587,-349,587,-356,588,-363,589,-370,590,-379,591,-384,594,-392,595,-394,600,-399,606,-405,607,-406,607,-412,608,-416,609,-421,609,-424,610,-430,607,-437,603,-439,601,-440,598,-442,597,-445,592,-451,582,-458,577,-460,570,-461,558,-461,550,-459,547,-458,544,-457,544,-458,543,-459,546,-463,549,-465,551,-466,555,-469,558,-472L564,-476,562,-483C559,-488,559,-495,560,-497,561,-497,564,-497,568,-496,577,-493,579,-493,582,-498,584,-502,585,-502,589,-501,599,-499,601,-499,605,-505,607,-507,611,-511,615,-514,619,-517,625,-522,629,-526,636,-534,636,-534,647,-537,653,-539,661,-541,665,-543L672,-546,671,-553C671,-556,670,-563,668,-567,667,-571,665,-579,664,-585,663,-590,662,-596,662,-597,661,-598,606,-628,604,-628,603,-628,602,-627,601,-625,599,-623,599,-622,600,-619,603,-614,603,-614,599,-613,598,-612,595,-609,594,-607,592,-602,589,-601,576,-601,564,-601,556,-604,552,-610,551,-612,549,-615,548,-616,545,-617,545,-618,548,-619,551,-620,551,-624,549,-633,547,-641,544,-643,537,-641,533,-639,532,-639,530,-641,529,-642,528,-643,529,-644,529,-645,529,-650,528,-655,527,-666,525,-668,517,-668,514,-668,512,-669,510,-672,508,-675,508,-676,509,-681,510,-684,512,-688,514,-691L518,-696,515,-701C514,-704,511,-708,510,-709,509,-711,508,-712,509,-713,509,-714,510,-718,510,-721,511,-727,511,-727,517,-730,521,-732,525,-735,529,-740,532,-744,535,-748,536,-748,536,-748,541,-749,546,-750,554,-752,554,-752,560,-750,565,-747,566,-747,571,-748,576,-749,576,-749,580,-745L583,-741,588,-742C591,-743,594,-744,595,-744,597,-745,601,-738,601,-734,601,-729,605,-722,609,-719,612,-717,613,-717,615,-719,617,-720,624,-721,627,-719,628,-719,629,-718,629,-717,629,-715,630,-714,630,-714,631,-714,632,-717,632,-721,632,-728,633,-729,638,-730,642,-731,648,-737,646,-739,645,-740,634,-743,629,-743,620,-743,608,-750,608,-755,608,-757,602,-764,600,-764,598,-764,598,-767,600,-771,602,-773,602,-774,600,-778,595,-786,595,-787,591,-784,584,-781,581,-786,586,-793,589,-795,590,-796,592,-795,594,-794,597,-794,605,-797,616,-800,626,-805,628,-807,628,-808,629,-813,629,-818,630,-824,632,-829,635,-836,639,-845,639,-845,644,-846,649,-846,650,-846,652,-844L654,-842,659,-845C664,-849,665,-852,661,-864,659,-871,658,-873,654,-875,649,-877,645,-878,644,-876,642,-872,633,-876,633,-880,633,-883,631,-883,618,-879,600,-874,600,-876,617,-884,623,-887,628,-890,628,-891,628,-893,605,-881,604,-879,602,-875,589,-872,587,-874,585,-875,595,-889,601,-894,605,-897,607,-899,607,-902,610,-904,608,-905,619,-910,629,-915,635,-916,653,-920,669,-923,676,-924,679,-923,682,-923,696,-923,711,-922,735,-922,738,-922,748,-919,759,-916,770,-911,779,-905,784,-901,787,-901,793,-903,795,-904,796,-904,798,-903,802,-901,813,-899,816,-901,818,-901,820,-904,822,-909,824,-916,824,-916,831,-920,842,-924,848,-930,847,-933,847,-936,847,-936,851,-936,854,-936,857,-937,858,-938,860,-939,863,-940,869,-940,878,-941,880,-942,880,-947,880,-949,882,-951,885,-953,890,-955,892,-955,900,-955L909,-955,917,-943C922,-937,928,-929,930,-926,932,-923,936,-918,939,-914,947,-904,948,-904,956,-868,957,-862,958,-854,959,-851,959,-846,960,-844,961,-843,966,-841,973,-841,976,-842,979,-843,980,-842,985,-839,987,-836,990,-833,991,-831,992,-829,994,-827,995,-827,999,-826,1000,-823,997,-820,995,-817,995,-815,996,-808,996,-801,996,-799,993,-794,990,-788,990,-788,992,-785,993,-783,995,-781,996,-781,997,-780,997,-778,996,-774,995,-769,995,-769,986,-764,981,-762,974,-757,970,-753,961,-747,960,-746,952,-749,944,-752,941,-750,936,-740,934,-736,931,-731,929,-730,926,-728,925,-726,925,-724,925,-723,922,-717,919,-712,916,-707,911,-700,909,-695,906,-687,902,-668,902,-662,902,-656,900,-654,895,-651,892,-649,890,-648,888,-649,885,-649,885,-649,885,-644,885,-640,884,-636,884,-635,882,-632,883,-631,884,-628,887,-623,887,-619,882,-614,877,-609,872,-606,869,-606,868,-606,867,-604,866,-603,865,-601,862,-598,860,-595,855,-591,855,-591,856,-584,857,-577,857,-576,854,-571,851,-566,850,-564,850,-556,850,-548,849,-543,848,-537,847,-536,846,-535,845,-535,843,-535,841,-533,838,-530,835,-523,832,-522,822,-522,819,-522,815,-522,815,-521,814,-520,814,-517,814,-514,815,-509,812,-507,807,-507L803,-507,802,-497C802,-491,801,-486,800,-485,798,-482,797,-477,799,-474,801,-469,800,-467,795,-463,790,-459,785,-448,785,-441,785,-437,785,-436,775,-424,769,-418,764,-413,764,-413,763,-413,762,-412,762,-410,762,-408,766,-405,773,-399L776,-397,773,-397C771,-397,769,-396,766,-392,763,-387,762,-387,758,-387,756,-387,754,-386,754,-385,754,-385,753,-382,751,-380,748,-376,747,-374,747,-369,747,-365,747,-362,746,-361,745,-361,744,-359,744,-358,743,-356,741,-354,739,-354,736,-353,735,-351,734,-348,732,-342,730,-341,718,-340,711,-339,708,-340,707,-341z"
}, {
	"id": "NG.NW",
	"properties": { "hc-key": "ng-nw", "hasc": "NG.NW", "country": "Nigeria", "type-en": "Region", "type": "Region" },
	"name": "North-West",
	"path": "M481,-564C475,-570,472,-572,469,-570,466,-570,463,-567,462,-564,460,-557,456,-559,456,-567,456,-571,455,-575,453,-575,451,-576,449,-579,448,-581,446,-587,440,-587,435,-582,431,-579,430,-579,421,-583,412,-588,411,-588,406,-585,399,-579,391,-580,388,-586,386,-589,386,-592,390,-598,395,-604,395,-606,392,-611,391,-615,389,-623,389,-629L389,-641,375,-642C359,-643,356,-647,365,-655,372,-661,373,-665,369,-667,368,-668,364,-674,361,-681,356,-692,354,-694,349,-694,346,-694,343,-693,343,-692,343,-689,333,-688,328,-690,322,-694,312,-689,306,-679,300,-671,300,-671,295,-675,292,-678,291,-680,292,-687,293,-691,294,-698,294,-702,294,-706,295,-710,296,-712,298,-714,297,-718,290,-726L281,-736,275,-732C272,-729,263,-726,256,-724,242,-720,237,-722,237,-730,237,-733,235,-738,234,-740,232,-743,230,-746,230,-749,230,-751,228,-753,225,-754,217,-756,178,-745,178,-741,178,-737,185,-732,194,-730,204,-727,208,-721,202,-716,199,-714,199,-713,203,-708,207,-704,207,-704,201,-701,198,-700,193,-700,190,-700,186,-701,185,-700,184,-693,183,-688,183,-682,185,-678,189,-668,186,-662,178,-660,174,-659,170,-657,169,-655,169,-653,167,-652,165,-652,163,-652,162,-657,160,-667,159,-681,159,-683,164,-687,167,-689,171,-692,171,-692,172,-692,174,-695,174,-699L177,-713C178,-718,178,-720,175,-720,173,-720,169,-722,166,-725,161,-729,159,-730,140,-728,120,-727,119,-727,111,-733,105,-737,101,-739,97,-738,91,-736,88,-738,81,-750,72,-764,72,-773,82,-782,89,-790,90,-791,87,-796,85,-800,85,-802,88,-805,91,-809,92,-814,91,-827,91,-836,90,-846,90,-850,88,-855,90,-857,100,-864,107,-868,114,-876,120,-885,128,-898,129,-900,129,-917,130,-933,130,-934,135,-934,138,-934,143,-937,146,-940,154,-949,162,-953,169,-953,173,-953,179,-955,184,-957,191,-960,192,-960,193,-957,194,-954,199,-953,209,-953,221,-953,224,-954,229,-959,232,-963,236,-965,243,-965,250,-965,271,-957,287,-948,289,-947,294,-946,297,-946,312,-946,323,-938,339,-914,357,-888,366,-884,378,-896,383,-902,385,-902,391,-899,398,-897,400,-898,414,-907,437,-922,447,-923,467,-907,475,-901,484,-897,487,-897,491,-897,495,-895,497,-891,504,-881,515,-878,556,-874,594,-871,596,-871,612,-876,628,-880,629,-880,632,-876,634,-873,637,-873,642,-874,651,-876,658,-870,660,-859,662,-849,659,-846,647,-847,639,-848,638,-847,633,-839,631,-834,628,-825,627,-819,626,-808,625,-807,613,-802,607,-799,598,-797,594,-797,586,-797,581,-792,581,-785,581,-781,582,-781,588,-782,596,-784,601,-777,598,-770,595,-765,597,-760,601,-760,603,-760,605,-757,607,-754,611,-746,623,-739,635,-739,644,-739,645,-738,642,-735,641,-733,638,-732,636,-732,635,-732,632,-730,630,-727,626,-722,611,-719,607,-723,606,-725,604,-729,603,-733,600,-746,598,-748,591,-746,587,-744,584,-744,581,-747,579,-749,574,-751,570,-751,565,-751,560,-752,558,-753,551,-756,534,-750,527,-741,524,-737,518,-733,515,-731,506,-727,504,-712,511,-703,516,-697,516,-696,512,-692,507,-686,505,-676,508,-672,510,-669,510,-667,506,-660,503,-655,501,-644,500,-633,499,-622,497,-613,494,-611,490,-606,492,-594,499,-586L504,-581,499,-569C496,-563,492,-557,491,-557,489,-556,485,-559,481,-564z"
}, {
	"id": "NG.SW",
	"properties": { "hc-key": "ng-sw", "hasc": "NG.SW", "country": "Nigeria", "type-en": "Region", "type": "Region" },
	"name": "South-West",
	"path": "M181,-309C154,-337,135,-342,56,-339L1,-337,2,-350C3,-357,5,-364,7,-364,9,-366,9,-368,7,-372,3,-379,3,-388,6,-392,8,-394,8,-396,6,-398,5,-400,4,-402,6,-403,7,-403,7,-409,7,-415,6,-423,6,-426,9,-428,11,-430,11,-431,9,-435,7,-438,5,-445,6,-451,6,-458,5,-461,3,-462,0,-463,0,-466,2,-474,3,-480,5,-487,6,-489,7,-491,7,-495,6,-497,2,-506,3,-515,9,-518,11,-520,15,-521,17,-520,19,-520,25,-523,32,-529,41,-537,45,-538,49,-537,54,-536,57,-537,63,-542,67,-545,76,-550,83,-552,92,-556,95,-557,96,-563,97,-572,101,-573,107,-565,113,-557,129,-552,136,-555,139,-557,140,-557,140,-554,140,-550,133,-543,129,-543,118,-543,149,-479,163,-474,165,-473,172,-474,178,-475,188,-477,191,-477,192,-474,194,-473,198,-471,203,-471,208,-471,215,-470,219,-469,224,-468,226,-468,228,-471,230,-475,238,-476,240,-473,241,-472,244,-471,246,-472,250,-473,250,-472,249,-466,249,-460,250,-458,256,-454,260,-451,265,-449,267,-450,270,-451,273,-450,276,-446,280,-438,280,-432,276,-432,273,-432,272,-431,274,-423,274,-418,274,-414,273,-414,270,-414,260,-390,261,-385,263,-379,258,-372,248,-368,239,-363,239,-363,240,-369,242,-377,238,-381,225,-381,217,-381,213,-379,209,-375,203,-369,203,-365,204,-347,204,-344,202,-340,199,-337,193,-330,193,-328,200,-322L206,-316,201,-306C198,-300,195,-296,195,-296,194,-296,188,-302,181,-309z"
}, {
	"id": "NG.NC",
	"properties": { "hc-key": "ng-nc", "hasc": "NG.NC", "country": "Nigeria", "type-en": "Region", "type": "Region" },
	"name": "North-Central",
	"path": "M564,-352C554,-364,554,-364,543,-363,533,-361,532,-361,528,-368,525,-375,516,-381,508,-381,506,-381,502,-377,500,-373,496,-367,495,-366,489,-367,484,-368,480,-368,477,-365,474,-362,473,-362,470,-365,469,-367,466,-369,465,-369,460,-369,444,-361,444,-358,444,-356,442,-355,440,-355,436,-355,435,-356,437,-362,438,-371,433,-378,424,-376,417,-375,411,-381,411,-389,411,-394,407,-397,400,-397,398,-397,389,-391,381,-384,368,-373,365,-372,364,-375,362,-378,360,-377,355,-368,351,-363,348,-356,348,-354,348,-351,346,-350,342,-350,336,-350,336,-351,336,-362,336,-369,338,-380,340,-388,343,-403,343,-403,338,-407,335,-409,331,-411,328,-411,326,-411,323,-413,321,-416,320,-419,316,-421,312,-421,309,-421,305,-422,304,-424,303,-427,301,-428,297,-427,293,-426,291,-426,291,-429,291,-431,289,-433,286,-434,284,-434,282,-436,282,-438,282,-440,280,-444,277,-447,273,-452,271,-453,267,-452,260,-451,251,-460,252,-469,252,-475,252,-475,241,-476,233,-477,229,-476,226,-473,223,-470,221,-470,217,-472,215,-473,209,-474,204,-474,200,-475,195,-476,193,-477,191,-479,187,-479,180,-478,166,-476,164,-476,155,-486,147,-495,129,-529,129,-536,129,-538,132,-542,137,-545,143,-549,144,-551,143,-555,142,-559,141,-559,137,-558,130,-556,131,-556,122,-558,118,-559,112,-563,110,-567,102,-578,95,-576,93,-563,92,-560,88,-557,82,-554,76,-552,67,-548,62,-544,55,-539,52,-538,49,-540,45,-542,42,-541,32,-532,25,-526,19,-523,18,-524,18,-526,16,-526,13,-524,9,-522,8,-523,9,-540,9,-563,10,-566,20,-566,35,-566,36,-567,40,-574,43,-580,44,-585,42,-592,41,-600,42,-602,46,-604,49,-606,51,-609,51,-610,51,-612,53,-614,56,-614,60,-614,60,-615,59,-620,57,-627,60,-630,69,-630,76,-630,81,-636,81,-643,81,-646,83,-650,84,-651,87,-653,86,-656,83,-661,79,-667,79,-669,82,-673,84,-676,89,-679,91,-679,96,-679,98,-681,100,-689,103,-697,103,-699,100,-703,98,-705,96,-713,95,-720,94,-737,97,-738,110,-730,119,-724,121,-724,139,-726,157,-727,159,-727,167,-722,174,-717,175,-716,173,-706,172,-698,169,-694,164,-689,156,-683,156,-683,158,-667,159,-656,161,-651,164,-649,170,-646,171,-646,171,-650,171,-652,175,-655,179,-657,188,-661,192,-669,187,-678,184,-684,186,-700,190,-697,192,-696,197,-697,202,-699L211,-702,206,-707C202,-712,202,-713,205,-715,208,-716,209,-718,207,-723,206,-728,204,-730,196,-732,190,-733,184,-736,183,-738,180,-741,184,-743,206,-749,220,-753,228,-752,228,-746,228,-743,229,-741,230,-741,231,-741,232,-738,232,-735,232,-731,234,-726,237,-723L241,-717,258,-722C268,-725,277,-729,279,-730,281,-732,283,-731,285,-728,292,-719,293,-716,291,-697,288,-678,289,-677,294,-671L300,-666,307,-676C316,-689,321,-691,327,-687,331,-684,345,-686,345,-690,345,-691,347,-692,349,-692,353,-692,362,-678,362,-672,362,-670,364,-667,366,-666,370,-664,369,-663,362,-656,352,-645,355,-640,374,-639,386,-639,387,-638,387,-632,388,-627,387,-624,384,-622,381,-619,381,-619,384,-616,392,-610,393,-605,387,-598,382,-591,382,-589,384,-584,386,-580,388,-579,394,-579,399,-579,404,-580,407,-581,411,-583,414,-583,423,-580,433,-576,434,-576,436,-579,440,-585,442,-584,448,-577,452,-573,454,-568,454,-563,454,-554,456,-553,462,-560,470,-570,472,-570,481,-561,488,-553,489,-552,493,-555,497,-559,506,-575,506,-580,506,-582,504,-585,501,-588,496,-593,494,-609,499,-613,500,-614,502,-623,502,-633,504,-652,509,-664,517,-665,523,-666,528,-658,526,-649,525,-641,529,-636,537,-638,542,-639,544,-639,546,-635,549,-629,549,-622,544,-620,541,-619,541,-618,547,-613,550,-610,553,-606,553,-605,553,-601,572,-597,582,-599,594,-601,605,-611,603,-620,602,-623,603,-626,604,-626,604,-626,617,-619,632,-611,654,-600,659,-596,660,-591,661,-587,663,-577,666,-568,670,-548,669,-546,649,-540,639,-537,632,-533,626,-527,603,-505,599,-502,591,-503,586,-503,582,-502,580,-499,578,-496,576,-496,569,-498,562,-500,561,-500,558,-497,556,-494,556,-491,559,-485,562,-477,562,-477,553,-471,540,-462,536,-450,548,-456,555,-459,573,-459,581,-455,584,-453,592,-447,597,-441,607,-431,608,-430,606,-419,605,-411,602,-405,599,-402,592,-395,586,-377,586,-363,586,-353,582,-343,578,-341,576,-341,570,-346,564,-352z"
}, {
	"id": "NG.SS",
	"properties": { "hc-key": "ng-ss", "hasc": "NG.SS", "country": "Nigeria", "type-en": "Region", "type": "Region" },
	"name": "South-South",
	"path": "M272,-168C260,-175,244,-189,244,-193,244,-195,242,-199,240,-202,237,-205,232,-217,229,-229,225,-240,220,-252,217,-256,214,-259,211,-263,211,-265,211,-266,209,-271,206,-274,204,-277,202,-281,202,-283,202,-285,201,-286,199,-286,195,-286,197,-292,203,-304L209,-315,203,-321C197,-328,195,-333,199,-333,200,-333,202,-336,205,-340,208,-346,208,-349,206,-353,205,-358,205,-362,207,-368,211,-376,217,-379,230,-378,237,-377,238,-376,238,-371,237,-363,243,-357,245,-363,246,-365,249,-366,251,-366,257,-366,266,-380,264,-385,262,-389,272,-411,276,-411,278,-411,278,-414,277,-420,275,-430,275,-429,279,-430,286,-431,289,-430,289,-426,289,-423,290,-423,295,-424,298,-424,302,-423,303,-421,305,-420,308,-418,311,-418,315,-418,318,-416,319,-414,321,-411,324,-409,327,-409,330,-409,334,-407,336,-406,340,-403,340,-401,337,-390,332,-372,333,-351,338,-334,342,-320,342,-319,338,-306,335,-298,332,-291,331,-290,330,-289,329,-281,328,-274,327,-261,327,-261,333,-259,337,-258,338,-256,338,-250,338,-238,348,-232,367,-232,378,-232,381,-231,381,-228,381,-222,394,-213,400,-214,406,-216,409,-222,410,-234,410,-241,411,-244,414,-245,417,-246,418,-249,418,-255,418,-265,423,-265,431,-256,437,-249,445,-246,448,-251,449,-252,447,-256,444,-261,442,-265,440,-270,440,-273,440,-280,452,-296,460,-299,469,-303,482,-322,482,-330,482,-333,483,-336,485,-336,487,-337,486,-341,481,-349,473,-362,475,-365,489,-364,496,-364,498,-365,502,-371,504,-375,508,-378,510,-378,516,-378,526,-370,528,-364,529,-360,531,-359,541,-360,554,-361,560,-357,567,-347,572,-339,571,-331,566,-331,565,-331,560,-327,555,-323,551,-318,545,-313,542,-311,539,-309,534,-303,532,-297,529,-292,524,-286,522,-284,517,-280,517,-279,521,-276,525,-271,525,-270,521,-261,519,-257,517,-251,517,-246,517,-240,514,-232,506,-218,499,-207,494,-198,494,-197,494,-193,492,-194,482,-200,472,-207,471,-205,476,-194,479,-188,479,-187,476,-185,474,-183,466,-181,459,-181,435,-180,415,-178,414,-176,413,-175,407,-173,401,-172,394,-172,386,-170,382,-169,376,-168,376,-168,377,-172,378,-175,377,-175,373,-175,370,-175,366,-174,366,-172,365,-169,362,-168,357,-170,353,-170,350,-170,350,-169,350,-167,310,-161,294,-161,286,-161,279,-163,272,-168z"
}, {
	"id": "NG.SE",
	"properties": { "hc-key": "ng-se", "hasc": "NG.SE", "country": "Nigeria", "type-en": "Region", "type": "Region" },
	"name": "South-East",
	"path": "M391,-221C388,-224,386,-228,385,-231,384,-235,383,-236,369,-235,349,-234,341,-239,341,-252,341,-259,340,-261,335,-262,330,-263,329,-264,330,-267,331,-269,332,-275,332,-279,332,-284,333,-289,335,-291,337,-293,339,-298,340,-302,340,-305,342,-311,344,-314,345,-318,345,-322,342,-330,337,-345,337,-348,344,-348,349,-348,350,-349,350,-353,350,-356,353,-362,356,-366,359,-371,362,-373,362,-372,362,-367,366,-368,379,-379,385,-384,393,-390,395,-392,400,-396,409,-393,408,-389,405,-383,416,-374,425,-373,434,-372,434,-372,433,-362,433,-353,433,-352,440,-352,444,-352,447,-353,447,-355,447,-357,451,-360,456,-363,465,-367,470,-366,470,-362,470,-360,474,-355,477,-349,484,-341,484,-339,481,-336,479,-334,477,-330,477,-328,477,-320,467,-305,458,-301,453,-299,449,-296,448,-293,447,-291,445,-287,442,-285,436,-280,436,-268,441,-262,443,-259,444,-256,444,-254,444,-248,438,-251,433,-258,429,-263,426,-265,422,-265,417,-265,416,-264,416,-257,416,-251,415,-248,411,-247,408,-246,407,-244,407,-236,407,-227,402,-216,398,-216,397,-216,394,-218,391,-221z"
}];

module.exports = map_data;

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

// function to sort an object by its value property
function str_limit(str_value, number) {

    if (typeof number !== 'number') throw 'enter a number type for: ' + number;

    if (typeof str_value !== 'string') throw 'enter a string type for: ' + str_value;

    if (str_value.length <= number) return str_value;
    return str_value.substr(0, number) + ' ...';
}

module.exports = str_limit;

/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "tableModal",
  props: ["src", "sourceMetaData"],

  data: function data() {
    return {
      isSourceMetaModalActive: false,
      sourceInfo: {},
      firstLink: [],
      linkFirst: ''
    };
  },

  methods: {
    switchIt: function switchIt() {
      this.isSourceMetaModalActive = false;
      this.$emit('switchOff');
    },
    viewSourceMetadata: function viewSourceMetadata(theSource) {

      for (var i = 0; i < this.sourceMetaData.length; i++) {
        if (theSource == this.sourceMetaData[i][0]) {
          this.sourceInfo.name = this.sourceMetaData[i][0];
          this.sourceInfo.fullName = this.sourceMetaData[i][1];
          this.sourceInfo.description = this.sourceMetaData[i][2];
          this.sourceInfo.available = this.sourceMetaData[i][3];
          this.sourceInfo.nextAvailable = this.sourceMetaData[i][4];
          this.sourceInfo.links = this.sourceMetaData[i][5].replace(/\s+/g, '').split(',');
          // this.sourceInfo.links = this.sourceMetaData[i][5];
          this.sourceInfo.method = this.sourceMetaData[i][6];
          this.sourceInfo.subNatVal = this.sourceMetaData[i][7];
          // console.log(this.sourceMetaData[i][5]);

          var check1 = this.sourceMetaData[i][5];
          var check2 = check1.split(', ');

          // console.log(check2);

          // var check3 = check2.split(' ');

          this.firstLink = check2;
          this.linkFirst = this.firstLink;
          // console.log(this.firstLink);

        }
      }

      this.isSourceMetaModalActive = !this.isSourceMetaModalActive;
    }
  },

  mounted: function mounted() {
    //console.log(this.src);
    this.viewSourceMetadata(this.src);
    //console.log(this.src);
  }
});

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(833);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(65);
var gOPS = __webpack_require__(138);
var pIE = __webpack_require__(90);
var toObject = __webpack_require__(92);
var IObject = __webpack_require__(420);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(43)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(17);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(832) });


/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

__webpack_require__(418);
var firebase = _interopDefault(__webpack_require__(25));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = firebase;


/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firestore__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_firestore__);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(838),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(957),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 838:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "active": _vm.isSourceMetaModalActive,
      "has-modal-card": "",
      "onCancel": this.switchIt
    },
    on: {
      "update:active": function($event) {
        _vm.isSourceMetaModalActive = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_c('b', [_vm._v("DATA SOURCE: ")]), _vm._v(" " + _vm._s(this.sourceInfo.name))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "tabs is-boxed is-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("FULL NAME")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceInfo.fullName))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceInfo.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading col-xs-6"
  }, [_vm._v("YEARS WITH AVAILABLE DATA")]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading col-xs-6"
  }, [_vm._v("NEXT AVAILABLE DATA")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v(_vm._s(this.sourceInfo.available))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v(_vm._s(this.sourceInfo.nextAvailable))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("LINKS")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.firstLink), function(firstLink) {
    return _c('span', {
      key: firstLink
    }, [_c('a', {
      attrs: {
        "href": firstLink.trim().split(' ')[1],
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(firstLink.trim().split(' ')[0])), _c('br')])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("METHODOLOGY")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceInfo.method))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("SUB-NATIONAL DATA AVAILABLE")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceInfo.subNatVal))])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.switchIt
    }
  }, [_vm._v("CLOSE")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

var mapData = { "title": "Nigeria", "version": "1.1.2", "type": "FeatureCollection", "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth", "copyrightShort": "Natural Earth", "copyrightUrl": "http://www.naturalearthdata.com", "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG:26392" } }, "hc-transform": { "default": { "crs": "+proj=tmerc +lat_0=4 +lon_0=8.5 +k=0.99975 +x_0=670553.98 +y_0=0 +ellps=clrk80 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs", "scale": 0.000531855453682, "jsonres": 15.5, "jsonmarginX": -999, "jsonmarginY": 9851.0, "xoffset": 27017.6170862, "yoffset": 1093650.26339 } },
  "features": [{ "type": "Feature", "id": "NG.RI", "properties": { "hc-group": "admin1", "hc-middle-x": 0.36, "hc-middle-y": 0.55, "hc-key": "ng-ri", "hc-a2": "RI", "labelrank": "3", "hasc": "NG.RI", "alt-name": null, "woe-id": "2346344", "subregion": null, "fips": "NI50", "postal-code": "RI", "name": "Rivers", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "6.81969", "woe-name": "Rivers", "latitude": "4.9979", "woe-label": "Rivers, NG, Nigeria", "type": "State" }, "geometry": { "type": "MultiPolygon", "coordinates": [[[[3348, 1269], [3469, 1277], [3456, 1254], [3346, 1233], [3262, 1236], [3251, 1271], [3305, 1289], [3348, 1269]]], [[[3171, 1289], [3239, 1284], [3216, 1222], [3101, 1184], [3061, 1198], [3137, 1297], [3171, 1289]]], [[[3166, 1924], [3179, 1847], [3085, 1703], [3097, 1632], [3134, 1620], [3245, 1636], [3328, 1621], [3389, 1580], [3416, 1532], [3423, 1476], [3421, 1410], [3421, 1383], [3350, 1339], [3220, 1389], [3176, 1358], [3235, 1324], [3192, 1296], [3109, 1393], [3099, 1445], [3060, 1439], [3001, 1527], [3025, 1439], [3070, 1419], [3098, 1293], [3038, 1247], [2975, 1234], [2937, 1364], [2956, 1396], [2938, 1490], [2895, 1459], [2925, 1390], [2912, 1278], [2956, 1199], [2907, 1177], [2807, 1215], [2773, 1308], [2794, 1409], [2755, 1429], [2706, 1597], [2675, 1597], [2727, 1441], [2775, 1384], [2748, 1347], [2786, 1194], [2816, 1165], [2728, 1145], [2674, 1160], [2681, 1376], [2615, 1423], [2594, 1486], [2537, 1522], [2433, 1491], [2421, 1547], [2373, 1583], [2374, 1620], [2431, 1729], [2417, 1808], [2470, 1933], [2589, 2059], [2558, 2099], [2473, 2107], [2458, 2147], [2527, 2217], [2577, 2408], [2605, 2384], [2635, 2381], [2595, 2206], [2667, 2192], [2704, 2152], [2684, 2026], [2817, 1926], [2946, 1916], [3166, 1924]]]] } }, { "type": "Feature", "id": "NG.KT", "properties": { "hc-group": "admin1", "hc-middle-x": 0.38, "hc-middle-y": 0.34, "hc-key": "ng-kt", "hc-a2": "KT", "labelrank": "7", "hasc": "NG.KT", "alt-name": null, "woe-id": "2346352", "subregion": null, "fips": "NI24", "postal-code": "KT", "name": "Katsina", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.58609", "woe-name": "Katsina", "latitude": "12.5056", "woe-label": "Katsina, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[3022, 9038], [3143, 9148], [3256, 9135], [3317, 9143], [3642, 9338], [3703, 9354], [3930, 9321], [4080, 9232], [4215, 9107], [4337, 9097], [4467, 8969], [4734, 8896], [4678, 8811], [4595, 8756], [4511, 8748], [4396, 8779], [4339, 8883], [4078, 8883], [3982, 8869], [3964, 8725], [4011, 8696], [4082, 8694], [4112, 8646], [4027, 8633], [3976, 8507], [3943, 8476], [3785, 8417], [3716, 8370], [3708, 8049], [3725, 7927], [3762, 7809], [3630, 7764], [3601, 7730], [3580, 7642], [3594, 7596], [3656, 7543], [3624, 7496], [3551, 7466], [3443, 7540], [3377, 7553], [3321, 7520], [3300, 7458], [3175, 7458], [3176, 7359], [3124, 7320], [3048, 7373], [2950, 7410], [2988, 7473], [2962, 7525], [2851, 7553], [2877, 7698], [2846, 7754], [2881, 7918], [2934, 7942], [3019, 7929], [3093, 7986], [3114, 8031], [3169, 8034], [3159, 8088], [3062, 8165], [3102, 8270], [3071, 8417], [3047, 8465], [3033, 8566], [3006, 8942], [3022, 9038]]] } }, { "type": "Feature", "id": "NG.SO", "properties": { "hc-group": "admin1", "hc-middle-x": 0.48, "hc-middle-y": 0.27, "hc-key": "ng-so", "hc-a2": "SO", "labelrank": "7", "hasc": "NG.SO", "alt-name": null, "woe-id": "2346361", "subregion": null, "fips": "NI51", "postal-code": "SO", "name": "Sokoto", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "5.4366", "woe-name": "Sokoto", "latitude": "13.0603", "woe-label": "Sokoto, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[391, 9265], [400, 9504], [510, 9522], [653, 9654], [744, 9701], [1058, 9769], [1118, 9730], [1430, 9744], [1521, 9836], [1682, 9851], [2184, 9645], [2282, 9667], [2406, 9618], [2530, 9498], [2675, 9337], [2746, 9203], [2632, 9129], [2544, 9129], [2457, 9151], [2429, 9182], [2335, 9196], [2306, 9100], [2183, 9101], [2116, 9044], [2130, 8888], [2103, 8838], [2038, 8815], [1836, 8798], [1790, 8763], [1708, 8651], [1666, 8622], [1660, 8562], [1680, 8423], [1634, 8377], [1360, 8368], [1228, 8392], [1193, 8283], [1181, 7855], [1048, 7867], [875, 7792], [804, 7730], [735, 7777], [744, 7864], [785, 7949], [817, 8091], [816, 8442], [849, 8499], [914, 8514], [975, 8493], [1015, 8513], [1020, 8582], [995, 8730], [1017, 8864], [968, 8973], [1014, 9160], [976, 9172], [945, 9127], [883, 9114], [821, 9151], [697, 9195], [589, 9277], [525, 9257], [391, 9265]]] } }, { "type": "Feature", "id": "NG.ZA", "properties": { "hc-group": "admin1", "hc-middle-x": 0.58, "hc-middle-y": 0.45, "hc-key": "ng-za", "hc-a2": "ZA", "labelrank": "3", "hasc": "NG.ZA", "alt-name": null, "woe-id": "20070150", "subregion": null, "fips": "NI57", "postal-code": "ZA", "name": "Zamfara", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "6.12834", "woe-name": "Zamfara", "latitude": "12.0084", "woe-label": "Zamfara, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[1181, 7855], [1193, 8283], [1228, 8392], [1360, 8368], [1634, 8377], [1680, 8423], [1660, 8562], [1666, 8622], [1708, 8651], [1790, 8763], [1836, 8798], [2038, 8815], [2103, 8838], [2130, 8888], [2116, 9044], [2183, 9101], [2306, 9100], [2335, 9196], [2429, 9182], [2457, 9151], [2544, 9129], [2632, 9129], [2746, 9203], [2821, 9101], [2882, 9049], [3022, 9038], [3006, 8942], [3033, 8566], [3047, 8465], [3071, 8417], [3102, 8270], [3062, 8165], [3159, 8088], [3169, 8034], [3114, 8031], [3093, 7986], [3019, 7929], [2934, 7942], [2881, 7918], [2846, 7754], [2877, 7698], [2851, 7553], [2754, 7469], [2708, 7336], [2657, 7280], [2482, 7230], [2364, 7258], [2259, 7159], [2254, 7123], [2199, 7098], [2186, 7159], [2080, 7326], [2073, 7465], [2005, 7575], [1953, 7617], [1981, 7748], [1939, 7790], [1838, 7813], [1672, 7794], [1541, 7841], [1507, 7885], [1396, 7888], [1373, 7851], [1288, 7830], [1181, 7855]]] } }, { "type": "Feature", "id": "NG.YO", "properties": { "hc-group": "admin1", "hc-middle-x": 0.69, "hc-middle-y": 0.52, "hc-key": "ng-yo", "hc-a2": "YO", "labelrank": "3", "hasc": "NG.YO", "alt-name": null, "woe-id": "2346372", "subregion": null, "fips": "NI44", "postal-code": "YO", "name": "Yobe", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "11.5881", "woe-name": "Yobe", "latitude": "12.3156", "woe-label": "Yobe, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[5334, 8886], [5486, 9068], [5551, 9111], [5585, 9175], [5791, 9287], [6249, 9389], [6335, 9397], [6497, 9379], [6933, 9386], [7204, 9321], [7303, 9282], [7488, 9167], [7541, 9155], [7617, 9177], [7729, 9136], [7783, 9137], [7765, 8960], [7782, 8902], [7871, 8823], [7879, 8767], [7819, 8656], [7721, 8561], [7742, 8425], [7705, 8117], [7723, 7985], [7666, 7842], [7757, 7828], [7805, 7733], [7715, 7619], [7636, 7495], [7638, 7341], [7611, 7278], [7555, 7235], [7343, 7158], [7293, 7101], [7279, 6920], [7195, 6860], [7098, 6862], [7083, 6954], [7092, 7164], [7067, 7219], [6877, 7424], [6819, 7468], [6694, 7527], [6570, 7493], [6502, 7531], [6532, 7672], [6526, 7749], [6416, 8014], [6387, 8160], [6380, 8263], [6343, 8327], [6310, 8502], [6197, 8592], [6160, 8780], [6107, 8857], [5982, 8880], [5884, 8868], [5851, 8982], [5791, 9029], [5623, 8972], [5545, 8934], [5521, 8886], [5443, 8852], [5334, 8886]]] } }, { "type": "Feature", "id": "NG.KE", "properties": { "hc-group": "admin1", "hc-middle-x": 0.26, "hc-middle-y": 0.35, "hc-key": "ng-ke", "hc-a2": "KE", "labelrank": "3", "hasc": "NG.KE", "alt-name": null, "woe-id": "2346368", "subregion": null, "fips": "NI40", "postal-code": "KE", "name": "Kebbi", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "4.06548", "woe-name": "Kebbi", "latitude": "11.7712", "woe-label": "Kebbi, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[1181, 7855], [1288, 7830], [1373, 7851], [1396, 7888], [1507, 7885], [1541, 7841], [1672, 7794], [1838, 7813], [1939, 7790], [1981, 7748], [1953, 7617], [2005, 7575], [2073, 7465], [2080, 7326], [2020, 7342], [1951, 7274], [1889, 7264], [1732, 7199], [1582, 7190], [1547, 7230], [1552, 7336], [1478, 7444], [1466, 7512], [1413, 7545], [1348, 7548], [1081, 7497], [956, 7443], [941, 7386], [1062, 7314], [1158, 7295], [1202, 7263], [1222, 7163], [1178, 7109], [1234, 7002], [1084, 6937], [993, 6937], [977, 6876], [981, 6745], [1050, 6627], [1027, 6567], [970, 6539], [832, 6507], [810, 6415], [727, 6439], [748, 6572], [705, 6612], [695, 6746], [730, 6804], [836, 6862], [868, 6913], [901, 7149], [843, 7167], [734, 7240], [643, 7266], [549, 7253], [255, 7256], [75, 7356], [-15, 7360], [-53, 7381], [-211, 7612], [-225, 7658], [-189, 7762], [-124, 7867], [-40, 7945], [-90, 8027], [-94, 8079], [-48, 8153], [-73, 8252], [-45, 8411], [-46, 8649], [153, 8792], [212, 8847], [359, 9069], [391, 9265], [525, 9257], [589, 9277], [697, 9195], [821, 9151], [883, 9114], [945, 9127], [976, 9172], [1014, 9160], [968, 8973], [1017, 8864], [995, 8730], [1020, 8582], [1015, 8513], [975, 8493], [914, 8514], [849, 8499], [816, 8442], [817, 8091], [785, 7949], [744, 7864], [735, 7777], [804, 7730], [875, 7792], [1048, 7867], [1181, 7855]]] } }, { "type": "Feature", "id": "NG.AD", "properties": { "hc-group": "admin1", "hc-middle-x": 0.44, "hc-middle-y": 0.38, "hc-key": "ng-ad", "hc-a2": "AD", "labelrank": "3", "hasc": "NG.AD", "alt-name": null, "woe-id": "2346363", "subregion": null, "fips": "NI35", "postal-code": "AD", "name": "Adamawa", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "12.5768", "woe-name": "Adamawa", "latitude": "9.479060000000001", "woe-label": "Adamawa, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[9043, 7204], [8881, 6960], [8824, 6792], [8769, 6477], [8702, 6428], [8601, 6407], [8601, 6310], [8572, 6215], [8618, 6153], [8585, 5980], [8560, 5915], [8368, 5851], [8259, 5765], [8294, 5692], [8285, 5623], [8226, 5503], [8233, 5433], [8214, 5261], [8185, 5194], [8137, 5191], [8084, 5102], [7991, 5052], [7922, 5067], [7819, 5054], [7852, 4951], [7797, 4892], [7713, 4878], [7692, 4848], [7703, 4694], [7659, 4603], [7669, 4473], [7541, 4297], [7500, 4198], [7515, 4126], [7405, 3994], [7370, 4089], [7357, 4211], [7313, 4316], [7201, 4425], [7140, 4426], [7078, 4353], [7049, 4355], [6987, 4446], [6946, 4543], [6955, 4571], [7063, 4683], [7296, 4966], [7356, 5017], [7366, 5144], [7455, 5333], [7449, 5396], [7353, 5469], [7321, 5522], [7325, 5586], [7267, 5706], [7214, 5753], [7131, 5787], [7046, 5943], [7129, 5958], [7205, 5992], [7372, 6094], [7419, 6160], [7422, 6360], [7568, 6354], [7682, 6436], [7774, 6559], [7825, 6603], [7964, 6627], [8029, 6657], [8070, 6718], [8126, 6737], [8226, 6844], [8300, 6862], [8440, 6827], [8544, 6750], [8606, 6737], [8651, 6763], [8682, 6885], [8730, 7009], [8746, 7188], [8859, 7168], [9043, 7204]]] } }, { "type": "Feature", "id": "NG.BO", "properties": { "hc-group": "admin1", "hc-middle-x": 0.55, "hc-middle-y": 0.43, "hc-key": "ng-bo", "hc-a2": "BO", "labelrank": "3", "hasc": "NG.BO", "alt-name": null, "woe-id": "2346355", "subregion": null, "fips": "NI27", "postal-code": "BO", "name": "Borno", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "13.1533", "woe-name": "Borno", "latitude": "12.0019", "woe-label": "Borno, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[9043, 7204], [8859, 7168], [8746, 7188], [8730, 7009], [8682, 6885], [8651, 6763], [8606, 6737], [8544, 6750], [8440, 6827], [8300, 6862], [8226, 6844], [8126, 6737], [8070, 6718], [8029, 6657], [7964, 6627], [7825, 6603], [7774, 6559], [7682, 6436], [7568, 6354], [7422, 6360], [7357, 6400], [7295, 6498], [7188, 6558], [7140, 6632], [7142, 6672], [7207, 6780], [7195, 6860], [7279, 6920], [7293, 7101], [7343, 7158], [7555, 7235], [7611, 7278], [7638, 7341], [7636, 7495], [7715, 7619], [7805, 7733], [7757, 7828], [7666, 7842], [7723, 7985], [7705, 8117], [7742, 8425], [7721, 8561], [7819, 8656], [7879, 8767], [7871, 8823], [7782, 8902], [7765, 8960], [7783, 9137], [7860, 9125], [7915, 9200], [7937, 9289], [8082, 9364], [8210, 9494], [8185, 9519], [8272, 9526], [8351, 9568], [8529, 9579], [8561, 9662], [8644, 9734], [8865, 9729], [9288, 9164], [9400, 8679], [9405, 8533], [9439, 8509], [9625, 8508], [9708, 8482], [9740, 8408], [9802, 8352], [9851, 8342], [9795, 8216], [9814, 8112], [9787, 7989], [9749, 7929], [9818, 7849], [9796, 7726], [9664, 7645], [9594, 7618], [9515, 7542], [9413, 7482], [9247, 7513], [9150, 7411], [9104, 7321], [9046, 7272], [9043, 7204]]] } }, { "type": "Feature", "id": "NG.AK", "properties": { "hc-group": "admin1", "hc-middle-x": 0.38, "hc-middle-y": 0.61, "hc-key": "ng-ak", "hc-a2": "AK", "labelrank": "3", "hasc": "NG.AK", "alt-name": null, "woe-id": "2346349", "subregion": null, "fips": "NI21", "postal-code": "AK", "name": "Akwa Ibom", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.90963", "woe-name": "Akwa Ibom", "latitude": "4.89926", "woe-label": "Akwa Ibom, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[3389, 1580], [3359, 1730], [3409, 1793], [3426, 1972], [3416, 2025], [3530, 2047], [3504, 2088], [3528, 2150], [3522, 2212], [3581, 2224], [3657, 2145], [3756, 2079], [3730, 2050], [3774, 1980], [3851, 1983], [3907, 1941], [3900, 1829], [3970, 1687], [4077, 1575], [4123, 1548], [4176, 1405], [4105, 1333], [3879, 1344], [3596, 1301], [3446, 1314], [3421, 1410], [3419, 1417], [3423, 1476], [3416, 1532], [3389, 1580]]] } }, { "type": "Feature", "id": "NG.AB", "properties": { "hc-group": "admin1", "hc-middle-x": 0.56, "hc-middle-y": 0.30, "hc-key": "ng-ab", "hc-a2": "AB", "labelrank": "3", "hasc": "NG.AB", "alt-name": null, "woe-id": "2346362", "subregion": null, "fips": "NI45", "postal-code": "AB", "name": "Abia", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.56019", "woe-name": "Abia", "latitude": "5.57402", "woe-label": "Abia, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[3756, 2079], [3657, 2145], [3581, 2224], [3522, 2212], [3528, 2150], [3504, 2088], [3530, 2047], [3416, 2025], [3426, 1972], [3409, 1793], [3359, 1730], [3389, 1580], [3328, 1621], [3245, 1636], [3134, 1620], [3097, 1632], [3085, 1703], [3179, 1847], [3166, 1924], [3233, 2116], [3307, 2242], [3286, 2358], [3303, 2412], [3292, 2514], [3166, 2591], [3209, 2645], [3270, 2677], [3365, 2678], [3425, 2633], [3418, 2522], [3472, 2494], [3605, 2493], [3654, 2470], [3675, 2410], [3739, 2375], [3766, 2187], [3811, 2103], [3756, 2079]]] } }, { "type": "Feature", "id": "NG.IM", "properties": { "hc-group": "admin1", "hc-middle-x": 0.50, "hc-middle-y": 0.50, "hc-key": "ng-im", "hc-a2": "IM", "labelrank": "3", "hasc": "NG.IM", "alt-name": null, "woe-id": "2346356", "subregion": null, "fips": "NI28", "postal-code": "IM", "name": "Imo", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.01557", "woe-name": "Imo", "latitude": "5.55004", "woe-label": "Imo, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[3166, 2591], [3292, 2514], [3303, 2412], [3286, 2358], [3307, 2242], [3233, 2116], [3166, 1924], [2946, 1916], [2817, 1926], [2684, 2026], [2704, 2152], [2667, 2192], [2595, 2206], [2635, 2381], [2696, 2430], [2767, 2449], [2842, 2442], [2891, 2554], [3008, 2589], [3091, 2571], [3166, 2591]]] } }, { "type": "Feature", "id": "NG.BY", "properties": { "hc-group": "admin1", "hc-middle-x": 0.55, "hc-middle-y": 0.64, "hc-key": "ng-by", "hc-a2": "BY", "labelrank": "3", "hasc": "NG.BY", "alt-name": null, "woe-id": "20070152", "subregion": null, "fips": "NI52", "postal-code": "BY", "name": "Bayelsa", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "5.97421", "woe-name": "Bayelsa", "latitude": "4.73907", "woe-label": "Bayelsa, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[2681, 1376], [2662, 1331], [2655, 1222], [2637, 1322], [2624, 1248], [2655, 1153], [2585, 1138], [2565, 1276], [2540, 1142], [2495, 1131], [2417, 1154], [2399, 1131], [2267, 1104], [2245, 1130], [2324, 1235], [2230, 1191], [2192, 1094], [2107, 1091], [2115, 1179], [2059, 1217], [2075, 1107], [2016, 1129], [2003, 1218], [1970, 1144], [1820, 1255], [1649, 1420], [1628, 1505], [1588, 1530], [1540, 1613], [1464, 1878], [1528, 1874], [1693, 1778], [1745, 1776], [1810, 1815], [1932, 1848], [1974, 1896], [2043, 1849], [2109, 1889], [2150, 1886], [2219, 1926], [2214, 1980], [2286, 1990], [2342, 2062], [2460, 2079], [2473, 2107], [2558, 2099], [2589, 2059], [2470, 1933], [2417, 1808], [2431, 1729], [2374, 1620], [2373, 1583], [2421, 1547], [2433, 1491], [2537, 1522], [2594, 1486], [2615, 1423], [2681, 1376]]] } }, { "type": "Feature", "id": "NG.BE", "properties": { "hc-group": "admin1", "hc-middle-x": 0.64, "hc-middle-y": 0.47, "hc-key": "ng-be", "hc-a2": "BE", "labelrank": "3", "hasc": "NG.BE", "alt-name": null, "woe-id": "2346354", "subregion": null, "fips": "NI26", "postal-code": "BE", "name": "Benue", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "8.70736", "woe-name": "Benue", "latitude": "7.48719", "woe-label": "Benue, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[5350, 3134], [5312, 3128], [5263, 3062], [5208, 3039], [5164, 3116], [5055, 3243], [4974, 3284], [4831, 3257], [4737, 3276], [4723, 3378], [4613, 3442], [4485, 3470], [4427, 3448], [4407, 3358], [4338, 3332], [4226, 3337], [4117, 3273], [4078, 3362], [3994, 3350], [3960, 3305], [3850, 3292], [3827, 3185], [3786, 3131], [3724, 3169], [3694, 3232], [3725, 3317], [3716, 3405], [3655, 3460], [3595, 3431], [3524, 3444], [3435, 3528], [3391, 3638], [3494, 3575], [3535, 3660], [3656, 3725], [3694, 3788], [3713, 3890], [3742, 3948], [3655, 3976], [3630, 4120], [3633, 4226], [3611, 4291], [3558, 4358], [3549, 4504], [3824, 4448], [4119, 4349], [4232, 4275], [4238, 4322], [4174, 4481], [4189, 4545], [4240, 4588], [4359, 4602], [4609, 4527], [4742, 4531], [4915, 4403], [4865, 4328], [4876, 4308], [5002, 4349], [5142, 4353], [5281, 4338], [5384, 4267], [5466, 4166], [5559, 4083], [5600, 3978], [5564, 3868], [5558, 3761], [5473, 3691], [5408, 3592], [5379, 3433], [5372, 3222], [5350, 3134]]] } }, { "type": "Feature", "id": "NG.CR", "properties": { "hc-group": "admin1", "hc-middle-x": 0.44, "hc-middle-y": 0.43, "hc-key": "ng-cr", "hc-a2": "CR", "labelrank": "3", "hasc": "NG.CR", "alt-name": null, "woe-id": "2346350", "subregion": null, "fips": "NI22", "postal-code": "CR", "name": "Cross River", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "8.67873", "woe-name": "Cross River", "latitude": "5.93762", "woe-label": "Cross River, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[4123, 1548], [4077, 1575], [3970, 1687], [3900, 1829], [3907, 1941], [3851, 1983], [3774, 1980], [3730, 2050], [3756, 2079], [3811, 2103], [3766, 2187], [3739, 2375], [3777, 2454], [3775, 2497], [3820, 2559], [3827, 2651], [3898, 2653], [3916, 2612], [3999, 2648], [4025, 2686], [4075, 2674], [4108, 2766], [4197, 2872], [4194, 2991], [4251, 3023], [4215, 3129], [4130, 3223], [4117, 3273], [4226, 3337], [4338, 3332], [4407, 3358], [4427, 3448], [4485, 3470], [4613, 3442], [4723, 3378], [4737, 3276], [4831, 3257], [4974, 3284], [5055, 3243], [5164, 3116], [5208, 3039], [5148, 2967], [5061, 2930], [5012, 2843], [4887, 2742], [4753, 2600], [4747, 2563], [4692, 2570], [4632, 2518], [4637, 2432], [4598, 2387], [4666, 2313], [4672, 2266], [4627, 2214], [4626, 2140], [4595, 2059], [4604, 2015], [4580, 1891], [4543, 1869], [4497, 1780], [4400, 1638], [4409, 1593], [4370, 1585], [4324, 1476], [4289, 1520], [4224, 1517], [4224, 1576], [4177, 1561], [4132, 1629], [4060, 1686], [4123, 1548]]] } }, { "type": "Feature", "id": "NG.TA", "properties": { "hc-group": "admin1", "hc-middle-x": 0.62, "hc-middle-y": 0.56, "hc-key": "ng-ta", "hc-a2": "TA", "labelrank": "3", "hasc": "NG.TA", "alt-name": null, "woe-id": "2346371", "subregion": null, "fips": "NI43", "postal-code": "TA", "name": "Taraba", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "10.5428", "woe-name": "Taraba", "latitude": "7.93608", "woe-label": "Taraba, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[5350, 3134], [5372, 3222], [5379, 3433], [5408, 3592], [5473, 3691], [5558, 3761], [5564, 3868], [5600, 3978], [5559, 4083], [5466, 4166], [5384, 4267], [5281, 4338], [5142, 4353], [5002, 4349], [4876, 4308], [4865, 4328], [4915, 4403], [5097, 4534], [5085, 4637], [5037, 4698], [5065, 4770], [5258, 4739], [5319, 4802], [5437, 4804], [5503, 4822], [5614, 4921], [5738, 5000], [5875, 5165], [6085, 5217], [6228, 5288], [6259, 5347], [6251, 5493], [6202, 5632], [6198, 5758], [6172, 5850], [6220, 5881], [6335, 5886], [6446, 5938], [6506, 5949], [6631, 5935], [6728, 5928], [7046, 5943], [7131, 5787], [7214, 5753], [7267, 5706], [7325, 5586], [7321, 5522], [7353, 5469], [7449, 5396], [7455, 5333], [7366, 5144], [7356, 5017], [7296, 4966], [7063, 4683], [6955, 4571], [6946, 4543], [6987, 4446], [7049, 4355], [7078, 4353], [7140, 4426], [7201, 4425], [7313, 4316], [7357, 4211], [7370, 4089], [7405, 3994], [7254, 3819], [7294, 3799], [7387, 3673], [7321, 3645], [7260, 3577], [7212, 3567], [7097, 3465], [7076, 3417], [7107, 3365], [7051, 3224], [6966, 3186], [6942, 3097], [6878, 3063], [6715, 3056], [6675, 3073], [6641, 3186], [6637, 3302], [6588, 3363], [6503, 3378], [6473, 3406], [6431, 3524], [6222, 3626], [6200, 3692], [6163, 3529], [6125, 3458], [5891, 3454], [5837, 3494], [5823, 3561], [5782, 3566], [5559, 3377], [5464, 3364], [5394, 3143], [5350, 3134]]] } }, { "type": "Feature", "id": "NG.KW", "properties": { "hc-group": "admin1", "hc-middle-x": 0.64, "hc-middle-y": 0.69, "hc-key": "ng-kw", "hc-a2": "KW", "labelrank": "3", "hasc": "NG.KW", "alt-name": null, "woe-id": "2346358", "subregion": null, "fips": "NI30", "postal-code": "KW", "name": "Kwara", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "4.46906", "woe-name": "Kwara", "latitude": "8.804449999999999", "woe-label": "Kwara, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[-926, 5000], [-940, 5225], [-913, 5261], [-914, 5347], [-894, 5485], [-812, 5479], [-785, 5500], [-699, 5485], [-637, 5500], [-600, 5544], [-543, 5691], [-562, 5821], [-540, 5874], [-455, 5961], [-453, 6006], [-404, 6006], [-368, 6045], [-386, 6141], [-363, 6169], [-261, 6204], [-207, 6197], [-127, 6308], [-114, 6400], [-66, 6453], [19, 6467], [164, 6470], [251, 6439], [551, 6076], [610, 6055], [624, 5993], [612, 5852], [641, 5801], [787, 5796], [796, 5707], [902, 5660], [910, 5563], [952, 5536], [1116, 5590], [1257, 5519], [1312, 5420], [1423, 5394], [1484, 5397], [1545, 5355], [1621, 5338], [1722, 5241], [1809, 5229], [1849, 5169], [1972, 5161], [2123, 5179], [2185, 5142], [2235, 5152], [2196, 5103], [2143, 4882], [2116, 4834], [1860, 4858], [1679, 4914], [1598, 4974], [1452, 4809], [1472, 4727], [1546, 4646], [1607, 4608], [1613, 4553], [1516, 4551], [1463, 4518], [1447, 4468], [1334, 4470], [1274, 4508], [1217, 4491], [1183, 4521], [1118, 4518], [1072, 4568], [839, 4524], [721, 4529], [679, 4560], [621, 4700], [544, 4783], [515, 4906], [483, 4955], [404, 5134], [405, 5245], [525, 5371], [510, 5407], [465, 5380], [374, 5396], [266, 5435], [192, 5487], [146, 5561], [61, 5577], [20, 5548], [-13, 5444], [-52, 5411], [-240, 5319], [-358, 5242], [-466, 5195], [-556, 5216], [-764, 5059], [-872, 5045], [-926, 5000]]] } }, { "type": "Feature", "id": "NG.LA", "properties": { "hc-group": "admin1", "hc-middle-x": 0.71, "hc-middle-y": 0.48, "hc-key": "ng-la", "hc-a2": "LA", "labelrank": "7", "hasc": "NG.LA", "alt-name": null, "woe-id": "2346342", "subregion": null, "fips": "NI05", "postal-code": "LA", "name": "Lagos", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "3.52478", "woe-name": "Lagos", "latitude": "6.43313", "woe-label": "Lagos, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[512, 3010], [315, 3048], [81, 3070], [-309, 3054], [-363, 3086], [-219, 3094], [-192, 3144], [-34, 3177], [-16, 3211], [71, 3226], [-5, 3245], [-106, 3198], [-243, 3160], [-276, 3174], [-273, 3229], [-346, 3184], [-377, 3091], [-364, 3043], [-519, 3044], [-640, 3031], [-782, 3040], [-987, 3023], [-979, 3120], [-865, 3112], [-813, 3165], [-614, 3154], [-560, 3161], [-488, 3314], [-459, 3325], [-376, 3269], [-325, 3270], [-303, 3307], [231, 3305], [286, 3290], [245, 3226], [281, 3171], [337, 3203], [393, 3200], [394, 3161], [342, 3111], [416, 3069], [515, 3062], [512, 3010]]] } }, { "type": "Feature", "id": "NG.NI", "properties": { "hc-group": "admin1", "hc-middle-x": 0.59, "hc-middle-y": 0.47, "hc-key": "ng-ni", "hc-a2": "NI", "labelrank": "3", "hasc": "NG.NI", "alt-name": null, "woe-id": "2346359", "subregion": null, "fips": "NI31", "postal-code": "NI", "name": "Niger", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "5.45494", "woe-name": "Niger", "latitude": "9.95553", "woe-label": "Niger, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[-15, 7360], [75, 7356], [255, 7256], [549, 7253], [643, 7266], [734, 7240], [843, 7167], [901, 7149], [868, 6913], [836, 6862], [730, 6804], [695, 6746], [705, 6612], [748, 6572], [727, 6439], [810, 6415], [832, 6507], [970, 6539], [1027, 6567], [1050, 6627], [981, 6745], [977, 6876], [993, 6937], [1084, 6937], [1234, 7002], [1178, 7109], [1222, 7163], [1202, 7263], [1158, 7295], [1062, 7314], [941, 7386], [956, 7443], [1081, 7497], [1348, 7548], [1413, 7545], [1466, 7512], [1478, 7444], [1552, 7336], [1547, 7230], [1582, 7190], [1732, 7199], [1889, 7264], [1951, 7274], [2020, 7342], [2080, 7326], [2186, 7159], [2199, 7098], [2155, 7047], [2165, 6901], [2135, 6752], [2207, 6640], [2238, 6644], [2328, 6751], [2436, 6832], [2500, 6846], [2564, 6796], [2630, 6826], [2699, 6826], [2715, 6877], [2805, 6875], [2818, 6784], [2864, 6789], [2914, 6746], [2922, 6621], [3013, 6579], [2989, 6519], [2854, 6403], [2894, 6350], [2959, 6322], [3160, 6316], [3203, 6285], [3218, 6106], [3147, 6069], [3217, 6019], [3256, 5928], [3147, 5774], [3192, 5718], [3185, 5663], [3230, 5665], [3102, 5484], [3054, 5507], [2969, 5589], [2915, 5607], [2747, 5601], [2721, 5565], [2727, 4914], [2754, 4859], [2795, 4854], [2723, 4772], [2664, 4673], [2556, 4807], [2460, 4879], [2375, 5106], [2291, 5158], [2235, 5152], [2185, 5142], [2123, 5179], [1972, 5161], [1849, 5169], [1809, 5229], [1722, 5241], [1621, 5338], [1545, 5355], [1484, 5397], [1423, 5394], [1312, 5420], [1257, 5519], [1116, 5590], [952, 5536], [910, 5563], [902, 5660], [796, 5707], [787, 5796], [641, 5801], [612, 5852], [624, 5993], [610, 6055], [551, 6076], [251, 6439], [164, 6470], [19, 6467], [-66, 6453], [-65, 6484], [-147, 6598], [-73, 6734], [22, 6705], [97, 6882], [86, 6976], [50, 6990], [4, 7089], [26, 7164], [-15, 7360]]] } }, { "type": "Feature", "id": "NG.FC", "properties": { "hc-group": "admin1", "hc-middle-x": 0.36, "hc-middle-y": 0.56, "hc-key": "ng-fc", "hc-a2": "FC", "labelrank": "3", "hasc": "NG.FC", "alt-name": "Abuja", "woe-id": "2346345", "subregion": null, "fips": "NI11", "postal-code": "FC", "name": "Federal Capital Territory", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.18889", "woe-name": "Federal Capital Territory", "latitude": "8.78852", "woe-label": "Abuja Capital Territory, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[2795, 4854], [2754, 4859], [2727, 4914], [2721, 5565], [2747, 5601], [2915, 5607], [2969, 5589], [3054, 5507], [3102, 5484], [3230, 5665], [3316, 5674], [3389, 5659], [3438, 5713], [3515, 5676], [3476, 5600], [3455, 5503], [3456, 5357], [3413, 5173], [3373, 5064], [3302, 4969], [3185, 4912], [3056, 4878], [2925, 4858], [2885, 4852], [2795, 4854]]] } }, { "type": "Feature", "id": "NG.OG", "properties": { "hc-group": "admin1", "hc-middle-x": 0.39, "hc-middle-y": 0.56, "hc-key": "ng-og", "hc-a2": "OG", "labelrank": "3", "hasc": "NG.OG", "alt-name": null, "woe-id": "2346346", "subregion": null, "fips": "NI16", "postal-code": "OG", "name": "Ogun", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "3.29255", "woe-name": "Ogun", "latitude": "7.01845", "woe-label": "Ogun, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[650, 2964], [570, 2999], [512, 3010], [515, 3062], [416, 3069], [342, 3111], [394, 3161], [393, 3200], [337, 3203], [281, 3171], [245, 3226], [286, 3290], [231, 3305], [-303, 3307], [-325, 3270], [-376, 3269], [-459, 3325], [-488, 3314], [-560, 3161], [-614, 3154], [-813, 3165], [-865, 3112], [-979, 3120], [-955, 3196], [-959, 3273], [-915, 3325], [-918, 3367], [-965, 3418], [-952, 3476], [-970, 3583], [-914, 3629], [-950, 3695], [-925, 3749], [-942, 3975], [-903, 3985], [-894, 4038], [-958, 4139], [-950, 4328], [-999, 4420], [-913, 4478], [-825, 4474], [-802, 4431], [-799, 4328], [-758, 4274], [-735, 4361], [-700, 4361], [-696, 4281], [-731, 4188], [-713, 4121], [-645, 4051], [-605, 3975], [-542, 3916], [-441, 3900], [-404, 3931], [-366, 4022], [-328, 4047], [-253, 3961], [-198, 3987], [-107, 3984], [-76, 3939], [-75, 3872], [-22, 3838], [2, 3722], [-58, 3634], [110, 3644], [276, 3691], [341, 3721], [367, 3641], [481, 3668], [537, 3568], [703, 3591], [717, 3573], [695, 3454], [549, 3324], [526, 3236], [551, 3203], [642, 3189], [720, 3245], [744, 3113], [670, 3052], [626, 3042], [719, 3002], [706, 2960], [650, 2964]]] } }, { "type": "Feature", "id": "NG.ON", "properties": { "hc-group": "admin1", "hc-middle-x": 0.31, "hc-middle-y": 0.46, "hc-key": "ng-on", "hc-a2": "ON", "labelrank": "3", "hasc": "NG.ON", "alt-name": null, "woe-id": "2346347", "subregion": null, "fips": "NI48", "postal-code": "ON", "name": "Ondo", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "5.19165", "woe-name": "Ondo", "latitude": "7.1444", "woe-label": "Ondo, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[1113, 2535], [1007, 2674], [953, 2707], [854, 2819], [650, 2964], [706, 2960], [719, 3002], [626, 3042], [670, 3052], [744, 3113], [720, 3245], [642, 3189], [551, 3203], [526, 3236], [549, 3324], [695, 3454], [717, 3573], [752, 3591], [799, 3676], [874, 3716], [965, 3666], [999, 3671], [1003, 3805], [1027, 3891], [1112, 3923], [1113, 3960], [1177, 3980], [1376, 3976], [1422, 3962], [1462, 3854], [1514, 3834], [1610, 3914], [1661, 4029], [1690, 4142], [1798, 4242], [1862, 4266], [1935, 4278], [2002, 4160], [2058, 4098], [1972, 4024], [1990, 3975], [1988, 3848], [1918, 3784], [1872, 3645], [1835, 3604], [1837, 3501], [1804, 3465], [1785, 3384], [1742, 3338], [1675, 3358], [1609, 3319], [1586, 3379], [1610, 3428], [1569, 3461], [1313, 3463], [1188, 3292], [1181, 3221], [1225, 3136], [1168, 3016], [1125, 2998], [1094, 2927], [1161, 2854], [1201, 2838], [1217, 2783], [1114, 2536], [1113, 2535]]] } }, { "type": "Feature", "id": "NG.EK", "properties": { "hc-group": "admin1", "hc-middle-x": 0.45, "hc-middle-y": 0.44, "hc-key": "ng-ek", "hc-a2": "EK", "labelrank": "7", "hasc": "NG.EK", "alt-name": null, "woe-id": "20070151", "subregion": null, "fips": "NI51", "postal-code": "EK", "name": "Ekiti", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "5.35929", "woe-name": "Ekiti", "latitude": "7.67104", "woe-label": "Ekiti, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[1183, 4521], [1217, 4491], [1274, 4508], [1334, 4470], [1447, 4468], [1463, 4518], [1516, 4551], [1613, 4553], [1596, 4490], [1704, 4508], [1733, 4475], [1686, 4431], [1692, 4353], [1722, 4326], [1862, 4266], [1798, 4242], [1690, 4142], [1661, 4029], [1610, 3914], [1514, 3834], [1462, 3854], [1422, 3962], [1376, 3976], [1177, 3980], [1113, 3960], [1042, 4154], [1056, 4351], [1162, 4447], [1183, 4521]]] } }, { "type": "Feature", "id": "NG.OS", "properties": { "hc-group": "admin1", "hc-middle-x": 0.52, "hc-middle-y": 0.51, "hc-key": "ng-os", "hc-a2": "OS", "labelrank": "3", "hasc": "NG.OS", "alt-name": null, "woe-id": "2346370", "subregion": null, "fips": "NI42", "postal-code": "OS", "name": "Osun", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "4.54911", "woe-name": "Osun", "latitude": "7.47613", "woe-label": "Osun, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[1183, 4521], [1162, 4447], [1056, 4351], [1042, 4154], [1113, 3960], [1112, 3923], [1027, 3891], [1003, 3805], [999, 3671], [965, 3666], [874, 3716], [799, 3676], [752, 3591], [717, 3573], [703, 3591], [537, 3568], [481, 3668], [367, 3641], [341, 3721], [276, 3691], [342, 4021], [285, 4123], [241, 4160], [291, 4363], [353, 4346], [454, 4458], [507, 4424], [540, 4370], [577, 4362], [725, 4466], [721, 4529], [839, 4524], [1072, 4568], [1118, 4518], [1183, 4521]]] } }, { "type": "Feature", "id": "NG.OY", "properties": { "hc-group": "admin1", "hc-middle-x": 0.49, "hc-middle-y": 0.47, "hc-key": "ng-oy", "hc-a2": "OY", "labelrank": "3", "hasc": "NG.OY", "alt-name": null, "woe-id": "2346360", "subregion": null, "fips": "NI32", "postal-code": "OY", "name": "Oyo", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "3.61681", "woe-name": "Oyo", "latitude": "8.189690000000001", "woe-label": "Oyo, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[721, 4529], [725, 4466], [577, 4362], [540, 4370], [507, 4424], [454, 4458], [353, 4346], [291, 4363], [241, 4160], [285, 4123], [342, 4021], [276, 3691], [110, 3644], [-58, 3634], [2, 3722], [-22, 3838], [-75, 3872], [-76, 3939], [-107, 3984], [-198, 3987], [-253, 3961], [-328, 4047], [-366, 4022], [-404, 3931], [-441, 3900], [-542, 3916], [-605, 3975], [-645, 4051], [-713, 4121], [-731, 4188], [-696, 4281], [-700, 4361], [-735, 4361], [-758, 4274], [-799, 4328], [-802, 4431], [-825, 4474], [-913, 4478], [-999, 4420], [-984, 4457], [-962, 4644], [-937, 4711], [-970, 4811], [-963, 4900], [-926, 5000], [-872, 5045], [-764, 5059], [-556, 5216], [-466, 5195], [-358, 5242], [-240, 5319], [-52, 5411], [-13, 5444], [20, 5548], [61, 5577], [146, 5561], [192, 5487], [266, 5435], [374, 5396], [465, 5380], [510, 5407], [525, 5371], [405, 5245], [404, 5134], [483, 4955], [515, 4906], [544, 4783], [621, 4700], [679, 4560], [721, 4529]]] } }, { "type": "Feature", "id": "NG.AN", "properties": { "hc-group": "admin1", "hc-middle-x": 0.48, "hc-middle-y": 0.50, "hc-key": "ng-an", "hc-a2": "AN", "labelrank": "3", "hasc": "NG.AN", "alt-name": null, "woe-id": "2346353", "subregion": null, "fips": "NI25", "postal-code": "AN", "name": "Anambra", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "6.98472", "woe-name": "Anambra", "latitude": "6.30827", "woe-label": "Anambra, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[3270, 2677], [3209, 2645], [3166, 2591], [3091, 2571], [3008, 2589], [2891, 2554], [2842, 2442], [2767, 2449], [2696, 2430], [2635, 2381], [2605, 2384], [2577, 2408], [2596, 2495], [2650, 2574], [2668, 2729], [2707, 2753], [2720, 2812], [2698, 2873], [2648, 3092], [2645, 3148], [2720, 3147], [2750, 3177], [2792, 3309], [2854, 3367], [2861, 3312], [2922, 3308], [3031, 3268], [3027, 3206], [2976, 3152], [2959, 3061], [3017, 3041], [3072, 2932], [3055, 2876], [3089, 2878], [3180, 2697], [3270, 2677]]] } }, { "type": "Feature", "id": "NG.BA", "properties": { "hc-group": "admin1", "hc-middle-x": 0.53, "hc-middle-y": 0.72, "hc-key": "ng-ba", "hc-a2": "BA", "labelrank": "7", "hasc": "NG.BA", "alt-name": null, "woe-id": "2346343", "subregion": null, "fips": "NI46", "postal-code": "BA", "name": "Bauchi", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "9.88584", "woe-name": "Bauchi", "latitude": "10.4101", "woe-label": "Bauchi, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[6631, 5935], [6506, 5949], [6446, 5938], [6335, 5886], [6220, 5881], [6172, 5850], [5992, 5954], [5548, 6157], [5494, 6121], [5542, 6040], [5533, 6010], [5451, 5967], [5425, 5911], [5357, 5890], [5214, 5882], [5030, 5923], [4958, 6025], [4903, 6057], [4942, 6163], [4919, 6300], [4861, 6321], [4756, 6302], [4723, 6325], [4724, 6470], [4701, 6565], [4669, 6605], [4564, 6609], [4484, 6690], [4524, 6804], [4591, 6909], [4585, 6972], [4518, 7090], [4521, 7235], [4548, 7292], [4634, 7310], [4785, 7485], [4874, 7497], [4959, 7528], [5014, 7527], [5124, 7489], [5237, 7494], [5318, 7434], [5486, 7456], [5546, 7365], [5539, 7247], [5560, 7197], [5612, 7176], [5754, 7187], [5820, 7158], [5853, 7269], [5952, 7308], [6009, 7382], [5723, 7432], [5657, 7458], [5533, 7637], [5488, 7632], [5474, 7687], [5503, 7742], [5488, 7839], [5443, 7876], [5356, 7856], [5318, 7882], [5336, 7950], [5384, 7993], [5460, 8000], [5519, 8033], [5792, 8139], [5804, 8237], [5889, 8499], [6004, 8542], [6079, 8513], [6197, 8592], [6310, 8502], [6343, 8327], [6380, 8263], [6387, 8160], [6416, 8014], [6526, 7749], [6532, 7672], [6502, 7531], [6570, 7493], [6516, 7436], [6432, 7386], [6360, 7304], [6265, 7260], [6194, 7050], [6145, 6958], [6242, 6918], [6281, 6783], [6404, 6717], [6423, 6663], [6423, 6482], [6321, 6429], [6354, 6346], [6541, 6209], [6569, 6150], [6591, 6034], [6631, 5935]]] } }, { "type": "Feature", "id": "NG.GO", "properties": { "hc-group": "admin1", "hc-middle-x": 0.50, "hc-middle-y": 0.46, "hc-key": "ng-go", "hc-a2": "GO", "labelrank": "3", "hasc": "NG.GO", "alt-name": null, "woe-id": "20070155", "subregion": null, "fips": "NI55", "postal-code": "GO", "name": "Gombe", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "11.2421", "woe-name": "Gombe", "latitude": "10.4342", "woe-label": "Gombe, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[7046, 5943], [6728, 5928], [6631, 5935], [6591, 6034], [6569, 6150], [6541, 6209], [6354, 6346], [6321, 6429], [6423, 6482], [6423, 6663], [6404, 6717], [6281, 6783], [6242, 6918], [6145, 6958], [6194, 7050], [6265, 7260], [6360, 7304], [6432, 7386], [6516, 7436], [6570, 7493], [6694, 7527], [6819, 7468], [6877, 7424], [7067, 7219], [7092, 7164], [7083, 6954], [7098, 6862], [7195, 6860], [7207, 6780], [7142, 6672], [7140, 6632], [7188, 6558], [7295, 6498], [7357, 6400], [7422, 6360], [7419, 6160], [7372, 6094], [7205, 5992], [7129, 5958], [7046, 5943]]] } }, { "type": "Feature", "id": "NG.DE", "properties": { "hc-group": "admin1", "hc-middle-x": 0.45, "hc-middle-y": 0.67, "hc-key": "ng-de", "hc-a2": "DE", "labelrank": "3", "hasc": "NG.DE", "alt-name": null, "woe-id": "2346364", "subregion": null, "fips": "NI36", "postal-code": "DE", "name": "Delta", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "5.88195", "woe-name": "Delta", "latitude": "5.44265", "woe-label": "Delta, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[2577, 2408], [2527, 2217], [2458, 2147], [2473, 2107], [2460, 2079], [2342, 2062], [2286, 1990], [2214, 1980], [2219, 1926], [2150, 1886], [2109, 1889], [2043, 1849], [1974, 1896], [1932, 1848], [1810, 1815], [1745, 1776], [1693, 1778], [1528, 1874], [1529, 1920], [1440, 1909], [1419, 2067], [1523, 2089], [1536, 2063], [1592, 2105], [1636, 2100], [1599, 2145], [1603, 2218], [1552, 2128], [1505, 2114], [1349, 2152], [1290, 2211], [1281, 2250], [1319, 2285], [1468, 2264], [1500, 2320], [1575, 2301], [1501, 2351], [1456, 2298], [1407, 2306], [1413, 2414], [1365, 2317], [1273, 2285], [1227, 2327], [1191, 2401], [1195, 2461], [1244, 2467], [1280, 2522], [1355, 2549], [1376, 2584], [1220, 2506], [1151, 2455], [1113, 2535], [1114, 2536], [1217, 2783], [1281, 2752], [1324, 2701], [1322, 2594], [1356, 2586], [1409, 2631], [1414, 2684], [1535, 2682], [1596, 2648], [1661, 2699], [1718, 2700], [1824, 2642], [1929, 2552], [1906, 2487], [1922, 2431], [2044, 2445], [2217, 2604], [2228, 2674], [2144, 2739], [2074, 2903], [2112, 2981], [2184, 2924], [2248, 2971], [2525, 3110], [2590, 3105], [2645, 3148], [2648, 3092], [2698, 2873], [2720, 2812], [2707, 2753], [2668, 2729], [2650, 2574], [2596, 2495], [2577, 2408]]] } }, { "type": "Feature", "id": "NG.ED", "properties": { "hc-group": "admin1", "hc-middle-x": 0.57, "hc-middle-y": 0.54, "hc-key": "ng-ed", "hc-a2": "ED", "labelrank": "3", "hasc": "NG.ED", "alt-name": null, "woe-id": "2346365", "subregion": null, "fips": "NI37", "postal-code": "ED", "name": "Edo", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "5.84934", "woe-name": "Edo", "latitude": "6.52416", "woe-label": "Edo, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[1217, 2783], [1201, 2838], [1161, 2854], [1094, 2927], [1125, 2998], [1168, 3016], [1225, 3136], [1181, 3221], [1188, 3292], [1313, 3463], [1569, 3461], [1610, 3428], [1586, 3379], [1609, 3319], [1675, 3358], [1742, 3338], [1785, 3384], [1804, 3465], [1837, 3501], [1835, 3604], [1872, 3645], [1918, 3784], [1988, 3848], [1990, 3975], [1972, 4024], [2058, 4098], [2133, 4055], [2152, 3963], [2272, 3996], [2351, 3919], [2425, 3923], [2496, 3801], [2603, 3827], [2666, 3773], [2686, 3708], [2656, 3531], [2621, 3430], [2621, 3265], [2645, 3148], [2590, 3105], [2525, 3110], [2248, 2971], [2184, 2924], [2112, 2981], [2074, 2903], [2144, 2739], [2228, 2674], [2217, 2604], [2044, 2445], [1922, 2431], [1906, 2487], [1929, 2552], [1824, 2642], [1718, 2700], [1661, 2699], [1596, 2648], [1535, 2682], [1414, 2684], [1409, 2631], [1356, 2586], [1322, 2594], [1324, 2701], [1281, 2752], [1217, 2783]]] } }, { "type": "Feature", "id": "NG.EN", "properties": { "hc-group": "admin1", "hc-middle-x": 0.55, "hc-middle-y": 0.48, "hc-key": "ng-en", "hc-a2": "EN", "labelrank": "7", "hasc": "NG.EN", "alt-name": null, "woe-id": "2346366", "subregion": null, "fips": "NI47", "postal-code": "EN", "name": "Enugu", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.38408", "woe-name": "Enugu", "latitude": "6.55396", "woe-label": "Enugu, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[3391, 3638], [3435, 3528], [3524, 3444], [3595, 3431], [3655, 3460], [3716, 3405], [3725, 3317], [3694, 3232], [3574, 3211], [3609, 3094], [3608, 3029], [3569, 2908], [3607, 2750], [3566, 2698], [3571, 2605], [3546, 2592], [3470, 2648], [3425, 2633], [3365, 2678], [3270, 2677], [3180, 2697], [3089, 2878], [3055, 2876], [3072, 2932], [3017, 3041], [2959, 3061], [2976, 3152], [3027, 3206], [3031, 3268], [2922, 3308], [2861, 3312], [2854, 3367], [2909, 3435], [2959, 3369], [3034, 3441], [3156, 3536], [3208, 3603], [3316, 3668], [3391, 3638]]] } }, { "type": "Feature", "id": "NG.EB", "properties": { "hc-group": "admin1", "hc-middle-x": 0.59, "hc-middle-y": 0.42, "hc-key": "ng-eb", "hc-a2": "EB", "labelrank": "3", "hasc": "NG.EB", "alt-name": null, "woe-id": "20070153", "subregion": null, "fips": "NI53", "postal-code": "EB", "name": "Ebonyi", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.98254", "woe-name": "Ebonyi", "latitude": "6.32648", "woe-label": null, "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[4117, 3273], [4130, 3223], [4215, 3129], [4251, 3023], [4194, 2991], [4197, 2872], [4108, 2766], [4075, 2674], [4025, 2686], [3999, 2648], [3916, 2612], [3898, 2653], [3827, 2651], [3820, 2559], [3775, 2497], [3777, 2454], [3739, 2375], [3675, 2410], [3654, 2470], [3605, 2493], [3472, 2494], [3418, 2522], [3425, 2633], [3470, 2648], [3546, 2592], [3571, 2605], [3566, 2698], [3607, 2750], [3569, 2908], [3608, 3029], [3609, 3094], [3574, 3211], [3694, 3232], [3724, 3169], [3786, 3131], [3827, 3185], [3850, 3292], [3960, 3305], [3994, 3350], [4078, 3362], [4117, 3273]]] } }, { "type": "Feature", "id": "NG.KD", "properties": { "hc-group": "admin1", "hc-middle-x": 0.54, "hc-middle-y": 0.35, "hc-key": "ng-kd", "hc-a2": "KD", "labelrank": "7", "hasc": "NG.KD", "alt-name": null, "woe-id": "2346351", "subregion": null, "fips": "NI23", "postal-code": "KD", "name": "Kaduna", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "7.43906", "woe-name": "Kaduna", "latitude": "10.3294", "woe-label": "Kaduna, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[4524, 6804], [4484, 6690], [4564, 6609], [4552, 6552], [4451, 6458], [4435, 6390], [4458, 6321], [4423, 6201], [4426, 6065], [4360, 5963], [4360, 5833], [4474, 5686], [4452, 5578], [4366, 5434], [4292, 5391], [4204, 5498], [4093, 5531], [4016, 5436], [3944, 5397], [3911, 5591], [3847, 5636], [3810, 5708], [3754, 5699], [3688, 5621], [3515, 5676], [3438, 5713], [3389, 5659], [3316, 5674], [3230, 5665], [3185, 5663], [3192, 5718], [3147, 5774], [3256, 5928], [3217, 6019], [3147, 6069], [3218, 6106], [3203, 6285], [3160, 6316], [2959, 6322], [2894, 6350], [2854, 6403], [2989, 6519], [3013, 6579], [2922, 6621], [2914, 6746], [2864, 6789], [2818, 6784], [2805, 6875], [2715, 6877], [2699, 6826], [2630, 6826], [2564, 6796], [2500, 6846], [2436, 6832], [2328, 6751], [2238, 6644], [2207, 6640], [2135, 6752], [2165, 6901], [2155, 7047], [2199, 7098], [2254, 7123], [2259, 7159], [2364, 7258], [2482, 7230], [2657, 7280], [2708, 7336], [2754, 7469], [2851, 7553], [2962, 7525], [2988, 7473], [2950, 7410], [3048, 7373], [3124, 7320], [3176, 7359], [3175, 7458], [3300, 7458], [3321, 7520], [3377, 7553], [3443, 7540], [3551, 7466], [3624, 7496], [3656, 7543], [3718, 7548], [3823, 7627], [3950, 7667], [3982, 7652], [3960, 7555], [4007, 7506], [4070, 7483], [4122, 7430], [4253, 7388], [4345, 7290], [4363, 7163], [4345, 7093], [4359, 6984], [4289, 6915], [4339, 6874], [4411, 6865], [4451, 6818], [4524, 6804]]] } }, { "type": "Feature", "id": "NG.KO", "properties": { "hc-group": "admin1", "hc-middle-x": 0.72, "hc-middle-y": 0.60, "hc-key": "ng-ko", "hc-a2": "KO", "labelrank": "3", "hasc": "NG.KO", "alt-name": null, "woe-id": "2346369", "subregion": null, "fips": "NI41", "postal-code": "KO", "name": "Kogi", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "6.6142", "woe-name": "Kogi", "latitude": "7.78485", "woe-label": "Kogi, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[3391, 3638], [3316, 3668], [3208, 3603], [3156, 3536], [3034, 3441], [2959, 3369], [2909, 3435], [2854, 3367], [2792, 3309], [2750, 3177], [2720, 3147], [2645, 3148], [2621, 3265], [2621, 3430], [2656, 3531], [2686, 3708], [2666, 3773], [2603, 3827], [2496, 3801], [2425, 3923], [2351, 3919], [2272, 3996], [2152, 3963], [2133, 4055], [2058, 4098], [2002, 4160], [1935, 4278], [1862, 4266], [1722, 4326], [1692, 4353], [1686, 4431], [1733, 4475], [1704, 4508], [1596, 4490], [1613, 4553], [1607, 4608], [1546, 4646], [1472, 4727], [1452, 4809], [1598, 4974], [1679, 4914], [1860, 4858], [2116, 4834], [2143, 4882], [2196, 5103], [2235, 5152], [2291, 5158], [2375, 5106], [2460, 4879], [2556, 4807], [2664, 4673], [2723, 4772], [2795, 4854], [2885, 4852], [2925, 4858], [2895, 4768], [2938, 4691], [2927, 4497], [2887, 4368], [3020, 4446], [3204, 4507], [3394, 4496], [3549, 4504], [3558, 4358], [3611, 4291], [3633, 4226], [3630, 4120], [3655, 3976], [3742, 3948], [3713, 3890], [3694, 3788], [3656, 3725], [3535, 3660], [3494, 3575], [3391, 3638]]] } }, { "type": "Feature", "id": "NG.PL", "properties": { "hc-group": "admin1", "hc-middle-x": 0.53, "hc-middle-y": 0.64, "hc-key": "ng-pl", "hc-a2": "PL", "labelrank": "3", "hasc": "NG.PL", "alt-name": null, "woe-id": "2346348", "subregion": null, "fips": "NI49", "postal-code": "PL", "name": "Plateau", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "9.60601", "woe-name": "Plateau", "latitude": "8.95327", "woe-label": "Plateau, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[6172, 5850], [6198, 5758], [6202, 5632], [6251, 5493], [6259, 5347], [6228, 5288], [6085, 5217], [5875, 5165], [5738, 5000], [5614, 4921], [5503, 4822], [5437, 4804], [5319, 4802], [5286, 4849], [5131, 4925], [5074, 4926], [4933, 4894], [4848, 4895], [4717, 4949], [4695, 5069], [4656, 5143], [4716, 5242], [4749, 5253], [4808, 5325], [4826, 5383], [4785, 5420], [4727, 5403], [4606, 5414], [4563, 5458], [4548, 5520], [4452, 5578], [4474, 5686], [4360, 5833], [4360, 5963], [4426, 6065], [4423, 6201], [4458, 6321], [4435, 6390], [4451, 6458], [4552, 6552], [4564, 6609], [4669, 6605], [4701, 6565], [4724, 6470], [4723, 6325], [4756, 6302], [4861, 6321], [4919, 6300], [4942, 6163], [4903, 6057], [4958, 6025], [5030, 5923], [5214, 5882], [5357, 5890], [5425, 5911], [5451, 5967], [5533, 6010], [5542, 6040], [5494, 6121], [5548, 6157], [5992, 5954], [6172, 5850]]] } }, { "type": "Feature", "id": "NG.NA", "properties": { "hc-group": "admin1", "hc-middle-x": 0.49, "hc-middle-y": 0.48, "hc-key": "ng-na", "hc-a2": "NA", "labelrank": "3", "hasc": "NG.NA", "alt-name": null, "woe-id": "20070154", "subregion": null, "fips": "NI56", "postal-code": "NA", "name": "Nasarawa", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "8.27694", "woe-name": "Nasarawa", "latitude": "8.50412", "woe-label": "Nasarawa, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[4452, 5578], [4548, 5520], [4563, 5458], [4606, 5414], [4727, 5403], [4785, 5420], [4826, 5383], [4808, 5325], [4749, 5253], [4716, 5242], [4656, 5143], [4695, 5069], [4717, 4949], [4848, 4895], [4933, 4894], [5074, 4926], [5131, 4925], [5286, 4849], [5319, 4802], [5258, 4739], [5065, 4770], [5037, 4698], [5085, 4637], [5097, 4534], [4915, 4403], [4742, 4531], [4609, 4527], [4359, 4602], [4240, 4588], [4189, 4545], [4174, 4481], [4238, 4322], [4232, 4275], [4119, 4349], [3824, 4448], [3549, 4504], [3394, 4496], [3204, 4507], [3020, 4446], [2887, 4368], [2927, 4497], [2938, 4691], [2895, 4768], [2925, 4858], [3056, 4878], [3185, 4912], [3302, 4969], [3373, 5064], [3413, 5173], [3456, 5357], [3455, 5503], [3476, 5600], [3515, 5676], [3688, 5621], [3754, 5699], [3810, 5708], [3847, 5636], [3911, 5591], [3944, 5397], [4016, 5436], [4093, 5531], [4204, 5498], [4292, 5391], [4366, 5434], [4452, 5578]]] } }, { "type": "Feature", "id": "NG.JI", "properties": { "hc-group": "admin1", "hc-middle-x": 0.54, "hc-middle-y": 0.28, "hc-key": "ng-ji", "hc-a2": "JI", "labelrank": "3", "hasc": "NG.JI", "alt-name": null, "woe-id": "2346367", "subregion": null, "fips": "NI39", "postal-code": "JI", "name": "Jigawa", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "9.36225", "woe-name": "Jigawa", "latitude": "12.0714", "woe-label": "Jigawa, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[6197, 8592], [6079, 8513], [6004, 8542], [5889, 8499], [5804, 8237], [5792, 8139], [5519, 8033], [5460, 8000], [5384, 7993], [5336, 7950], [5318, 7882], [5356, 7856], [5443, 7876], [5488, 7839], [5503, 7742], [5474, 7687], [5488, 7632], [5533, 7637], [5657, 7458], [5723, 7432], [6009, 7382], [5952, 7308], [5853, 7269], [5820, 7158], [5754, 7187], [5612, 7176], [5560, 7197], [5539, 7247], [5546, 7365], [5486, 7456], [5318, 7434], [5237, 7494], [5124, 7489], [5014, 7527], [4959, 7528], [4984, 7629], [5072, 7722], [5019, 7751], [4960, 7848], [4872, 7868], [4917, 7971], [4942, 8075], [4918, 8155], [4789, 8138], [4782, 8183], [4716, 8173], [4687, 8203], [4708, 8245], [4707, 8329], [4669, 8376], [4562, 8399], [4545, 8483], [4477, 8527], [4466, 8618], [4334, 8651], [4236, 8617], [4183, 8514], [4112, 8646], [4082, 8694], [4011, 8696], [3964, 8725], [3982, 8869], [4078, 8883], [4339, 8883], [4396, 8779], [4511, 8748], [4595, 8756], [4678, 8811], [4734, 8896], [4995, 8866], [5092, 8881], [5282, 8859], [5334, 8886], [5443, 8852], [5521, 8886], [5545, 8934], [5623, 8972], [5791, 9029], [5851, 8982], [5884, 8868], [5982, 8880], [6107, 8857], [6160, 8780], [6197, 8592]]] } }, { "type": "Feature", "id": "NG.KN", "properties": { "hc-group": "admin1", "hc-middle-x": 0.50, "hc-middle-y": 0.38, "hc-key": "ng-kn", "hc-a2": "KN", "labelrank": "7", "hasc": "NG.KN", "alt-name": null, "woe-id": "2346357", "subregion": null, "fips": "NI29", "postal-code": "KN", "name": "Kano", "country": "Nigeria", "type-en": "State", "region": null, "longitude": "8.541460000000001", "woe-name": "Kano", "latitude": "11.7323", "woe-label": "Kano, NG, Nigeria", "type": "State" }, "geometry": { "type": "Polygon", "coordinates": [[[4524, 6804], [4451, 6818], [4411, 6865], [4339, 6874], [4289, 6915], [4359, 6984], [4345, 7093], [4363, 7163], [4345, 7290], [4253, 7388], [4122, 7430], [4070, 7483], [4007, 7506], [3960, 7555], [3982, 7652], [3950, 7667], [3823, 7627], [3718, 7548], [3656, 7543], [3594, 7596], [3580, 7642], [3601, 7730], [3630, 7764], [3762, 7809], [3725, 7927], [3708, 8049], [3716, 8370], [3785, 8417], [3943, 8476], [3976, 8507], [4027, 8633], [4112, 8646], [4183, 8514], [4236, 8617], [4334, 8651], [4466, 8618], [4477, 8527], [4545, 8483], [4562, 8399], [4669, 8376], [4707, 8329], [4708, 8245], [4687, 8203], [4716, 8173], [4782, 8183], [4789, 8138], [4918, 8155], [4942, 8075], [4917, 7971], [4872, 7868], [4960, 7848], [5019, 7751], [5072, 7722], [4984, 7629], [4959, 7528], [4874, 7497], [4785, 7485], [4634, 7310], [4548, 7292], [4521, 7235], [4518, 7090], [4585, 6972], [4591, 6909], [4524, 6804]]] } }] };

module.exports = mapData;

/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);


function isEmpty(opt) {
  if (opt === 0) return false;
  if (Array.isArray(opt) && opt.length === 0) return true;
  return !opt;
}

function not(fun) {
  return function () {
    return !fun.apply(undefined, arguments);
  };
}

function includes(str, query) {
  /* istanbul ignore else */
  if (str === undefined) str = 'undefined';
  if (str === null) str = 'null';
  if (str === false) str = 'false';
  var text = str.toString().toLowerCase();
  return text.indexOf(query.trim()) !== -1;
}

function filterOptions(options, search, label, customLabel) {
  return options.filter(function (option) {
    return includes(customLabel(option, label), search);
  });
}

function stripGroups(options) {
  return options.filter(function (option) {
    return !option.$isLabel;
  });
}

function flattenOptions(values, label) {
  return function (options) {
    return options.reduce(function (prev, curr) {
      /* istanbul ignore else */
      if (curr[values] && curr[values].length) {
        prev.push({
          $groupLabel: curr[label],
          $isLabel: true
        });
        return prev.concat(curr[values]);
      }
      return prev;
    }, []);
  };
}

function filterGroups(search, label, values, groupLabel, customLabel) {
  return function (groups) {
    return groups.map(function (group) {
      var _ref;

      /* istanbul ignore else */
      if (!group[values]) {
        console.warn('Options passed to vue-multiselect do not contain groups, despite the config.');
        return [];
      }
      var groupOptions = filterOptions(group[values], search, label, customLabel);

      return groupOptions.length ? (_ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, groupLabel, group[groupLabel]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, values, groupOptions), _ref) : [];
    });
  };
}

var flow = function flow() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduce(function (v, f) {
      return f(v);
    }, x);
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      isOpen: false,
      prefferedOpenDirection: 'below',
      optimizedHeight: this.maxHeight,
      groupCollapsibleExpandedList: []
    };
  },

  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: true
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Presets the selected options value.
     * @type {Object||Array||String||Integer}
     */
    value: {
      type: null,
      default: function _default() {
        return [];
      }
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: 'Select option'
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: true
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: false
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default: function _default(option, label) {
        if (isEmpty(option)) return '';
        return label ? option[label] : option;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: 'Press enter to create a tag'
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: 'top'
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: false
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1000
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: false
    },
    /**
     * Allow to use collapsible group
     * values
     *
     * @default false
     * @type {Boolean}
     */
    groupCollapsible: {
      type: Boolean,
      default: false
    },
    /**
     * Set default state of collapsible
     * groups to expanded or collapsed
     *
     * @default false
     * @type {Boolean}
     */
    groupCollapsibleExpanded: {
      type: Boolean,
      default: false
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: false
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    /* istanbul ignore else */
    if (!this.multiple && !this.clearOnSelect) {
      console.warn('[Vue-Multiselect warn]: ClearOnSelect and Multiple props can’t be both set to false.');
    }
    if (!this.multiple && this.max) {
      console.warn('[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false.');
    }
    if (this.preselectFirst && !this.internalValue.length && this.options.length) {
      this.select(this.filteredOptions[0]);
    }
    if (this.groupCollapsibleExpanded) {
      this.options.map(function (item) {
        if (item.hasOwnProperty(_this.groupValues) && item[_this.groupValues].length) {
          _this.groupCollapsibleExpandedList.push(item[_this.groupLabel]);
        }
      });
    }
  },

  computed: {
    internalValue: function internalValue() {
      return this.value || this.value === 0 ? Array.isArray(this.value) ? this.value : [this.value] : [];
    },
    filteredOptions: function filteredOptions() {
      var search = this.search || '';
      var normalizedSearch = search.toLowerCase().trim();

      var options = this.options.concat();

      /* istanbul ignore else */
      if (this.internalSearch) {
        options = this.groupValues ? this.filterAndFlat(options, normalizedSearch, this.label) : filterOptions(options, normalizedSearch, this.label, this.customLabel);
      } else {
        options = this.groupValues ? flattenOptions(this.groupValues, this.groupLabel)(options) : options;
      }

      options = this.hideSelected ? options.filter(not(this.isSelected)) : options;

      /* istanbul ignore else */
      if (this.taggable && normalizedSearch.length && !this.isExistingOption(normalizedSearch)) {
        if (this.tagPosition === 'bottom') {
          options.push({ isTag: true, label: search });
        } else {
          options.unshift({ isTag: true, label: search });
        }
      }

      return options.slice(0, this.optionsLimit);
    },
    valueKeys: function valueKeys() {
      var _this2 = this;

      if (this.trackBy) {
        return this.internalValue.map(function (element) {
          return element[_this2.trackBy];
        });
      } else {
        return this.internalValue;
      }
    },
    optionKeys: function optionKeys() {
      var _this3 = this;

      var options = this.groupValues ? this.flatAndStrip(this.options) : this.options;
      return options.map(function (element) {
        return _this3.customLabel(element, _this3.label).toString().toLowerCase();
      });
    },
    currentOptionLabel: function currentOptionLabel() {
      return this.multiple ? this.searchable ? '' : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? '' : this.placeholder;
    }
  },
  watch: {
    internalValue: function internalValue() {
      /* istanbul ignore else */
      if (this.resetAfter && this.internalValue.length) {
        this.search = '';
        this.$emit('input', this.multiple ? [] : null);
      }
    },
    search: function search() {
      this.$emit('search-change', this.search, this.id);
    }
  },
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue: function getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },

    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @returns {Array} returns a filtered and flat options list
     */
    filterAndFlat: function filterAndFlat(options, search, label) {
      return flow(filterGroups(search, label, this.groupValues, this.groupLabel, this.customLabel), flattenOptions(this.groupValues, this.groupLabel))(options);
    },

    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @returns {Array} returns a flat options list without group labels
     */
    flatAndStrip: function flatAndStrip(options) {
      return flow(flattenOptions(this.groupValues, this.groupLabel), stripGroups)(options);
    },

    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch: function updateSearch(query) {
      this.search = query;
    },

    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @returns {Boolean} returns true if element is available
     */
    isExistingOption: function isExistingOption(query) {
      return !this.options ? false : this.optionKeys.indexOf(query) > -1;
    },

    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected: function isSelected(option) {
      var opt = this.trackBy ? option[this.trackBy] : option;
      return this.valueKeys.indexOf(opt) > -1;
    },

    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel: function getOptionLabel(option) {
      if (isEmpty(option)) return '';
      /* istanbul ignore else */
      if (option.isTag) return option.label;
      /* istanbul ignore else */
      if (option.$isLabel) return option.$groupLabel;

      var label = this.customLabel(option, this.label);
      /* istanbul ignore else */
      if (isEmpty(label)) return '';
      return label;
    },

    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select: function select(option, key) {
      /* istanbul ignore else */
      if (option.$isLabel && this.groupSelect) {
        this.selectGroup(option);
        return;
      }
      if (this.blockKeys.indexOf(key) !== -1 || this.disabled || option.$isDisabled || option.$isLabel) return;
      /* istanbul ignore else */
      if (this.max && this.multiple && this.internalValue.length === this.max) return;
      /* istanbul ignore else */
      if (key === 'Tab' && !this.pointerDirty) return;
      if (option.isTag) {
        this.$emit('tag', option.label, this.id);
        this.search = '';
        if (this.closeOnSelect && !this.multiple) this.deactivate();
      } else {
        var isSelected = this.isSelected(option);

        if (isSelected) {
          if (key !== 'Tab') this.removeElement(option);
          return;
        }

        this.$emit('select', option, this.id);

        if (this.multiple) {
          this.$emit('input', this.internalValue.concat([option]), this.id);
        } else {
          this.$emit('input', option, this.id);
        }

        /* istanbul ignore else */
        if (this.clearOnSelect) this.search = '';
      }
      /* istanbul ignore else */
      if (this.closeOnSelect) this.deactivate();
    },

    /**
     * Add the given option to the list of expanded options.
     * If option is already expanded -> remove it from the
     * current expanded list.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param {Boolean} toggledByIcon
     */
    groupCollapsibleToggle: function groupCollapsibleToggle(option) {
      var toggledByIcon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      /* istanbul ignore else */
      if (!toggledByIcon && this.groupSelect || toggledByIcon && !this.groupSelect) return;
      /* istanbul ignore else */
      if (!this.groupCollapsible || !option.$isLabel || !option.$groupLabel) return;

      if (!this.groupCollapsibleExpandedList.includes(option.$groupLabel)) {
        this.groupCollapsibleExpandedList.push(option.$groupLabel);
      } else {
        this.groupCollapsibleExpandedList = this.groupCollapsibleExpandedList.filter(function (item) {
          return item !== option.$groupLabel;
        });
      }
    },

    /**
     * Checks whether the option for group collapsible is expanded.
     *
     * @param {Object} option
     */
    isGroupCollapsibleOptionExpanded: function isGroupCollapsibleOptionExpanded(option) {
      var _this4 = this;

      if (option.$isLabel) return this.groupCollapsibleExpandedList.includes(option.$groupLabel);

      var expanded = false;
      this.options.map(function (item) {
        if (expanded) return;
        if (item.hasOwnProperty(_this4.groupValues) && item[_this4.groupValues].length) {
          var groupOption = item[_this4.groupValues].find(function (groupOptionItem) {
            return groupOptionItem[_this4.trackBy] === option[_this4.trackBy];
          });
          expanded = groupOption && _this4.groupCollapsibleExpandedList.includes(item[_this4.groupLabel]);
        }
      });

      return expanded;
    },

    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup: function selectGroup(selectedGroup) {
      var _this5 = this;

      var group = this.options.find(function (option) {
        return option[_this5.groupLabel] === selectedGroup.$groupLabel;
      });

      if (!group) return;

      if (this.wholeGroupSelected(group)) {
        this.$emit('remove', group[this.groupValues], this.id);

        var newValue = this.internalValue.filter(function (option) {
          return group[_this5.groupValues].indexOf(option) === -1;
        });

        this.$emit('input', newValue, this.id);
      } else {
        var optionsToAdd = group[this.groupValues].filter(not(this.isSelected));

        this.$emit('select', optionsToAdd, this.id);
        this.$emit('input', this.internalValue.concat(optionsToAdd), this.id);
      }
    },

    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    expandGroup: function expandGroup(selectedGroup) {
      var _this6 = this;

      var group = this.options.find(function (option) {
        return option[_this6.groupLabel] === selectedGroup.$groupLabel;
      });

      if (!group) return;

      if (this.wholeGroupSelected(group)) {
        this.$emit('remove', group[this.groupValues], this.id);

        var newValue = this.internalValue.filter(function (option) {
          return group[_this6.groupValues].indexOf(option) === -1;
        });

        this.$emit('input', newValue, this.id);
      } else {
        var optionsToAdd = group[this.groupValues].filter(not(this.isSelected));

        this.$emit('select', optionsToAdd, this.id);
        this.$emit('input', this.internalValue.concat(optionsToAdd), this.id);
      }
    },

    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected: function wholeGroupSelected(group) {
      return group[this.groupValues].every(this.isSelected);
    },

    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @returns {type}        description
     */
    removeElement: function removeElement(option) {
      var shouldClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      /* istanbul ignore else */
      if (this.disabled) return;
      /* istanbul ignore else */
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }

      var index = (typeof option === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) === 'object' ? this.valueKeys.indexOf(option[this.trackBy]) : this.valueKeys.indexOf(option);

      this.$emit('remove', option, this.id);
      if (this.multiple) {
        var newValue = this.internalValue.slice(0, index).concat(this.internalValue.slice(index + 1));
        this.$emit('input', newValue, this.id);
      } else {
        this.$emit('input', null, this.id);
      }

      /* istanbul ignore else */
      if (this.closeOnSelect && shouldClose) this.deactivate();
    },

    /**
    * Removes the given option from collapsible expanded list options.
    *
    * @param {type} option description
    * @returns {type} description
    */
    removeFromExpanded: function removeFromExpanded(option) {},

    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement: function removeLastElement() {
      /* istanbul ignore else */
      if (this.blockKeys.indexOf('Delete') !== -1) return;
      /* istanbul ignore else */
      if (this.search.length === 0 && Array.isArray(this.internalValue)) {
        this.removeElement(this.internalValue[this.internalValue.length - 1], false);
      }
    },

    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate: function activate() {
      var _this7 = this;

      /* istanbul ignore else */
      if (this.isOpen || this.disabled) return;

      this.adjustPosition();
      /* istanbul ignore else  */
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;
      /* istanbul ignore else  */
      if (this.searchable) {
        if (!this.preserveSearch) this.search = '';
        this.$nextTick(function () {
          return _this7.$refs.search.focus();
        });
      } else {
        this.$el.focus();
      }
      this.$emit('open', this.id);
    },

    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate: function deactivate() {
      /* istanbul ignore else */
      if (!this.isOpen) return;

      this.isOpen = false;
      /* istanbul ignore else  */
      if (this.searchable) {
        this.$refs.search.blur();
      } else {
        this.$el.blur();
      }
      if (!this.preserveSearch) this.search = '';
      this.$emit('close', this.getValue(), this.id);
    },

    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle: function toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },

    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition: function adjustPosition() {
      if (typeof window === 'undefined') return;

      var spaceAbove = this.$el.getBoundingClientRect().top;
      var spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      var hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === 'below' || this.openDirection === 'bottom') {
        this.prefferedOpenDirection = 'below';
        this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
      } else {
        this.prefferedOpenDirection = 'above';
        this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
      }
    }
  }
});

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pointer: 0,
      pointerDirty: false
    };
  },

  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition: function pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements: function visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions: function filteredOptions() {
      this.pointerAdjust();
    },
    isOpen: function isOpen() {
      this.pointerDirty = false;
    }
  },
  methods: {
    optionHighlight: function optionHighlight(index, option) {
      return {
        'multiselect__option--highlight': index === this.pointer && this.showPointer,
        'multiselect__option--selected': this.isSelected(option)
      };
    },
    groupHighlight: function groupHighlight(index, selectedGroup) {
      var _this = this;

      if (!this.groupSelect) {
        return ['multiselect__option--disabled'];
      }

      var group = this.options.find(function (option) {
        return option[_this.groupLabel] === selectedGroup.$groupLabel;
      });

      return [this.groupSelect ? 'multiselect__option--group' : 'multiselect__option--disabled', { 'multiselect__option--highlight': index === this.pointer && this.showPointer }, { 'multiselect__option--group-selected': this.wholeGroupSelected(group) }];
    },
    addPointerElement: function addPointerElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Enter',
          key = _ref.key;

      /* istanbul ignore else */
      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerForward: function pointerForward() {
      /* istanbul ignore else */
      if (this.pointer < this.filteredOptions.length - 1) {
        this.pointer++;
        /* istanbul ignore next */
        if (this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight) {
          this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.collapsibleStateUpdate();
      this.pointerDirty = true;
    },
    pointerBackward: function pointerBackward() {
      if (this.pointer > 0) {
        this.pointer--;
        /* istanbul ignore else */
        if (this.$refs.list.scrollTop >= this.pointerPosition) {
          this.$refs.list.scrollTop = this.pointerPosition;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerBackward();
      } else {
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.collapsibleStateUpdate();
      this.pointerDirty = true;
    },
    pointerReset: function pointerReset() {
      /* istanbul ignore else */
      if (!this.closeOnSelect) return;
      this.pointer = 0;
      /* istanbul ignore else */
      if (this.$refs.list) {
        this.$refs.list.scrollTop = 0;
      }
    },
    pointerAdjust: function pointerAdjust() {
      /* istanbul ignore else */
      if (this.pointer >= this.filteredOptions.length - 1) {
        this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0;
      }

      if (this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) {
        this.pointerForward();
      }
    },
    pointerSet: function pointerSet(index) {
      this.pointer = index;
      this.pointerDirty = true;
    },
    collapsibleStateUpdate: function collapsibleStateUpdate() {
      var _this2 = this;

      if (this.groupCollapsible) {
        var groupOption = false;
        this.options.map(function (item) {
          if (groupOption) return;
          if (item.hasOwnProperty(_this2.groupValues) && item[_this2.groupValues].length) {
            groupOption = item[_this2.groupValues].find(function (groupOptionItem) {
              return groupOptionItem[_this2.trackBy] === _this2.filteredOptions[_this2.pointer][_this2.trackBy];
            });
            if (groupOption) _this2.groupCollapsibleExpandedList.push(item[_this2.groupLabel]);
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(888), __esModule: true };

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(966),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(954),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(971),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(962),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, module) {(function (w) {
  "use strict";

  function findBest(atobNative) {
    // normal window
    if ('function' === typeof atobNative) { return atobNative; }


    // browserify (web worker)
    if ('function' === typeof Buffer) {
      return function atobBrowserify(a) {
        //!! Deliberately using an API that's deprecated in node.js because
        //!! this file is for browsers and we expect them to cope with it.
        //!! Discussion: github.com/node-browser-compat/atob/pull/9
        return new Buffer(a, 'base64').toString('binary');
      };
    }

    // ios web worker with base64js
    if ('object' === typeof w.base64js) {
      // bufferToBinaryString
      // https://git.coolaj86.com/coolaj86/unibabel.js/blob/master/index.js#L50
      return function atobWebWorker_iOS(a) {
        var buf = w.base64js.b64ToByteArray(a);
        return Array.prototype.map.call(buf, function (ch) {
          return String.fromCharCode(ch);
        }).join('');
      };
    }

		return function () {
			// ios web worker without base64js
			throw new Error("You're probably in an old browser or an iOS webworker." +
				" It might help to include beatgammit's base64-js.");
    };
  }

  var atobBest = findBest(w.atob);
  w.atob = atobBest;

  if ((typeof module === 'object') && module && module.exports) {
    module.exports = atobBest;
  }
}(window));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5).Buffer, __webpack_require__(42)(module)))

/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = url_shortener;
/* unused harmony export url_decode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_firebaseConfig__ = __webpack_require__(822);



var btoa = __webpack_require__(887);
var atob = __webpack_require__(847);

function url_shortener(des_url) {

  // Get all existing documents from firebase
  var doShorten = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var enc, el;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__assets_js_on_firebaseConfig__["a" /* db */].collection("short_url").get().then(function (q) {
                q.forEach(function (doc) {
                  fireResults.push(doc.data()); // Populate fireResults with data
                });
              }).catch(function (error) {
                return err = true;
              });

            case 2:

              index = fireResults.length;

              urlObj = { // Create a model for new data
                id: index + 1,
                longURL: des_url,
                createdAt: Date.now()
              };

              enc = btoa(urlObj.id); // This is outside due to javscript limitations

              if (enc.indexOf('=') > 0) {
                enc = enc.substring(0, enc.indexOf('='));
              }
              urlObj.shortURL = enc;
              console.log(urlObj.shortURL);

              if (fireResults.length < 1) {
                pushToFirestore();
              }

              el = 0;

            case 10:
              if (!(el < fireResults.length)) {
                _context.next = 26;
                break;
              }

              if (!(fireResults[el].longURL === des_url)) {
                _context.next = 16;
                break;
              }

              // If the URL already exists, return the URL
              urlObj = fireResults[el];
              return _context.abrupt('return', urlObj);

            case 16:
              console.log("Creating new URL Object...");
              // Else push to firestore and return the created Url object
              pushToFirestore();
              // then

              if (!err) {
                _context.next = 22;
                break;
              }

              return _context.abrupt('return', false);

            case 22:
              return _context.abrupt('return', urlObj);

            case 23:
              el++;
              _context.next = 10;
              break;

            case 26:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function doShorten() {
      return _ref.apply(this, arguments);
    };
  }();

  // Using Axios
  // Write logic to retrieve from Firestore - We will get from firestore and
  // store the results in an object
  var index = 0;
  var err = false;
  var fireResults = [];
  var urlObj = {};

  function pushToFirestore() {
    // Logic to update firestore with new urlObj
    __WEBPACK_IMPORTED_MODULE_2__assets_js_on_firebaseConfig__["a" /* db */].collection("short_url").doc(urlObj.id.toString()).set({
      longURL: urlObj.longURL,
      shortURL: urlObj.shortURL,
      createdAt: urlObj.createdAt
    }).then(function () {
      console.log("saved");
    }).catch(function (error) {
      console.error(error);
      err = true;
    });
  }

  var returnVariableToRuleThemAll = doShorten();
  return returnVariableToRuleThemAll;
}

function url_decode(url) {
  var doDecode = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__assets_js_on_firebaseConfig__["a" /* db */].collection("short_url").where("shortURL", "==", url).get().then(function (q) {
                q.forEach(function (doc) {
                  fireResults.push(doc.data()); // Populate fireResults with data
                });
              }).catch(function (error) {
                return err = true;
              });

            case 2:
              return _context2.abrupt('return', fireResults[0]);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function doDecode() {
      return _ref2.apply(this, arguments);
    };
  }();

  var fireResults = [];
  var err = false;

  var anotherVariableThatWillRuleTheFirstVariable = doDecode();
  return anotherVariableThatWillRuleTheFirstVariable;
}

/***/ }),

/***/ 855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = supportFullScreen;
/* harmony export (immutable) */ __webpack_exports__["a"] = fullScreenStatus;
/* harmony export (immutable) */ __webpack_exports__["c"] = requestFullscreen;
/* harmony export (immutable) */ __webpack_exports__["d"] = exitFullscreen;
/* harmony export (immutable) */ __webpack_exports__["b"] = onFullScreenEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = offFullScreenEvent;
/* unused harmony export extend */
function supportFullScreen() {
  var doc = document.documentElement;

  return 'requestFullscreen' in doc || 'mozRequestFullScreen' in doc && document.mozFullScreenEnabled || 'msRequestFullscreen' in doc && document.msFullscreenEnabled || 'webkitRequestFullScreen' in doc;
}

function fullScreenStatus() {
  if (document.fullscreen || document.mozFullScreen || document.fullscreenElement || document.msFullscreenElement || document.webkitIsFullScreen) {
    return true;
  } else {
    return false;
  }
}

function requestFullscreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  } else {
    console.log('Fullscreen API is not supported.');
  }
}

function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else {
    console.log('Fullscreen API is not supported.');
  }
}

function onFullScreenEvent(callback) {
  document.addEventListener('fullscreenchange', callback);
  document.addEventListener('mozfullscreenchange', callback);
  document.addEventListener('MSFullscreenChange', callback);
  document.addEventListener('webkitfullscreenchange', callback);
}

function offFullScreenEvent(callback) {
  document.removeEventListener('fullscreenchange', callback);
  document.removeEventListener('mozfullscreenchange', callback);
  document.removeEventListener('MSFullscreenChange', callback);
  document.removeEventListener('webkitfullscreenchange', callback);
}

// 实现jquery对象继承，支持深拷贝
function extend() {
  var extended = {};
  var deep = false;
  var i = 0;
  var length = arguments.length;

  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0];
    i++;
  }

  function merge(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  }

  for (; i < length; i++) {
    var obj = arguments[i];
    merge(obj);
  }

  return extended;
}

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(855);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    background: {
      type: String,
      default: '#333'
    },
    fullscreenClass: {
      type: String,
      default: 'fullscreen'
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      supportFullScreen: false,
      isFullscreen: false
    };
  },


  computed: {
    wrapperStyle: function wrapperStyle() {
      return {
        'background': this.background,
        'overflow-y': 'auto',
        'width': '100%',
        'height': '100%'
      };
    }
  },

  methods: {
    toggle: function toggle(value) {
      if (value === undefined) {
        // 如果已经是全屏状态，则退出
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* fullScreenStatus */])()) {
          this.exit();
        } else {
          this.enter();
        }
      } else {
        value ? this.enter() : this.exit();
      }
    },
    enter: function enter() {
      if (!this.supportFullScreen) {
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* onFullScreenEvent */])(this.fullScreenCallback);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* requestFullscreen */])(this.$el);
    },
    exit: function exit() {
      if (!this.supportFullScreen) {
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* exitFullscreen */])();
    },
    getState: function getState() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* fullScreenStatus */])();
    },
    shadeClick: function shadeClick(e) {
      if (e.target === this.$el) {
        this.exit();
      }
    },
    fullScreenCallback: function fullScreenCallback() {
      this.isFullscreen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* fullScreenStatus */])();
      if (!this.isFullscreen) {
        // 退出全屏时解绑回调
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* offFullScreenEvent */])(this.fullScreenCallback);
      }
      this.$emit('change', this.isFullscreen);
      this.$emit('update:fullscreen', this.isFullscreen);
    }
  },

  watch: {
    fullscreen: function fullscreen(value) {
      if (value !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* fullScreenStatus */])()) {
        value ? this.enter() : this.exit();
      }
    }
  },

  created: function created() {
    this.supportFullScreen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* supportFullScreen */])();
  }
});

/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__multiselectMixin__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pointerMixin__ = __webpack_require__(841);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "vue-multiselect",
  mixins: [__WEBPACK_IMPORTED_MODULE_0__multiselectMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__pointerMixin__["a" /* default */]],
  props: {
    /**
     * name attribute to match optional label element
     * @default ''
     * @type {String}
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * String to show when pointing to an option
     * @default 'Press enter to select'
     * @type {String}
     */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
     * String to show when pointing to an option
     * @default 'Press enter to select'
     * @type {String}
     */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
     * String to show when pointing to the collapsible group option if it is expanded
     *
     * @default 'Click to collapse'
     * @type {String}
     */
    collapseGroupLabel: {
      type: String,
      default: "Click to collapse group"
    },
    /**
     * String to show when pointing to the collapsible group option if it is collapsed
     *
     * @default 'Click to expand'
     * @type {String}
     */
    expandGroupLabel: {
      type: String,
      default: "Click to expand group"
    },
    /**
     * String to show when pointing to the collapsible group option if it is expanded
     *
     * @default 'Click to collapse'
     * @type {String}
     */
    collapseByToggleGroupLabel: {
      type: String,
      default: "Click on toggle icon to collapse group"
    },
    /**
     * String to show when pointing to the collapsible group option if it is collapsed
     *
     * @default 'Click to expand'
     * @type {String}
     */
    expandByToggleGroupLabel: {
      type: String,
      default: "Click on toggle icon to expand group"
    },
    /**
     * String to show next to selected option
     * @default 'Selected'
     * @type {String}
     */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
     * String to show when pointing to an already selected option
     * @default 'Press enter to remove'
     * @type {String}
     */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
     * String to show when pointing to an already selected option
     * @default 'Press enter to remove'
     * @type {String}
     */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
     * Decide whether to show pointer labels
     * @default true
     * @type {Boolean}
     */
    showLabels: {
      type: Boolean,
      default: true
    },
    /**
     * Decide whether to show input
     * @default true
     * @type {Boolean}
     */
    showInput: {
      type: Boolean,
      default: true
    },
    /**
     * Limit the display of selected options. The rest will be hidden within the limitText string.
     * @default 99999
     * @type {Integer}
     */
    limit: {
      type: Number,
      default: 99999
    },
    /**
     * Sets maxHeight style value of the dropdown
     * @default 300
     * @type {Integer}
     */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
     * Function that process the message shown when selected
     * elements pass the defined limit.
     * @default 'and * more'
     * @param {Int} count Number of elements more than limit
     * @type {Function}
     */
    limitText: {
      type: Function,
      default: function _default(count) {
        return "and " + count + " more";
      }
    },
    /**
     * Set true to trigger the loading spinner.
     * @default False
     * @type {Boolean}
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Disables the multiselect if true.
     * @default false
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Fixed opening direction
     * @default ''
     * @type {String}
     */
    openDirection: {
      type: String,
      default: ""
    },
    /**
     * Shows slot with message about empty options
     * @default true
     * @type {Boolean}
     */
    showNoOptions: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isSingleLabelVisible: function isSingleLabelVisible() {
      return this.singleValue && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible: function isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues: function visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue: function singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText: function deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText: function deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText: function selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText: function selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText: function selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    collapsedGroupLabelText: function collapsedGroupLabelText() {
      return this.showLabels && this.groupCollapsible ? this.groupSelect ? this.collapseByToggleGroupLabel : this.collapseGroupLabel : "";
    },
    expandedGroupLabelText: function expandedGroupLabelText() {
      return this.showLabels && this.groupCollapsible ? this.groupSelect ? this.expandByToggleGroupLabel : this.expandGroupLabel : "";
    },
    inputStyle: function inputStyle() {
      if (
      // this.searchable ||
      // (this.multiple && this.value && this.value.length)
      this.multiple && this.value && this.value.length) {
        // Hide input by setting the width to 0 allowing it to receive focus
        return this.isOpen ? { width: "auto" } : { width: "0", position: "absolute", padding: "0" };
      }
    },
    contentStyle: function contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove: function isAbove() {
      if (this.openDirection === "above" || this.openDirection === "top") {
        return true;
      } else if (this.openDirection === "below" || this.openDirection === "bottom") {
        return false;
      } else {
        return this.prefferedOpenDirection === "above";
      }
    },
    showSearchInput: function showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : true);
    }
  }
});

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_on_firebaseConfig__ = __webpack_require__(822);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comment',
  components: {},
  data: function data() {
    return {
      // start floating buttons variables
      // direction: 'left',
      // hover: false,
      // top: false,
      // right: true,
      // bottom: true,
      // left: false,
      fab: false,
      fling: false,
      tabs: null,
      transition: 'slide-y-reverse-transition',
      // end
      isComponentModalActive: false,
      // user comment attribute
      fullName: '',
      organization: '',
      comment: '',
      userComments: JSON.parse(this.$ls.get('user_comments')) || [],
      internetCheckURL: 'https://jsonplaceholder.typicode.com/todos/1'
    };
  },

  methods: {
    fetchComments: function fetchComments() {
      var _this = this;

      var userComments = this.userComments.slice(0);
      this.$firestore.userComments.get().then(function (querySnapShot) {
        var tempComments = [];
        querySnapShot.forEach(function (doc) {
          // console.log(doc.id, doc.data());
          var data = {
            'id': doc.id,
            'fullName': doc.data().fullName,
            'organization': doc.data().organization,
            'comment': doc.data().comment,
            'timestamp': doc.data().timestamp,
            'deleted': doc.data().deleted
          };
          tempComments.push(data);
        });
        // sync local storage with firestore...
        userComments = _this.syncFirestoreToLocalstorage(tempComments, userComments);
        // update the localstorage with the latest comments from firestore.
        _this.$ls.set('user_comments', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(userComments));
        // sort the comments in the order they were made...
        _this.userComments = userComments.slice(0).sort(function (a, b) {
          return b.timestamp - a.timestamp;
        });
      }).catch(function (error) {
        console.log('cannot read from firestore', error);
      });
    },

    // check if comments in firestore is not already in local storage
    syncFirestoreToLocalstorage: function syncFirestoreToLocalstorage(tempComments, userComments) {
      var hasDocument = false;
      var commentsToSync = this.userComments.slice(0);
      for (var i = 0; i < tempComments.length; i++) {
        for (var j = 0; j < userComments.length; j++) {
          if (tempComments[i].timestamp === userComments[j].timestamp) {
            // doocument from firestore exists in local storage, skip
            hasDocument = true;
            break;
          }
        }
        // document from firestore doesn't exist and document is not deleted, add
        if (!hasDocument && !tempComments[i].deleted) {
          commentsToSync.push(tempComments[i]);
        }
        // reset hasDocument.
        hasDocument = false;
      }
      return commentsToSync.slice(0);
    },

    // check if comments in localstorage is not already on firestore
    syncLocalstorageToFirestore: function syncLocalstorageToFirestore(tempComments, userComments) {
      // tempComments are existing comments on firestore...
      var hasDocument = false;
      var commentsToSync = [];
      for (var i = 0; i < userComments.length; i++) {
        for (var j = 0; j < tempComments.length; j++) {
          if (userComments[i].timestamp === tempComments[j].timestamp) {
            // doocument from firestore exists in local storage, skip
            hasDocument = true;
            break;
          }
        }
        // document from firestore doesn't exist, add
        if (!hasDocument) {
          commentsToSync.push(userComments[i]);
        }
        // reset hasDocument.
        hasDocument = false;
      }
      return commentsToSync.slice(0);
    },
    loadCommentModal: function loadCommentModal(isModalActive) {
      var _this2 = this;

      // load all comments from local storage...
      var userComments = JSON.parse(this.$ls.get('user_comments'));
      this.userComments = userComments.slice(0).sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });

      this.axios.get(this.internetCheckURL).then(function (result) {
        _this2.fetchComments(); // fetch synchronized comments...
      }).catch(function (error) {
        console.log('no network to connect to API', error);
      });
      this.isComponentModalActive = !isModalActive;
    },

    // post comments and feedback to localstorage
    postComment: function postComment() {
      var _this3 = this;

      // load comment from localstorage
      var userComments = JSON.parse(this.$ls.get('user_comments'));
      if (!userComments) {
        userComments = [];
        this.$ls.set('user_comments', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(userComments));
      }
      var userComment = {
        fullName: this.fullName,
        organization: this.organization,
        comment: this.comment,
        timestamp: new Date().getTime() + parseInt(Math.random(60)),
        deleted: false
        // update the userComments
      };userComments.push(userComment);
      // update the local storage...
      this.$ls.set('user_comments', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(userComments));
      this.userComments = userComments.slice(0).sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });
      // push to firestore; check if there's network connection
      this.axios.get(this.internetCheckURL).then(function (result) {
        // yes, there's internet... now we update firestore with
        // existing comments not sent yet due to absence of internet
        _this3.$firestore.userComments.get().then(function (querySnapShot) {
          var tempComments = [];
          querySnapShot.forEach(function (doc) {
            // console.log(doc.id, doc.data());
            var data = {
              'id': doc.id,
              'fullName': doc.data().fullName,
              'organization': doc.data().organization,
              'comment': doc.data().comment,
              'timestamp': doc.data().timestamp,
              'deleted': doc.data().deleted
            };
            tempComments.push(data);
          });
          // get the comments in localstorage not yet in firestore...
          var commentsToSync = _this3.syncLocalstorageToFirestore(tempComments, userComments);
          // add new and pending comments in local storage to firestore...
          commentsToSync.map(function (userComment, index) {
            _this3.$firestore.userComments.add(userComment).then(function (docRef) {
              console.log('New comment written, id: ', docRef.id);
            }).catch(function (error) {
              console.log('Error adding document to firestore', error);
            });
          });
        });
      }).catch(function (error) {
        // no there's not, do nothing
        console.log('no network to connect to API', error);
      });
      this.fullName = this.organization = this.comment = '';
    }
  },
  firestore: function firestore() {
    return {
      userComments: __WEBPACK_IMPORTED_MODULE_3__assets_js_on_firebaseConfig__["a" /* db */].collection('user_comments')
    };
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.axios.get(_this4.internetCheckURL).then(function (result) {
                // get comments from firestore and save to local storage
                _this4.fetchComments(); // fetch synchronized comments...
              }).catch(function (error) {
                console.log('No internet available, cant fetch from firestore: ', error);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'widget-container',
  props: ['showComponents', 'showMoreFeatures'],
  components: {},
  data: function data() {
    return {
      // start floating buttons variables
      fab: false,
      fling: false,
      tabs: null,
      transition: 'slide-y-reverse-transition',
      widgets: []
    };
  },

  methods: {
    addWidget: function addWidget() {}
  },
  watch: {
    showComponents: function showComponents(val, oldval) {
      console.log(val, oldval);
    }
  }

});

/***/ }),

/***/ 865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lineChart__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__lineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tableComponent__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tableComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tableComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__barChartComponent__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__barChartComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__barChartComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__maptypes__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__maptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__maptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chartTypes__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chartTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__chartTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chartTypes_barChart__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chartTypes_barChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__chartTypes_barChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_html2pdf_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_html2pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_html2pdf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuedraggable__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_js_on_highchart_options__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_comments__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_comments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_comments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgetContainer__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_widgetContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_widgetContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_cookies__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_js_on_url_shortener__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_async__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_js_on_vue_multiselect__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__main__ = __webpack_require__(135);







var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Importing of necessary compoNents








// import sortObjects from '@/assets/js-on/sortObjects';



// import Sortable from 'sortablejs';









// const Swal = require('sweetalert2');
var platform = __webpack_require__(933);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "maincardashboard",
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_22__assets_js_on_vue_multiselect__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_14_vuedraggable___default.a,
    PlotMap: __WEBPACK_IMPORTED_MODULE_10__maptypes___default.a,
    PlotChart: __WEBPACK_IMPORTED_MODULE_11__chartTypes___default.a,
    BarChart: __WEBPACK_IMPORTED_MODULE_12__chartTypes_barChart___default.a,
    BarChartComponent: __WEBPACK_IMPORTED_MODULE_8__barChartComponent___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_6__lineChart___default.a,
    TableComponent: __WEBPACK_IMPORTED_MODULE_7__tableComponent___default.a,
    RegionsChart: function RegionsChart() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 947));
    },
    ColumnChart: function ColumnChart() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 942));
    },
    RegionsMap: function RegionsMap() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 945));
    },
    Comments: __WEBPACK_IMPORTED_MODULE_16__components_comments___default.a,
    WidgetContainer: __WEBPACK_IMPORTED_MODULE_17__components_widgetContainer___default.a,
    compareSection: function compareSection() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 943));
    },
    carousel: function carousel() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 422));
    },
    CompareSec: function CompareSec() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 939));
    }
  },
  props: ["appData", "indicator_variables", "indicator_year"],
  //
  // indDB: indDB,
  data: function data() {
    var _ref;

    return _ref = {
      requestedBytes: 1024 * 1024 * 20, // 10MB
      loader: false,
      isOnline: window.navigator.onLine,
      // FullScreen
      fullscreen: false,
      alertMobile: true,
      detect: false,
      nofields: false,
      successmessage: false,
      errormessage: false,
      contactFormFields: {
        name: "",
        email_address: "",
        profession: "",
        organisation: "",
        newsletter: false,
        category: "",
        comment: ""
      },
      ndStateData: "",
      ndLgaData: "",
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      estimatesData: JSON.parse(this.$ls.get("estimates_dataset")),
      // lgaData: JSON.parse(this.$ls.get("lga_dataset")),
      lgaData: [],
      metaData: JSON.parse(this.$ls.get("meta_data_dataset")),
      sourceMetaData: JSON.parse(this.$ls.get("source_meta_dataset")),
      indicatorMetaData: JSON.parse(this.$ls.get("indicator_meta_dataset")),
      isDataLoadedFirstTime: false,
      showMoreFeatures: true,
      owlNavText: ["<i class='owlCar fa fa-angle-left ' ></i>", "<i class='owlCar fa fa-angle-right'></i>"],
      // openCPanel: false,
      showIcon: false,
      barChartHidden: false,
      // isOpen: true,
      collapsible: true,
      elementToCompare: "source",
      isElementToCompareIndicator: false,
      optionYear: [],
      zonalYearOptions: [],
      zonalSourcesOptions: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS", "World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
      zonalSelectedYear: "",
      zonalSelectedSource: "",
      shareButtonClicked: false,
      scrolledToBottom: false,
      isTourActive: true,
      isTourStarts: false,
      firstTimeNotification: false,
      // showIHMEEstimate: false,
      computeUncertaintyTruthVal: false,
      comparisonSelectedSource: "NHMIS",
      comparisonSelectedState: "National",
      mapComparisonSelectedSource: "NHMIS",
      comparisonSelectedIndicator: {
        name: "Skilled attendance at delivery or birth"
      },
      loading: false,
      optionSources: ["MICS", "NHMIS", "NNHS", "NDHS", "NMIS", "PCCS", "NARHS", "IHME", "World Bank", "WHO-GHO", "WUENIC"],
      snackbar: true,
      regionalChartYearOptionsData: [],
      contactForm: false,
      showComponents: true,
      componentTypeArray: [],
      componentType: "Charts",
      specificComponentOptions: ["line", "column"],
      specificComponentType: "line",
      specificMapType: ["states", "states", "states"],
      specificChartType: ["line", "line", "line"],
      firstTimeUser: false,
      selectedOption: { name: "Option 4.1" },
      loadingbar: false,
      selectedYear: null,
      showMoreMsg: "hide zonal charts",
      showCompareMsg: "hide comparison charts",
      selectedIndicator: { name: "Skilled attendance at delivery or birth" },
      optionIndicators: [],
      headerObj: {},
      traceArray: [],
      dashboardState: {},
      plotData: {},
      // Api Links
      // apiUrl: "https://msdat-database.firebaseio.com/masterSheet.json",
      apiUrl: "https://car-dashboard-others.firebaseio.com/masterSheet.json",
      // targetUrl: "https://car-dashboard-others.firebaseio.com/targets.json",
      estimatesUrl: "https://car-dashboard-others.firebaseio.com/estimates.json",
      LGA_Url: "https://car-dashboard-others.firebaseio.com/car-lga-data.json",
      // LGA_Url: "https://car-dashboard-others.firebaseio.com/car-lga-data2.json",
      metaDataUrl: "https://car-dashboard-others.firebaseio.com/meta-data.json",
      // metaDataUrl: "https://msdat-database.firebaseio.com/meta-data-test.json",
      dataSourceUrl: "https://car-dashboard-others.firebaseio.com/data-source-meta-data.json",
      // dataSourceUrl: "https://msdat-database.firebaseio.com/data-source-meta-data.json",
      indicatorUrl: "https://car-dashboard-others.firebaseio.com/indicator-meta-data.json",
      // indicatorUrl: "https://msdat-database.firebaseio.com/indicator-meta-data-test.json",
      //numerator-denominator api url
      // ndStateUrl: "https://car-dashboard-others.firebaseio.com/ndlga.json",
      // ndLgaUrl: "https://car-dashboard-others.firebaseio.com/ndState.json",
      nhmisMonthlyUrl: "https://car-dashboard-others.firebaseio.com/nhmis_monthly.json",
      selectedSource: "null",
      sourceClickProp: null,
      dataSourceForChart: [],
      tableColumnHeaderAttr: null,
      //Default Selected National
      selectedState: "National",
      //Select options
      optionStates: ["National", "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      options: [],
      value: [],
      isToggleClicked: false,
      isIHMEtoggleClicked: false,
      relativeIndicators: [],
      callerComponentName: "",
      linkCopied: false,
      shareURL: "",
      shareURLHash: "",
      shortURL: "",
      loadingURLIcon: false,
      errorFetchingURL: false,
      params: this.$store.getters.getParams,
      urlParams: ""
    }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "shortURL", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "urlParam", this.$route.params.sharer), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "dashboardStateOptions", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "dashboardStateOptionsArray", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "multiselectPlaceholder", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "statePlaceholder", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "mapPlotData", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "compareIndicatorMultitselectPlaceholder", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "comparisonSelectedSourcePlaceholder", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "comparisonSelectedStatePlaceholder", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "compareSectionColorClass", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "config_radius", 3), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "isChartRendered", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "timer", ""), _ref;
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_vuex__["a" /* mapActions */])("CAR", ["storeLgaData"]), (_extends2 = {
    closeAlert: function closeAlert() {
      this.detect = false;
    },
    detectBrowser: function detectBrowser() {
      //for opera
      var isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
      // Firefox 1.0+
      var isFirefox = typeof InstallTrigger !== "undefined";
      // Safari 3.0+ "[object HTMLElementConstructor]"
      var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      }(!window["safari"] || typeof safari !== "undefined" && safari.pushNotification);
      // Internet Explorer 6-11
      var isIE = /*@cc_on!@*/false || !!document.documentMode;
      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;
      // Chrome 1+
      var isChrome = !!window.chrome;
      // Blink engine detection
      var isBlink = (isChrome || isOpera) && !!window.CSS;

      // rework for browser(s) detection

      // if (isChrome || isBlink) {
      //   return true;
      // } else if (isSafari || isFirefox || isOpera || isOpera || isEdge) {
      //   return false;
      // }
      //rework for browser detection
      if (platform.name == "Chrome") {
        return true;
      } else {
        return false;
      }

      // if((isChrome === true && isBlink===true)&& isOpera===false && isFirefox === false && isSafari === false && isOpera === false && isEdge === false){
      //   return true;
      // } else {
      //   return false;
      // }
    },
    conformSend: function conformSend() {
      var _this = this;

      var headers = {
        Authorization: "Bearer 054d817a3b1a3a2c5edf656959334969e1264e84"
      };
      this.loader = true;
      if (this.contactFormFields.name != "" || this.contactFormFields.email != "" || this.contactFormFields.profession != "") {
        if (this.contactFormFields.name && this.contactFormFields.email && this.contactFormFields.profession) {
          __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post("http://135.181.212.168:9234/api/account/contact/", this.contactFormFields, { headers: headers }).then(function (response) {
            // console.log(this.apiFormat(this.contactFormFields))
            if (response.status === 201) {
              // this.successmessage = true;
              _this.loader = false;
              _this.successmessage = true;
              _this.contactFormFields.name = "";
              _this.contactFormFields.email = "";
              _this.contactFormFields.profession = "";
              _this.contactFormFields.newsletter = false;
              _this.contactFormFields.organization = "";
              //location.reload(true);

              self = _this;
              setTimeout(function () {
                // console.log('close');
                self.closeContactform();
              }, 4000);
              // this.contactForm = false;

              // setTimeout(() => {
              // this.formShow = false;
              // },4000);
            } else {
              _this.errormessage = true;
              _this.loader = false;
            }
          }).catch(function (e) {
            // console.log(e);
            _this.errormessage = true;
            _this.loader = false;
          });
          // console.log("testing form");
        }
      } else {
        this.nofields = true;
      }
    },
    closeContactform: function closeContactform() {
      this.contactForm = false;
    },
    apiFormat: function apiFormat(value) {
      var parentArray = [];
      var childArray = [];
      childArray.push(value.name, value.email, value.profession, value.organization, value.category, value.comment, value.newsletter);
      parentArray.push(childArray);
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({ data: parentArray });
    },
    nextItem: function nextItem() {
      var owl = $(".owl-carousel");
      $(".owl-carousel").next();
      if (event.keyCode == 37 || event.which == 37) {
        $(".owl-prev").trigger("click");
      } else if (event.keyCode == 39 || event.which == 39) {
        $(".owl-next").trigger("click");
      }
    },

    /**
     *
     * toggle fullscreen
     */
    toggle: function toggle() {
      // this.$refs['fullscreen'].background = "green";
      // console.log("Here");

      this.$refs["fullscreen"].toggle();
    },
    clearLocalStorage: function clearLocalStorage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //Remove local files
                _this2.$ls.remove("car_other_dataset");
                _this2.$ls.remove("estimates_dataset");
                _this2.$ls.remove("lga_dataset");
                _this2.$ls.remove("meta_data_dataset");
                _this2.$ls.remove("source_meta_dataset");
                _this2.$ls.remove("indicator_meta_dataset");
                _this2.$ls.remove("nd_data");

                // Ignore cached data and fetch new data
                location.reload(true);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },

    //Get plot data for region state map
    getMapPlotData: function getMapPlotData(e) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.mapPlotData = e;

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getComponentTypeArray: function getComponentTypeArray(e) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var allEqual, isElementEqual;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.componentTypeArray = e;

                allEqual = function allEqual(arr) {
                  return arr.every(function (v) {
                    return v === arr[0];
                  });
                };

                isElementEqual = allEqual(_this4.componentTypeArray);

                if (isElementEqual && _this4.elementToCompare === "source") {
                  _this4.componentType = e[0];
                } else {
                  _this4.componentType = "Charts";
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },

    // Listen for render event
    chartRendered: function chartRendered(e) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.isChartRendered = e;

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    openedMultiselect: function openedMultiselect() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.multiselectPlaceholder = "Search Indicator";
                // this.multiselectPlaceholder = 'Search';
                _this6.collapsible = true;

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    closedMultiselect: function closedMultiselect(e) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.multiselectPlaceholder = e;
                _this7.collapsible = true;

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    openedCompareIndicatorMultitselect: function openedCompareIndicatorMultitselect() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.compareIndicatorMultitselectPlaceholder = "Search Indicator";
                _this8.collapsible = true;

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    closedCompareIndicatorMultitselect: function closedCompareIndicatorMultitselect(e) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this9.compareIndicatorMultitselectPlaceholder = e;

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    openedCompareSourceMultitselect: function openedCompareSourceMultitselect() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this10.comparisonSelectedSourcePlaceholder = "Search source";

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    closedCompareSourceMultitselect: function closedCompareSourceMultitselect(e) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this11.comparisonSelectedSourcePlaceholder = e;

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    openedCompareStateMultiselect: function openedCompareStateMultiselect() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this12.comparisonSelectedStatePlaceholder = "Search state";

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    },
    closedCompareStateMultiselect: function closedCompareStateMultiselect(e) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this13.comparisonSelectedStatePlaceholder = e;

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this13);
      }))();
    },
    multiselectSearch: function multiselectSearch() {
      this.collapsible = false;
    },
    openedStateMultiselect: function openedStateMultiselect() {
      this.statePlaceholder = "Search";
    },
    closedStateMultiselect: function closedStateMultiselect(e) {
      this.statePlaceholder = e;
    },
    enter: function enter() {
      return true;
    },
    scrolldown: function scrolldown() {
      this.scrollPage("#bottom_of_page");
      setTimeout(function () {
        document.getElementById("scrollToTopButton").style.display = "block";
        document.getElementById("scrollToButtomButton").style.display = "none";
      }, 500);
    },
    scrollup: function scrollup() {
      this.scrollPage("#top_of_page");
      setTimeout(function () {
        document.getElementById("scrollToButtomButton").style.display = "block";
        document.getElementById("scrollToTopButton").style.display = "none";
      }, 500);
    },
    handleScroll: function handleScroll() {
      // console.log(document.documentElement.scrollTop);
      // if (document.body.scrollTop == 0 || document.documentElement.scrollTop == 0 ) {
      //      document.getElementById("scrollToTopButton").style.display = "none";
      //      document.getElementById("scrollToButtomButton").style.display = "block";
      // }
      // else
      // check scroll bar and change scroll display
      if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
        document.getElementById("scrollToTopButton").style.display = "block";
        document.getElementById("scrollToButtomButton").style.display = "none";
        setTimeout(function () {
          this.loading = false;
          this.loadingbar = false;
        }.bind(this), 5000);
      } else {
        document.getElementById("scrollToTopButton").style.display = "none";
        document.getElementById("scrollToButtomButton").style.display = "block";
        this.loadingbar = true;

        // setTimeout(function () { this.loading = true; this.loadingbar = false  }.bind(this), 5000)

        // setTimeout(function(){ this.loading = true; this.loadingbar = false }, 3000);
      }
    },
    getCallerComponent: function getCallerComponent(e) {
      this.callerComponentName = e;
    },
    copyURL: function copyURL() {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var urlInput;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                urlInput = document.getElementById("urlInput");

                urlInput.select();
                document.execCommand("copy");

                _this14.linkCopied = true;

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this14);
      }))();
    },
    printPage: function printPage(doc) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                window.print();

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this15);
      }))();
    },
    hideBarChartClicked: function hideBarChartClicked(e) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this16.barChartHidden = e;

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this16);
      }))();
    },
    eyeIconClicked: function eyeIconClicked() {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this17.barChartHidden = !_this17.barChartHidden;

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this17);
      }))();
    },

    // shareDashboardState() {
    //   this.shareCounter++;
    // },
    shareViaEmail: function shareViaEmail() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                window.location = "mailto:?subject=Central Analytics Repository Dashboard&body=" + _this18.shareURL;

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this18);
      }))();
    },
    shareViaFacebook: function shareViaFacebook() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var facebookURL;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                facebookURL = "https://www.facebook.com/sharer.php?u=" + _this19.shareURLHash;

                window.open(facebookURL, "_blank", "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=640, height=480");

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this19);
      }))();
    },
    shareViaTwitter: function shareViaTwitter() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var facebookURL;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                facebookURL = "https://twitter.com/share?text=Central Analytics Repository&url=" + _this20.shareURLHash + "&hashtags=fmohconnect";

                window.open(facebookURL, "_blank", "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=640, height=480");

              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this20);
      }))();
    },
    shareViaLinkedin: function shareViaLinkedin() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var linkedinURL;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                linkedinURL = "https://www.linkedin.com/shareArticle?mini=true&url=" + _this21.shareURLHash + "&title=Central%20Analytics%20Repository&summary=Health%20Dashboards&source=CAR";

                window.open(linkedinURL, "_blank", "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=640, height=480");

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this21);
      }))();
    },
    changeDashboardState: function changeDashboardState(e) {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var callerName;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                callerName = _this22.callerComponentName;


                _this22.dashboardState[callerName] = e;

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this22);
      }))();
    },

    /**
     * toggle fullscreen boolean value
     * @param fullscreen | boolean
     */
    fullscreenChange: function fullscreenChange(fullscreen) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _this23.fullscreen = fullscreen;

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this23);
      }))();
    },

    /**
     *
     * Activate the start tour function
     */
    startTour: function startTour() {
      this.isTourActive = true;
      // Instance the tour
      this.isTourStarts = false;
      this.isTourActive = false;
      introJs().start();
    },

    /**
     *
     * Hide the view for the extended chart section on large screens/TVs but show on smaller screens/PCs
     */
    showMore: function showMore(val) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (val == "zonal") {
                  _this24.showMoreFeatures = !_this24.showMoreFeatures;
                  _this24.showMoreMsg = _this24.showMoreFeatures ? "hide zonal charts" : "see zonal charts";
                } else {
                  _this24.showComponents = !_this24.showComponents;
                  _this24.showCompareMsg = _this24.showComponents ? "hide comparison charts" : "see comparison charts";
                }

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this24);
      }))();
    },

    /**
     *
     * Hide the view for the extended chart section on large screens/TVs but show on smaller screens/PCs
     */
    toggleClicked: function toggleClicked(e) {
      var _this25 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _this25.isToggleClicked = e;

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this25);
      }))();
    },
    hideBarChart: function hideBarChart() {
      var _this26 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this26.showIcon = true;

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this26);
      }))();
    },
    mouseLeave: function mouseLeave() {
      var _this27 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _this27.showIcon = false;

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this27);
      }))();
    },
    IHMEtoggleClicked: function IHMEtoggleClicked(e) {
      var _this28 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this28.isIHMEtoggleClicked = e;

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this28);
      }))();
    },
    chartSourceData: function chartSourceData(e) {
      var _this29 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _this29.dataSourceForChart = e;

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this29);
      }))();
    },
    goto: function goto(url) {
      var _this30 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                window.open(url);
                //location.href = "https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/";

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this30);
      }))();
    },
    convertToPDF: function convertToPDF(element_id) {
      var _this31 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee30() {
        var element, opt;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                element = document.getElementById(element_id);
                opt = {
                  margin: 1,
                  filename: "central_analytics_dashboard.pdf",
                  image: { type: "jpeg", quality: 0.98 },
                  html2canvas: { scale: 2 },
                  jsPDF: { unit: "mm", format: "a3", orientation: "l" }
                };
                // New Promise-based usage:

                __WEBPACK_IMPORTED_MODULE_13_html2pdf_js___default()().from(element).set(opt).save();

              case 3:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this31);
      }))();
    },
    toggleWidget: function toggleWidget(param) {
      var _this32 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee31() {
        var widget_num, widget;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                widget_num = param.target.id;
                widget = document.getElementById("widget_" + widget_num);

                widget.parentNode.removeChild(widget);

              case 3:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this32);
      }))();
    },
    plotUncertainty: function plotUncertainty(e) {
      var _this33 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee32() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                // toggle show estimate: switch with normal line chart by data sources.
                _this33.computeUncertaintyTruthVal = !_this33.computeUncertaintyTruthVal;
                // this.showIHMEEstimate = e;

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, _this33);
      }))();
    },
    regionalChartYearOptions: function regionalChartYearOptions(e) {
      var _this34 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee33() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _this34.regionalChartYearOptionsData = e;

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, _this34);
      }))();
    },
    dropdownChangedChart: function dropdownChangedChart(value, key) {
      var _this35 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee34() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _this35.specificChartType[key] = value;

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, _this35);
      }))();
    },
    dropdownChangedMap: function dropdownChangedMap(value, key) {
      var _this36 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee35() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _this36.specificMapType[key] = value;
                // this.specificMapType = value

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, _this36);
      }))();
    },
    compareIndicators: function compareIndicators(elemToCompare) {
      var _this37 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee36() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                // this.elementToCompare = elemToCompare;
                // if(elemToCompare === 'indicator'){
                //   this.isElementToCompareIndicator = true;
                //   this.compareSectionColorClass = true;
                // } else {
                //   this.isElementToCompareIndicator = false;
                //   this.compareSectionColorClass = false;
                // }
                _this37.showComponents = !_this37.showComponents;
                // this.specificComponentType = this.specificComponentOptions[0]
                if (_this37.showComponents) {
                  _this37.scrollPage("#compare-section");
                } else {
                  _this37.scrollPage("#top_of_page");
                }

              case 2:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, _this37);
      }))();
    },
    scrollPage: function scrollPage(section_id) {
      var _this38 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee37() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _this38.$scrollTo(section_id, 500, {});

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, _this38);
      }))();
    },
    indicatorRelatives: function indicatorRelatives(e) {
      var _this39 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee38() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                // if (this.showComponents){
                _this39.relativeIndicators = e;

              case 1:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, _this39);
      }))();
    },
    extractStateValuesForIndicator: function extractStateValuesForIndicator(indicator, selectedSource) {
      var _this40 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee39() {
        var ivt, vt, it, stateByIndicatorByYear, selectedIndicatorValuesForEachState, indicatorSource, indexOfindicatorSource, statesWithIndicatorsYearAndValues, stateName, stateCurrentYearVals, temp, obj, regions, sortedObj, xAxis, yAxis, _stateName, plotData;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                ivt = _this40.$store.state.CAR.indicatorAttributesOtherSources[indicator];

                if (ivt !== undefined) {
                  vt = ivt[1] === "P" ? "%" : "";
                  it = ivt[1] === "P" ? "% of total" : "";
                }
                stateByIndicatorByYear = _this40.$store.getters.getCurrentIndicatorsValue;
                selectedIndicatorValuesForEachState = {};
                indicatorSource = indicator + " -> " + selectedSource;
                indexOfindicatorSource = _this40.lsData[0].indexOf(indicatorSource) - 1;
                statesWithIndicatorsYearAndValues = _this40.getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear);


                if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
                  for (stateName in stateByIndicatorByYear) {
                    if (stateName !== undefined) {
                      if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
                        // var len = stateByIndicatorByYear[stateName].length;
                        stateCurrentYearVals = stateByIndicatorByYear[stateName][statesWithIndicatorsYearAndValues[2][stateName]];
                        // console.log(stateCurrentYearVals);

                        if (stateCurrentYearVals !== undefined) {
                          selectedIndicatorValuesForEachState[stateName] = [stateCurrentYearVals[0], stateCurrentYearVals[indexOfindicatorSource]];
                        }
                      }
                    }
                  }
                } else {
                  selectedIndicatorValuesForEachState = statesWithIndicatorsYearAndValues[0];
                }

                temp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selectedIndicatorValuesForEachState);
                obj = {};

                temp.map(function (elem, index) {
                  obj[elem] = selectedIndicatorValuesForEachState[elem][1];
                });

                regions = ["North-East", "North-West", "North-Central", "South-East", "South-West", "South-South"];
                sortedObj = sortObjects(obj); // custom method

                xAxis = [], yAxis = [];

                for (_stateName in sortedObj) {
                  if (sortedObj.hasOwnProperty(_stateName)) {
                    if (regions.indexOf(_stateName) < 0) {
                      // don't need the regions in this chart
                      yAxis.push(_stateName);
                      xAxis.push(sortedObj[_stateName]);
                    }
                  }
                }

                plotData = {};
                // get the data required for ngMap

                yAxis.map(function (elem, index) {
                  plotData[elem] = xAxis[index];
                });

                return _context39.abrupt("return", plotData);

              case 18:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, _this40);
      }))();
    },


    /**
     *
     * change the main selected indicator as it change on the data table
     * @param selectedIndicator
     */
    mainSelectedIndicatorFromTable: function mainSelectedIndicatorFromTable(val) {
      var _this41 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee40() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                // console.log(val);
                _this41.selectedIndicator = val;

              case 1:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, _this41);
      }))();
    },
    getYearWithCurrentIndicatorValues: function getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear) {
      var _this42 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee41() {
        var statesWithIndicatorsYearAndValues, tempArr, sourceActiveYear, sourcetempArr, stateName, i, selectedIndicatorVal, plotData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                statesWithIndicatorsYearAndValues = {};
                tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value

                sourceActiveYear = {};
                sourcetempArr = [];
                _context41.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(stateByIndicatorByYear);

              case 5:
                if ((_context41.t1 = _context41.t0()).done) {
                  _context41.next = 22;
                  break;
                }

                stateName = _context41.t1.value;

                if (!stateByIndicatorByYear.hasOwnProperty(stateName)) {
                  _context41.next = 20;
                  break;
                }

                i = stateByIndicatorByYear[stateName].length - 1;

              case 9:
                if (!(i >= 0)) {
                  _context41.next = 19;
                  break;
                }

                statesWithIndicatorsYearAndValues[stateName] = [];
                selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
                // if (selectedIndicatorVal) {

                if (!(stateByIndicatorByYear[stateName][i][0] === parseInt(_this42.selectedYear))) {
                  _context41.next = 16;
                  break;
                }

                tempArr[stateName] = i;
                statesWithIndicatorsYearAndValues[stateName].push(stateByIndicatorByYear[stateName][i][0], stateByIndicatorByYear[stateName][i][indexOfindicatorSource]);
                return _context41.abrupt("break", 19);

              case 16:
                i--;
                _context41.next = 9;
                break;

              case 19:
                // get all the years where there's a value for the indicator...
                for (i = stateByIndicatorByYear[stateName].length - 1; i >= 0; i--) {
                  if (!sourceActiveYear[stateName]) {
                    sourceActiveYear[stateName] = {};
                  }
                  selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];


                  if (selectedIndicatorVal) {
                    sourcetempArr.push(i);
                    sourceActiveYear[stateName][stateByIndicatorByYear[stateName][i][0]] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
                    // break;
                  }
                }

              case 20:
                _context41.next = 5;
                break;

              case 22:
                plotData = {};
                // get the data required for ngMap

                yAxis.map(function (elem, index) {
                  plotData[elem] = xAxis[index];
                });
                return _context41.abrupt("return", plotData);

              case 25:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, _this42);
      }))();
    }
  }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getYearWithCurrentIndicatorValues", function getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear) {
    var _this43 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee42() {
      var statesWithIndicatorsYearAndValues, tempArr, sourceActiveYear, sourcetempArr, stateName, i, selectedIndicatorVal, rowIndex;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              statesWithIndicatorsYearAndValues = {};
              tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value

              sourceActiveYear = {};
              sourcetempArr = [];
              _context42.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(stateByIndicatorByYear);

            case 5:
              if ((_context42.t1 = _context42.t0()).done) {
                _context42.next = 22;
                break;
              }

              stateName = _context42.t1.value;

              if (!stateByIndicatorByYear.hasOwnProperty(stateName)) {
                _context42.next = 20;
                break;
              }

              i = stateByIndicatorByYear[stateName].length - 1;

            case 9:
              if (!(i >= 0)) {
                _context42.next = 19;
                break;
              }

              statesWithIndicatorsYearAndValues[stateName] = [];
              selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
              // if (selectedIndicatorVal) {

              if (!(stateByIndicatorByYear[stateName][i][0] === parseInt(_this43.selectedYear))) {
                _context42.next = 16;
                break;
              }

              tempArr[stateName] = i;
              statesWithIndicatorsYearAndValues[stateName].push(stateByIndicatorByYear[stateName][i][0], stateByIndicatorByYear[stateName][i][indexOfindicatorSource]);
              return _context42.abrupt("break", 19);

            case 16:
              i--;
              _context42.next = 9;
              break;

            case 19:
              // get all the years where there's a value for the indicator...
              for (i = stateByIndicatorByYear[stateName].length - 1; i >= 0; i--) {
                if (!sourceActiveYear[stateName]) {
                  sourceActiveYear[stateName] = {};
                }
                selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];


                if (selectedIndicatorVal) {
                  sourcetempArr.push(i);
                  sourceActiveYear[stateName][stateByIndicatorByYear[stateName][i][0]] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
                  // break;
                }
              }

            case 20:
              _context42.next = 5;
              break;

            case 22:

              // we leverage the fact that National always has data for all the indicators
              _this43.optionYear = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sourceActiveYear["National"]);

              rowIndex = Math.max.apply(null, tempArr);
              return _context42.abrupt("return", [statesWithIndicatorsYearAndValues, rowIndex, tempArr]);

            case 25:
            case "end":
              return _context42.stop();
          }
        }
      }, _callee42, _this43);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getIndicators", function getIndicators() {
    var _this44 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee43() {
      var headerObj;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
        while (1) {
          switch (_context43.prev = _context43.next) {
            case 0:
              headerObj = _this44.$store.getters.getIndicators;

              _this44.headerObj = headerObj;
              // this.optionIndicators = this.options; // Object.keys(headerObj);

            case 2:
            case "end":
              return _context43.stop();
          }
        }
      }, _callee43, _this44);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getCarData", function getCarData() {
    var _this45 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee44() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
        while (1) {
          switch (_context44.prev = _context44.next) {
            case 0:
              return _context44.abrupt("return", _this45.axios.get(_this45.apiUrl));

            case 1:
            case "end":
              return _context44.stop();
          }
        }
      }, _callee44, _this45);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getNdState", function getNdState() {
    var _this46 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee45() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45) {
        while (1) {
          switch (_context45.prev = _context45.next) {
            case 0:
              return _context45.abrupt("return", _this46.axios.get(_this46.ndStateUrl));

            case 1:
            case "end":
              return _context45.stop();
          }
        }
      }, _callee45, _this46);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getNdLga", function getNdLga() {
    var _this47 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee46() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46) {
        while (1) {
          switch (_context46.prev = _context46.next) {
            case 0:
              return _context46.abrupt("return", _this47.axios.get(_this47.ndLgaUrl));

            case 1:
            case "end":
              return _context46.stop();
          }
        }
      }, _callee46, _this47);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getEstimateData", function getEstimateData() {
    var _this48 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee47() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47) {
        while (1) {
          switch (_context47.prev = _context47.next) {
            case 0:
              return _context47.abrupt("return", _this48.axios.get(_this48.estimatesUrl));

            case 1:
            case "end":
              return _context47.stop();
          }
        }
      }, _callee47, _this48);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getLGAData", function getLGAData() {
    return this.axios.get(this.LGA_Url);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getMetaData", function getMetaData() {
    return this.axios.get(this.metaDataUrl);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getSourceMetaData", function getSourceMetaData() {
    return this.axios.get(this.dataSourceUrl);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getIndicatorMetaData", function getIndicatorMetaData() {
    return this.axios.get(this.indicatorUrl);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "metaDataValue", function metaDataValue() {
    var _this49 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee48() {
      var metaData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48) {
        while (1) {
          switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return _this49.getMetaData();

            case 2:
              metaData = _context48.sent;
              return _context48.abrupt("return", metaData.data);

            case 4:
            case "end":
              return _context48.stop();
          }
        }
      }, _callee48, _this49);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getNhmisMonthly", function getNhmisMonthly() {
    return this.axios.get(this.nhmisMonthlyUrl);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "generateShareURL", function generateShareURL() {
    this.shareButtonClicked = true;
    this.dashboardState[selectedIndicator] = this.selectedIndicator.name;
    this.dashboardState.selectedState = this.selectedState;
    var barChartComponentYear = this.dashboardState.barChartComponentYear || "";
    var columnChartSource = void 0;
    if (Array.isArray(this.dashboardState.columnChartSource)) {
      columnChartSource = [];
      for (var i in this.dashboardState.columnChartSource) {
        columnChartSource.push(this.dashboardState.columnChartSource[i].name);
      }
    } else {
      columnChartSource = this.dashboardState.columnChartSource.name || "";
    }

    var columnChartIndicator = this.dashboardState.columnChartIndicator || "";
    if (this.dashboardState.columnChartIndicator.indexOf("/") > 0) {
      columnChartIndicator = this.dashboardState.columnChartIndicator.replace("/", "_") || "";
    }
    var regionsChartYear = this.dashboardState.regionsChartYear || "";
    var selectedIndicator = this.dashboardState[selectedIndicator] || "";
    var selectedState = this.dashboardState.selectedState || "";
    var host = "http://" + window.location.hostname + ":" + window.location.port;
    var theURL = host + ("/central_analytics/" + selectedIndicator + "/" + selectedState + "/" + barChartComponentYear + "/" + columnChartSource + "/" + columnChartIndicator);
    // this.shareURL = encodeURI(theURL);

    this.urlParams = selectedIndicator + "&" + selectedState + "&" + barChartComponentYear + "&" + columnChartSource + "&" + columnChartIndicator + "&" + regionsChartYear;
    this.shortenURL();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "shortenURL", function shortenURL() {
    var _this50 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee49() {
      var hashTag, shortened;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49) {
        while (1) {
          switch (_context49.prev = _context49.next) {
            case 0:
              _this50.loadingURLIcon = true;
              _context49.next = 3;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__assets_js_on_url_shortener__["a" /* url_shortener */])(_this50.urlParams);

            case 3:
              _this50.shortURL = _context49.sent;

              if (!_this50.shortURL) {
                _this50.loadingURLIcon = false;
                _this50.errorFetchingURL = true;
              } else {
                _this50.loadingURLIcon = false;
                hashTag = encodeURIComponent("#");
                shortened = "http://" + window.location.hostname + ":" + window.location.port + "/" + hashTag + "/central_analytics/" + _this50.shortURL.shortURL;

                l;
                _this50.shareURLHash = shortened;
              }

            case 5:
            case "end":
              return _context49.stop();
          }
        }
      }, _callee49, _this50);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "shortenURL_bak", function shortenURL_bak() {
    var _this51 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee50() {
      var bitlyLink, shortURL;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee50$(_context50) {
        while (1) {
          switch (_context50.prev = _context50.next) {
            case 0:
              _this51.loadingURLIcon = true;
              bitlyLink = "https://api-ssl.bitly.com/v3/shorten?access_token=21fa28d6cfcc24b9600b635288f373cfe28716e2&longUrl=" + "http://hybridashforus.surge.sh/central_analytics/National/2017/MICS/Skilled%20attendance%20at%20delivery%20or%20birth";
              _context50.next = 4;
              return _this51.axios.get(bitlyLink).then(function (response) {
                debugger;
                if (response.data.status_code === 200) {
                  _this51.loadingURLIcon = false;
                  _this51.shareURL = response.data.data.url;
                } else {
                  _this51.errorFetchingURL = true;
                }
              }).catch(function (err) {
                _this51.loadingURLIcon = false;
                _this51.errorFetchingURL = true;
                // console.error(err);
              });

            case 4:
              shortURL = _context50.sent;

            case 5:
            case "end":
              return _context50.stop();
          }
        }
      }, _callee50, _this51);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "splitIntoArray", function splitIntoArray(str, divider) {
    var _this52 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee51() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee51$(_context51) {
        while (1) {
          switch (_context51.prev = _context51.next) {
            case 0:
              return _context51.abrupt("return", str.split(divider));

            case 1:
            case "end":
              return _context51.stop();
          }
        }
      }, _callee51, _this52);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getYearOptionsWithData", function getYearOptionsWithData(source) {
    var _this53 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee52() {
      var years, statesByIndicatorByYear, indicatorSource, indicatorSourceIndex, i;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee52$(_context52) {
        while (1) {
          switch (_context52.prev = _context52.next) {
            case 0:
              // console.log(source);

              years = [];
              statesByIndicatorByYear = _this53.$store.getters.getCurrentIndicatorsValue;
              indicatorSource = _this53.selectedIndicator.name + " -> " + source;
              indicatorSourceIndex = _this53.lsData[0].indexOf(indicatorSource) - 1;

              for (i in statesByIndicatorByYear) {
                statesByIndicatorByYear[i].map(function (el, i) {
                  if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
                    if (years.indexOf(el[0]) < 0) {
                      years.push(el[0]);
                    }
                  }
                });
              }
              years = years.sort();

              _this53.zonalYearOptions = years;
              if (_this53.zonalYearOptions.length !== 0) {
                _this53.zonalSelectedYear = _this53.zonalYearOptions[_this53.zonalYearOptions.length - 1].toString();
              }

            case 8:
            case "end":
              return _context52.stop();
          }
        }
      }, _callee52, _this53);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getCurrentSourceOptions", function getCurrentSourceOptions() {
    var sources = [];
    var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
    // console.log(statesByIndicatorByYear);

    for (var k in this.optionSources) {
      for (var i in statesByIndicatorByYear) {
        for (var j in statesByIndicatorByYear[i]) {
          var indicatorSource = this.selectedIndicator.name + " -> " + this.optionSources[k];
          var _indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
          if (statesByIndicatorByYear[i][j][_indicatorSourceIndex] !== "" && _indicatorSourceIndex > 0) {
            if (sources.indexOf(this.optionSources[k]) < 0) sources.push(this.optionSources[k]);
            break;
          }
        }
      }
    }
    this.zonalSourcesOptions = sources;
    // console.log(this.zonalSourcesOptions);

    if (this.zonalSourcesOptions.includes("NHMIS")) {
      // this.zonalSelectedSource = "NHMIS";
    } else {
        // this.zonalSelectedSource = this.zonalSourcesOptions[0];
      }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "showForm", function showForm() {
    var _this54 = this;

    this.contactForm = true;
    this.timer = setTimeout(function () {
      _this54.contactForm = false;
    }, 30000);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "stopTimer", function stopTimer() {
    clearTimeout(this.timer);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_extends2, "getParamsFromUrl", function getParamsFromUrl() {
    // if (!this.$route.query.location) {
    //   this.selectedState = "National";
    //   this.$store.dispatch('storeSelectedState',  "National");
    // };
    // if (this.$route.query.location == " ") {
    //   this.selectedState = "National";
    //   this.$store.dispatch('storeSelectedState',  "National");
    // }
    this.$router.push({ query: this.params });
    if (this.$route.query.location) {
      this.params.location = this.$route.query.location;
    }
    if (this.$route.query.indicator) {
      this.params.indicator = this.$route.query.indicator;
    }

    if (this.$route.query.location) {
      // console.log(this.$route.query.location);
      var locationParam = this.$route.query.location;
      //this.dashboardState.selectedState = locationParam;
      this.comparisonSelectedState = locationParam;
      this.$store.dispatch("storeSelectedState", locationParam);
      this.selectedState = locationParam;
      // console.log(this.selectedState);
      //this.isChartRendered = true;
    }

    // if (!this.$route.query.indicator){
    //   this.selectedIndicator.name = "Skilled attendance at delivery or birth";
    //   this.$store.dispatch('storeSelectedIndicator', "Skilled attendance at delivery or birth");
    // }

    if (this.$route.query.indicator) {
      //this.isChartRendered = false;
      var indicatorParam = this.$route.query.indicator;
      this.selectedIndicator = { name: indicatorParam };
      this.$store.dispatch("storeSelectedIndicator", indicatorParam);
      //console.log(this.selectedIndicator.name)
    }
  }), _extends2)),
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    myFullscreen: function myFullscreen() {
      var _this55 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee53() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                return _context53.abrupt("return", _this55.$store.state.CAR.fullscreen);

              case 1:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, _this55);
      }))();
    },
    multiselectPlaceholderComputed: function multiselectPlaceholderComputed() {
      var _this56 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee54() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _this56.multiselectPlaceholder = _this56.selectedIndicator.name;
                _this56.statePlaceholder = _this56.selectedState;
                _this56.compareIndicatorMultitselectPlaceholder = _this56.comparisonSelectedIndicator.name;
                _this56.comparisonSelectedSourcePlaceholder = _this56.comparisonSelectedSource;
                // this.comparisonSelectedStatePlaceholder = this.comparisonSelectedState;
                _this56.comparisonSelectedStatePlaceholder = _this56.$store.state.CAR.selectedState;

              case 5:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, _this56);
      }))();
    },
    sourceClicked: function sourceClicked() {
      var _this57 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee55() {
        var tableColumnHeaderAttr, sources, val, selectedSource, stateSelectedIndicatorSource, selectedIndicatorSource, optionYear;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                tableColumnHeaderAttr = _this57.$store.getters.getSourceClicked;
                sources = tableColumnHeaderAttr[0];
                val = tableColumnHeaderAttr[1];
                // check for availability of data in the source here

                // var defaultSource = this.$store.getters.getDefaultSource;

                selectedSource = sources; //? sources: defaultSource;
                // this.selectedSource = selectedSource;

                // get the state indicator source object from store

                stateSelectedIndicatorSource = _this57.$store.getters.getSelectedIndicatorSource;
                selectedIndicatorSource = stateSelectedIndicatorSource[selectedSource];


                if (selectedIndicatorSource) {
                  // compute the years custom to the data
                  optionYear = [];

                  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(stateSelectedIndicatorSource).map(function (elem, index) {
                    if (stateSelectedIndicatorSource[elem].length > 0) {
                      optionYear.push(stateSelectedIndicatorSource[elem][0]);
                    }
                  });
                  //this.optionYear = optionYear; // assign to select year field
                  // get the indicator selected, and watch the year of its current value.
                  if (selectedIndicatorSource.length > 0) {
                    _this57.selectedYear = selectedIndicatorSource[0];
                  }
                }
                return _context55.abrupt("return", selectedSource);

              case 8:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, _this57);
      }))();
    },
    relativeIndicatorsValues: function relativeIndicatorsValues() {
      var _this58 = this;

      var selectedSource = this.sourceClicked;
      var statesValueForIndicator = [];
      this.relativeIndicators.map(function (elem, index) {
        statesValueForIndicator.push(_this58.extractStateValuesForIndicator(elem, selectedSource));
      });
      return statesValueForIndicator;
    },
    watchState: function watchState() {
      return this.$store.state.CAR.selectedState;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapGetters */])({
    shareCounter: "getShareCounter",
    zonalChartCounter: "getZonalChartCounter",
    reloadDataState: "getReloadDataState",
    getRelatedIndicators: "getRelatedIndicators"
  })),
  // fetch data before entering the route. This makes things alot faster than
  // when it's done on created.
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _this59 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee56() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee56$(_context56) {
        while (1) {
          switch (_context56.prev = _context56.next) {
            case 0:
              next(function (vm) {
                vm.axios.all([vm.getEstimateData(), vm.getLGAData(), vm.getMetaData(), vm.getSourceMetaData(), vm.getIndicatorMetaData(), vm.getCarData(), vm.getNhmisMonthly()]).then(vm.axios.spread(function (estimatesData, lgaData, metaData, sourceMetaData, indicatorMetaData, carData, nhmisMonthlyData) {
                  localStorage.removeItem("clearedDB");
                  localStorage.removeItem("clearedDB2");

                  var interval = 14;
                  // set an initial value to the clearDate key if it doesn't exist
                  var year = new Date().getFullYear();
                  var month = new Date().getMonth();
                  month += 1;
                  var day = new Date().getDate();
                  var initialDate = month + "/" + day + "/" + year;
                  if (localStorage.getItem("clearDate") === null) {
                    localStorage.setItem("clearDate", initialDate);
                  } else {
                    // ======================
                    var date = new Date(localStorage.getItem("clearDate"));
                    //  =====================

                    var time = Date.now() - date.getTime();
                    var diff = time / (1000 * 3600 * 24);
                    console.log(diff, interval, 'checks');

                    if (diff === interval) {
                      localStorage.removeItem("car_other_dataset");
                      localStorage.removeItem("estimates_dataset");
                      localStorage.removeItem("indicator_meta_dataset");
                      localStorage.removeItem("meta_data_dataset");
                      localStorage.removeItem("nhmis_monthly");
                      localStorage.removeItem("source_meta_dataset");
                      localStorage.setItem("clearDate", initialDate);
                      location.reload();
                    }
                  }
                  // All requests are now complete

                  //lga data here ...
                  vm.lgaData = lgaData.data;
                  // vm.$ls.set("lga_dataset", JSON.stringify(vm.lgaData));
                  // vm.$store.dispatch("storeLgaData", { list: vm.lgaData });

                  // vm.isDataLoadedFirstTime = true;

                  //estimate data here ...
                  vm.estimatesData = estimatesData.data;
                  vm.$ls.set("estimates_dataset", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(vm.estimatesData));
                  // console.log(lgaData);
                  // vm.isDataLoadedFirstTime = true;

                  // source meta data here ...
                  vm.sourceMetaData = sourceMetaData.data;
                  vm.$ls.set("source_meta_dataset", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(vm.sourceMetaData));
                  // vm.$store.dispatch('storeMetaData',{list:vm.lgaData});
                  // vm.isDataLoadedFirstTime = true;

                  // indicator meta data here ...
                  vm.indicatorMetaData = indicatorMetaData.data;
                  vm.$ls.set("indicator_meta_dataset", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(vm.indicatorMetaData));
                  // vm.isDataLoadedFirstTime = true;

                  // car data here ...
                  vm.lsData = carData.data;
                  vm.$ls.set("car_other_dataset", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(vm.lsData));
                  vm.$store.dispatch("storeCARData", { list: vm.lsData });

                  // meta data here ...
                  vm.metaData = metaData.data;
                  vm.$ls.set("meta_data_dataset", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(vm.metaData));
                  vm.$store.dispatch("storeIndicatorMetaData", vm.metaData);
                  // vm.isDataLoadedFirstTime = true;

                  // NHmis Monthly Data
                  vm.$store.state.CAR.NhmisMonthlyData = nhmisMonthlyData.data;
                  vm.$ls.set("nhmis_monthly", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(nhmisMonthlyData.data));

                  //numerator-denominator data here
                  // vm.ndStateData = ndStateData.data;
                  // vm.$ls.set('nd_state_data', JSON.stringify(vm.ndStateData));
                  //vm.$store.dispatch('storeNdStateData', vm.ndStateData);
                  //console.log(vm.ndStateData);

                  // vm.ndLgaData = ndLgaData.data;
                  // vm.$ls.set('nd_lga_data', JSON.stringify(vm.ndLgaData));
                  // vm.$store.dispatch('storeNdLgaData', vm.ndLgaData);
                  //console.log(vm.ndLgaData);

                  if (!vm.estimatesData) {
                    vm.estimatesData = JSON.parse(vm.$ls.get("estimates_dataset"));
                  }
                  if (!vm.lgaData) {
                    vm.lgaData = JSON.parse(vm.$ls.get("lga_dataset"));
                  }
                  if (!vm.metaData) {
                    vm.metaData = JSON.parse(vm.$ls.get("meta_data_dataset"));
                  }
                  if (!vm.sourceMetaData) {
                    vm.sourceMetaData = JSON.parse(vm.$ls.get("source_meta_dataset"));
                  }
                  if (!vm.indicatorMetaData) {
                    vm.indicatorMetaData = JSON.parse(vm.$ls.get("indicator_meta_dataset"));
                  }
                  if (!vm.lsData) {
                    vm.lsData = JSON.parse(vm.$ls.get("car_other_dataset"));
                  }
                  // if(!vm.ndStateData){
                  //   vm.ndStateData = JSON.parse(vm.$ls.get('nd_state_data'));
                  // }
                  // if(!vm.ndLgaData){
                  //   vm.ndLgaData = JSON.parse(vm.$ls.get('nd_lga_data'));
                  // }

                  vm.isDataLoadedFirstTime = true;

                  //force load static files from server if data is loaded and chart is not rendered after 30secs
                  setTimeout(function () {
                    if (vm.isChartRendered == false) {
                      _this59.location.reload(true);
                    }
                  }, 30000);
                })).catch(function (error) {
                  // if(!vm.lsTargetData){
                  //   vm.lsTargetData = JSON.parse(vm.$ls.get('car_targets'));
                  // }
                  if (!vm.estimatesData) {
                    vm.estimatesData = JSON.parse(vm.$ls.get("estimates_dataset"));
                  }
                  if (!vm.lgaData) {
                    vm.lgaData = JSON.parse(vm.$ls.get("lga_dataset"));
                  }
                  if (!vm.metaData) {
                    vm.metaData = JSON.parse(vm.$ls.get("meta_data_dataset"));
                  }
                  if (!vm.sourceMetaData) {
                    vm.sourceMetaData = JSON.parse(vm.$ls.get("source_meta_dataset"));
                  }
                  if (!vm.indicatorMetaData) {
                    vm.indicatorMetaData = JSON.parse(vm.$ls.get("indicator_meta_dataset"));
                  }
                  if (!vm.lsData) {
                    vm.lsData = JSON.parse(vm.$ls.get("car_other_dataset"));
                  }
                  // if(!vm.ndStateData){
                  //   vm.ndStateData = JSON.parse(vm.$ls.get('nd_state_data'));
                  // }
                  // if(!vm.ndLgaData){
                  //   vm.ndLgaData = JSON.parse(vm.$ls.get('nd_lga_data'));
                  // }

                  vm.isDataLoadedFirstTime = true;

                  //force load static files from server if data is loaded and chart is not rendered after 30secs
                  setTimeout(function () {
                    if (vm.isChartRendered == false) {
                      _this59.location.reload(true);
                    }
                  }, 35000);
                });
              });

            case 1:
            case "end":
              return _context56.stop();
          }
        }
      }, _callee56, _this59);
    }))();
  },

  // beforeRouteEnter(to, from, next) {}
  // beforeRouteLeave (to, from, next) {},
  created: function created() {
    var _this60 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee57() {
      var token, programArea, indicatorArray, indicatorAndProgramArea, lsMetaData, indicatorsAndProgramAreas, indicatorAttributes, indicatorsRelative, shortIndicatorNames, _indicatorArray, _programArea, _indicatorAndProgramArea, indicatorNamesArray, _indicatorsAndProgramAreas, _indicatorAttributes, _indicatorsRelative, _shortIndicatorNames, temp, tokencheck, innerURLParam, tempOptions;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee57$(_context57) {
        while (1) {
          switch (_context57.prev = _context57.next) {
            case 0:
              // check if user is first time user:::
              token = Math.random().toString(36).substring(7) + new Date().getTime();

              if (__WEBPACK_IMPORTED_MODULE_18_vue_cookies___default.a.isKey("firstTimeUser")) {
                _context57.next = 25;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_18_vue_cookies___default.a.set("firstTimeUser", token, "3d");
              _this60.firstTimeUser = _this60.firstTimeNotification = true;

              programArea = [];
              indicatorArray = [];
              indicatorAndProgramArea = [];
              _context57.next = 9;
              return _this60.metaDataValue();

            case 9:
              lsMetaData = _context57.sent;


              _this60.$store.dispatch("indicatorLength", lsMetaData.length - 1);
              _this60.$store.dispatch("lastUpdated", lsMetaData[0][16]);

              //Dynamically populate program area array from sheet
              indicatorsAndProgramAreas = {};
              indicatorAttributes = {};
              indicatorsRelative = {};
              shortIndicatorNames = {};


              lsMetaData.slice(1).map(function (meta, count) {
                var slope = [];
                var percent = "";

                if (meta[6] in indicatorsAndProgramAreas) {
                  indicatorsAndProgramAreas[meta[6]].push(meta[0]);
                } else {
                  indicatorsAndProgramAreas[meta[6]] = [];
                  indicatorsAndProgramAreas[meta[6]].push(meta[0]);
                }

                if (meta[4] == "Positive") {
                  slope = ["G", "R"];
                }
                if (meta[4] == "Negative") {
                  slope = ["R", "G"];
                }
                if (meta[3] == "in percentage") {
                  percent = "P";
                } else {
                  percent = "N";
                }

                indicatorAttributes[meta[0]] = [slope, percent];
                // indicatorsRelative[meta[0]] = [meta[12], meta[13], meta[14], meta[15]]      //For four indicator relatives
                indicatorsRelative[meta[0]] = [meta[12], meta[13]];
                shortIndicatorNames[meta[0]] = meta[1];

                if (programArea.indexOf(meta[6]) < 0) {
                  // if(meta[6] === 'Mortality'){
                  //   programArea.unshift(meta[6])
                  // } else {
                  programArea.push(meta[6]);
                  // }
                }
              });

              _this60.$store.dispatch("indicatorsAndProgramAreas", indicatorsAndProgramAreas);
              _this60.$store.dispatch("indicatorAttributes", indicatorAttributes);
              _this60.$store.dispatch("indicatorsRelative", indicatorsRelative);
              _this60.$store.dispatch("indicatorShortNames", shortIndicatorNames);

              // programArea.sort((a, b) => {
              //   return Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(a) - Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(b);
              // })

              programArea.map(function (element, index) {
                var tempArr = [];
                // Structure the indicator names by program areas
                // indicatorArray.map((el,i) => {
                _this60.metaData.slice(1).map(function (data, index) {
                  if (element === data[6]) {
                    tempArr.push({ name: data[0] });
                  }
                });
                // });
                var obj = {
                  programArea: element,
                  indicators: tempArr
                };
                indicatorAndProgramArea.push(obj);
              });

              // console.log(indicatorAndProgramArea);

              _this60.optionIndicators = indicatorAndProgramArea.slice(0);

              /*  End of snippet to get indicator options from the meta data JSON sheet */
              _context57.next = 49;
              break;

            case 25:
              _this60.firstTimeUser = _this60.firstTimeNotification = false;
              // console.log(this.firstTimeUser);
              /* Begining of snippet to get indicator options from the JSON data */

              _indicatorArray = [];
              _programArea = [];
              _indicatorAndProgramArea = [];
              indicatorNamesArray = _this60.lsData[0];

              //Slicing indicator names array to remove period and state name

              indicatorNamesArray.slice(2).map(function (indicator, index) {
                if (_indicatorArray.indexOf(indicator.split(" -> ")[0]) < 0) {
                  _indicatorArray.push(indicator.split(" -> ")[0]);
                }
              });

              //Dynamically populate program area array from sheet
              _indicatorsAndProgramAreas = {};
              _indicatorAttributes = {};
              _indicatorsRelative = {};
              _shortIndicatorNames = {};


              _this60.$store.dispatch("indicatorLength", _this60.metaData.length - 1);
              _this60.$store.dispatch("lastUpdated", _this60.metaData[0][16]);

              _this60.metaData.slice(1).map(function (meta, count) {
                var slope = [];
                var percent = "";

                if (meta[6] in _indicatorsAndProgramAreas) {
                  _indicatorsAndProgramAreas[meta[6]].push(meta[0]);
                } else {
                  _indicatorsAndProgramAreas[meta[6]] = [];
                  _indicatorsAndProgramAreas[meta[6]].push(meta[0]);
                }

                if (meta[4] == "Positive") {
                  slope = ["G", "R"];
                }
                if (meta[4] == "Negative") {
                  slope = ["R", "G"];
                }
                if (meta[3] == "in percentage") {
                  percent = "P";
                } else {
                  percent = "N";
                }

                _indicatorAttributes[meta[0]] = [slope, percent];
                // indicatorsRelative[meta[0]] = [meta[12], meta[13], meta[14], meta[15]]      //For four indicator relatives
                _indicatorsRelative[meta[0]] = [meta[12], meta[13]];
                _shortIndicatorNames[meta[0]] = meta[1];

                if (_programArea.indexOf(meta[6]) < 0) {
                  // if(meta[6] === 'Mortality'){
                  //   programArea.unshift(meta[6])
                  // } else {
                  _programArea.push(meta[6]);
                  // }
                }
              });

              _this60.$store.dispatch("indicatorsAndProgramAreas", _indicatorsAndProgramAreas);
              _this60.$store.dispatch("indicatorAttributes", _indicatorAttributes);
              _this60.$store.dispatch("indicatorsRelative", _indicatorsRelative);
              _this60.$store.dispatch("indicatorShortNames", _shortIndicatorNames);

              // programArea.sort((a, b) => {
              //   return Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(a) - Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(b);
              // })

              _programArea.map(function (element, index) {
                var tempArr = [];
                // Structure the indicator names by program areas
                // indicatorArray.map((el,i) => {
                _this60.metaData.slice(1).map(function (data, index) {
                  if (element === data[6]) {
                    tempArr.push({ name: data[0] });
                  }
                });
                // });
                var obj = {
                  programArea: element,
                  indicators: tempArr
                };
                _indicatorAndProgramArea.push(obj);
              });

              // console.log(indicatorAndProgramArea);

              _this60.optionIndicators = _indicatorAndProgramArea.slice(0);

              /*  End of snippet to get indicator options from the meta data JSON sheet */

              temp = [];

              _this60.$store.dispatch("sourceLength", _this60.sourceMetaData.length - 1);

              _this60.sourceMetaData.slice(1).map(function (source, count) {
                temp.push(source[0]);
              });

              _this60.optionSources = temp;
              temp = [];

            case 49:
              tokencheck = Math.random().toString(36).substring(7) + new Date().getTime();

              if (!__WEBPACK_IMPORTED_MODULE_18_vue_cookies___default.a.isKey("onBoardingUser")) {
                __WEBPACK_IMPORTED_MODULE_18_vue_cookies___default.a.set("onBoardingUser", tokencheck, "3d");
                _this60.isTourActive = true;
                // this.isTourActive = false;
              } else {
                _this60.isTourActive = false;
                //this.isTourActive = true;
              }

              innerURLParam = _this60.urlParam;
              tempOptions = "";
              // async function doDecode() {

              //   if(innerURLParam) {

              //     let url = innerURLParam;
              //     let returnedUrl = await url_decode(url);

              //     return returnedUrl
              //   }

              // }

              // doDecode().then((q) => {

              //   if(q){
              //     this.dashboardStateOptions = q.longURL
              //   }

              // });
              // Add Scroll listener
              // window.addEventListener('scroll', this.handleScroll, { passive: true });

              window.addEventListener("scroll", _this60.handleScroll);

            case 54:
            case "end":
              return _context57.stop();
          }
        }
      }, _callee57, _this60);
    }))();
  },
  mounted: function mounted() {
    var _this61 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee58() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee58$(_context58) {
        while (1) {
          switch (_context58.prev = _context58.next) {
            case 0:
              //display contact form after timeout
              setTimeout(function () {
                _this61.showForm();
              }, 180000);
              setTimeout(function () {
                if (_this61.detectBrowser() == false) {
                  _this61.detect = true;
                }
              }, 15000);
              if (_this61.detectBrowser() == false) {
                _this61.detect = true;
                setTimeout(function () {
                  _this61.closeAlert();
                }, 22000);
              }

              //Listener on the onboarding
              document.addEventListener("keyup", _this61.nextItem);
              // call get indicator to get indicators

              // Check if URL has a parameter and set dashboard state
              // if(this.dashboardStateOptions){
              //   console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers');

              //   this.dashboardStateOptionsArray = this.splitIntoArray(this.dashboardStateOptions,'&');
              //   this.selectedIndicator.name = this.dashboardStateOptionsArray[0];
              //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
              //   this.selectedState = this.dashboardStateOptionsArray[1];
              // } else {
              //   this.selectedIndicator.name = 'Skilled attendance at delivery or birth';
              //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
              //   this.selectedState = 'National';
              //   this.$store.dispatch('storeSelectedState',  this.selectedState);
              // }
              if (_this61.lsData) {
                _this61.getParamsFromUrl();

                // console.log(this.metaData)
                _this61.getCurrentSourceOptions();
                _this61.getYearOptionsWithData(_this61.zonalSelectedSource);
                _this61.$store.dispatch("storeMultipleSourceData", { list: _this61.lsData });
                // this.$store.dispatch('storeTargetData',{list:this.lsTargetData})
                // this.getIndicators();        //Used to set header object but not used
                _this61.isDataLoadedFirstTime = true;
                if (_this61.firstTimeUser) {
                  // setTimeout(this.startTour, 10000);
                }
              }

              //The block below is no longer used since we are getting the data from metaData
              // if (this.lsTargetData) {
              //   this.$store.dispatch('storeTargetData', {list:this.lsTargetData})
              // }

              // forces reload form server if chart is not rendered in 30secs after mounted
              // setTimeout(()=>{
              //   if (!this.isChartRendered) {
              //     location.reload(true);
              //   }
              // },30000);
              _this61.getCurrentSourceOptions();

            case 6:
            case "end":
              return _context58.stop();
          }
        }
      }, _callee58, _this61);
    }))();
  },
  updated: function updated() {
    this.isOnline = window.navigator.onLine;
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    /**
     * Watchers for CompareSection component
     */
    watchState: function watchState(newState, old) {
      this.comparisonSelectedStatePlaceholder = newState;
    },
    params: function params(newValue) {
      this.$router.dispatch("setParams", newValue);
    },
    "$route.query.location": function $routeQueryLocation(param) {
      // console.log("url parameters changing");
      // console.log(param);
      //console.log(this.$route.query.location)
      //console.log(this.param);

      //else this.params.indicator = "Skilled attendance at delivery or birth";
      // if (this.$route.query.location) {
      // this.params.location = params.location;
      // }else this.params.indicator = "National";
      if (this.$route.query.location) {
        this.params.location = param;
        // doDecode().then((q) => {

        //   if(q){
        //     this.dashboardStateOptions = q.longURL
        //   }

        // });
        // Add Scroll listener
        // window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener("scroll", this.handleScroll);
      }
    },
    mounted: function mounted() {
      var _this62 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee59() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _this62.scroll();

                //display contact form after timeout
                setTimeout(function () {
                  _this62.showForm();
                }, 180000);

                if (_this62.detectBrowser() == false) {
                  _this62.detect = true;
                }

                setTimeout(function () {
                  if (_this62.detect == true) {
                    _this62.closeAlert();
                  }
                }, 15000);

                //Listener on the onboarding
                document.addEventListener("keyup", _this62.nextItem);
                // call get indicator to get indicators

                // Check if URL has a parameter and set dashboard state
                // if(this.dashboardStateOptions){
                //   console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers');

                //   this.dashboardStateOptionsArray = this.splitIntoArray(this.dashboardStateOptions,'&');
                //   this.selectedIndicator.name = this.dashboardStateOptionsArray[0];
                //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
                //   this.selectedState = this.dashboardStateOptionsArray[1];
                // } else {
                //   this.selectedIndicator.name = 'Skilled attendance at delivery or birth';
                //   this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
                //   this.selectedState = 'National';
                //   this.$store.dispatch('storeSelectedState',  this.selectedState);
                // }
                if (_this62.lsData) {
                  _this62.getParamsFromUrl();
                } else {
                  _this62.selectedState = "National";
                  _this62.$store.dispatch("storeSelectedState", "National");
                }

                //this.$router.push({query: this.params});

                //console.log(this.$route.query.location)

                //this.selectedIndicator = "Skilled attendance at delivery or birth"

              case 6:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, _this62);
      }))();
    },
    "$route.query.indicator": function $routeQueryIndicator(param) {
      // console.log("indicator param cahnging");
      //console.log(param);
      if (this.$route.query.indicator) {
        this.params.indicator = param;
        this.getParamsFromUrl();
      } else {
        this.selectedIndicator.name = "Skilled attendance at delivery or birth";
        this.$store.dispatch("storeSelectedIndicator", "Skilled attendance at delivery or birth");
        comparisonSelectedIndicator.name = "Skilled attendance at delivery or birth";
      }
    },
    selectedIndicator: function selectedIndicator(_ref2) {
      var name = _ref2.name;

      this.isChartRendered = false;
      // var name = val.name
      //console.log("selected");
      this.$store.dispatch("storeSelectedIndicator", name);

      //this.$store.dispatch('storeSelectedIndicator', name);
      // console.log("selected Indicator");

      this.getCurrentSourceOptions();
      // console.log(this.zonalSelectedSource);

      this.getYearOptionsWithData(this.zonalSelectedSource);
      this.dashboardState.selectedIndicator = name;
      this.params.indicator = name;
      this.$router.push({ query: this.params });
    },
    selectedState: function selectedState(val) {
      var _this63 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee60() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                if (_this63.lsData) {
                  //console.log(val);
                  _this63.$store.dispatch("storeSelectedState", val);
                  //this.dashboardState.selectedState = val;

                  _this63.params.location = val;
                  _this63.$router.push({ query: _this63.params });
                  //console.log(this.params.location);
                }

              case 1:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, _this63);
      }))();
    },
    componentType: function componentType(val) {
      var _this64 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee61() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                if (val === "Map") {
                  _this64.specificComponentOptions = ["states", "zones"];
                  _this64.specificComponentType = "states";
                  // this.elementToCompare = 'indicator'
                } else {
                  _this64.specificComponentOptions = ["line", "column"];
                  _this64.specificComponentType = "line";
                  // this.elementToCompare = 'source'
                }

              case 1:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, _this64);
      }))();
    },
    shareCounter: function shareCounter(val) {
      var _this65 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee62() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                if (val > 0) {
                  _this65.generateShareURL();
                }

              case 1:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, _this65);
      }))();
    },

    // This function is mapped from the store value and is always in sync with the store data
    zonalChartCounter: function zonalChartCounter(val) {
      var _this66 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee63() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                // console.log(val)
                if (val === "compare-section") {
                  _this66.showComponents = true;
                  _this66.showCompareMsg = _this66.showComponents ? "hide comparison charts" : "see comparison charts";
                  _this66.$scrollTo("#compare-section", 300);
                } else if (val !== "") {
                  // this.showComponents = false;  //Remove comparison section if val is not empty
                  // scroll to the value of the weirdly named field if its not compare section and is also not an empty string
                  _this66.$scrollTo("#" + val, 300);
                } else {}
                // console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers')

                // Push empty string to store to reset the weirdly named field
                _this66.$store.dispatch("goToZonalChart", "");

              case 2:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, _this66);
      }))();
    },
    reloadDataState: function reloadDataState(val) {
      var _this67 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee64() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                if (val) {
                  _this67.clearLocalStorage();
                }

              case 1:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, _this67);
      }))();
    },

    // async  dashboardStateOptions(val){
    //     if(val){
    //       console.log('We see you\'re the curious type! If you\'re a competent developer, feel free to apply at https://ehealth4everyone.com/careers');

    //       this.dashboardStateOptionsArray = this.splitIntoArray(val,'&');
    //       this.selectedIndicator.name = this.dashboardStateOptionsArray[0];
    //       this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
    //       this.selectedState = this.dashboardStateOptionsArray[1];
    //     } else {
    //       this.selectedIndicator.name = 'Skilled attendance at delivery or birth';
    //       this.$store.dispatch('storeSelectedIndicator', this.selectedIndicator.name);
    //       this.selectedState = 'National';
    //       this.$store.dispatch('storeSelectedState',  this.selectedState);
    //     }
    //   },
    elementToCompare: function elementToCompare(val) {
      var _this68 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee65() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                if (val === "indicator") {
                  _this68.isElementToCompareIndicator = true;
                } else {
                  _this68.isElementToCompareIndicator = false;
                }

              case 1:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, _this68);
      }))();
    },
    metaData: function metaData(val) {
      var _this69 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee66() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                if (val) {
                  _this69.firstTimeNotification = false;
                  _this69.$store.dispatch("storeMetaData", { list: _this69.val });
                }

              case 1:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, _this69);
      }))();
    },
    sourceMetaData: function sourceMetaData(val) {
      var _this70 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee67() {
        var temp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                if (val) {
                  temp = [];


                  val.slice(1).map(function (source, count) {
                    temp.push(source[0]);
                  });

                  _this70.optionSources = temp;
                  temp = [];
                  // console.log(this.optionSources);
                }

              case 1:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, _this70);
      }))();
    },
    lsData: function lsData(val) {
      var _this71 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee68() {
        var indicatorArray, programArea, indicatorAndProgramArea, indicatorNamesArray;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                if (val) {
                  _this71.getParamsFromUrl();
                  _this71.$store.dispatch("storeCARData", { list: val });
                }

                //Method to get indicator options from the JSON data
                if (val && _this71.metaData) {
                  indicatorArray = [];
                  programArea = [];
                  indicatorAndProgramArea = [];
                  indicatorNamesArray = _this71.lsData[0];
                  //Slicing indicator names array to remove period and state name

                  indicatorNamesArray.slice(2).map(function (indicator, index) {
                    if (indicatorArray.indexOf(indicator.split(" -> ")[0]) < 0) {
                      indicatorArray.push(indicator.split(" -> ")[0]);
                    }
                  });

                  //populate program area array
                  _this71.metaData.slice(1).map(function (meta, count) {
                    if (programArea.indexOf(meta[6]) < 0) {
                      // if(meta[6] === 'Mortality'){
                      //   programArea.unshift(meta[6])
                      // } else {
                      programArea.push(meta[6]);
                      // }
                    }
                  });
                  // programArea.sort((a, b) => {
                  //   return Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(a) - Object.keys(this.$store.state.CAR.programAreasToIndicators).indexOf(b);
                  // })
                  programArea.map(function (element, index) {
                    var tempArr = [];
                    // Structure the indicator names by program areas
                    // indicatorArray.map((el,i) => {
                    _this71.metaData.slice(1).map(function (data, index) {
                      if (element === data[6]) {
                        tempArr.push({ name: data[0] });
                      }
                    });
                    // });
                    var obj = {
                      programArea: element,
                      indicators: tempArr
                    };
                    indicatorAndProgramArea.push(obj);
                  });
                  _this71.optionIndicators = indicatorAndProgramArea.slice(0);
                  //End of method to get indicator options from the JSON data
                }

              case 2:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, _this71);
      }))();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(416)))

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_fullscreen_src_component_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_fullscreen_src_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_fullscreen_src_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel_3d__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_js_on_sortObjects__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_js_on_sortObjects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_js_on_sortObjects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_on_highchart_options__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__maptypes_states_vue__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__maptypes_states_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__maptypes_states_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_async__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__main_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__main__ = __webpack_require__(135);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var $ = __WEBPACK_IMPORTED_MODULE_4_jquery___default.a;




//import PlotlyVue from "@/components/Plotly";







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "barChartComponent",
  components: {
    Fullscreen: __WEBPACK_IMPORTED_MODULE_5_vue_fullscreen_src_component_vue___default.a,
    Carousel3d: __WEBPACK_IMPORTED_MODULE_8_vue_carousel_3d__["Carousel3d"],
    Slide: __WEBPACK_IMPORTED_MODULE_8_vue_carousel_3d__["Slide"],
    MultiSelect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a,
    vueSlider: __WEBPACK_IMPORTED_MODULE_7_vue_slider_component___default.a
  },
  // props: ["appData", "targetData", "lgaData","dashboardStateOptions",'metaData'],
  props: ["appData", "lgaData", "dashboardStateOptions", "metaData", "stateClicked"],
  data: function data() {
    var _statesToShortCode,
        _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
      ndLgaUrl: "https://numerator-denominator-data.firebaseio.com/ndLga.json",
      ndIndexState: [],
      ndIndexLga: [],
      chartNd: [],
      showToggle: true,
      ndSwitch: "OFF",
      fullscreen: false,
      noSubData: false,
      lgaAvailable: true,
      showBarChart: true,
      highchart_options: __WEBPACK_IMPORTED_MODULE_10__assets_js_on_highchart_options__["b" /* chart_options */],
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      ndStateData: JSON.parse(this.$ls.get("nd_state_data")),
      ndLgaData: "",
      isDataLoadedFirstTime: false,
      searchTerm: "",
      traceArray: [],
      lga: [],
      nodata: false,
      district: [],
      nationalTarget: "",
      sdgTarget: "",
      maxValue: 0,
      chartLength: 0,
      selectedIndicator: "Skilled attendance at delivery or birth",
      selectedYear: "2020",
      optionYear: [],
      sourceOptions: ["NHMIS", "NDHS", "MICS", "NNHS", "NARHS", "WHO-GHO", "World Bank", "IHME", "KDGHS"],
      selectedState: "National",
      testData: {},
      optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "National", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      statesToShortCode: (_statesToShortCode = {
        Abia: "AB",
        Adamawa: "AD",
        "Akwa Ibom": "AK",
        Anambra: "AN",
        Bauchi: "BA",
        Benue: "BE",
        Borno: "BO"
      }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Bauchi", "BA"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Bayelsa", "BY"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Cross River", "CR"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Delta", "DE"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Ebonyi", "EB"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Edo", "ED"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Ekiti", "EK"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Enugu", "EN"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "FCT", "FC"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Gombe", "GO"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Imo", "IM"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Jigawa", "JI"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Kano", "KN"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Katsina", "KT"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Kaduna", "KD"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Kebbi", "KE"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Kogi", "KO"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Kwara", "KW"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Lagos", "LA"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Nasarawa", "NA"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Niger", "NI"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Ogun", "OG"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Ondo", "ON"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Osun", "OS"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Oyo", "OY"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Plateau", "PL"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Rivers", "RI"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Sokoto", "SO"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Taraba", "TA"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Yobe", "YO"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_statesToShortCode, "Zamfara", "ZA"), _statesToShortCode),
      headerObj: {},
      showTargetInfo: false,
      nationalTargetInfo: "",
      SDGTargetInfo: "",
      selectedSource: "NHMIS",
      sourceClickProp: null,
      plotData: {},
      tableColumnHeaderAttr: null,
      options: [
        // {
        //     programArea: 'program area name',
        //     indicators: [
        //         { name: 'indicator name'}
        //     ]
        // }
      ],
      value: [],
      theStateName: "the country"
    }, "highchart_options", {
      responsive: {
        rules: [{
          condition: {
            maxWidth: 380
          },
          chartOptions: {}
        }]
      },
      chart: {
        type: "bar",
        zoomType: "xy",
        borderColor: "#FFFFFF",
        events: {
          drillup: function drillup(e) {
            document.querySelector("p#imp").setAttribute("style", "display:none;");
            _this.theStateName = "the country";
            _this.noSubData = false;
          },
          drilldown: function drilldown(e) {
            document.querySelector("p#imp").setAttribute("style", "display:block;");
            _this.theStateName = e.seriesOptions.name + " state";

            // if (
            //   this.lgaAvailable == false ||
            //   this.highchart_options.drilldown.series[0].data.length == 0 ||
            //   this.highchart_options.drilldown.series[0].data[0].y ==
            //     undefined
            // ) {
            //   this.noSubData = true;
            // } else {
            //   this.noSubData = false;
            // }
            // if (this.nodata == true) {
            //   this.noSubData = false;
            // }
          }
        }
      },
      lang: {
        drillUpText: "Back to States",
        noData: "<div style='text-align:center !important; border: 2px solid gray;padding:10%;width: 120%;height: 120%;' class='noSubDataMockUp'><img alt='No data Image' style='width:45%;' src='static/img/noSubnationalData.png'><br><h3 style=' text-align: center;'>NO SUB-NATIONAL <br> LEVEL DATA</h3><br><p style='font-size:13px;font-weight: 200;text-align: center;padding-bottom:4%'>There is no sub-national data available <br>for the indicator,  data source <br> and period you have <br> selected. Try selecting another <br> data source or period</p></div>"
      },
      noData: {
        style: {},
        position: {
          x: -25,
          y: -30
        },
        useHTML: true
      },
      title: {
        margin: 25,
        text: "Loading...",
        style: {
          fontSize: "16px",
          fontFamily: '"Open Sans", sans-serif',
          fontWeight: "600"
        }
      },
      subtitle: {
        text: 'Default subtitle. Source: <a href="http://netmarketshare.com">changesourcelink.com</a>.'
      },
      credits: {
        enabled: false
      },
      xAxis: {
        type: "category",
        //categories: null,
        title: {
          text: "x-axis title"
        },
        labels: {
          style: {
            fontSize: "9px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
            color: "#999999"
          }
        }
      },
      yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        plotLines: [],
        title: {
          text: "y-axis title",
          style: {
            fontSize: "11px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal",
            color: "#888888"
          }
        },
        labels: {
          style: {
            fontSize: "10px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "normal",
            color: "#888888"
          }
        }
      },
      legend: {
        enabled: true,
        borderColor: "black",
        //   borderRadius: 10,
        borderWidth: 3,
        title: {
          text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
          style: {
            fontSize: "12px",
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: "600",
            color: "#666666"
          }
        }
      },
      plotOptions: {
        series: {
          events: {
            // legendItemClick: function (e) {
            //     this.visible = !this.visible;
            //     var visibility = this.visible ? 'visible' : 'hidden';
            //     // if (!confirm('The series is currently ' +
            //     //              visibility + '. Do you want to change that?')) {
            //     //     return true;
            //     // }
            // }
          },
          borderWidth: 0,
          point: {
            events: {
              click: function click(e) {
                // console.log(e);
              }
            }
          },
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            borderWidth: 0,
            crop: false,
            overflow: "allow",
            padding: 1,
            format: "{point.y:.1f}",
            style: {
              fontSize: "8px",
              fontFamily: '"Open Sans", sans-serif',
              fontWeight: "normal",
              color: "#555555"
            }
          },

          // states: {
          //     hover: {
          //         enabled: true,
          //         lineWidth: 4
          //     }
          // },
          zones: []
        }
      },
      tooltip: {
        // backgroundColor: '#FCFFC5',
        // borderColor: 'black',
        // borderRadius: 10,
        // borderWidth: 3,
        // crosshairs: [true, true],
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}</b> of total<br/>'
      },
      // navigation: {
      //     menuItemStyle: {
      //         fontSize: '10px'
      //     }
      // },
      series: [],
      drilldown: {
        activeAxisLabelStyle: {
          color: "black",
          textDecoration: "none",
          fontWeight: "normal"
        },
        activeDataLabelStyle: {
          color: "black",
          textDecoration: "none",
          fontWeight: "normal"
        },
        series: [{
          name: "Anambra",
          id: "Anambra",
          data: [["v65.0", 0.1], ["v64.0", 1.3], ["v63.0", 53.02], ["v62.0", 1.4], ["v61.0", 0.88], ["v60.0", 0.56], ["v59.0", 0.45], ["v58.0", 0.49], ["v57.0", 0.32], ["v56.0", 0.29], ["v55.0", 0.79], ["v54.0", 0.18], ["v51.0", 0.13], ["v49.0", 2.16], ["v48.0", 0.13], ["v47.0", 0.11], ["v43.0", 0.17], ["v29.0", 0.26]]
        }]
      }
    });
  },

  methods: {
    getIdb: function getIdb() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var closeFriends;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_14__main__["indDB"].transaction("rw", __WEBPACK_IMPORTED_MODULE_14__main__["indDB"].stateNumDen, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_14__main__["indDB"].stateNumDen.toArray();

                        case 2:
                          closeFriends = _context.sent;

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                })).catch(function (err) {
                  // Catch any error event or exception and log it:
                  //console.error(err.stack || err);
                });

              case 2:
                return _context2.abrupt("return", closeFriends);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchNdLgaData: function fetchNdLgaData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _this3.axios.get(_this3.ndLgaUrl));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getIndicatorSourceIndex: function getIndicatorSourceIndex(data) {
      //let list = this.lsNdStateData[0]
      //console.log(list)
      var check = this.selectedIndicator + " -> " + this.selectedSource;
      // console.log(check)
      // console.log(data[0])
      return data[0].indexOf(check);
    },
    ndFilterByYear: function ndFilterByYear(data) {
      var _this4 = this;

      return data.filter(function (val) {
        return val[0] == _this4.selectedYear;
      });
      //console.log(ndYearData)
    },
    thousandSeperator: function thousandSeperator(x) {
      //return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return Number(x).toLocaleString();
    },
    getNdChartData: function getNdChartData() {},
    plotLgaND: function plotLgaND() {
      var _this5 = this;

      var lgaData = this.ndFilterByYear(this.ndLgaData);
      var lgaIndex = this.ndIndexLga;

      if (lgaData.length > 0) {
        var ivt;
        var vt;
        var it;

        (function () {
          ivt = _this5.$store.state.CAR.indicatorAttributesOtherSources[_this5.selectedIndicator];
          vt = ivt[1] === "P" ? "%" : "";
          it = ivt[1] === "P" ? "%" : "";


          var highChartSeries = _this5.highchart_options.series;

          // num-den data for LGA
          if (_this5.ndSwitch == "ON") {
            var _loop = function _loop(x) {
              var _loop2 = function _loop2(y) {
                var location = highChartSeries[x].data[y].name;
                //console.log(location)

                // filters lgaData with all the locations to return data for each location
                var value = _this5.lgaData.filter(function (val) {
                  val[1] == highChartSeries[x].data[y].name;
                });
                //console.log(value)

                value = value[0][lgaIndex].split("#");
                //loops through value[0](numerator data) and adds , seperator
                var numData = _this5.thousandSeperator(value[0]);
                var denData = _this5.thousandSeperator(value[1]);
                console.log(numData);
                console.log(denData);

                highChartSeries[x].data[y].nd = numData;
                highChartSeries[x].data[y].dn = denData;
              };

              for (var y = 0; y < highChartSeries[x].data.length; y++) {
                _loop2(y);
              }
            };

            // console.log(ivt)

            //Adds the num/den data to the highchart series when there is no national target
            //when there is no national target highChartSeries.length==2 and data is in the second index
            //when there is a national target highChartSeries.length==4 and there is nothing in the 4th index

            // if (highChartSeries.length == 2){
            //   for (let x = 0; x < highChartSeries.length ; x++) {
            //     for (let y = 0; y < highChartSeries[x].data.length; y++) {
            //       let lgaName = highChartSeries[x].data[y].name;

            //       // filters ndLgadata with all the locations to return data for each location
            //       let value = lgaData.filter(val => {
            //         val[1] == highChartSeries[x].data[y].name
            //       });
            //       // console.log(value)

            //       value = value[0][lgaIndex].split("#");
            //       //loops through value[0](numerator data) and adds , seperator
            //       let numData = this.thousandSeperator(value[0]);
            //       let denData = this.thousandSeperator(value[1]);
            //       console.log(numData);
            //       console.log(denData)
            //       highChartSeries[x].data[y].nd = numData;
            //       highChartSeries[x].data[y].dn = denData;
            //     }
            //   }
            //   //console.log(highChartSeries)

            //   this.highchart_options.plotOptions.series.dataLabels.format =
            //     "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";
            //   this.highchart_options.tooltip.pointFormat =
            //     '<span style="font-size:10px; color:black;">' +
            //     "{point.name}:" +
            //     " {point.y:.2f}" +
            //     it +
            //     "<br>" +
            //     '<span style="font-size:10px; color:black;">' +
            //     "(" +
            //     "{point.nd} " +
            //     this.of +
            //     " {point.dn}" +
            //     ")" +
            //     "</span>";
            // }

            for (var x = 0; x < highChartSeries.length - 1; x++) {
              _loop(x);
            }
            // console.log(highChartSeries)

            // This shows the num/den values inside brackets on the charts
            _this5.highchart_options.plotOptions.series.dataLabels.format = "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";

            //Add num/den data to the tooltip
            _this5.highchart_options.tooltip.pointFormat = '<span style="font-size:10px; color:black;">' + "{point.name}:" + " {point.y:.2f}" + it + "<br>" + '<span style="font-size:10px; color:black;">' + "(" + "{point.nd} " + "of" + " {point.dn}" + ")" + "</span>";
          }
          //clears the num/den values and bracket from the chart
          else if (_this5.ndSwitch == "OFF") {
              _this5.highchart_options.tooltip.pointFormat = '<span style="font-size:10px; color:black;">{point.name}:  {point.y:.2f}' + it + " </span><br/>";
            }
        })();
      } else {
        console.log("NO DATA FOR " + this.selectedYear);
        this.nodata = true;
        if (this.ndSwitch == "OFF") {
          this.nodata = false;
        }
      }
    },
    plotStateND: function plotStateND() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var indexx, ivt, vt, it, _loop3, x, _loop5;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.getIdb();

              case 2:
                _this6.ndStateData = _context4.sent;
                indexx = _this6.getIndicatorSourceIndex(_this6.ndStateData);

                _this6.ndStateData = _this6.ndFilterByYear(_this6.ndStateData);
                ivt = _this6.$store.state.CAR.indicatorAttributesOtherSources[_this6.selectedIndicator];
                vt = ivt[1] === "P" ? "%" : "";
                it = ivt[1] === "P" ? "%" : "";
                // console.log(indexx)
                // console.log(this.ndStateData)
                // console.log(this.highchart_options.series)

                if (_this6.ndSwitch == "ON") {
                  //console.log(this.highchart_options.series)

                  //Adds the num/den data to the highchart series when there is no national target
                  //when there is no national target this.highchart_options.series.length==2 and data is in the second index
                  //when there is a national target this.highchart_options.series.length==4 and there is nothing in the 4th index

                  if (_this6.highchart_options.series.length == 2) {
                    _loop3 = function _loop3(x) {
                      var _loop4 = function _loop4(y) {
                        var location = _this6.highchart_options.series[x].data[y].name;
                        //console.log(location)
                        // filters ndStatedata with all the locations to return data for each location
                        var value = _this6.ndStateData.filter(function (val) {
                          return val[1] == _this6.highchart_options.series[x].data[y].name;
                        });
                        value = value[0][indexx].split("#");
                        //loops through value[o](numerator data) and adds , seperator
                        var numData = _this6.thousandSeperator(value[0]);
                        var denData = _this6.thousandSeperator(value[1]);
                        //console.log(numData);
                        //console.log(denData)
                        _this6.highchart_options.series[x].data[y].nd = numData;
                        _this6.highchart_options.series[x].data[y].dn = denData;
                      };

                      for (var y = 0; y < _this6.highchart_options.series[x].data.length; y++) {
                        _loop4(y);
                      }
                    };

                    for (x = 0; x < _this6.highchart_options.series.length; x++) {
                      _loop3(x);
                    }
                    //console.log(this.highchart_options.series)

                    _this6.highchart_options.plotOptions.series.dataLabels.format = "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";
                    _this6.highchart_options.tooltip.pointFormat = '<span style="font-size:10px; color:black;">' + "{point.name}:" + " {point.y:.2f}" + it + "<br>" + '<span style="font-size:10px; color:black;">' + "(" + "{point.nd} " + _this6.of + " {point.dn}" + ")" + "</span>";
                  }

                  _loop5 = function _loop5(x) {
                    var _loop6 = function _loop6(y) {
                      var location = _this6.highchart_options.series[x].data[y].name;
                      //console.log(location)
                      // filters ndStatedata with all the locations to return data for each location
                      var value = _this6.ndStateData.filter(function (val) {
                        return val[1] == _this6.highchart_options.series[x].data[y].name;
                      });
                      //console.log(value[0][13])
                      value = value[0][indexx].split("#");
                      //loops through value[o](numerator data) and adds , seperator
                      var numData = _this6.thousandSeperator(value[0]);
                      var denData = _this6.thousandSeperator(value[1]);
                      //console.log(numData);
                      //console.log(denData)
                      _this6.highchart_options.series[x].data[y].nd = numData;
                      _this6.highchart_options.series[x].data[y].dn = denData;
                    };

                    for (var y = 0; y < _this6.highchart_options.series[x].data.length; y++) {
                      _loop6(y);
                    }
                  };

                  for (x = 0; x < _this6.highchart_options.series.length - 1; x++) {
                    _loop5(x);
                  }
                  // console.log(this.highchart_options.series)

                  // This shows the num/den values inside brackets on the charts
                  _this6.highchart_options.plotOptions.series.dataLabels.format = "<b>" + "{point.y:.1f}" + vt + "</b>" + "  (" + "{point.nd}" + ")";

                  //Add num/den data to the tooltip
                  _this6.highchart_options.tooltip.pointFormat = '<span style="font-size:10px; color:black;">' + "{point.name}:" + " {point.y:.2f}" + it + "<br>" + '<span style="font-size:10px; color:black;">' + "(" + "{point.nd} " + "of" + " {point.dn}" + ")" + "</span>";
                }
                //clears the num/den values and bracket from the chart
                else if (_this6.ndSwitch == "OFF") {
                    _this6.highchart_options.tooltip.pointFormat = '<span style="font-size:10px; color:black;">{point.name}:  {point.y:.2f}' + it + " </span><br/>";
                  }

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    toggle: function toggle() {
      // this.$refs['fullscreen'].background = "green";
      this.$refs["fullscreen"].toggle();
    },

    //Method to hide or show the bar chart
    hideBar: function hideBar() {
      this.$emit("barChartBoolValue", this.showBarChart);
      this.showBarChart = !this.showBarChart;
    },
    enter: function enter() {
      return true;
    },
    convertToObject: function convertToObject(arrayData, arrayDataName) {
      var tempCadre = [];

      for (var i = 0; i < arrayData.length; i++) {
        var data = {
          name: arrayDataName[i],
          y: arrayData[i],
          drilldown: arrayDataName[i]
        };
        // console.log(data.y); //Second try

        tempCadre.push(data);

        /* Implementation of national drill down to states data */
        var drillColor = "#58a5e8";
        // let drillColor = "";

        if (arrayDataName[0] !== "National") {
          if (arrayData[i] >= this.nationalTarget) {
            drillColor = "#13b433";
          }
          if (arrayData[i] < this.nationalTarget) {
            drillColor = "#e85d58";
          }
          // else{
          //   drillColor = "#1E70EC";
          // }

          var natDrillData = {
            name: arrayDataName[i],
            y: arrayData[i],
            color: drillColor
          };
          this.highchart_options.drilldown.series[7].data.push(natDrillData);
        }
        /* End implementation of national drill down to states data */
      }
      var indexed = 0;
      arrayData.forEach(function (item, index, array) {
        if (parseInt(item) === 0) {
          indexed++;
        }
      });
      // console.log(arrayData);
      // console.log(indexed);
      if (indexed === 37) {
        this.nodata = true;
      } else {
        this.nodata = false;
      }
      return tempCadre;
    },
    getDrilldownData: function getDrilldownData() {
      var _this7 = this;

      //Applying slice to create a new instance of the lgaData
      var tempLGAdata = this.lga.slice(0);
      var series_drilldownDataPerState = [];
      this.highchart_options.drilldown.series = [];
      var indicatorAndSourceValueByState = {};
      this.optionStates.map(function (elem, index) {
        indicatorAndSourceValueByState[elem] = [];
      });
      // console.log(indicatorAndSourceValueByState);

      // get the values of the indicators by state and by year
      tempLGAdata.map(function (elem, index) {
        var stateName = elem[1];

        if (stateName !== "State") {
          var rowDataWithoutState = elem.slice(0);
          rowDataWithoutState.splice(1, 1); // remove the state name
          indicatorAndSourceValueByState[stateName].push(rowDataWithoutState);
        }
      });
      var indicatorSource = this.selectedIndicator + " -> " + this.selectedSource;
      // console.log(this.selectedIndicator);
      //get index of selected indicator
      if (this.lgaData !== null && this.lgaData[0] !== undefined) {
        var indexOfindicatorSource = this.lgaData[0].indexOf(indicatorSource) - 1;
      }
      // console.log(this.lgaData[0]); //i think this is the place

      // console.log(indexOfindicatorSource + ' ' + this.selectedSource + this.lgaData[0]);
      // if(indexOfindicatorSource <= 40){
      //   indexOfindicatorSource = indexOfindicatorSource + 1
      // }

      // console.log(this.lgaData[0].indexOf(indicatorSource) - 1);

      var stateDataByYear = [];
      this.optionStates.map(function (elem, index) {
        var _drilldownData;

        //get array of LGA by states and year
        // console.log(elem);
        stateDataByYear[elem] = [];
        indicatorAndSourceValueByState[elem].map(function (element, index) {
          // console.log(element[1]);
          _this7.noSubData = false;
          if (element[0] === parseInt(_this7.selectedYear)) {
            //this.nodata = true;
            stateDataByYear[elem].push(element);
          }
        });
        var drilldownDataPerState = [];
        stateDataByYear[elem].forEach(function (element) {
          var tempData = [];
          var elementName = element[1].substring(0, element[1].length - 3);
          // console.log(element[indexOfindicatorSource]);
          // console.log(element.length);
          if (element[indexOfindicatorSource] !== "") {
            // console.log(elementName);
            //  this.lgaAvailable = true;
            drilldownDataPerState.push({
              name: elementName,
              y: element[indexOfindicatorSource],
              color: _this7.getColorForLGA(element[indexOfindicatorSource], _this7.nationalTarget !== "" ? _this7.nationalTarget : 0)
            });
          } else {
            //this.lgaAvailable = false;
          }
        });
        var drilldownData = {
          name: elem,
          // name: "On Target",
          // color:
          id: elem,
          data: drilldownDataPerState
        };
        var drilldownData2 = (_drilldownData = {
          name: elem
        }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_drilldownData, "name", "Not on target"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_drilldownData, "id", elem), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_drilldownData, "data", drilldownDataPerState), _drilldownData);
        series_drilldownDataPerState.push(drilldownData);
        // series_drilldownDataPerState2.push(drilldownData2);

        // if( drilldownData2.data[58] !== ''){
        //   this.nodata = true;
        // }
      });

      // var tempArr = series_drilldownDataPerState;
      series_drilldownDataPerState.forEach(function (element) {
        element.data.sort(function (a, b) {
          // this.testData = b;
          // console.log(this.testData);
          return b.y - a.y;
        });
      });

      //sort array of objects by value
      var tempArr = series_drilldownDataPerState;
      tempArr.forEach(function (element) {
        element.data.sort(function (a, b) {
          return b.y - a.y;
        });
      });

      //  this.testData = series_drilldownDataPerState;
      //  console.log(this.highchart_options);

      this.highchart_options.drilldown.series = series_drilldownDataPerState;

      // this.testData = console.log(this.highchart_options.series[1]);

      if (this.highchart_options.drilldown.series[1].data.length === 0) {
        this.nodata = true;
      } else {
        this.nodata = false;
      }
    },
    getColorForLGA: function getColorForLGA(data, target) {
      var indicatorSignalType = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator];
      var colorType = ["#13b433", "#1E70EC", "#e85d58"]; // G, B, R

      var color = [];
      if (indicatorSignalType[0][0] === "G") {
        color = [0, 2];
      } else {
        color = [2, 0];
      }
      if (target > 0) {
        if (data > target) {
          return colorType[color[0]];
        } else if (data < target) {
          return colorType[color[1]];
        }
      } else {
        return colorType[1];
      }
    },
    getDisplayFactor: function getDisplayFactor() {
      var displayFactor = "";
      for (var i in this.metaData) {
        if (this.metaData[i][0] === this.selectedIndicator) {
          displayFactor = this.metaData[i][3];

          //set target info
          this.nationalTargetInfo = this.metaData[i][9];
          this.SDGtargetInfo = this.metaData[i][11];
          //console.log(this.SDGtargetInfo);

          break;
        }
      }
      this.highchart_options.yAxis.title.text = displayFactor;
    },
    splitLGADistrict: function splitLGADistrict() {
      var _this8 = this;

      var lgaDistrict = this.lgaData;
      if (lgaDistrict !== null) {
        lgaDistrict.map(function (elem) {
          var theLGADist = elem[2].split(" ");
          theLGADist = theLGADist[theLGADist.length - 1];
          // console.log(theLGADist);
          if (theLGADist === "LGA") {
            _this8.lga.push(elem);
            // console.log(elem);
          }
          if (theLGADist === "Dist.") {
            _this8.district.push(elem);
          }
        });
      }
    },
    sortByLatestAvailableYear: function sortByLatestAvailableYear() {
      var _this9 = this;

      var years = [];
      var rightOptions = [];
      for (var one in this.sourceOptions) {
        rightOptions[one] = {
          name: this.sourceOptions[one],
          yrs: []
        };
      }

      var _loop7 = function _loop7() {
        var theYears = [];
        var statesByIndicatorByYear = _this9.$store.getters.getCurrentIndicatorsValue;
        var indicatorSource = _this9.selectedIndicator + " -> " + rightOptions[item].name;
        var indicatorSourceIndex = _this9.lsData[0].indexOf(indicatorSource) - 1;
        for (i in statesByIndicatorByYear) {
          statesByIndicatorByYear[i].map(function (el, i) {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (theYears.indexOf(el[0]) < 0) {
                theYears.push(el[0]);
              }
            }
          });
        }
        rightOptions[item].yrs.push(theYears.sort(function (a, b) {
          return b - a;
        }));
      };

      for (var item in rightOptions) {
        var i;

        _loop7();
      }
      // console.log(rightOptions);
      var latestYrs = [];

      for (var opt in rightOptions) {
        if (rightOptions[opt].yrs[0][0] !== undefined) {
          latestYrs.push(rightOptions[opt].yrs[0][0]);
        }
      }
      var temp = [];
      for (var val in rightOptions) {
        if (rightOptions[val].yrs[0][0] == Math.max.apply(Math, latestYrs)) {
          //console.log(rightOptions)
          this.selectedSource = rightOptions[val].name;
          if (this.selectedSource == "NHMIS") break;
        }
      }
      //console.log(temp);
      if (temp.includes("NHMIS")) {
        this.selectedSource = "NHMIS";
      }
    },


    // This function returns the first year for each source
    getSourceYear: function getSourceYear(data) {
      var _this10 = this;

      var years = [];
      var rightOptions = [];
      for (var one in this.sourceOptions) {
        rightOptions[one] = {
          name: this.sourceOptions[one],
          yrs: []
        };
      }

      var _loop8 = function _loop8() {
        var theYears = [];
        var statesByIndicatorByYear = _this10.$store.getters.getCurrentIndicatorsValue;
        var indicatorSource = _this10.selectedIndicator + " -> " + rightOptions[item].name;
        var indicatorSourceIndex = _this10.lsData[0].indexOf(indicatorSource) - 1;
        for (i in statesByIndicatorByYear) {
          statesByIndicatorByYear[i].map(function (el, i) {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (theYears.indexOf(el[0]) < 0) {
                theYears.push(el[0]);
              }
            }
          });
        }
        rightOptions[item].yrs.push(theYears.sort(function (a, b) {
          return b - a;
        }));
      };

      for (var item in rightOptions) {
        var i;

        _loop8();
      }

      if (rightOptions[this.sourceOptions.indexOf(data)] !== -1 || rightOptions[this.sourceOptions.indexOf(data)] !== undefined) {
        return rightOptions[this.sourceOptions.indexOf(data)].yrs[0][0];
      }
    },
    plotStateChart: function plotStateChart() {
      this.ndSwitch = "OFF";
      if (this.stateClicked === "National") {
        if (this.selectedSource == "NHMIS (monthly)") {
          this.plotNhmisMonthly(this.selectedIndicator);
        } else {
          this.theStateName = "the country";
          __WEBPACK_IMPORTED_MODULE_13__main_js__["eventBus"].$emit("changedStateName", this.theStateName);
          document.querySelector("#imp").setAttribute("style", "display:none;");
          this.getDrilldownData();
          this.noSubData = false;
          var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator];
          var vt = ivt[1] === "P" ? "%" : "";
          var it = ivt[1] === "P" ? "%" : "";
          var stateByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
          var selectedIndicatorValuesForEachState = {};

          var indicatorSource = this.selectedIndicator + " -> " + this.selectedSource;
          var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
          // get the current year with values for each indicator...
          var statesWithIndicatorsYearAndValues = this.getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear);

          // what is the idea behind this?
          if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
            for (var stateName in stateByIndicatorByYear) {
              if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
                // var len = stateByIndicatorByYear[o].length;
                var stateCurrentYearVals = stateByIndicatorByYear[stateName][statesWithIndicatorsYearAndValues[2][stateName]];
                selectedIndicatorValuesForEachState[stateName] = [stateCurrentYearVals[0], stateCurrentYearVals[indexOfindicatorSource]]; // stateByIndicatorByYear[stateName][len - 1]
              }
            }
          } else {
            selectedIndicatorValuesForEachState = statesWithIndicatorsYearAndValues[0];
          }

          var temp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selectedIndicatorValuesForEachState);
          var obj = {};
          var statesValue;
          temp.map(function (elem, index) {
            statesValue = selectedIndicatorValuesForEachState[elem][1];
            obj[elem] = statesValue; //? statesValue: ""; //selectedIndicatorValuesForEachState[elem][1];
          });
          var regions = ["North-East", "North-West", "North-Central", "South-East", "South-West", "South-South"];
          var sortedObj = __WEBPACK_IMPORTED_MODULE_9__assets_js_on_sortObjects___default()(obj); // custom method
          var xAxis = [],
              yAxis = [];
          for (var _stateName in sortedObj) {
            if (sortedObj.hasOwnProperty(_stateName)) {
              if (regions.indexOf(_stateName) < 0) {
                // don't need the regions in this chart
                yAxis.push(_stateName);
                xAxis.push(sortedObj[_stateName] ? sortedObj[_stateName] : null);
              }
            }
          }
          // console.log(yAxis);
          var plotData = {};
          // get the data required for ngMap
          yAxis.map(function (elem, index) {
            plotData[elem] = xAxis[index] ? xAxis[index] : 0;
          });
          this.$emit("plotData", plotData);
          var new_yAxis = yAxis.slice(0),
              new_xAxis = xAxis.slice(0);
          for (var i in yAxis) {
            if (yAxis[i] === "National") {
              var tempName = yAxis[i];
              var tempValue = xAxis[i];
              new_yAxis.splice(i, 1);
              new_yAxis.unshift(tempName);
              new_xAxis.splice(i, 1);
              new_xAxis.unshift(tempValue);
            }
          }
          // extract the top5, least5 and others
          // var cadre = this.computeCadre(xAxis, yAxis);
          var cadre2 = this.computeCadre2(xAxis, yAxis);
          var indicatorSignalType = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator];

          var colorType = ["#13b433", "#1E70EC", "#e85d58"]; // G, B, R
          var legendText = ["On target", "Target not Available", "Not on target"];

          var color = [];
          var text = [];
          if (indicatorSignalType[0][0] === "G") {
            color = [0, 2];
          } else {
            color = [2, 0];
          }
          // for highchart...

          if (vt === "%" && this.stateClicked === "National" && this.maxValue < 100) {
            this.highchart_options.yAxis.max = 100 + 10;
          } else {
            this.highchart_options.yAxis.max = null;
          }
          this.highchart_options.series = [];
          this.highchart_options.title.text = this.selectedIndicatorShortName;
          this.highchart_options.subtitle.text = this.selectedSource + " - " + this.selectedYear;
          this.highchart_options.yAxis.plotLines = [];
          this.highchart_options.yAxis.gridLineWidth = 0, //Remove gridlines
          // this.highchart_options.yAxis.minorGridLineWidth= 0;    //Insignificant here
          this.highchart_options.tooltip.headerFormat = '<span style="font-size:12px; font-weight:bold;">{series.name}</span><br>';
          this.highchart_options.tooltip.pointFormat = '<span style="font-size:10px; color:black;">{point.name}:  {point.y:.2f}' + it + " </span><br/>";
          this.highchart_options.plotOptions.series.dataLabels.format = "{point.y:.1f}" + vt;

          this.highchart_options.yAxis.softMax = "";
          this.highchart_options.exporting = {
            allowHTML: "true",
            buttons: {
              //     toggleButton: {
              //     text: 'ON',
              //     text: 'NUM/DEN',
              //     onclick: function () {
              //       eventBus.$emit("nd")
              //       // this.enterdp();
              //         // alert(this.theStateName);
              //         console.log(this.theStateName);
              //     },
              //     theme: {
              //       padding: 30
              //       padding: 20
              //     },
              //     align: "left"

              // },
              contextButton: {
                menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
                //"viewData",
                "openInCloud"],

                symbol: "download"
                // symbolStrokeWidth: 2,
                // symbolFill: '#330033',
                // symbolStroke: '#b3d4fc'
              }
            },
            filename: this.selectedIndicator + " (" + this.selectedSource + " - " + this.selectedYear + ")"
          };

          if (xAxis[0] < cadre2.nationalTarget) {
            this.highchart_options.yAxis.softMax = cadre2.nationalTarget + 10;
          }
          //   var statesNameInOrder = (cadre.top5_yAxis.reverse().concat(cadre.others_yAxis.reverse()))
          //                           .concat(cadre.least5_yAxis.reverse());
          //   var statesValuesInOrder = (cadre.top5_xAxis.reverse().concat(cadre.others_xAxis.reverse()))
          //                             .concat(cadre.least5_xAxis.reverse());

          var nationalLineID = "natID";
          var nationalTargetLine = {
            // id: 'L1',
            id: nationalLineID,
            color: "#222222",
            width: 0.5,
            value: cadre2.nationalTarget,
            label: {
              text: "NT: " + cadre2.nationalTarget + vt, // vt is value type; whether percentage or number
              verticalAlign: "top",
              rotation: 0,
              textAlign: "left",
              y: 0, //y: -475, on mobile
              x: -20,
              style: {
                fontSize: "10px",
                fontFamily: '"Open Sans", sans-serif'
              }
            }
          };

          var sdgTargetLine = {
            id: "L2",
            color: "#222222",
            width: 0.5,
            value: cadre2.sdgTarget,
            dashStyle: "longdashdot",
            label: {
              text: "SDG: " + cadre2.sdgTarget + vt, // vt is value type; whether percentage or number
              verticalAlign: "top",
              rotation: 0,
              textAlign: "right",
              y: 0,
              x: 0,
              style: {
                fontSize: "10px",
                fontFamily: '"Open Sans", sans-serif'
              }
            }
          };

          //Series for target Legend
          var nationalTargetLegend = {
            // Series that mimics the plot line
            color: "#222222",
            name: "National Target (NT)",
            // dashStyle: 'shortdash',
            marker: {
              symbol: "triangle"
            },
            events: {
              legendItemClick: function legendItemClick(e) {
                if (this.visible) {
                  e.target.chart.yAxis[0].removePlotLine(nationalLineID);
                } else {
                  e.target.chart.yAxis[0].addPlotLine(nationalTargetLine);
                }
              }
            }
          };

          if (typeof cadre2.nationalTarget == "number") {
            this.highchart_options.yAxis.plotLines.push(nationalTargetLine);
          }
          if (typeof cadre2.sdgTarget == "number") {
            this.highchart_options.yAxis.plotLines.push(sdgTargetLine);
          }

          var statesNameInOrder = cadre2.top5_yAxis.concat(cadre2.noTarget_yAxis).concat(cadre2.least5_yAxis);
          var statesValuesInOrder = cadre2.top5_xAxis.concat(cadre2.noTarget_xAxis).concat(cadre2.least5_xAxis);

          var nationalSeriesColor = "#58a5e8";
          var chartData = [];

          if (cadre2.nationalTarget == "") {
            nationalSeriesColor = "#58a5e8";
          } else if (cadre2.national_xAxis[0] > cadre2.nationalTarget) {
            nationalSeriesColor = colorType[color[0]];
          } else {
            nationalSeriesColor = colorType[color[1]];
          }

          var nationalObject = {
            showInLegend: false,
            name: "National Value",
            data: this.convertToObject(cadre2.national_xAxis, cadre2.national_yAxis),
            pointWidth: 8,
            color: nationalSeriesColor
          };

          if (cadre2.noTarget_xAxis.length == 37) {
            var national = cadre2.noTarget_xAxis.length - cadre2.national_yAxis;
            for (var i = 0; i < national; i++) {
              cadre2.national_xAxis.push(null);
              cadre2.national_yAxis.push(null);
            }
            var temp = {
              name: "Target not Available",
              data: this.convertToObject(cadre2.noTarget_xAxis, cadre2.noTarget_yAxis), //data:cadre2.noTarget_xAxis
              pointWidth: 8,
              color: "#58a5e8"
            };

            // this.highchart_options.series.push(nationalObject,temp);
            chartData.push(nationalObject, temp);
          } else {
            var numberOfTargetMet = cadre2.top5_xAxis.length;
            var numberOfTargetNotMet = cadre2.least5_xAxis.length;
            var targetsMet = cadre2.top5_xAxis;
            var targetsNotMet = cadre2.least5_xAxis;

            var _national = numberOfTargetMet + numberOfTargetNotMet - cadre2.national_yAxis.length;

            var nationalArrayLength = cadre2.national_yAxis.length;
            var targetsMetObject = {
              name: legendText[color[0]],
              data: this.convertToObject(targetsMet, cadre2.top5_yAxis), //data:targetsMet
              pointWidth: 8,
              color: colorType[color[0]]
            };
            var targetsNotMetObject = {
              name: legendText[color[1]],
              data: this.convertToObject(targetsNotMet, cadre2.least5_yAxis), //data:targetsNotMet
              pointWidth: 8,
              color: colorType[color[1]]
            };
            chartData.push(nationalObject, targetsMetObject, targetsNotMetObject, nationalTargetLegend);
          }

          this.highchart_options.series = chartData;
          // console.log(this.highchart_options.series);
          // console.log(this.highchart_options.series[1].data.length);
          if (this.data !== undefined) {
            if (this.highchart_options.series[1].data.length < 1 || this.highchart_options.series[2].data.length < 1) {
              this.nodata = true;

              if (this.highchart_options.series[1].data.length > 2 || this.highchart_options.series[2].data.length > 2) {
                this.nodata = false;
              }

              if (this.highchart_options.series[2].data[0].y == 0) {
                this.nodata = true;
              }
            } else if (this.highchart_options.series[1].data.length == 37) {
              this.nodata = false;
            }
          }
        }
      } else {
        this.plotLGAChart();
      }
    },
    plotNhmisMonthly: function plotNhmisMonthly(indicator) {
      var nhmisMonthlyData = this.$store.state.CAR.NhmisMonthlyData;
      this.nodata = nhmisMonthlyData.length > 0 ? false : true;
      var index = nhmisMonthlyData[0].indexOf(indicator + " -> " + "NHMIS");
      var latestData = nhmisMonthlyData.slice(-36);
      var currentDate = latestData[0][0];
      // let currentData = latestData.filter(val => val[1] == this.selectedState);
      var dataSeries = [];
      latestData.forEach(function (element) {
        var temp = {
          name: element[1],
          y: element[index]
        };
        dataSeries.push(temp);
      });

      var sortedData = dataSeries.sort(function (a, b) {
        if (a.y > b.y) return -1;
        if (a.y < b.y) return 1;
      });
      var indexNational = sortedData.findIndex(function (e) {
        return e.name == "National";
      });
      var NationalValue = sortedData[indexNational];
      sortedData.splice(indexNational, 1);
      sortedData.unshift(NationalValue);

      var monthlDataSeries = {
        name: "NHMIS-DHIS2 (monthly)",
        data: sortedData,
        showInLegend: true,
        color: "#13b433"
      };

      this.highchart_options.yAxis.plotLines = "";
      this.highchart_options.subtitle.text = this.selectedSource + " / " + currentDate;

      this.highchart_options.series = [];
      this.highchart_options.series.push(monthlDataSeries);
    },
    plotLGAChart: function plotLGAChart() {
      var _this11 = this;

      if (this.lgaAvailable == false || this.highchart_options.drilldown.series[0].data.length == 0 || this.highchart_options.drilldown.series[0].data[0].y == undefined) {
        this.noSubData = true;
      } else {
        this.noSubData = false;
      }
      this.ndSwitch = "OFF";
      // if(this.lgaAvailable == false ||this.highchart_options.drilldown.series[0].data.length == 0 || this.highchart_options.drilldown.series[0].data[0].y== undefined){
      //                   this.noSubData = true;
      //             } else{
      //                 this.noSubData = false;
      //             }
      this.highchart_options.yAxis.max = null;
      this.theStateName = this.stateClicked + " State";
      __WEBPACK_IMPORTED_MODULE_13__main_js__["eventBus"].$emit("changedStateName", this.theStateName);
      document.querySelector("#imp").setAttribute("style", "display:none;");
      var indicatorSignalType = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator];
      var stateByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;

      var indicatorSource = this.selectedIndicator + " -> " + this.selectedSource;
      var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
      // get the current year with values for each indicator...
      this.getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear);
      var colorType = ["#13b433", "#1E70EC", "#e85d58"]; // G, B, R
      var legendText = ["On target", "Target not Available", "Not on target"];

      var color = [];
      var text = [];
      if (indicatorSignalType[0][0] === "G") {
        color = [0, 2];
      } else {
        color = [2, 0];
      }
      this.getDrilldownData();
      var data = this.highchart_options.drilldown.series;

      var lgaData = data.find(function (e) {
        return e.name === _this11.stateClicked;
      });

      if (this.nodata == false) {
        if (this.lgaAvailable == false || this.highchart_options.drilldown.series[0].data.length == 0 || this.highchart_options.drilldown.series[0].data[0].y == undefined) {
          this.noSubData = true;
        } else {
          this.noSubData = false;
        }
      }
      this.highchart_options.title.text = this.selectedIndicatorShortName;
      this.highchart_options.subtitle.text = this.selectedSource + " - " + this.selectedYear;
      this.highchart_options.series = [];
      var series_object = {
        name: this.stateClicked,
        data: lgaData.data,
        showInLegend: false,
        pointWidth: 8
      };
      var notOnTarget = {
        name: legendText[color[0]],
        color: colorType[color[0]],
        data: null,
        pointWidth: 0
      };
      var onTarget = {
        name: legendText[color[1]],
        color: colorType[color[1]],
        data: null,
        pointWidth: 0
      };
      var series_obj = {
        name: this.stateClicked,
        data: lgaData.data,
        showInLegend: true,
        pointWidth: 8
      };

      var nt_legend = {
        name: "National Target",
        data: this.nationalTarget,
        showInLegend: true,
        pointWidth: 1,
        color: "#222222"
      };

      if (this.nationalTarget == "") {
        this.highchart_options.series.push(series_obj);
      } else {
        this.highchart_options.series.push(series_object, notOnTarget, onTarget, nt_legend);
      }
    },


    // compute the cadre targets for the different states
    computeCadre2: function computeCadre2(xAxis, yAxis) {
      var _this12 = this;

      //Taking the target value for national
      var nationalTarget = void 0;
      var sdgTarget = void 0;
      // let targetValues = targetObj["National"];

      this.metaData.map(function (elem) {
        if (_this12.selectedIndicator == elem[0]) {
          nationalTarget = elem[7];
          sdgTarget = elem[10];

          _this12.nationalTarget = nationalTarget;
          _this12.sdgTarget = sdgTarget;
        }
      });
      // console.log(sdgTarget1);

      // if(targetValues != ""){
      //   let targetTest = targetValues.toString();
      //   // targetTest = "57 -> 40"
      //   let targetTestArray = targetTest.split("->");
      //   nationalTarget = targetTestArray[0];

      //   if(targetTestArray[0] != ""){
      //     nationalTarget = parseInt(targetTestArray[0]);
      //   }
      //   if(targetTestArray.length > 1){
      //     sdgTarget = parseInt(targetTestArray[1]);
      //     // console.log(targetTestArray);
      //     // console.log(sdgTarget);
      //   }
      // }

      var national_xAxis = [];
      var national_yAxis = [];
      var top5_xAxis = [];
      var top5_yAxis = [];
      var noTarget_xAxis = [];
      var noTarget_yAxis = [];
      var least5_xAxis = [];
      var least5_yAxis = [];
      yAxis.map(function (elem, index) {
        if (elem === "National") {
          national_xAxis.push(xAxis[index]);
          national_yAxis.push(yAxis[index]);

          _this12.maxValue = _this12.maxValue < xAxis[index] ? xAxis[index] : _this12.maxValue;
        } else {
          // if (targetObj[elem] == "") {
          if (nationalTarget == "") {
            noTarget_xAxis.push(xAxis[index]);
            noTarget_yAxis.push(yAxis[index]);

            _this12.maxValue = _this12.maxValue < xAxis[index] ? xAxis[index] : _this12.maxValue;
            // } else if (targetObj[elem] <= xAxis[index]) {
          } else if (nationalTarget <= xAxis[index]) {
            top5_xAxis.push(xAxis[index]);
            top5_yAxis.push(yAxis[index]);

            _this12.maxValue = _this12.maxValue < xAxis[index] ? xAxis[index] : _this12.maxValue;
          } else {
            least5_xAxis.push(xAxis[index]);
            least5_yAxis.push(yAxis[index]);

            _this12.maxValue = _this12.maxValue < xAxis[index] ? xAxis[index] : _this12.maxValue;
          }
        }
      });
      return {
        national_xAxis: national_xAxis,
        national_yAxis: national_yAxis,
        nationalTarget: nationalTarget, // targetValue,
        sdgTarget: sdgTarget,
        top5_xAxis: top5_xAxis,
        top5_yAxis: top5_yAxis,
        noTarget_xAxis: noTarget_xAxis,
        noTarget_yAxis: noTarget_yAxis,
        least5_xAxis: least5_xAxis,
        least5_yAxis: least5_yAxis
      };
    },
    getYearWithCurrentIndicatorValues: function getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear) {
      var statesWithIndicatorsYearAndValues = {};
      var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
      var sourceActiveYear = {};
      var sourcetempArr = [];

      for (var stateName in stateByIndicatorByYear) {
        if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
          for (var i = stateByIndicatorByYear[stateName].length - 1; i >= 0; i--) {
            statesWithIndicatorsYearAndValues[stateName] = [];
            var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            if (stateByIndicatorByYear[stateName][i][0] === parseInt(this.selectedYear)) {
              tempArr[stateName] = i;
              statesWithIndicatorsYearAndValues[stateName].push(stateByIndicatorByYear[stateName][i][0], stateByIndicatorByYear[stateName][i][indexOfindicatorSource]);
              break;
            }
          }
          // get all the years where there's a value for the indicator...
          for (var i = stateByIndicatorByYear[stateName].length - 1; i >= 0; i--) {
            if (!sourceActiveYear[stateName]) {
              sourceActiveYear[stateName] = {};
            }
            var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];

            if (selectedIndicatorVal) {
              sourcetempArr.push(i);
              sourceActiveYear[stateName][stateByIndicatorByYear[stateName][i][0]] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            }
          }
        }
      }
      // we leverage the fact that National always has data for all the indicators
      // O we changed our minds and no longer leverage the above
      // We expect the value to be national or next state if national is empty

      var year = [];
      for (var _i in sourceActiveYear) {
        var tempObj = sourceActiveYear[_i];
        var tempYears = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tempObj);
        year = this.$_.union(year, tempYears);
      }

      // this.optionYear = year;
      this.optionYear = year.sort(function (a, b) {
        return b - a;
      }); //Object.keys(sourceActiveYear["National"]);

      this.$emit("optionYear", this.optionYear);
      var rowIndex = Math.max.apply(null, tempArr);

      return [statesWithIndicatorsYearAndValues, rowIndex, tempArr];
    }
  },
  computed: {
    sourceClicked: function sourceClicked() {
      //for tablecomponent.vue
      var tempSource = this.$store.getters.getTableSourceClicked;
      // console.log(tempSource);

      if (this.lsData) {
        // for customtable.vue
        /**
         * Dynamically select a particular source to be used for the bar chart
         */

        var _indicatorSourceIndex = void 0,
            indicator_source = void 0;

        if (Array.isArray(tempSource)) {
          this.sortByLatestAvailableYear();
          this.sourceOptions = tempSource;
          // return singleSource;
          // console.log(singleSource);
          // console.log(this.selectedSource);
        } else {
          this.selectedSource = tempSource;
          indicator_source = this.selectedIndicator + " -> " + tempSource;
          _indicatorSourceIndex = this.lsData[0].indexOf(indicator_source);
          // return tempSource;
        }
        // console.log(tempSource);
      }
    },
    indicatorSelected: function indicatorSelected() {
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;

      var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
      // console.log(this.selectedIndicator);

      return "Some values";
    },
    selectedIndicatorShortName: function selectedIndicatorShortName() {
      // send message to reset list of sources...
      return this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
    }
  },
  created: function created() {
    // get the program area indicator grouping

    this.highchart_options.chart.type = "bar";
    this.highchart_options.plotOptions.series.cropThreshold = 300;
    this.highchart_options.subtitle.text = "Loading...";
    this.highchart_options.legend = {
      // layout: 'vertical',
      align: "center",
      verticalAlign: "bottom",
      x: -20,
      y: 10,
      itemStyle: {
        fontSize: "12px",
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: "600"
      }
      // floating: false,
      // borderWidth: 1,
      // shadow: true
    };
    this.highchart_options.xAxis.title.text = "";
    // this.highchart_options.xAxis.lineWidth = 2;
    this.highchart_options.yAxis.gridLineWidth = 1;
    this.highchart_options.yAxis.title.text = "";
    this.highchart_options.plotOptions.colorByPoint = true;
    this.highchart_options.chart.height = 670;
  },
  mounted: function mounted() {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var tempSource, sources;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // const clearDB = localStorage.getItem('cleardb')
              // if (clearDB !== 'done'){
              //   localStorage.clear();
              //   localStorage.setItem('cleardb', 'done')
              // }
              // console.log('already cleared db')

              _this13.sourceOptions = ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS", "World Bank", "IHME", "WHO-GHO"];
              _context5.next = 3;
              return _this13.getIdb();

            case 3:
              //this.ndLgaData = this.fetchNdLgaData();

              __WEBPACK_IMPORTED_MODULE_13__main_js__["eventBus"].$on("chartToggleEvent", function (data) {
                _this13.showToggle = data;
              });

              _this13.selectedSource = "NHMIS";
              _context5.next = 7;
              return _this13.getIdb();

            case 7:
              _this13.ndStateData = _context5.sent;

              _this13.ndIndexState = _this13.getIndicatorSourceIndex(_this13.ndStateData);

              _this13.fetchNdLgaData().then(function (ndLgaData) {
                _this13.ndLgaData = ndLgaData.data;
                _this13.ndIndexLga = _this13.getIndicatorSourceIndex(_this13.ndLgaData);
              });

              // this.ndLgaData = JSON.parse(this.$ls.get("nd_lga_data"))
              // this.ndIndexLga = this.getIndicatorSourceIndex(this.ndLgaData)
              //console.log(this.ndStateData)
              //console.log(this.ndLgaData)
              //this.ndFilterByYear()

              _this13.tableColumnHeaderAttr = _this13.$store.getters.getSourceClicked;
              tempSource = _this13.$store.getters.getTableSourceClicked;
              sources = _this13.tableColumnHeaderAttr[0];
              // var selectedSource = sources; //? sources: defaultSource;

              _this13.sortByLatestAvailableYear();
              if (_this13.dashboardStateOptions.length > 0) {
                _this13.selectedIndicator = _this13.dashboardStateOptions[0];
                _this13.selectedYear = _this13.dashboardStateOptions[2];
              } else {
                _this13.selectedIndicator = "Skilled attendance at delivery or birth";
                //this.selectedYear = '2017';
              }
              if (_this13.lgaData && _this13.metaData) {
                // call get indicator to get indicators
                if (_this13.lsData) {
                  _this13.optionYear = _this13.$store.getters.getOtherDatasetYear;
                  // this.ls_lgaData = this.$store.getters.getLgaData;
                  _this13.isDataLoadedFirstTime = true;

                  // this.ls_lgaData = this.lgaData;
                  _this13.splitLGADistrict();
                  // this.ls_lgaData = this.lga;
                  _this13.plotStateChart();
                  _this13.selectedYear = Math.max.apply(null, _this13.optionYear);
                }
                if (_this13.metaData) {
                  _this13.getDisplayFactor();
                }
              }
              _this13.getNdChartData();
              // this.selectedSource = "NHMIS";
              // this.selectedYear = "2020"

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this13);
    }))();
  },
  updated: function updated() {},

  watch: {
    ndSwitch: function ndSwitch(val) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (val == "OFF") {
                  _this14.highchart_options.plotOptions.series.dataLabels.format = "{point.y:.1f}";
                }

                if (!(_this14.stateClicked == "National")) {
                  _context6.next = 9;
                  break;
                }

                _context6.next = 4;
                return _this14.getIdb();

              case 4:
                _this14.ndStateData = _context6.sent;

                _this14.ndIndexState = _this14.getIndicatorSourceIndex(_this14.ndStateData);
                _this14.plotStateND();
                _context6.next = 10;
                break;

              case 9:
                _this14.plotLgaND();

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this14);
      }))();
    },
    selectedIndicator: function selectedIndicator(val) {
      var _this15 = this;

      // if(this.metaData && this.ls_lgaData){
      // console.log(this.sourceOptions);
      this.sortByLatestAvailableYear();
      if (this.metaData) {
        setTimeout(function () {
          _this15.splitLGADistrict();
          _this15.plotStateChart();
          _this15.getDisplayFactor();
        }, 5);
      }
    },
    selectedSource: function selectedSource(val) {
      var _this16 = this;

      if (val) {
        this.selectedYear = this.getSourceYear(val);

        // if (this.metaData && this.ls_lgaData) {
        /* fires event when selectedSource is changed*/
        __WEBPACK_IMPORTED_MODULE_13__main_js__["eventBus"].$emit("barSourceEvent", val);
        if (this.metaData) {
          setTimeout(function () {
            _this16.splitLGADistrict();
            _this16.plotStateChart();
            _this16.getDisplayFactor();
            // console.log(this.optionYear);
          }, 1);
          this.ndSwitch = "OFF";
        }
      }
    },
    selectedYear: function selectedYear(val) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                //this.ndStateData = await this.getIdb();
                //this.ndIndexState = this.getIndicatorSourceIndex(this.ndStateData);
                //this.lsTargetData = this.$store.getters.getTargetData;
                //this.plotStateND();
                // eventBus.$emit("computeNd", val);
                if (_this17.lsData) {
                  // if (this.metaData && this.ls_lgaData) {
                  if (_this17.metaData) {
                    // this.splitLGADistrict();
                    _this17.plotStateChart();
                    _this17.$emit("callerName", "barChartComponentYear");
                    _this17.$emit("selectedYear", val);
                  }
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this17);
      }))();
    },
    appData: function appData(val) {
      if (!this.lsData) {
        this.lsData = val;
        this.isDataLoadedFirstTime = true;
        // if (this.metaData && this.ls_lgaData) {
        if (this.metaData) {
          this.getDisplayFactor();
          this.plotStateChart();
        }
        // if(this.metaData){
        //   this.getDisplayFactor();
        // }
      }
      // call method ...
    },
    metaData: function metaData(val) {
      if (val) {
        this.metaData = val;
        this.getDisplayFactor();
        this.plotStateChart();
      }
    },
    lgaData: function lgaData(val) {
      if (val) {
        this.splitLGADistrict();
        // this.ls_lgaData = this.lga;
        if (this.metaData) {
          this.plotStateChart();
        }
      }
    },
    dashboardStateOptions: function dashboardStateOptions(val) {
      if (val) {
        this.selectedIndicator = val[0];
        this.selectedYear = val[2];
      }
    },
    stateClicked: function stateClicked(val) {
      this.plotStateChart();
      // if(val !== 'National') {

      // }
    },
    optionYear: function optionYear() {
      // this.selectedYear= this.optionYear[0]
    }
  }
});

/***/ }),

/***/ 869:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "barChart",
  props: {
    barChartData: {
      type: Array
    }
  },
  data: function data() {
    return {
      chartHasNoData: false,
      options: {
        chart: {
          type: null,
          height: 720
          // zoomType: 'xy'
        },
        title: {
          text: 'Loading...',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: '600'
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: '11px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 'normal'
          }
        },
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'category',
          categories: null,
          title: {
            text: ''
          },
          labels: {
            style: {
              fontWeight: 'normal',
              color: '#686464'
            }
          }
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          title: {
            text: ''
          }
        },
        legend: {
          enabled: true,
          // backgroundColor: '#FCFFC5',
          // borderColor: 'black',
          // borderRadius: 10,
          // borderWidth: 3,
          verticalAlign: 'top',
          x: -20,
          y: -15
        },
        plotOptions: {
          series: {
            pointWidth: 6,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:.1f}',
              style: {
                fontWeight: 'normal'
              }
            },
            cursor: 'pointer',
            dashStyle: "Solid",
            point: {},
            marker: {
              lineWidth: 1
            },
            zones: []
          }
        },

        tooltip: {
          // backgroundColor: '#FCFFC5',
          // borderColor: 'black',
          // borderRadius: 10,
          // borderWidth: 3,
          // crosshairs: [true, true],
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}%</b> of total<br/>'
        },
        series: [{
          name: 'Female',
          data: [2.1, 2.0, 2.1, 2.3, 2.6, 2.9, 3.2, 3.1, 2.9, 3.4, 4.3, 4.0, 3.5, 2.9, 2.5, 2.7, 2.2, 1.1, 0.6, 0.2, 0.0]
        }],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
              //"viewData",
              "openInCloud"],
              symbol: 'download'
              // symbolStrokeWidth: 2,
              // symbolFill: '#330033',
              // symbolStroke: '#b3d4fc'
            }
          }
        }
      }
    };
  },

  methods: {
    computeChart: function computeChart() {
      var _this = this;

      //this.options.exporting.filename = indicator +" ("+ source +' - '+ this.selectedYear +")";
      var plotData = this.barChartData[0];
      var xAxis = [],
          yAxis = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(plotData).map(function (elem, index) {
        xAxis.push(plotData[elem]);
        yAxis.push(elem);
      });
      var cadre = this.computeCadre(xAxis, yAxis);
      var indicatorSignalType = this.$store.state.CAR.indicatorAttributesOtherSources[this.barChartData[1]];
      var colorType = ['#13b433', '#1E70EC', '#e85d58']; // G, B, R

      var color = [];
      if (indicatorSignalType[0][0] === 'G') {
        color = [0, 2];
      } else {
        color = [2, 0];
      }
      var selectedIndicatorShortName = this.$store.getters.getShortIndicatorNames(this.barChartData[1]);
      // ivt = indicator value type
      var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[this.barChartData[1]];
      var vt = ivt[1] === 'P' ? '%' : '';
      var it = ivt[1] === 'P' ? '% of total' : '';

      // for highchart...
      this.options.series = [];
      this.options.xAxis.categories = [];
      this.options.title.text = selectedIndicatorShortName + '-' + this.barChartData[2];

      this.options.tooltip.headerFormat = '<span style="font-size:11px; font-weight:bold; text-decoration: underline">' + this.barChartData[2] + '-' + this.barChartData[3] + '</span><br>';
      this.options.tooltip.pointFormat = '<span style="color:black; font-weight: bold;">{series.name} - <b>{point.y:.2f}' + it + '</b> </span><br/>';
      this.options.plotOptions.series.dataLabels.format = '{point.y:.1f}' + vt;

      var statesNameInOrder = cadre.top5_yAxis.reverse().concat(cadre.others_yAxis.reverse()).concat(cadre.least5_yAxis.reverse());
      var statesValuesInOrder = cadre.top5_xAxis.reverse().concat(cadre.others_xAxis.reverse()).concat(cadre.least5_xAxis.reverse());

      this.options.xAxis.categories = statesNameInOrder;
      var temp = cadre.top5_xAxis;
      var top5 = {
        name: "Top5",
        data: [temp[0], temp[1], temp[2], temp[3], temp[4], null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
        // pointWidth: 4,
        color: colorType[color[0]]
      };

      temp = cadre.others_xAxis;
      var others = {
        name: "Others",
        data: [null, null, null, null, null, temp[0], temp[1], temp[2], temp[3], temp[4], temp[5], temp[6], temp[7], temp[8], temp[9], temp[10], temp[11], temp[12], temp[13], temp[14], temp[15], temp[16], temp[17], temp[18], temp[19], temp[20], temp[21], temp[22], temp[23], temp[24], temp[25], temp[26], temp[27], null, null, null, null, null],
        // pointWidth: 4,
        color: '#58a5e8'
      };

      temp = cadre.least5_xAxis;
      var least5 = {
        name: "Least 5",
        data: [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, temp[0], temp[1], temp[2], temp[3], temp[4]],
        // pointWidth: 4,
        color: colorType[color[1]]
      };
      var stateAndTargetValues = [top5, others, least5];
      stateAndTargetValues.map(function (elem, index) {
        if (!elem.data.includes(undefined)) {
          _this.options.series.push(elem);
        }
      });
      //this.options.series.push(top5, others, least5);
      // console.log(this.options.series);
      return;
    },

    // compute the cadre for the different states
    computeCadre: function computeCadre(xAxis, yAxis) {
      // console.log(this.lsTargetData.slice[0])

      //compute the cadre for top states
      var top5_xAxis = xAxis.filter(function (elem, index, arr) {
        return index < 5;
      }).reverse();

      var top5_yAxis = yAxis.filter(function (elem, index, arr) {
        return index < 5;
      }).reverse();

      //compute the cadre for least 5 states
      var least5_xAxis = xAxis.filter(function (elem, index, arr) {
        return index > 32;
      }).reverse();

      var least5_yAxis = yAxis.filter(function (elem, index, arr) {
        return index > 32;
      }).reverse();

      //compute the cadre for other 27 states
      var others_xAxis = xAxis.filter(function (elem, index, arr) {
        return index > 4 && index < 33;
      }).reverse();

      var others_yAxis = yAxis.filter(function (elem, index, arr) {
        return index > 4 && index < 33;
      }).reverse();

      return { top5_xAxis: top5_xAxis, top5_yAxis: top5_yAxis, least5_xAxis: least5_xAxis, least5_yAxis: least5_yAxis, others_xAxis: others_xAxis, others_yAxis: others_yAxis };
    }
  },
  computed: {},
  mounted: function mounted() {},
  created: function created() {
    this.options.chart.type = 'bar';
    this.options.plotOptions = {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    };
    this.options.yAxis.gridLineWidth = 1;
    this.options.yAxis.title.text = '';
    this.options.plotOptions.colorByPoint = true;
    this.options.chart.height = 680;
  },

  // },
  // computed: {
  //     sourceClicked() {

  //         this.tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
  //         var sources = this.tableColumnHeaderAttr[0];
  //         var val = this.tableColumnHeaderAttr[1];
  //         // check for availability of data in the source here

  //         // var defaultSource = this.$store.getters.getDefaultSource;
  //         var selectedSource = sources;//? sources: defaultSource;
  //         this.selectedSource = selectedSource;

  //         // get the the state indicator source object from store
  //         var stateSelectedIndicatorSource = this.$store.getters.getSelectedIndicatorSource;
  //         var selectedIndicatorSource = stateSelectedIndicatorSource[selectedSource];

  //         // console.log(stateSelectedIndicatorSource);
  //         if (selectedIndicatorSource) {
  //             // compute the years custom to the data
  //             var optionYear = [];
  //             Object.keys(stateSelectedIndicatorSource).map( (elem, index) => {
  //                 if (stateSelectedIndicatorSource[elem].length > 0) {
  //                     optionYear.push(stateSelectedIndicatorSource[elem][0])
  //                 }
  //             })
  //             this.optionYear = optionYear; // assign to select year field

  //             // get the indicator selected, and watch the year of its current value.
  //             if (selectedIndicatorSource.length > 0) {
  //                 this.selectedYear = selectedIndicatorSource[0];
  //             }
  //         }
  //         return selectedSource;
  //     },
  //     indicatorSelected() {

  //         this.selectedIndicator = this.$store.getters.getSelectedIndicator;
  //         var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
  //         return 'Some values';
  //     },
  //     selectedIndicatorShortName () {

  //         // send message to reset list of sources...
  //         return this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
  //     },
  // },
  updated: function updated() {
    this.computeChart();
  },

  watch: {
    barChartData: {
      handler: function handler(val) {
        // this.computeChart;
        var anyValueInMapData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val[0]).filter(function (e, i, arr) {
          return val[0][e] !== undefined;
        });
        if (anyValueInMapData.length === 0) {
          this.chartHasNoData = true;
        } else {
          this.chartHasNoData = false;
        }
        this.computeChart();
      },

      immediate: true,
      deep: true
    }
  }
});

/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__barChart__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__barChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__barChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_on_vue_multiselect__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_async__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_async__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import MultiSelect from 'vue-multiselect'
// multiselect with dropdown/accordion



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'plotchartIndex',
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_1__barChart___default.a, LineChart: __WEBPACK_IMPORTED_MODULE_2__line___default.a, MultiSelect: __WEBPACK_IMPORTED_MODULE_3__assets_js_on_vue_multiselect__["a" /* default */]
  },
  props: ['masterIndicator', 'relativeIndicator', 'indicatorOptions', 'appData', 'selectedState', 'chartType', 'isExpanded', 'indicatorClicked', 'sourceSelected'],
  data: function data() {
    return {
      selectedIndicator: { name: '' },
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      dataSources: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS", "World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
      optionStates: ["National", "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      optionSources: [],
      optionYear: [],
      selectedSource: 'MICS:2021',
      selectedYear: '',
      expandedView: false,
      collapsible: true,
      indicatorPlaceholder: '',
      indicatorOpenedPlaceholder: 'Search indicator',
      indicatorMultiselectOpened: false,
      sourcePlaceholder: '',
      sourceOpenedPlaceholder: 'Search sources',
      sourceMultiselectOpened: false
    };
  },

  methods: {
    // These methods handle the placeholder for all multiselects on the map component
    openedIndicatorMultiselect: function openedIndicatorMultiselect() {
      this.indicatorMultiselectOpened = true;
    },
    closedIndicatorMultiselect: function closedIndicatorMultiselect() {
      this.indicatorMultiselectOpened = false;
    },
    changedIndicator: function changedIndicator(e) {
      this.indicatorMultiselectPlaceholder = e;
    },
    openedYearMultiselect: function openedYearMultiselect() {
      this.yearMultiselectPlaceholder = 'Select year';
    },
    closedYearMultiselect: function closedYearMultiselect(year) {
      this.yearMultiselectPlaceholder = year.toString();
    },
    openedSourceMultiselect: function openedSourceMultiselect() {
      this.sourceMultiselectOpened = true;
    },
    closedSourceMultiselect: function closedSourceMultiselect() {
      this.sourceMultiselectOpened = false;
    },

    // End of multiselect methods

    /**
     * This method emits a false value to compareSection.vue
     * This was done so as to make sure the expanded value of a section remains true
     * That way you're able to open a single section and close as much as you wish
     */
    closeExpandedBool: function closeExpandedBool() {
      this.expandedView = false;
      this.$emit('expanded', false);
    },

    /**
     * This method was previously used, but still remains here in case of further implementaions
     * Feel free to remove this method any time  
     */
    extractStateValuesForIndicator: function extractStateValuesForIndicator(indicator, selectedSource) {
      var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[indicator];
      var vt = ivt[1] === 'P' ? '%' : '';
      var it = ivt[1] === 'P' ? '% of total' : '';
      var stateByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      var selectedIndicatorValuesForEachState = {};
      var indicatorSource = indicator + ' -> ' + selectedSource;
      var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;

      var statesWithIndicatorsYearAndValues = this.getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear);

      if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
        for (var stateName in stateByIndicatorByYear) {
          if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
            // var len = stateByIndicatorByYear[stateName].length;
            var stateCurrentYearVals = stateByIndicatorByYear[stateName][statesWithIndicatorsYearAndValues[2][stateName]];
            selectedIndicatorValuesForEachState[stateName] = [stateCurrentYearVals[0], stateCurrentYearVals[indexOfindicatorSource]];
          }
        }
      } else {
        selectedIndicatorValuesForEachState = statesWithIndicatorsYearAndValues[0];
      }
      var temp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(selectedIndicatorValuesForEachState);
      var obj = {};
      temp.map(function (elem, index) {
        obj[elem] = selectedIndicatorValuesForEachState[elem][1];
      });
      var regions = ['North-East', 'North-West', 'North-Central', 'South-East', 'South-West', 'South-South'];
      var sortedObj = sortObjects(obj); // custom method
      var xAxis = [],
          yAxis = [];
      for (var _stateName in sortedObj) {
        if (sortedObj.hasOwnProperty(_stateName)) {
          if (regions.indexOf(_stateName) < 0) {
            // don't need the regions in this chart
            yAxis.push(_stateName);
            xAxis.push(sortedObj[_stateName]);
          }
        }
      }
      var plotData = {};
      // get the data required for ngMap
      yAxis.map(function (elem, index) {
        plotData[elem] = xAxis[index];
      });
      return plotData;
    },

    // This method is not currently used
    getYearWithCurrentIndicatorValues: function getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear) {

      var statesWithIndicatorsYearAndValues = {};
      var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
      var sourceActiveYear = {};
      var sourcetempArr = [];

      for (var stateName in stateByIndicatorByYear) {
        if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
          for (var i = stateByIndicatorByYear[stateName].length - 1; i >= 0; i--) {
            statesWithIndicatorsYearAndValues[stateName] = [];
            var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            // if (selectedIndicatorVal) {
            if (stateByIndicatorByYear[stateName][i][0] === parseInt(this.data[3])) {
              tempArr[stateName] = i;
              statesWithIndicatorsYearAndValues[stateName].push(stateByIndicatorByYear[stateName][i][0], stateByIndicatorByYear[stateName][i][indexOfindicatorSource]);
              break;
            }
          }
          // get all the years where there's a value for the indicator...
          for (var i = stateByIndicatorByYear[stateName].length - 1; i >= 0; i--) {
            if (!sourceActiveYear[stateName]) {
              sourceActiveYear[stateName] = {};
            }
            var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
            if (selectedIndicatorVal) {
              sourcetempArr.push(i);
              sourceActiveYear[stateName][stateByIndicatorByYear[stateName][i][0]] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
              // break;
            }
          }
        }
      }
      // we leverage the fact that National always has data for all the indicators
      // this.optionYear = Object.keys(sourceActiveYear['National']);
      var rowIndex = Math.max.apply(null, tempArr);
      return [statesWithIndicatorsYearAndValues, rowIndex, tempArr];
    },

    /**
     * This method get the sources with available data for all states excluding National
     * This was done becuase National doesn't show up on the map
     */
    getCurrentSourceOptions: function getCurrentSourceOptions(indicator) {
      var sources = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      for (var k in this.dataSources) {
        for (var i in statesByIndicatorByYear) {
          for (var j in statesByIndicatorByYear[i]) {
            // if(i !== 'National'){
            var indicatorSource = indicator + ' -> ' + this.dataSources[k];
            var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
            if (statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (sources.indexOf(this.dataSources[k]) < 0) sources.push(this.dataSources[k]);
              break;
            }
            // }
          }
        }
      }
      // this.optionSources = sources;
      return sources;
    },


    // This method get the years with available data for the selected indicator and source
    getYearOptionsWithData: function getYearOptionsWithData(indicator, source) {
      var years = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      var indicatorSource = indicator + ' -> ' + source;
      var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
      this.optionStates.map(function (elem, index) {
        for (var i in statesByIndicatorByYear) {
          statesByIndicatorByYear[elem].map(function (el, i) {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (years.indexOf(el[0]) < 0) {
                years.push(el[0]);
              }
            }
          });
        }
      });
      this.optionYear = years.sort(function (a, b) {
        return b - a;
      });
    },
    multiselectSearch: function multiselectSearch() {
      this.collapsible = false;
    },

    // This method assigns this.selectedSource and this.selectedYear
    // Was done to avoid repeated code writing
    yearComputation: function yearComputation(indicator, source) {
      this.getYearOptionsWithData(indicator, source);
      if (this.optionYear.length > 0) {
        var randomYear = Math.floor(Math.random() * this.optionYear.length);
        var maxYear = Math.max.apply(null, this.optionYear);
        this.selectedYear = maxYear;
      } else {
        this.selectedYear = 0;
      }
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
    }
  },
  mounted: function mounted() {
    //indicatorOptions','appData','relativeIndicator','mapType','isExpanded','indicatorClicked', 'sourceSelected'
    if (this.lsData) {
      // console.log(this.relativeIndicator);

      this.optionSources = this.getCurrentSourceOptions(this.relativeIndicator);
      this.indicatorPlaceholder = this.relativeIndicator;
      this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      this.sourcePlaceholder = this.selectedSource;
      this.yearComputation(this.relativeIndicator, this.selectedSource);
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
      // this.$store.dispatch('storeIndicatorSelected',this.relativeIndicator);
    }
  },

  computed: {},
  watch: {
    masterIndicator: function masterIndicator(val) {
      this.$emit('indicatorClicked', val); // Emits the selectedIndicator for other charts to use
      this.indicatorPlaceholder = this.selectedIndicator.name;
      // this.$store.dispatch('storeIndicatorSelected',name);
      this.optionSources = this.getCurrentSourceOptions(name);
      if (this.optionSources.indexOf('MICS') < 0) {
        this.selectedSource = this.optionSources[0];
      } else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      //console.log(this.optionSources);

      this.yearComputation(name, this.selectedSource);
    },
    selectedIndicator: function selectedIndicator(_ref) {
      var name = _ref.name;

      this.$emit('indicatorClicked', name); // Emits the selectedIndicator for other charts to use
      this.indicatorPlaceholder = name;
      // this.$store.dispatch('storeIndicatorSelected',name);
      this.optionSources = this.getCurrentSourceOptions(name);
      if (this.optionSources.indexOf('MICS') < 0) {
        this.selectedSource = this.optionSources[0];
      } else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      //console.log(this.optionSources);

      this.yearComputation(name, this.selectedSource);
    },
    selectedSource: function selectedSource(val) {
      this.$emit('sourceSelected', val);

      this.sourcePlaceholder = val;
      if (this.selectedIndicator.name !== '') {
        this.yearComputation(this.selectedIndicator.name, val);
      } else {
        this.yearComputation(this.relativeIndicator, val);
      }
    },
    isExpanded: function isExpanded(val) {
      this.expandedView = val;
    },
    indicatorClicked: function indicatorClicked(val) {
      this.indicatorPlaceholder = val;
    },
    sourceSelected: function sourceSelected(val) {
      // console.log(val); 
      this.selectedSource = val;
    },
    relativeIndicator: function relativeIndicator(val) {

      this.optionSources = this.getCurrentSourceOptions(val);
      // console.log(this.optionSources);

      this.indicatorPlaceholder = val;
      if (this.optionSources.indexOf('MICS') < 0) {
        this.selectedSource = this.optionSources[0];
      } else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      this.sourcePlaceholder = this.selectedSource;
      this.yearComputation(val, this.selectedSource);
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
    }
  }
});

/***/ }),

/***/ 871:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_on_strlimit__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_on_strlimit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_js_on_strlimit__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'slide5sub1',
    components: { Fullscreen: __WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue___default.a, Carousel3d: __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__["Carousel3d"], Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__["Slide"], MultiSelect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a, vueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a },
    props: ['relativeIndicator', 'selectedIndicator', 'sourceClicked', 'appData', 'selectedState', 'chartType', 'indicatorClicked'],
    data: function data() {
        return {
            chartHasNoData: false,
            fullscreen: false,
            lsData: JSON.parse(this.$ls.get('car_other_dataset')),
            isDataLoadedFirstTime: false,
            colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
            searchTerm: '',
            traceArray: [],
            // selectedIndicator: 'Skilled attendance at delivery or birth',
            optionsIndicator: [],
            optionSources: [],
            dataSources: ['MICS', 'NHMIS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
            // selectedState: 'National',
            // optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa",
            //     "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo",
            //     "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi",  "Kwara", "Lagos", "Nasarawa", "National",
            //     "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe",
            //     "Zamfara"],
            selectedSource: '',
            headerObj: {},
            data: [],
            tableColumnHeaderAttr: null,
            highchart_options: {
                chart: {
                    type: 'line',
                    // spline, inverted: true,
                    height: 440,
                    zoomType: 'xy'
                },
                title: {
                    text: 'Loading...',
                    style: {
                        fontSize: '16px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: '600'
                    }
                },

                subtitle: {
                    text: "Loading...",
                    style: {
                        fontSize: '11px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: 'normal'
                    }
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    // reversed: true,
                    type: 'category',
                    categories: null,
                    title: {
                        enabled: false,
                        text: 'x-axis title'
                    },
                    labels: {
                        style: {
                            fontWeight: 'normal',
                            color: '#686464'
                        }
                    },
                    tickInterval: 4,
                    // maxPadding: 0.05,
                    showLastLabel: true
                },
                yAxis: {
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    min: 0,
                    title: {
                        text: ''
                    }
                    //minRange: 100,
                    // tickInterval: 20,
                },
                legend: {
                    enabled: true,
                    // backgroundColor: '#FCFFC5',
                    // borderColor: 'black',
                    // borderRadius: 10,
                    // borderWidth: 3,
                    verticalAlign: 'top',
                    x: -20,
                    y: -5,
                    title: {
                        // text: 'City<br/><span style="font-size: 9px; color: #666; font-weight: normal">(Click to hide)</span>',
                        // style: {
                        //   fontWeight: 'normal'
                        // }
                    },
                    itemStyle: {
                        fontWeight: 'normal',
                        fontSize: '13px'
                        // layout: 'vertical',
                        // align: 'right',
                        // floating: false,
                        // borderWidth: 1,
                        // shadow: true
                    } },
                plotOptions: {

                    series: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                        connectNulls: true,
                        borderWidth: 0,
                        dataLabels: {
                            enabled: false,
                            format: '{point.y:.1f}%',
                            style: {
                                fontWeight: 'normal'
                            }
                        },
                        cursor: 'pointer',
                        dashStyle: "Solid",
                        point: {},
                        marker: {
                            lineWidth: 0,
                            radius: 3,
                            symbol: 'circle'
                        }
                    }, 'connectNulls', true),
                    colorByPoint: true

                },
                tooltip: {
                    // backgroundColor: '#FCFFC5',
                    // borderColor: 'black',
                    // borderRadius: 10,
                    // borderWidth: 3,
                    // crosshairs: [true, true],
                    headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.x}</span>: <b>{point.y:.2f}%</b> of total<br/>'
                },
                series: [{
                    name: 'example',
                    data: []
                }], //this.lineChartData
                exporting: {
                    buttons: {
                        contextButton: {
                            menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
                            //"viewData",
                            "openInCloud"],
                            symbol: 'download'
                            // symbolStrokeWidth: 2,
                            // symbolFill: '#330033',
                            // symbolStroke: '#b3d4fc'
                        }
                    }
                }
            }
        };
    },

    methods: {
        toggle: function toggle() {
            // this.$refs['fullscreen'].background = "green";
            this.$refs['fullscreen'].toggle();
        },
        enter: function enter() {
            return true;
        },

        //  ...mapMutations([
        //     'storeHeaderIndex', // map `this.increment()` to `this.$store.commit('increment')`

        //     // `mapMutations` also supports payloads:
        //     'incrementBy' // map `this.incrementBy(amount)` to `this.$store.commit('incrementBy', amount)`
        // ]),
        getCurrentSourceOptions: function getCurrentSourceOptions(indicator) {
            var sources = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            for (var k in this.dataSources) {
                for (var i in statesByIndicatorByYear) {
                    for (var j in statesByIndicatorByYear[i]) {
                        var indicatorSource = indicator + ' -> ' + this.dataSources[k];
                        var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
                        if (statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
                            if (sources.indexOf(this.dataSources[k]) < 0) sources.push(this.dataSources[k]);
                            break;
                        }
                    }
                }
            }
            this.optionSources = sources;
        },
        plotStateChart: function plotStateChart() {
            this.data = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];

            var data_trace = [];
            this.highchart_options.series = [];
            this.highchart_options.title.text = this.selectedIndicator;
            this.highchart_options.subtitle.text = this.lineChartData[2] + ' - ' + this.selectedState;;
            this.highchart_options.tooltip.headerFormat = '<span style="font-size:11px"><b>{point.key}</b></span><br>';
            this.highchart_options.tooltip.pointFormat = '<span style="color:{point.color}"><b>{series.name}</b></span>: <b>{point.y:.2f}</b><br/>';

            if (Array.isArray(this.dataSources) && this.dataSources.length > 1) {
                this.multipleSourcesClicked(this.dataSources);
            } else if (Array.isArray(this.dataSources) && this.dataSources.length < 2) {
                this.singleSourceClicked(this.selectedIndicator, this.dataSources[0]);
            } else {
                this.singleSourceClicked(this.selectedIndicator, this.dataSources);
            }
        },

        //Method for plotting line chart if sources selected are more than one
        multipleSourcesClicked: function multipleSourcesClicked(sources) {
            var _this = this;

            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
            sources.map(function (elem, index) {
                var indicatorSource = _this.selectedIndicator + ' -> ' + elem;

                if (_this.lsData[0].indexOf(indicatorSource) > 0) {
                    var indexOfindicatorSource = _this.lsData[0].indexOf(indicatorSource) - 1;
                    var sourceStateYearsVals = selectedStateByIndicatorByYear.map(function (elem2, index2) {
                        return [elem2[0], elem2[indexOfindicatorSource]];
                    });
                    var xAxis = [],
                        yAxis = [];
                    sourceStateYearsVals.map(function (elem3, index3) {
                        xAxis.push(elem3[0]);
                        yAxis.push(elem3[1]);
                    });
                    // var trace = {
                    //     x: xAxis,
                    //     y: yAxis,
                    //     type: 'line',
                    //     name: elem,
                    //     // fill: 'toself',
                    //     line: {'shape': 'spline', 'smoothing': 1.0,
                    //             dash: 'dot'},
                    //     connectgaps: true,
                    //     // text: yAxis,
                    //     // hoverinfo: 'none',
                    //     textposition: 'bottom right',
                    //     mode: 'lines+markers',
                    //     marker: {
                    //         size: 10
                    //     }
                    //     // mode: 'lines+markers'
                    // }

                    var series_data = { name: elem, data: yAxis };
                    _this.highchart_options.xAxis.categories = xAxis;
                    _this.highchart_options.series.push(series_data);
                    // this.checkPlotMaxRange(yAxis);
                    // data_trace.push(trace);
                }
            });
        },

        //Method to execute when a single source is selected
        singleSourceClicked: function singleSourceClicked(indicator, elem) {
            var _this2 = this;

            this.highchart_options.series = [];
            //elem is the selected source
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
            var indicatorSource = indicator + ' -> ' + elem;
            if (this.lsData[0].indexOf(indicatorSource) > 0) {
                var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
                var sourceStateYearsVals = selectedStateByIndicatorByYear.map(function (elem2, index2) {
                    return [elem2[0], elem2[indexOfindicatorSource]];
                });
                this.chartHasNoData = true;
                var xAxis = [],
                    yAxis = [];
                sourceStateYearsVals.map(function (elem3, index3) {
                    if (elem3[1] !== "") {
                        yAxis.push(elem3);
                        _this2.chartHasNoData = false;
                    }
                });
                // To check if a single value exists in the yAxis array
                var color = this.colors[Math.floor(Math.random() * 10)];
                // console.log(color);

                //Dynamically calculate the tick interval based on the difference between the highest and lowest year

                if (yAxis[yAxis.length - 1][0] - yAxis[0][0] < 8) {
                    this.highchart_options.xAxis.tickInterval = 1;
                } else if (yAxis[yAxis.length - 1][0] - yAxis[0][0] < 16) {
                    this.highchart_options.xAxis.tickInterval = 2;
                } else if (yAxis[yAxis.length - 1][0] - yAxis[0][0] < 24) {
                    this.highchart_options.xAxis.tickInterval = 4;
                } else {
                    this.highchart_options.xAxis.tickInterval = 8;
                }
                var series_data = {
                    name: elem,
                    data: yAxis,
                    color: color
                };
                this.highchart_options.series.push(series_data);
                // this.checkPlotMaxRange(yAxis);
                // data_trace.push(trace);
            }
        },
        checkPlotMaxRange: function checkPlotMaxRange(yAxis) {
            var maxValForRangeSup = Math.max.apply(null, yAxis);
            if (maxValForRangeSup > 100) {
                this.layout.yaxis.range = [0, maxValForRangeSup % 10 === 0 ? maxValForRangeSup : maxValForRangeSup + maxValForRangeSup % 10];
                this.layout.yaxis.dtick = (maxValForRangeSup + maxValForRangeSup % 10) / 5;
            } else {
                this.layout.yaxis.range = [0, 100];
                this.layout.yaxis.dtick = 25;
            }
        },

        //Plot chart for single selected source and indicator
        plotSourceChart: function plotSourceChart(indicator, source) {
            this.data = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
            this.highchart_options.exporting.filename = indicator + " (" + source + ")";
            var data_trace = [];
            this.highchart_options.series = [];
            this.highchart_options.title.text = indicator;
            this.highchart_options.subtitle.text = source + ' - ' + this.selectedState;
            this.highchart_options.tooltip.headerFormat = '<span style="font-size:11px"><b>{point.key}</b></span><br>';
            this.highchart_options.tooltip.pointFormat = '<span style="color:{point.color}"><b>{series.name}</b></span>: <b>{point.y:.2f}</b><br/>';
            this.singleSourceClicked(indicator, source);
        },
        sourceAndYearComputation: function sourceAndYearComputation(indicator) {
            this.getCurrentSourceOptions(indicator);
            var randomSource = Math.floor(Math.random() * this.optionSources.length);
            this.selectedSource = this.sourceClicked;
        },

        // A method that calculates the width of the bars if the chart type is a bar and sets highchart pointWidth option
        calculatePointWidth: function calculatePointWidth(val) {
            if (val === 'column') {
                // let yAxis = this.highchart_options.series[0].data;
                this.highchart_options.plotOptions.series.pointWidth = 8;
                // //Dynamically calculate the tick interval based on the difference between the highest and lowest year
                // if(yAxis[yAxis.length-1][0] - yAxis[0][0]  < 8){
                //     this.highchart_options.plotOptions.series.pointWidth = 8;
                // } else if(yAxis[yAxis.length-1][0] - yAxis[0][0] < 16){
                //     this.highchart_options.plotOptions.series.pointWidth = 4;
                // } else if(yAxis[yAxis.length-1][0] - yAxis[0][0] < 24){
                //     this.highchart_options.plotOptions.series.pointWidth = 2;
                // } else {
                //     this.highchart_options.plotOptions.series.pointWidth = 1;
                // }
            }
        }
    },
    computed: {
        // sourceClicked() {
        //     this.tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
        //     var source = this.tableColumnHeaderAttr[0];
        //     var val = this.tableColumnHeaderAttr[1];
        //     var carSources = this.$store.getters.getCarSources;
        //     var selectedSource = [source]; // ? [source]: carSources;
        //     if (!val) {
        //         selectedSource = carSources
        //     }
        //     this.selectedSource = selectedSource;
        //     return selectedSource;
        // },
        indicatorSelected: function indicatorSelected() {

            // this.selectedIndicator = this.lineChartData[1]; // this.$store.getters.getSelectedIndicator;
            var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
            return __WEBPACK_IMPORTED_MODULE_6__assets_js_on_strlimit___default()(temp, 80);
        }
    },
    created: function created() {},
    mounted: function mounted() {
        if (this.lsData) {
            this.selectedSource = this.sourceClicked;
            if (this.selectedIndicator.length < 1) {
                if (this.selectedSource === '') {
                    this.sourceAndYearComputation(this.relativeIndicator); // Calculates the sources with data for the selected indicator
                }
                this.plotSourceChart(this.relativeIndicator, this.selectedSource); // Plots the chart
                this.highchart_options.chart.type = this.chartType; // Changes the chart type to line/bar
                this.calculatePointWidth(this.chartType); // A method call that calculates the width of the bars if the chart type is a bar
            } else {
                if (this.indicatorClicked.length > 1) {
                    if (this.selectedSource === '') {
                        this.sourceAndYearComputation(this.indicatorClicked); // Calculates the sources with data for the selected indicator
                    }
                    this.plotSourceChart(this.indicatorClicked, this.selectedSource);
                    this.highchart_options.chart.type = this.chartType;
                    this.calculatePointWidth(this.chartType);
                } else {
                    if (this.selectedSource === '') {
                        this.sourceAndYearComputation(this.selectedIndicator); // Calculates the sources with data for the selected indicator
                    }
                    this.plotSourceChart(this.selectedIndicator, this.selectedSource);
                    this.highchart_options.chart.type = this.chartType;
                    this.calculatePointWidth(this.chartType);
                }
            }
        }
    },
    updated: function updated() {
        // Plotly.relayout(this.$refs.others_sub1, {
        //     'xaxis.autorange': true,
        //     'yaxis.autorange': false
        // });
    },

    watch: {
        selectedIndicator: function selectedIndicator(val) {
            this.selectedSource = this.sourceClicked;
            this.sourceAndYearComputation(val);
            this.plotSourceChart(val, this.selectedSource);
        },
        sourceClicked: function sourceClicked(val) {
            // console.log(val)
            this.selectedSource = val;
            if (this.selectedIndicator !== '') {
                this.plotSourceChart(this.selectedIndicator, val);
            } else {
                this.plotSourceChart(this.relativeIndicator, val);
            }
        },
        chartType: function chartType(val) {
            this.highchart_options.chart.type = val;
            this.calculatePointWidth(val);
        },
        selectedState: function selectedState(val) {
            if (this.selectedIndicator !== '') {
                this.plotSourceChart(this.selectedIndicator, this.selectedSource);
            } else {
                this.plotSourceChart(this.relativeIndicator, this.selectedSource);
            }
        },
        indicatorClicked: function indicatorClicked(val) {
            this.sourceAndYearComputation(val);
            this.plotSourceChart(val, this.selectedSource);
        }
    }
});

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_on_strlimit__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_on_strlimit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_js_on_strlimit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_on_highchart_options__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_timers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main_js__ = __webpack_require__(135);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import PlotlyVue from '@/components/Plotly';






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'lineChart',
  components: { Fullscreen: __WEBPACK_IMPORTED_MODULE_1_vue_fullscreen_src_component_vue___default.a, Carousel3d: __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__["Carousel3d"], Slide: __WEBPACK_IMPORTED_MODULE_4_vue_carousel_3d__["Slide"], MultiSelect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a, vueSlider: __WEBPACK_IMPORTED_MODULE_3_vue_slider_component___default.a },
  props: ['appData', 'meta_data', 'uncertaintyData', 'isToggleClickedVal', 'isIHMEtoggleClickedVal'],
  data: function data() {
    return {
      fullscreen: false,
      theName: "Nigeria",
      highchart_options: __WEBPACK_IMPORTED_MODULE_6__assets_js_on_highchart_options__["a" /* chart_options2 */],
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      estimatesData: JSON.parse(this.$ls.get('estimates_dataset')),
      metaData: JSON.parse(this.$ls.get('meta_data_dataset')),
      isDataLoadedFirstTime: false,
      ihme_sdg_available_truthyVal: false,
      searchTerm: '',
      componentType: "line",
      traceArray: [],
      selectedIndicator: 'Skilled attendance at delivery or birth',
      optionsIndicator: [],
      selectedState: 'National',
      nationalTarget: '',
      sdgTarget: '',
      optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "National", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      selectedSource: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS", "World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
      headerObj: {},
      clicked: false,
      IHMEtoggleClicked: false,
      data: [],
      tableColumnHeaderAttr: null,
      computeUncertaintyTruthVal: false,
      lineSelected: true,
      columnSelected: false,
      tableSources: [],
      plottedUncertainty: [],
      confirmParentSource: [],
      toggleClicked: [],
      nhmisMonthlyAlert: false
    };
  },

  methods: {
    toggle: function toggle() {
      // this.$refs['fullscreen'].background = "green";
      this.$refs['fullscreen'].toggle();
    },
    enter: function enter() {
      return true;
    },
    changeChart: function changeChart(chart) {
      if (chart === 'line') {
        this.lineSelected = true;
        this.columnSelected = false;
        this.componentType = 'line';
      } else {
        this.lineSelected = false;
        this.columnSelected = true;
        this.componentType = 'column';
      }
    },

    //   compareIndicators(e) {
    //     this.$emit('compareIndicators', true);
    //   },
    getDisplayFactor: function getDisplayFactor() {
      //Get display factor for the line chart (e.g percentage, per 1000, per 100,000 etc)
      var displayFactor = '';
      for (var i in this.metaData) {
        if (this.metaData[i][0] === this.selectedIndicator) {
          displayFactor = this.metaData[i][3];
          break;
        }
      }
      this.highchart_options.yAxis.title.text = displayFactor;
    },
    plotUncertainty: function plotUncertainty(e) {
      this.computeUncertaintyTruthVal = !this.computeUncertaintyTruthVal;
      //this.$emit('plotUncertainty', this.computeUncertaintyTruthVal);
    },
    getValue: function getValue() {
      var _this = this;

      //Compute data object to map states name to arraylist
      var indicatorAndSourceValueByState = {};
      var statesAndRegions = this.$store.state.CAR.optionStates2;
      statesAndRegions.map(function (elem, index) {
        indicatorAndSourceValueByState[elem] = [];
        var data = _this.estimatesData.slice(1);
        data.forEach(function (el) {
          if (el[1] === elem) {
            indicatorAndSourceValueByState[elem].push(el);
          }
        });
      });
      return indicatorAndSourceValueByState;
    },
    extractUncertaintyData: function extractUncertaintyData(indexOfindicatorSource, stateByIndicatorByYear) {
      var lineChartData = [];
      var finalLinechartData = [];
      var xAxis = [],
          yAxis = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
      var sourceStateYearsVals = selectedStateByIndicatorByYear.map(function (elem2, index2) {
        return [elem2[0], elem2[indexOfindicatorSource]];
      });
      for (var i in stateByIndicatorByYear[this.selectedState]) {
        lineChartData.push([stateByIndicatorByYear[this.selectedState][i][0], stateByIndicatorByYear[this.selectedState][i][indexOfindicatorSource]]);
      }
      lineChartData.map(function (elem) {
        var tempArray = [];
        var tempObj = {};
        var splittedArray = [];
        // console.log(elem);

        if (elem[1].indexOf('#') > -1) {
          /*Spread the elements of the array after splitting with '#'
          (... is an ES6 syntax for spread)*/

          splittedArray = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(elem[1].split('#')));
          for (var i in splittedArray) {
            splittedArray[i] = parseFloat(splittedArray[i]);
          }
          tempArray = [elem[0]].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(splittedArray));
          tempObj = {
            year: elem[0],
            lb: splittedArray[0],
            ub: splittedArray[1]
          };
          finalLinechartData.push(tempObj);
        }
      });
      //To fill up empty spaces upto 1990 with null
      // for(var i=0; i<4; i++){
      //     // finalLinechartData.unshift(null);
      // }
      // finalLinechartData.unshift(null);
      return finalLinechartData;
    },
    plotStateChart: function plotStateChart() {
      var _this2 = this;

      this.nhmisMonthlyAlert = false;
      if (this.tableSources == 'NHMIS-DHIS2 (monthly)') {
        this.plotNhmisMonthly(this.selectedIndicator);
      } else {

        var _vm = this;
        var longestChartData = 0;
        var availableYears = [];
        var nationalLongestChartDataArray = [],
            sdgLongestChartDataArray = [];
        this.ihme_sdg_available_truthyVal = false;
        var nationalTarget = void 0;
        var sdgTarget = void 0;

        this.meta_data.map(function (elem) {
          if (_this2.selectedIndicator == elem[0]) {
            nationalTarget = elem[7];
            sdgTarget = elem[10];
            _this2.nationalTarget = nationalTarget === "" ? null : nationalTarget;
            _this2.sdgTarget = sdgTarget === "" ? null : sdgTarget;
          }
        });
        this.data = [];
        var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
        var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
        var data_trace = [];
        this.highchart_options.series = [];
        this.highchart_options.tooltip.headerFormat = '<span style="font-size:11px"><b>{point.key}</b></span><br>';
        this.highchart_options.tooltip.crosshairs = true;
        this.highchart_options.tooltip.shared = true;
        this.highchart_options.exporting = {
          buttons: {
            contextButton: {
              menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
              //"viewData",
              "openInCloud"],

              symbol: 'download'
              // symbolStrokeWidth: 2,
              // symbolFill: '#330033',
              // symbolStroke: '#b3d4fc'
            }
          },
          filename: this.selectedIndicator
          // this.highchart_options.tooltip.pointFormat = '<span style="color:{point.color}"><b>{series.name}</b></span>: <b>{point.y:.2f}</b><br/>'
        };var uncertainty_data;
        this.tableSources.map(function (elem, index) {
          var indicatorSource = _this2.selectedIndicator + ' -> ' + elem;
          if (_this2.lsData[0].indexOf(indicatorSource) > 0) {
            var indexOfindicatorSource = _this2.lsData[0].indexOf(indicatorSource) - 1;
            var sourceStateYearsVals = selectedStateByIndicatorByYear.map(function (elem2, index2) {
              return [elem2[0], elem2[indexOfindicatorSource]];
            });
            var xAxis = [],
                yAxis = [];

            // Remove years with empty data

            sourceStateYearsVals.map(function (elem3, index3) {

              if (elem3[1] !== "") {
                // xAxis.push(elem3[0]);
                // yAxis.push(elem3[1]);
                yAxis.push(elem3);
              }
            });

            yAxis.map(function (e, i) {
              if (!availableYears.includes(e[0])) {
                availableYears.push(e[0]);
              }
            });

            var series_data;
            // var range_data
            series_data = {
              name: elem,
              data: yAxis,
              zoneAxis: "x",
              tooltip: {
                pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
              }

              //This block of code iterates through the series to be plotted and removes the sources that have no data. This fix was necessary because some datasets have national data but no state data. On selecting any state in such datasets, the legend still contains sources with no state data (but have national data) even though they are not plotted on the chart.
            };_this2.highchart_options.series.push(series_data);
            for (var i = 0; i < _this2.highchart_options.series.length; i++) {
              if (_this2.highchart_options.series[i].data.length < 1) {
                _this2.highchart_options.series.splice(i, 1);
                i--;
              }
            }

            var maxArray = [];

            // for( var i = 0; i < this.highchart_options.series.length; i++){
            //   for(var j =0; j < this.highchart_options.series[i].data.length; j++) {

            //                     //console.log(this.highchart_options.series[i].data[j][1]);
            //                    maxArray.push(this.highchart_options.series[i].data[j][1]);

            //   }
            // }

            //  //console.log(maxArray);
            //  var max = Math.max(...maxArray);
            //  console.log(max);
            //  console.log(this.nationalTarget);

            // if (max <= this.nationalTarget){
            //   this.highchart_options.yAxis.max = this.nationalTarget+5;
            // }
            // else{
            //   this.highchart_options.yAxis.max = max+5;
            // }


            _this2.highchart_options.chart.events.load = function () {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_timers__["setTimeout"])(function () {
                _vm.$emit('chartRendered', true);
              }, 0);
            };

            // this.highchart_options.xAxis.min = minimumVal;     //Remove negative from line chart
          }
        });

        availableYears.sort(function (a, b) {
          return a - b;
        });

        availableYears.map(function (year) {
          nationalLongestChartDataArray.push([year, _this2.nationalTarget]);
          sdgLongestChartDataArray.push([year, _this2.sdgTarget]);
        });

        var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator];
        var vt = ivt[1] === "P" ? "%" : "";
        var it = ivt[1] === "P" ? "% of total" : "";

        // if (vt === '%') {
        //   this.highchart_options.yAxis.tickInterval = 25;
        // } else {
        //   this.highchart_options.yAxis.tickInterval = null;
        // }
        this.highchart_options.yAxis.plotLines = [];
        var nationalTargetLine = {
          id: 'nationalLineID',
          color: '#222222',
          width: 0.5,
          value: this.nationalTarget,
          label: {
            text: 'NT : ' + this.nationalTarget + vt, // vt is value type; whether percentage or number
            align: "right",
            rotation: 90,
            y: 25,
            x: -5
          }
        };

        var sdgTargetLine = {
          id: 'sdgLineID',
          color: '#222222',
          width: 0.5,
          value: this.sdgTarget,
          dashStyle: 'longdashdot',
          label: {
            text: 'SDG: ' + this.sdgTarget + vt, // vt is value type; whether percentage or number
            align: "right",
            rotation: 0,
            y: 12,
            x: -10
          }
        };

        if (this.componentType === 'line') {
          if (this.nationalTarget !== null) {
            var nationalPlotLinesSeries = {
              name: 'National Target',
              data: nationalLongestChartDataArray,
              // color: '#444444',
              color: '#2F4F4F',
              label: {
                enabled: true
              },
              lineWidth: 0.5,
              marker: {
                enabled: false
              },
              tooltip: {
                pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
              }

              // this.highchart_options.series.push(nationalPlotLinesSeries);
            };
          }
          if (this.sdgTarget !== null) {
            var sdgPlotLinesSeries = {
              name: 'SDG Target',
              data: sdgLongestChartDataArray,
              color: '#444444',
              lineWidth: 0.5,
              dashStyle: 'longdashdot',
              marker: {
                enabled: false
              },
              tooltip: {
                pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
              }
            };

            this.highchart_options.series.push(sdgPlotLinesSeries);
          }
          this.highchart_options.yAxis.plotLines.push(nationalTargetLine, sdgTargetLine);
        } else {
          this.highchart_options.yAxis.plotLines.push(nationalTargetLine, sdgTargetLine);
        }
        if (longestChartData > 45) {
          this.highchart_options.xAxis.tickInterval = 3;
        } else {
          this.highchart_options.xAxis.tickInterval = 1;
        }
      }
    },
    plotNhmisMonthly: function plotNhmisMonthly(indicator) {
      var _this3 = this;

      var nhmisMonthlyData = this.$store.state.CAR.NhmisMonthlyData;
      var index = nhmisMonthlyData[0].indexOf(indicator + " -> " + "NHMIS");
      // let currentDate = latestData[0][0];
      var currentData = nhmisMonthlyData.filter(function (val) {
        return val[1] == _this3.selectedState;
      });
      var lastFiveMonths = currentData.slice(Math.max(currentData.length - 12, 0));

      var data = lastFiveMonths.map(function (element) {
        var elem = void 0;
        return elem = [element[0], element[index]];
      });

      this.highchart_options.series = [];
      this.highchart_options.tooltip.headerFormat = '<span style="font-size:11px"><b>{point.key}</b></span><br>';
      this.highchart_options.tooltip.crosshairs = true;
      this.highchart_options.tooltip.shared = true;
      this.highchart_options.exporting = {
        enabled: false,
        buttons: {
          contextButton: {
            menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
            //"viewData",
            "openInCloud"],

            symbol: 'download'
            // symbolStrokeWidth: 2,
            // symbolFill: '#330033',
            // symbolStroke: '#b3d4fc'
          }
        },
        filename: this.selectedIndicator
      };

      var series_data = {
        name: this.tableSources,
        data: data,
        zoneAxis: "x",
        tooltip: {
          pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
        }
      };
      this.nhmisMonthlyAlert = true;
      this.highchart_options.xAxis.title.text = 'Month';
      this.highchart_options.series.push(series_data);
    },
    plotUncertaintyChart: function plotUncertaintyChart(source, addTruthy) {
      var _this4 = this;

      this.plotStateChart();
      if (addTruthy) {
        this.plottedUncertainty.push(source);
      } else {
        var uncertIndex = this.plottedUncertainty.indexOf(source);
        if (uncertIndex > -1) {
          this.plottedUncertainty.splice(uncertIndex, 1);
        }
      }
      var two = void 0;

      if (this.plottedUncertainty.length > 0) {
        if (this.componentType === 'line') {
          this.plottedUncertainty.forEach(function (el) {
            _this4.highchart_options.tooltip.crosshairs = true;
            _this4.highchart_options.tooltip.shared = true;
            var indicatorSource = _this4.selectedIndicator + ' -> ' + el;
            var indexOfindicatorSource = _this4.estimatesData[0].indexOf(indicatorSource);
            var uncertainty_value = _this4.getValue();
            var uncertainty_dataObj = _this4.extractUncertaintyData(indexOfindicatorSource, uncertainty_value);
            var uncertainty_data = uncertainty_dataObj.map(function (row) {
              return [row.year, Number(row.lb.toFixed(2)), Number(row.ub.toFixed(2))];
            });
            //console.log(uncertainty_data);
            //console.log(typeof(uncertainty_data[0][1]))
            two = {
              name: el + ' confidence range',
              data: uncertainty_data,
              type: 'arearange',
              lineWidth: 2,
              //linkedTo: ':previous',
              // color: this.$Highcharts.getOptions().colors[0],
              fillOpacity: 0.1,
              zIndex: 0,
              tooltip: {
                formatter: function formatter() {
                  var _this5 = this;

                  var pointData = uncertainty_dataObj.find(function (row) {
                    return row.year === _this5.point.x;
                  });
                }
              },
              marker: {
                enabled: true,
                radius: 2,
                lineWidth: 1,
                width: 1
              }

              // zoneAxis: "x",
              // zones: [{
              //   value: 34
              // }, {
              //   dashStyle: "Dot",
              //   lineWidth: 0
              // }]

              // this.plotStateChart();

              //console.log(two);

            };for (var i = 0; i < _this4.highchart_options.series.length; i++) {
              if (_this4.highchart_options.series[i].name !== source) {
                _this4.highchart_options.series.splice(i, 1);
                i--;
              }
            }

            _this4.highchart_options.series.push(two);
            //console.log(source);
            //console.log(this.highchart_options.series);
          });
        }
      }
    },
    checkPlotMaxRange: function checkPlotMaxRange(yAxis) {
      var maxValForRangeSup = Math.max.apply(null, yAxis);
      if (maxValForRangeSup > 100) {
        this.layout.yaxis.range = [0, maxValForRangeSup % 10 === 0 ? maxValForRangeSup : maxValForRangeSup + maxValForRangeSup % 10];
        this.layout.yaxis.dtick = (maxValForRangeSup + maxValForRangeSup % 10) / 5;
      } else {
        this.layout.yaxis.range = [0, 100];
        this.layout.yaxis.dtick = 25;
      }
    }
  },
  computed: {
    sourceClicked: function sourceClicked() {
      this.tableSources = [];
      var tempSource = this.$store.getters.getTableSourceClicked;
      // this.tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
      // var source = this.tableColumnHeaderAttr[0];
      // var val = this.tableColumnHeaderAttr[1];
      // var carSources = this.$store.getters.getCarSources;
      // var selectedSource = [source]; // ? [source]: carSources;
      // if (!val) {
      //   selectedSource = carSources
      // }
      if (Array.isArray(tempSource)) {
        this.tableSources = tempSource;
      } else {
        this.tableSources.push(tempSource);
      }

      return tempSource;
    },
    indicatorSelected: function indicatorSelected() {
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;

      var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
      return __WEBPACK_IMPORTED_MODULE_5__assets_js_on_strlimit___default()(temp, 80);
    },
    stateSelected: function stateSelected() {
      this.selectedState = this.$store.getters.getSelectedState;
      return this.selectedState;
    }
  },
  created: function created() {
    var _this6 = this;

    __WEBPACK_IMPORTED_MODULE_9__main_js__["eventBus"].$on("changedStateName", function (data) {
      _this6.theName = data;
    });
    this.highchart_options.chart.type = 'line';
    this.highchart_options.plotOptions.line = {
      dataLabels: {
        enabled: false
      }
    };

    this.highchart_options.title.text = '';
    this.highchart_options.series = [];
    this.highchart_options.subtitle.text = '';
    this.highchart_options.legend = {
      // layout: 'vertical',
      // align: 'right',
      verticalAlign: 'top',
      x: -20,
      y: 0,
      itemStyle: {
        fontSize: '12px',
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: '600',
        color: '#333'
        // floating: false,
        // borderWidth: 1,
        // shadow: true
      } };
    this.highchart_options.xAxis.title.text = 'Year';
    this.highchart_options.tooltip.crosshairs = false;
    this.highchart_options.tooltip.shared = false;
    // this.highchart_options.yAxis.title.text = '';
    // this.highchart_options.plotOptions.series = {
    //   cursor: 'pointer',
    //   dashStyle: "LongDash",
    //   point: {
    //   },
    //   marker: {
    //     lineWidth: 1
    //   }
    // }
    this.highchart_options.plotOptions.colorByPoint = true;
    this.highchart_options.chart.height = 317;
  },
  mounted: function mounted() {
    if (this.$route.params.indicator && this.$route.params.state) {
      this.selectedIndicator = this.$route.params.indicator;
      this.selectedState = this.$route.params.state;
    } else {
      this.selectedIndicator = 'Skilled attendance at delivery or birth';
      this.selectedState = 'National';
    }
    // call get indicator to get indicators
    if (this.lsData) {
      // this.isDataLoadedFirstTime = true;
      this.plotStateChart();
    }
    if (this.metaData) {
      this.getDisplayFactor();
    }
  },
  updated: function updated() {},

  watch: {
    selectedIndicator: function selectedIndicator(val) {
      var _this7 = this;

      if (this.lsData) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_timers__["setTimeout"])(function () {
          _this7.plotStateChart();
        }, 5);
      }
      if (this.metaData) {
        this.getDisplayFactor();
      }
      this.plottedUncertainty = [];
    },
    selectedState: function selectedState(val) {
      if (this.lsData) {
        this.plotStateChart();
      }
      this.plottedUncertainty = [];
    },
    selectedSource: function selectedSource(val) {
      if (this.lsData) {
        this.plotStateChart();
      }
    },
    uncertaintyData: function uncertaintyData(val) {
      this.estimatesData = val;
      // this.plotStateChart();
      //this.$store.dispatch('storeEstimateSourceData', {list: val});
    },
    componentType: function componentType(val) {
      if (val === 'column') {
        this.highchart_options.plotOptions.series.pointWidth = 4;
        this.plotStateChart();
      } else {
        this.plotStateChart();
      }
      this.highchart_options.chart.type = val;
    },
    tableSources: function tableSources(val) {
      if (this.lsData) {
        this.plotStateChart();
      }
    },
    appData: function appData(val) {
      this.lsData = val;
      this.isDataLoadedFirstTime = true;
      this.plotStateChart();
      // call method ...
    },
    isToggleClickedVal: function isToggleClickedVal(val) {
      this.toggleClicked = val;
    },
    toggleClicked: function toggleClicked(val) {
      this.clicked = val[0];
      // console.log(val);

      if (val[0] === true) {
        this.plotUncertaintyChart(val[1], true);
        this.confirmParentSource.push(val[1]);
        // console.log(this.confirmParentSource);
      } else {
        // this.plotStateChart();
        this.plotUncertaintyChart(val[1], false);

        var index = this.confirmParentSource.indexOf(val[1]);
        this.confirmParentSource.splice(index, 1);
      }
    },
    meta_data: function meta_data(val) {
      if (val) {
        this.metaData = val;
        this.getDisplayFactor();
      }
    }
  }
});

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__states__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__states___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__states__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__regions__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__regions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__regions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_vue_multiselect__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_on_sortObjects__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_on_sortObjects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_js_on_sortObjects__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import MultiSelect from 'vue-multiselect'
// multiselect with dropdown/accordion



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'plotmap_index',
  components: {
    StatesMap: __WEBPACK_IMPORTED_MODULE_0__states___default.a, ZonesMap: __WEBPACK_IMPORTED_MODULE_1__regions___default.a, MultiSelect: __WEBPACK_IMPORTED_MODULE_2__assets_js_on_vue_multiselect__["a" /* default */]
  },
  props: ['masterIndicator', 'indicatorOptions', 'appData', 'relativeIndicator', 'mapType', 'isExpanded', 'indicatorClicked', 'sourceSelected'],
  data: function data() {
    return {
      isElementToCompareIndicator: false,
      dataSources: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS", "World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
      optionStates: ["National", "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      selectedSource: '',
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      selectedYear: '',
      relatives2Compare: [],
      selectedIndicator: { name: '' },
      optionSources: [],
      optionYear: [],
      expandedView: false,
      collapsible: true,
      indicatorPlaceholder: '',
      indicatorOpenedPlaceholder: 'Search indicator',
      indicatorMultiselectOpened: false,
      sourcePlaceholder: '',
      sourceOpenedPlaceholder: 'Search sources',
      sourceMultiselectOpened: false,
      yearMultiselectPlaceholder: ''
    };
  },

  methods: {
    // These methods handle the placeholder for all multiselects on the map component
    openedIndicatorMultiselect: function openedIndicatorMultiselect() {
      this.indicatorMultiselectOpened = true;
    },
    closedIndicatorMultiselect: function closedIndicatorMultiselect() {
      this.indicatorMultiselectOpened = false;
    },
    changedIndicator: function changedIndicator(e) {
      this.indicatorMultiselectPlaceholder = e;
    },
    openedYearMultiselect: function openedYearMultiselect() {
      this.yearMultiselectPlaceholder = 'Select year';
    },
    closedYearMultiselect: function closedYearMultiselect(year) {
      this.yearMultiselectPlaceholder = year.toString();
    },
    openedSourceMultiselect: function openedSourceMultiselect() {
      this.sourceMultiselectOpened = true;
    },
    closedSourceMultiselect: function closedSourceMultiselect() {
      this.sourceMultiselectOpened = false;
    },

    // End of multiselect methods

    /**
     * This method emits a false value to compareSection.vue
     * This was done so as to make sure the expanded value of a section remains true
     * That way you're able to open a single section and close as much as you wish
     */
    closeExpandedBool: function closeExpandedBool() {
      this.expandedView = false;
      this.$emit('expanded', false);
    },

    /**
     * This method was previously used, but still remains here in case of further implementaions
     * Feel free to remove this method any time  
     */
    // extractStateValuesForIndicator (indicator, selectedSource) {
    //   var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[indicator];
    //   var vt = ivt[1] === 'P'? '%': '';
    //   var it = ivt[1] === 'P'? '% of total': '';
    //   var stateByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
    //   var selectedIndicatorValuesForEachState = {};
    //   var indicatorSource = indicator + ' -> ' + selectedSource;
    //   var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;

    //   var statesWithIndicatorsYearAndValues = this.getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear);

    //   if (statesWithIndicatorsYearAndValues[1] !== -Infinity) {
    //     for (var stateName in stateByIndicatorByYear) {
    //       if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
    //           // var len = stateByIndicatorByYear[stateName].length;
    //         var stateCurrentYearVals = stateByIndicatorByYear[stateName][statesWithIndicatorsYearAndValues[2][stateName]];
    //         selectedIndicatorValuesForEachState[stateName] = [stateCurrentYearVals[0], stateCurrentYearVals[indexOfindicatorSource]];
    //       }
    //     }
    //   }else{
    //     selectedIndicatorValuesForEachState = statesWithIndicatorsYearAndValues[0]
    //   }
    //   var temp = Object.keys(selectedIndicatorValuesForEachState);
    //   var obj = {};
    //   temp.map( (elem, index) => {
    //       obj[elem] = selectedIndicatorValuesForEachState[elem][1];
    //   });
    //   var regions = ['North-East', 'North-West', 'North-Central', 'South-East', 'South-West', 'South-South']
    //   var sortedObj = sortObjects(obj); // custom method
    //   var xAxis = [], yAxis = [];
    //   for (let stateName in sortedObj){
    //       if (sortedObj.hasOwnProperty(stateName)){
    //           if (regions.indexOf(stateName) < 0) { // don't need the regions in this chart
    //               yAxis.push(stateName);
    //               xAxis.push(sortedObj[stateName]);
    //           }
    //       }
    //   }
    //   var plotData = {}
    //   // get the data required for ngMap
    //   yAxis.map( (elem, index)=> {
    //       plotData[elem] = xAxis[index];
    //   });
    //   return plotData;
    // },
    // This method is not currently used
    // getYearWithCurrentIndicatorValues(indexOfindicatorSource, stateByIndicatorByYear) {

    //   var statesWithIndicatorsYearAndValues = {};
    //   var tempArr = {}; // this is an object with statename as key and the rowIndex where for the selectedYear as value
    //   var sourceActiveYear = {};
    //   var sourcetempArr = [];

    //   for (var stateName in stateByIndicatorByYear) {
    //       if (stateByIndicatorByYear.hasOwnProperty(stateName)) {
    //           for ( var i = stateByIndicatorByYear[stateName].length - 1; i>=0; i--) {
    //               statesWithIndicatorsYearAndValues[stateName] = [];
    //               var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
    //               // if (selectedIndicatorVal) {
    //               if (stateByIndicatorByYear[stateName][i][0] === parseInt(this.data[3])) {
    //                   tempArr[stateName] = i;
    //                   statesWithIndicatorsYearAndValues[stateName].push(stateByIndicatorByYear[stateName][i][0], stateByIndicatorByYear[stateName][i][indexOfindicatorSource]);
    //                   break;
    //               }
    //           }
    //           // get all the years where there's a value for the indicator...
    //           for ( var i = stateByIndicatorByYear[stateName].length - 1; i>=0; i--) {
    //             if(!sourceActiveYear[stateName]) {
    //                 sourceActiveYear[stateName] = {};
    //             }
    //             var selectedIndicatorVal = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
    //             if (selectedIndicatorVal) {
    //               sourcetempArr.push(i)
    //               sourceActiveYear[stateName][stateByIndicatorByYear[stateName][i][0]] = stateByIndicatorByYear[stateName][i][indexOfindicatorSource];
    //               // break;
    //             }
    //           }
    //       }
    //   }
    //   // we leverage the fact that National always has data for all the indicators
    //   // this.optionYear = Object.keys(sourceActiveYear['National']);
    //   var rowIndex = Math.max.apply(null, tempArr);
    //   return [statesWithIndicatorsYearAndValues, rowIndex, tempArr]
    // },
    /**
     * This method get the sources with available data for all states excluding National
     * This was done becuase National doesn't show up on the map
     */
    getCurrentSourceOptions: function getCurrentSourceOptions(indicator) {
      var sources = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      for (var k in this.dataSources) {
        for (var i in statesByIndicatorByYear) {
          for (var j in statesByIndicatorByYear[i]) {
            // if(i !== 'National'){
            var indicatorSource = indicator + ' -> ' + this.dataSources[k];
            var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
            if (statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (sources.indexOf(this.dataSources[k]) < 0) sources.push(this.dataSources[k]);
              break;
            }
            // }
          }
        }
      }
      // this.optionSources = sources;
      return sources;
    },


    // This method get the years with available data for the selected indicator and source
    getYearOptionsWithData: function getYearOptionsWithData(indicator, source) {
      var years = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      var indicatorSource = indicator + ' -> ' + source;
      var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
      this.optionStates.map(function (elem, index) {
        for (var i in statesByIndicatorByYear) {
          statesByIndicatorByYear[elem].map(function (el, i) {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (years.indexOf(el[0]) < 0) {
                years.push(el[0]);
              }
            }
          });
        }
      });
      this.optionYear = years.sort(function (a, b) {
        return b - a;
      });
    },
    multiselectSearch: function multiselectSearch() {
      this.collapsible = false;
    },

    // This method assigns this.selectedSource and this.selectedYear
    // Was done to avoid repeated code writing
    yearComputation: function yearComputation(indicator, source) {
      this.getYearOptionsWithData(indicator, source);
      if (this.optionYear.length > 0) {
        this.selectedYear = this.optionYear.reduce(function (a, b) {
          return Math.max(a, b);
        });
      } else {
        this.selectedYear = 0;
      }
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
    }
  },
  mounted: function mounted() {
    //indicatorOptions','appData','relativeIndicator','mapType','isExpanded','indicatorClicked', 'sourceSelected'
    if (this.lsData) {
      // console.log(this.relativeIndicator);

      this.optionSources = this.getCurrentSourceOptions(this.relativeIndicator);
      this.indicatorPlaceholder = this.relativeIndicator;
      this.selectedSource = this.optionSources[1];
      this.sourcePlaceholder = this.selectedSource;
      this.yearComputation(this.relativeIndicator, this.selectedSource);
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
      // this.$store.dispatch('storeIndicatorSelected',this.relativeIndicator);
    }
  },

  computed: {},
  watch: {
    masterIndicator: function masterIndicator(val) {
      this.$emit('indicatorClicked', val); // Emits the selectedIndicator for other charts to use
      this.indicatorPlaceholder = val;
      // this.$store.dispatch('storeIndicatorSelected',name);
      this.optionSources = this.getCurrentSourceOptions(val);
      if (this.optionSources.indexOf('MICS') < 0) {
        this.selectedSource = this.optionSources[0];
      } else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      //console.log(val);

      this.yearComputation(val, this.selectedSource);
    },
    selectedIndicator: function selectedIndicator(_ref) {
      var name = _ref.name;


      // console.log(name);
      // console.log(this.relativeIndicator);      
      this.$emit('indicatorClicked', name); // Emits the selectedIndicator for other charts to use
      this.indicatorPlaceholder = name;
      // this.$store.dispatch('storeIndicatorSelected',name);
      this.optionSources = this.getCurrentSourceOptions(name);
      if (this.optionSources.indexOf('MICS') < 0) {
        this.selectedSource = this.optionSources[0];
      } else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      //console.log(this.optionSources);

      this.yearComputation(name, this.selectedSource);
    },
    selectedSource: function selectedSource(val) {
      this.$emit('sourceSelected', val);

      this.sourcePlaceholder = val;
      if (this.selectedIndicator.name !== '') {
        this.yearComputation(this.selectedIndicator.name, val);
      } else {
        this.yearComputation(this.relativeIndicator, val);
      }
    },
    isExpanded: function isExpanded(val) {
      this.expandedView = val;
    },
    indicatorClicked: function indicatorClicked(val) {
      this.indicatorPlaceholder = val;
    },
    sourceSelected: function sourceSelected(val) {
      // console.log(val); 
      this.selectedSource = val;
    },
    relativeIndicator: function relativeIndicator(val) {
      // console.log(val);   
      this.optionSources = this.getCurrentSourceOptions(val);
      // console.log(this.optionSources);

      this.indicatorPlaceholder = val;
      if (this.optionSources.indexOf('MICS') < 0) {
        this.selectedSource = this.optionSources[0];
      } else {
        this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
      }
      this.sourcePlaceholder = this.selectedSource;
      this.yearComputation(val, this.selectedSource);
      this.yearMultiselectPlaceholder = this.selectedYear.toString();
    }
  }
});

/***/ }),

/***/ 879:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'nigregion-map',
    props: ['relativeIndicator', 'selectedIndicator', 'appData', 'sourceClicked', 'yearClicked', 'indicatorClicked'],
    components: {},
    data: function data() {
        var data = [['ng-ne', 0], ['ng-nw', 1], ['ng-nc', 2], ['ng-se', 3], ['ng-sw', 4], ['ng-ss', 5]];
        return {
            chartHasNoData: false,
            series_data: [],
            optionYear: [],
            optionSources: [],
            lsData: JSON.parse(this.$ls.get('car_other_dataset')),
            selectedSource: this.sourceClicked,
            selectedYear: '',
            optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "National", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara", "North-East", "North-West", "North-Central", "South-East", "South-West", "South-South"],
            dataSources: ['MICS', 'NHMIS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
            stateToShortCode: {
                'North-East': 'ng-ne',
                'North-West': 'ng-nw',
                'North-Central': 'ng-nc',
                'South-East': 'ng-se',
                'South-West': 'ng-sw',
                'South-South': 'ng-ss'
            },
            mapPlotData: null,
            options: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
                chart: {
                    map: 'countries/ng/ng-all',
                    borderColor: '#335cad',
                    height: 438
                },

                colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],

                credits: {
                    enabled: true,
                    text: 'Map of Nigeria'
                },

                title: {
                    text: 'Loading...',
                    style: {
                        fontSize: '16px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: '600'
                    }
                },

                subtitle: {
                    text: "Loading...",
                    style: {
                        fontSize: '11px',
                        fontFamily: '"Open Sans", sans-serif',
                        fontWeight: 'normal'
                    }
                },

                exporting: {
                    csv: {
                        dateFormat: '%Y-%m-%d'
                    }
                },

                mapNavigation: {
                    enabled: true,
                    buttonOptions: {
                        verticalAlign: 'middle',
                        align: 'right'
                    }
                },

                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'right'
                },

                colorAxis: {
                    // min: 0,
                    // max: 100,
                    minColor: '#E6E7E8',
                    maxColor: '#114663'
                },

                plotOptions: {
                    map: {
                        allAreas: false,
                        mapData: __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigmap_region_data___default.a, // Highcharts.maps['countries/ng/ng-all'],
                        states: {
                            hover: {
                                color: '#BADA55'
                            }
                        },
                        joinBy: "hc-key",
                        dataLabels: {
                            allowOverlap: true,
                            align: 'center',
                            crop: true,
                            style: {
                                fontFamily: "'Open Sans', sans-serif",
                                fontSize: 10
                            },
                            enabled: true,
                            //format: '{point.name}',
                            color: '#FFFFFF',
                            formatter: function formatter() {
                                if (this.point.value) {
                                    return this.point.name;
                                }
                            }
                        },
                        tooltip: {
                            headerFormat: '<b>{series.name}</b><br>',
                            pointFormat: '{point.name}: <b>{point.value:.2f}</b>'
                        }
                    }
                },
                series: [{
                    type: "map",
                    data: data,
                    name: 'Random Name'
                }]
            }, 'exporting', {
                buttons: {
                    contextButton: {
                        menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
                        //"viewData",
                        "openInCloud"],
                        symbol: 'download'
                        // symbolStrokeWidth: 2,
                        // symbolFill: '#330033',
                        // symbolStroke: '#b3d4fc'
                    }
                }
            })
        };
    },

    methods: {
        getCurrentSourceOptions: function getCurrentSourceOptions(indicator) {
            var sources = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            for (var k in this.dataSources) {
                for (var i in statesByIndicatorByYear) {
                    for (var j in statesByIndicatorByYear[i]) {
                        if (i !== 'National') {
                            var indicatorSource = indicator + ' -> ' + this.dataSources[k];
                            var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
                            if (statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
                                if (sources.indexOf(this.dataSources[k]) < 0) sources.push(this.dataSources[k]);
                                break;
                            }
                        }
                    }
                }
            }
            this.optionSources = sources;
        },
        getYearOptionsWithData: function getYearOptionsWithData(indicator, source) {
            var years = [];
            var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
            var indicatorSource = indicator + ' -> ' + source;
            var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
            this.optionStates.map(function (elem, index) {
                if (elem !== 'National') {
                    statesByIndicatorByYear[elem].map(function (el, i) {
                        if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
                            if (years.indexOf(el[0]) < 0) {
                                years.push(el[0]);
                            }
                        }
                    });
                }
            });
            this.optionYear = years;
        },
        sourceAndYearComputation: function sourceAndYearComputation(indicator) {
            this.getCurrentSourceOptions(indicator);
            var randomSource = Math.floor(Math.random() * this.optionSources.length);
            this.selectedSource = this.sourceClicked;
            this.getYearOptionsWithData(indicator, this.selectedSource);
            if (this.optionYear.length > 0) {
                this.selectedYear = this.optionYear.reduce(function (a, b) {
                    return Math.max(a, b);
                });
            } else {
                this.selectedYear = 0;
            }
        },
        plotMap: function plotMap(data) {
            var _this = this;

            // Create the chart
            if (this.mapPlotData) {
                this.options.series[0].data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stateToShortCode).map(function (elem, index) {
                    return [_this.stateToShortCode[elem], data[elem]]; //this.mapPlotData[elem]];
                });
            }
        },
        computeMapData: function computeMapData(indicator, source) {
            var ngMapData = this.regionsMapData;
            if (this.lsData) {
                var regions_data = this.extractRegionData(indicator, this.selectedYear);
                this.mapPlotData = regions_data;
                this.options.title.text = indicator;
                this.options.exporting.filename = indicator + " (" + source + ' - ' + this.selectedYear + ")";
                this.options.subtitle.text = source + ' - ' + this.selectedYear;
                this.options.series[0].name = source;
                this.plotMap(regions_data);
            }

            return "Nigeria Map";
        },
        extractRegionData: function extractRegionData(indicator, selectedYear) {
            var _this2 = this;

            var indicatorSource = indicator + ' -> ' + this.selectedSource;
            var regions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stateToShortCode);
            var lsData = this.appData.slice(1);
            var indexOfIndicatorSource = this.appData[0].indexOf(indicatorSource);
            var regionsData = {};
            regions.map(function (elem, index) {
                regionsData[elem] = {};
                lsData.map(function (el, i) {
                    if (el[0] === selectedYear && el[1] === elem) {
                        if (el[indexOfIndicatorSource] !== "") {
                            regionsData[elem] = el[indexOfIndicatorSource];
                            _this2.chartHasNoData = false;
                        } else {
                            regionsData[elem] = 0;
                            _this2.chartHasNoData = true;
                        }
                    }
                });
            });
            return regionsData;
        },
        yearComputation: function yearComputation(indicator, source) {
            this.getYearOptionsWithData(indicator, source);
            if (this.optionYear.length > 0) {
                this.selectedYear = this.optionYear.reduce(function (a, b) {
                    return Math.max(a, b);
                });
            } else {
                this.selectedYear = 0;
            }
        }
    },
    computed: {},
    updated: function updated() {},
    mounted: function mounted() {
        if (this.lsData) {
            if (this.selectedIndicator.length < 1) {
                this.getCurrentSourceOptions(this.relativeIndicator);
                var randomSource = Math.floor(Math.random() * this.optionSources.length);
                if (this.optionSources.indexOf('MICS') == -1) {
                    this.selectedSource = this.optionSources[0];
                } else {
                    this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
                }

                this.yearComputation(this.relativeIndicator, this.selectedSource);
                if (this.selectedYear > 0) {
                    this.computeMapData(this.relativeIndicator, this.selectedSource);
                } else {
                    this.chartHasNoData = true;
                }
            } else {
                if (this.indicatorClicked.length > 1) {
                    this.getCurrentSourceOptions(this.indicatorClicked);
                    var _randomSource = Math.floor(Math.random() * this.optionSources.length);
                    this.selectedSource = this.sourceClicked;
                    this.yearComputation(this.indicatorClicked, this.selectedSource);
                    this.selectedYear = this.yearClicked;
                    if (this.selectedYear > 0) {
                        this.computeMapData(this.indicatorClicked, this.selectedSource);
                    } else {
                        this.chartHasNoData = true;
                    }
                } else {
                    this.getCurrentSourceOptions(this.selectedIndicator);
                    var _randomSource2 = Math.floor(Math.random() * this.optionSources.length);
                    this.selectedSource = this.sourceClicked;
                    this.yearComputation(this.selectedIndicator, this.selectedSource);
                    this.selectedYear = this.yearClicked;
                    if (this.selectedYear > 0) {
                        this.computeMapData(this.selectedIndicator, this.selectedSource);
                    } else {
                        this.chartHasNoData = true;
                    }
                }
            }
            // this.$store.dispatch('storeIndicatorSelected',this.relativeIndicator);
        }
        // this.plotMap();
        // Create the chart
        // console.log(this.options)
    },

    watch: {
        selectedIndicator: function selectedIndicator(val) {
            this.getCurrentSourceOptions(this.relativeIndicator);
            var randomSource = Math.floor(Math.random() * this.optionSources.length);
            this.selectedSource = this.sourceClicked;

            if (this.selectedYear > 0) {
                this.computeMapData(val, this.selectedSource);
            } else {
                this.chartHasNoData = true;
            }
        },
        sourceClicked: function sourceClicked(val) {
            this.selectedSource = val;
            if (this.selectedIndicator !== '') {
                this.yearComputation(this.selectedIndicator, val);
                if (this.selectedYear > 0) {
                    this.computeMapData(this.selectedIndicator, val);
                } else {
                    this.chartHasNoData = true;
                }
            } else {
                this.yearComputation(this.relativeIndicator, val);
                if (this.selectedYear > 0) {
                    this.computeMapData(this.relativeIndicator, val);
                } else {
                    this.chartHasNoData = true;
                }
            }
        },
        yearClicked: function yearClicked(val) {
            this.selectedYear = val;
            if (this.selectedIndicator !== '') {
                if (val > 0) {
                    this.computeMapData(this.selectedIndicator, this.selectedSource);
                } else {
                    this.chartHasNoData = true;
                }
            } else {
                if (val > 0) {
                    this.computeMapData(this.relativeIndicator, this.selectedSource);
                } else {
                    this.chartHasNoData = true;
                }
            }
        },
        indicatorClicked: function indicatorClicked(val) {
            this.getCurrentSourceOptions(val);
            var randomSource = Math.floor(Math.random() * this.optionSources.length);
            this.selectedSource = this.sourceClicked;

            if (this.selectedYear > 0) {
                this.computeMapData(val, this.selectedSource);
            } else {
                this.chartHasNoData = true;
            }
        }
    }
});

/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigeria_map_data__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigeria_map_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigeria_map_data__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'state-map',
  props: ['relativeIndicator', 'selectedIndicator', 'appData', 'sourceClicked', 'yearClicked', 'indicatorClicked'],
  components: {},
  data: function data() {
    var _stateToShortCode;

    var data = [['ng-ri', 0], ['ng-kt', 1], ['ng-so', 2], ['ng-za', 3], ['ng-yo', 4], ['ng-ke', 5], ['ng-ad', 6], ['ng-bo', 7], ['ng-ak', 8], ['ng-ab', 9], ['ng-im', 10], ['ng-by', 11], ['ng-be', 12], ['ng-cr', 13], ['ng-ta', 14], ['ng-kw', 15], ['ng-la', 16], ['ng-ni', 17], ['ng-fc', 18], ['ng-og', 19], ['ng-on', 20], ['ng-ek', 21], ['ng-os', 22], ['ng-oy', 23], ['ng-an', 24], ['ng-ba', 25], ['ng-go', 26], ['ng-de', 27], ['ng-ed', 28], ['ng-en', 29], ['ng-eb', 30], ['ng-kd', 31], ['ng-ko', 32], ['ng-pl', 33], ['ng-na', 34], ['ng-ji', 35], ['ng-kn', 36]];
    return {
      chartHasNoData: false,
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      dataSources: ['MICS', 'NHMIS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
      series_data: [],
      optionSources: [],
      optionYear: [],
      selectedSource: this.sourceClicked,
      selectedYear: '',
      stateToShortCode: (_stateToShortCode = {
        Abia: 'ng-ab',
        Adamawa: 'ng-ad',
        'Akwa Ibom': 'ng-ak',
        Anambra: 'ng-an',
        Bauchi: 'ng-ba',
        Benue: 'ng-be',
        Borno: 'ng-bo'
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Bauchi', 'ng-ba'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Bayelsa', 'ng-by'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Cross River', 'ng-cr'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Delta', 'ng-de'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Ebonyi', 'ng-eb'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Edo', 'ng-ed'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Ekiti', 'ng-ek'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Enugu', 'ng-en'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'FCT', 'ng-fc'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Gombe', 'ng-go'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Imo', 'ng-im'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Jigawa', 'ng-ji'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Kano', 'ng-kn'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Katsina', 'ng-kt'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Kaduna', 'ng-kd'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Kebbi', 'ng-ke'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Kogi', 'ng-ko'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Kwara', 'ng-kw'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Lagos', 'ng-la'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Nasarawa', 'ng-na'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Niger', 'ng-ni'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Ogun', 'ng-og'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Ondo', 'ng-on'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Osun', 'ng-os'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Oyo', 'ng-oy'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Plateau', 'ng-pl'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Rivers', 'ng-ri'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Sokoto', 'ng-so'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Taraba', 'ng-ta'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Yobe', 'ng-yo'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_stateToShortCode, 'Zamfara', 'ng-za'), _stateToShortCode),
      optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "National", "Bayelsa", "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo", "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe", "Zamfara"],
      mapPlotData: null,
      options: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              height: 550
            }
          }]
        },
        chart: {
          map: 'countries/ng/ng-all',
          borderColor: '#335cad',
          style: {
            "fontFamily": "'Open Sans', sans-serif",
            "fontSize": "12px"
          },
          // width: 500,
          height: 438
        },

        colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],

        credits: {
          enabled: true,
          text: 'Map of Nigeria'
        },

        title: {
          text: 'Loading...',
          style: {
            fontSize: '16px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: '600'
          }
        },

        subtitle: {
          text: "Loading...",
          style: {
            fontSize: '11px',
            fontFamily: '"Open Sans", sans-serif',
            fontWeight: 'normal'
          }
        },

        exporting: {
          csv: {
            dateFormat: '%Y-%m-%d'
          }
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: 'middle',
            align: 'right'
          }
        },
        legend: {
          enabled: true,
          layout: 'vertical',
          align: 'right'
        },
        colorAxis: {
          // min: 0,
          // max: 100,
          minColor: '#E6E7E8',
          maxColor: '#114663'
        },

        plotOptions: {
          map: {
            allAreas: false,
            mapData: __WEBPACK_IMPORTED_MODULE_2__assets_js_on_nigeria_map_data___default.a, // Highcharts.maps['countries/ng/ng-all'],
            states: {
              hover: {
                color: '#BADA55'
              }
            },
            joinBy: "hc-key",
            dataLabels: {
              enabled: true,
              //format: '{point.name}',
              color: '#FFFFFF',
              formatter: function formatter() {
                if (this.point.value) {
                  return this.point.name;
                }
              }
            },
            tooltip: {
              headerFormat: '<b>{series.name}</b><br>',
              pointFormat: '{point.name}: <b>{point.value:.2f}</b>'
            }
          }
        },
        series: [{
          data: data,
          name: 'Random Name'
        }]
      }, 'exporting', {
        buttons: {
          contextButton: {
            menuItems: ["printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS",
            //"viewData",
            "openInCloud"],

            symbol: 'download'
            // symbolStrokeWidth: 2,
            // symbolFill: '#330033',
            // symbolStroke: '#b3d4fc'
          }
        }
      })
    };
  },

  methods: {

    // Check info about these methods on index.vue
    getCurrentSourceOptions: function getCurrentSourceOptions(indicator) {
      var sources = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      for (var k in this.dataSources) {
        for (var i in statesByIndicatorByYear) {
          for (var j in statesByIndicatorByYear[i]) {
            if (i !== 'National') {
              var indicatorSource = indicator + ' -> ' + this.dataSources[k];
              var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
              if (statesByIndicatorByYear[i][j][indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
                if (sources.indexOf(this.dataSources[k]) < 0) sources.push(this.dataSources[k]);
                break;
              }
            }
          }
        }
      }
      this.optionSources = sources;
    },
    getYearOptionsWithData: function getYearOptionsWithData(indicator, source) {
      var years = [];
      var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
      var indicatorSource = indicator + ' -> ' + source;
      var indicatorSourceIndex = this.lsData[0].indexOf(indicatorSource) - 1;
      this.optionStates.map(function (elem, index) {
        if (elem !== 'National') {
          statesByIndicatorByYear[elem].map(function (el, i) {
            if (el[indicatorSourceIndex] !== "" && indicatorSourceIndex > 0) {
              if (years.indexOf(el[0]) < 0) {
                years.push(el[0]);
              }
            }
          });
        }
      });
      this.optionYear = years;
    },
    plotMap: function plotMap() {
      var _this = this;

      // Create the chart
      if (this.mapPlotData) {
        this.options.legend = {
          enabled: true,
          layout: 'horizontal',
          align: 'right'
        };
        this.options.series[0].data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stateToShortCode).map(function (elem, index) {
          return [_this.stateToShortCode[elem], _this.mapPlotData[elem]];
        });
      }
    },

    // Handles computation for map data
    getMapData: function getMapData(indicator, source) {
      var _this2 = this;

      var indicatorNames = this.appData[0];
      var indicatorSource = indicator + ' -> ' + source;
      var indexOfIndicatorSource = indicatorNames.indexOf(indicatorSource);
      var data = this.appData.slice(1);
      var stateData = {};
      this.optionStates.map(function (state, index) {
        stateData[state] = '';
        data.map(function (elem, index) {
          if (_this2.selectedYear === elem[0] && state === elem[1]) {
            if (elem[indexOfIndicatorSource] === "") {
              stateData[state] = 0;
            } else {
              stateData[state] = elem[indexOfIndicatorSource];
            }
          }
        });
      });
      return stateData;
    },

    // Sets highmaps options
    computeMapData: function computeMapData(indicator, source, caller) {
      //this.$store.getters.getCARngMapData;
      this.mapPlotData = this.getMapData(indicator, source);
      this.options.title.text = indicator;
      this.options.subtitle.text = source + ' - ' + this.selectedYear;
      this.options.exporting.filename = indicator + " (" + source + ' - ' + this.selectedYear + ")";
      this.options.series[0].name = source;
      var state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.mapPlotData);
      var noDataCounter = 0;
      for (var i in state) {
        //Excluding national from the condition because national isn't included on the map
        if (state[i] !== 'National') {
          if (this.mapPlotData[state[i]] !== 0) {
            this.chartHasNoData = false;
            break;
          } else {
            noDataCounter++;
          }
        }
      }
      if (noDataCounter === state.length - 1) this.chartHasNoData = true;
      this.plotMap();
      return "Nigeria Map";
    },
    yearComputation: function yearComputation(indicator, source) {
      this.getYearOptionsWithData(indicator, source);
      if (this.optionYear.length > 0) {
        this.selectedYear = this.optionYear.reduce(function (a, b) {
          return Math.max(a, b);
        });
      } else {
        this.selectedYear = 0;
      }
    }
  },
  computed: {},
  // updated() {
  //     if(this.selectedYear > 0){
  //         this.computeMapData();
  //     } else {
  //         this.chartHasNoData = true;
  //     }
  // },
  mounted: function mounted() {
    if (this.lsData) {
      /**
       * The if statement below checks if the length of the selectedIndicator 
       * is greater than 1. Initially, the selectedIndicator is empty and so 
       * this method runs all computations using the indicators gotten from the table
       * i.e (Indicator and relatives)
       */
      if (this.selectedIndicator.length < 1) {
        this.getCurrentSourceOptions(this.relativeIndicator);
        var randomSource = Math.floor(Math.random() * this.optionSources.length);
        if (this.optionSources.indexOf('MICS') == -1) {
          this.selectedSource = this.optionSources[0];
        } else {
          this.selectedSource = this.optionSources[this.optionSources.indexOf('MICS')];
        }

        this.yearComputation(this.relativeIndicator, this.selectedSource);
        // This checks if there's an available year for the current indicator and source
        // else it shows the noData chart
        if (this.selectedYear > 0) {
          this.computeMapData(this.relativeIndicator, this.selectedSource);
        } else {
          this.chartHasNoData = true;
        }
      } else {
        /**
         * This if checks if the indicator selected from other charts contains data
         * else it makes computations using the relative indicators from the table
         */
        if (this.indicatorClicked.length > 1) {
          this.getCurrentSourceOptions(this.indicatorClicked);
          var _randomSource = Math.floor(Math.random() * this.optionSources.length);
          this.selectedSource = this.sourceClicked;
          this.yearComputation(this.indicatorClicked, this.selectedSource);
          this.selectedYear = this.yearClicked;
          if (this.selectedYear > 0) {
            this.computeMapData(this.indicatorClicked, this.selectedSource);
          } else {
            this.chartHasNoData = true;
          }
        } else {
          this.getCurrentSourceOptions(this.selectedIndicator);
          var _randomSource2 = Math.floor(Math.random() * this.optionSources.length);
          this.selectedSource = this.sourceClicked;
          this.yearComputation(this.selectedIndicator, this.selectedSource);
          this.selectedYear = this.yearClicked;
          if (this.selectedYear > 0) {
            this.computeMapData(this.selectedIndicator, this.selectedSource);
          } else {
            this.chartHasNoData = true;
          }
        }
      }
    }
  },

  watch: {
    selectedIndicator: function selectedIndicator(val) {
      this.getCurrentSourceOptions(this.relativeIndicator);
      var randomSource = Math.floor(Math.random() * this.optionSources.length);
      this.selectedSource = this.sourceClicked;

      if (this.selectedYear > 0) {
        this.computeMapData(val, this.selectedSource);
      } else {
        this.chartHasNoData = true;
      }
    },
    sourceClicked: function sourceClicked(val) {
      this.selectedSource = val;
      if (this.selectedIndicator !== '') {
        this.yearComputation(this.selectedIndicator, val);
        if (this.selectedYear > 0) {
          this.computeMapData(this.selectedIndicator, val);
        } else {
          this.chartHasNoData = true;
        }
      } else {
        this.yearComputation(this.relativeIndicator, val);
        if (this.selectedYear > 0) {
          this.computeMapData(this.relativeIndicator, val);
        } else {
          this.chartHasNoData = true;
        }
      }
    },
    yearClicked: function yearClicked(val) {
      this.selectedYear = val;
      if (this.selectedIndicator !== '') {
        if (val > 0) {
          this.computeMapData(this.selectedIndicator, this.selectedSource);
        } else {
          this.chartHasNoData = true;
        }
      } else {
        if (val > 0) {
          this.computeMapData(this.relativeIndicator, this.selectedSource);
        } else {
          this.chartHasNoData = true;
        }
      }
    },
    indicatorClicked: function indicatorClicked(val) {
      this.getCurrentSourceOptions(val);
      var randomSource = Math.floor(Math.random() * this.optionSources.length);
      this.selectedSource = this.sourceClicked;
      if (this.selectedYear > 0) {
        this.computeMapData(val, this.selectedSource);
      } else {
        this.chartHasNoData = true;
      }
    }
  }
});

/***/ }),

/***/ 884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_js_on_strlimit__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_js_on_strlimit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_js_on_strlimit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_js_on_vue_multiselect__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mt_vue__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_mt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main_js__ = __webpack_require__(135);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import statements






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["appData", "uncertaintyData", "meta_data", "indicatorMetaData", "sourceMetaData", "selectedIndicator56"],
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_10__assets_js_on_vue_multiselect__["a" /* default */],
    TableModal: __WEBPACK_IMPORTED_MODULE_11__components_mt_vue___default.a
  },
  data: function data() {
    var _ref;

    return _ref = {
      lsNdStateData: JSON.parse(this.$ls.get("nd_state_data")),
      lsNdLgaData: JSON.parse(this.$ls.get("nd_lga_data")),
      ndSelected: "NHMIS:2020",
      //selectedSource: "NHMIS",
      selectedYear: "2020",
      ndYear: [],
      ndStateData: [],
      showToggle: false,
      ndOptionsArray: [],
      ndOptions: [],
      datasingle: "",
      datafull: [],
      denominator: "",
      numerator: "",
      numValue: "",
      denValue: "",
      selectedIndicator: "Skilled attendance at delivery or birth",
      NhmisMonthlySelectedState: "Nigeria",
      selectedState: "National",
      availableSources: [],
      sourceClass: [],
      isActive: false,
      sourceList: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS-DHIS2", "World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
      sourceFullName: {
        "NHMIS-DHIS2": "National Health Management Information System",
        "NHMIS-DHIS2 (monthly)": "National Health Management Information System Monthly",
        NDHS: "Nigeria Demographic and Health Survey",
        NHSPSS: "National HIV Sero-Prevalence Sentinel Survey",
        MICS: "Multiple Indicator Cluster Survey",
        NNHS: "National Nutrition and Health Survey",
        NMIS: "Nigeria Malaria Indicator Survey",
        NHA: "National Health Accounts",
        NARHS: "National HIV & AIDS and Reproductive Health Survey",
        KSGHR: "Kaduna State General Household Survey",
        PCCS: "Measles Post Campaign Coverage Survey",
        "WHO-GHO": "WHO - Global Health Observatory",
        "World Bank": "World Bank",
        IHME: "Institute for Health Metrics and Evaluation",
        WUENIC: "WHO and UNICEF Estimates of National Immunization Coverage",
        UNAIDS: "The Joint United Nations Programme on HIV and AIDS",
        NAIIS: "Nigeria HIV/AIDS Indicator and Impact Survey",
        KDGHS: "Kaduna General Household Survey"
      },
      dataSourceClass: {
        "NHMIS-DHIS2": "Routine",
        NDHS: "Surveys",
        NHSPSS: "Surveys",
        KDGHS: "Surveys",
        NHA: "Surveys",
        NAIIS: "Surveys",
        MICS: "Surveys",
        NNHS: "Surveys",
        NMIS: "Surveys",
        NARHS: "Surveys",
        KSGHR: "Surveys",
        PCCS: "Surveys",
        "UN IGME": "Estimate",
        "WHO-GHO": "Estimates",
        "World Bank": "Estimates",
        IHME: "Estimates",
        WUENIC: "Estimates",
        UNAIDS: "Estimates"
      },
      dataSourceUncertainty: {},
      indicatorRelativeValues: {},
      indicatorRelativeValuese: [],
      surveyCounter: 0,
      indicatorMetaDataToShow: "",
      lsData: JSON.parse(this.$ls.get("car_other_dataset")),
      spanning: 0,
      estimatesCounter: 0,
      routineCounter: 0,
      sourceIndicatorInfo: {},
      dataAvailable: {
        National: "grey",
        State: "grey",
        Senatorial: "grey",
        Zonal: "grey",
        LGA: "grey"
      },
      selectedTargetGroup: "",
      selectedSampledHouseholdData: "",
      indicatorInfo: [],
      dataSourceName: "",
      selectedDescription: ""
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "sourceIndicatorInfo", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isComponentModalActive", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isUncertaintyAvailable", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "optionIndicators", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "indicatorRelatives", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "selectIndicatorRelative", [{
      name: "ANC Coverage (at least 1 visit)"
    }, {
      name: "Postnatal care coverage (mother)"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "multiselectPlaceholder", ["Search1", "Search2"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "collapsible", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "indicatorRelativesObject", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isSourceMetaModalActive", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "sourceInfo", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "displayFactor", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "nhmisMonthlyData", []), _ref;
  },

  methods: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()({
    getDS: function getDS() {
      var result = [];
      var DSMeta = JSON.parse(this.$ls.get("source_meta_dataset"));
      var DSMeta2 = DSMeta.slice(1);
      DSMeta2.map(function (el) {
        result.push([el[0] + " : " + el[1]]);
      });
      // get the sourcelist data
      var ds = DSMeta2.map(function (el) {
        return el[0];
      });
      this.sourceList = ds;

      // get the datasource fullnames data
      var dsFullNames = result.map(function (el) {
        return el.map(function (keyVal) {
          return keyVal.split(":").map(function (_) {
            return _.trim();
          });
        }).reduce(function (accumulator, currentValue) {
          accumulator[currentValue[0]] = currentValue[1];
          return accumulator;
        }, {});
      });

      this.sourceFullName = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(dsFullNames)));

      // get classifications
      var results = [];
      DSMeta2.map(function (el) {
        results.push([el[0] + " : " + el[8]]);
      });

      var reOrderedDs = results.filter(function (el) {
        if (el[0].split(":")[0].trim() !== "NHMIS-DHIS2") {
          return el;
        }
      });
      reOrderedDs.unshift(["NHMIS-DHIS2 : Routine"]);

      var dsClassification = reOrderedDs.map(function (el) {
        return el.map(function (keyVal) {
          return keyVal.split(":").map(function (_) {
            return _.trim();
          });
        }).reduce(function (accumulator, currentValue) {
          accumulator[currentValue[0]] = currentValue[1];
          return accumulator;
        }, {});
      });

      this.dataSourceClass = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(dsClassification)));
    },
    getIdb: function getIdb() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_8__main__["indDB"].transaction("rw", __WEBPACK_IMPORTED_MODULE_8__main__["indDB"].stateNumDen, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_8__main__["indDB"].stateNumDen.toArray();

                        case 2:
                          data = _context.sent;

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this);
                })).catch(function (err) {
                  // Catch any error event or exception and log it:
                  //console.error(err.stack || err);
                });

              case 2:
                return _context2.abrupt("return", data);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    thousandSeperator: function thousandSeperator(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getNdMetaData: function getNdMetaData() {
      var _this2 = this;

      if (this.indicatorMetaData) {
        var result = this.indicatorMetaData.filter(function (val) {
          return val[0] == _this2.selectedSource && val[1] == _this2.selectedIndicator;
        });
        return result;
      }
    },
    getIndicatorSourceIndex: function getIndicatorSourceIndex(val) {
      //let list = this.lsNdStateData[0]
      //console.log(list)
      var check = this.selectedIndicator56 + " -> " + this.selectedSource;
      return val[0].indexOf(check);
    },
    ndSelectedOption: function ndSelectedOption() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var obj1, obj, index, ndValue, ndMeta;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // this.lsNdStateData = await this.getIdb();

                // let indicator, source, location;
                if (_this3.lsNdStateData !== null) {
                  obj1 = _this3.lsNdStateData.filter(function (val) {
                    return val[0] == _this3.selectedYear;
                  });
                  //console.log(this.selectedYear)
                  // console.log(obj1);

                  _this3.ndStateData = obj1;

                  //this.$store.dispatch('storeNdStateData',  this.ndStateData);

                  obj = obj1.filter(function (val) {
                    return val[1] == _this3.selectedState;
                  });
                  //console.log(obj)

                  index = _this3.getIndicatorSourceIndex(_this3.lsNdStateData);
                  //console.log(index)

                  if (index < 0) {
                    _this3.numerator = "Unavailable";
                    _this3.denominator = "Unavailable";
                    _this3.numValue = "";
                    _this3.denValue = "";
                  }
                  ndValue = obj[0][index];

                  if (ndValue !== undefined) {
                    ndValue = ndValue.split("#");
                    //console.log(obj1)
                    ndMeta = _this3.getNdMetaData();
                    //console.log(ndMeta[0][3])

                    if (obj.length !== 0 && ndMeta[0] !== undefined) {
                      _this3.numerator = ndMeta[0][3];
                      _this3.denominator = ndMeta[0][4];
                      _this3.numValue = ndValue[0];
                      _this3.denValue = ndValue[1];
                    } else {
                      _this3.numerator = "Unavailable";
                      _this3.denominator = "Unavailable";
                      _this3.numValue = "";
                      _this3.denValue = "";
                    }
                  }
                }
                //console.log(obj);
                _this3.ndSelected = "" + _this3.selectedSource + ":" + ("" + _this3.selectedYear);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    clearModal: function clearModal() {
      this.isSourceMetaModalActive = false;
    },
    scrollPage: function scrollPage(elem) {
      var scrollElem = document.getElementById("scrollTable");
      var scrollLeft = document.getElementById("scrollLeft");
      var getWidth = scrollElem.scrollWidth;

      if (elem == "scrollRight") {
        scrollElem.scrollLeft += 40;

        scrollLeft.style.display = "block";
      }
      if (elem == "scrollLeft") {
        scrollElem.scrollLeft -= 40;

        if (scrollElem.scrollLeft == 0) {
          scrollLeft.style.display = "none";
        }
      }
    },
    refreshSources: function refreshSources() {
      //Remove background color for all sources
      var tableSources = document.querySelectorAll(".table_sources");
      tableSources.forEach(function (sources, index) {
        // if (sources.style.background === "rgb(65, 145, 142)") {
        if (sources.style.background === "rgb(54, 117, 116)" || sources.style.background === "rgb(65, 145, 142)") {
          sources.childNodes[2].style.background = "#41918E";
          sources.childNodes[2].style.fill = "#DDD";
          sources.style.background = "";
          sources.style.color = "#333";
          sources.style.borderBottomColor = "#DDD";

          //Remove Background from NHMIS after refresh
          source_table.rows[2].cells[1].style.background = "#41918E";
          source_table.rows[2].cells[1].style.borderBottomColor = "#DDD";
          source_table.rows[2].cells[1].style.borderTopColor = "#DDD";
        }
      });

      this.$store.dispatch("storeSourceClicked", this.availableSources);
      this.showToggle = false;
    },

    /**
     * This method get the availble sources with data based in the indicator and state selected
     */
    getAvailbleSourcesByIndicator: function getAvailbleSourcesByIndicator(indicator, state) {
      var _this4 = this;

      // Variable declarations
      var routineCounter = 0,
          estimatesCounter = 0,
          surveyCounter = 0,
          data = this.appData.slice(0),
          stateData = void 0,
          indicatorNames = data[0],
          indicatorIndex = 0,
          sources = [],
          sourceClass = [],
          sourceData = {},
          sourceObject = {};

      this.dataSourceUncertainty = [];

      indicatorNames.map(function (indicatorName, count) {
        if (indicatorName.indexOf("->") > -1) {
          var sourceName = indicatorName.split(" -> ")[0];
          var sourceClassName = indicatorName.split(" -> ")[1];

          if (indicator === sourceName) {
            if (sources.indexOf(sourceClassName) < 0) {
              var mostRecentYearForSource = 0;
              sourceData[sourceClassName] = [];
              var _indicatorIndex = indicatorNames.indexOf(indicatorName);
              data.slice(1).map(function (data, index) {
                if (data[1] === state) {
                  if (typeof data[_indicatorIndex] === "number") {
                    sourceData[sourceClassName].push([parseInt(data[0]), data[_indicatorIndex]]);
                  }
                }
              });

              // console.log(sourceData, 'lsNdLgaData');

              //Filter sources without data
              if (sourceData[sourceClassName].length !== 0) {
                sourceObject[sourceClassName] = data[count];
                sourceClass.push(_this4.dataSourceClass[sourceClassName]);
                if (_this4.dataSourceClass[sourceClassName] === "Routine") {
                  routineCounter++;
                } else if (_this4.dataSourceClass[sourceClassName] === "Surveys") {
                  surveyCounter++;
                } else {
                  estimatesCounter++;
                }
                sources.push(sourceClassName);
              }
            }
          }
        }
      });

      /**
       * The block below check to make sure IHME,NHMIS, and NDHS remian fixed
       * whether they have data or not
       */
      // if (sources.indexOf('IHME') < 0 && estimatesCounter == 0) {      //Remove IHME if there are other estimates

      // if (sources.indexOf("IHME") < 0 || estimatesCounter == 0) {
      //   //Always have IHME even if there are other estimates
      //   sources.push("IHME");
      //   estimatesCounter++;
      // }
      // if (sources.indexOf("NDHS") < 0 || surveyCounter == 0) {
      //   sources.push("NDHS");
      //   surveyCounter++;
      // }

      if (sources.indexOf("NHMIS-DHIS2") < 0) {
        sources.push("NHMIS-DHIS2");
      }

      //Sort sources and source class list based on the this.dataSourceClass arrangement
      sources.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.dataSourceClass).indexOf(a) - __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.dataSourceClass).indexOf(b);
      });
      sourceClass.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(_this4.dataSourceClass).indexOf(a) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(_this4.dataSourceClass).indexOf(b);
      });

      this.surveyCounter = surveyCounter;
      this.estimatesCounter = estimatesCounter;
      this.routineCounter = routineCounter;
      this.spanning = surveyCounter + estimatesCounter + routineCounter;

      sources.map(function (el, i) {
        var obj = {
          name: el,
          uncertainty: false
        };
        _this4.dataSourceUncertainty.push(obj);
      });
      this.dataSourceUncertainty.unshift({
        name: "NHMIS-DHIS2 (monthly)",
        uncertainty: false
      });

      return [sourceClass, sources];
    },

    /**
     * This method gets the availble data for each source available for the selected indicator
     */
    getSourceData: function getSourceData(indicator, source) {
      var _this5 = this;

      var data = this.appData.slice(0);
      var indicatorNames = data[0];
      var sourceData = {};

      source.map(function (elem, index) {
        var mostRecentYearForSource = 0;
        sourceData[elem] = [];
        var indicatorSource = indicator + " -> " + elem;
        var indicatorIndex = indicatorNames.indexOf(indicatorSource);
        data.slice(1).map(function (data, index) {
          if (data[1] === _this5.selectedState) {
            if (typeof data[indicatorIndex] === "number") {
              sourceData[elem].push([parseInt(data[0]), data[indicatorIndex]]);
            }
          }
        });
      });
      return sourceData;
    },

    //Check display factor of selected indicator
    getDisplayFactor: function getDisplayFactor(indicator) {
      var displayFactor = "";

      for (var i in this.meta_data) {
        if (this.meta_data[i][0] === indicator) {
          displayFactor = this.meta_data[i][3];
          break;
        }
      }
      return displayFactor;
    },
    computeTableData: function computeTableData(indicatorRelatives) {
      var _this6 = this;

      this.$store.state.CAR.compareSection.relatedIndicators = indicatorRelatives;
      var tableData = {};
      var tableData2 = [];
      this.displayFactor = [];
      indicatorRelatives.map(function (indicator, counter) {
        var displayFactor = _this6.getDisplayFactor(indicator);
        _this6.displayFactor.push(displayFactor);
        var ivt = _this6.$store.state.CAR.indicatorAttributesOtherSources[indicator];
        var shortIndicatorName = _this6.$store.getters.getShortIndicatorNames(indicator);

        if (ivt) {
          var vt = ivt[1] === "P" ? "%" : "";
        }
        var data = _this6.getSourceData(indicator, _this6.availableSources);
        // console.log(this.availableSources, 'lsNdLgaData');

        tableData[shortIndicatorName] = [];
        if (counter === 0) {
          _this6.displayFactor.push("");
          tableData["Related Indicators"] = []; // Adds an empty row to the table
          tableData2[counter + 1] = [["Related Indicators"], []];
        }
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).map(function (dataArray, count) {
          if (data[dataArray].length > 0) {
            tableData[shortIndicatorName].push("<label class='ind_value'>" + (data[dataArray][data[dataArray].length - 1][1].toFixed(1) + vt) + "<br/>\n              <small style=\"font-size: 11px\">" + (data[dataArray][data[dataArray].length - 1][0] || " ") + "</small>\n            </label>");
            if (counter == 0) {
              tableData2[counter] = [[shortIndicatorName], tableData[shortIndicatorName]];
            } else {
              tableData2[counter + 1] = [[shortIndicatorName], tableData[shortIndicatorName]];
            }
          } else {
            tableData[shortIndicatorName].push("<label class='ind_value'>" + "<br/>\n              <small style=\"font-size: 11px\">" + " " + "</small>\n            </label>");

            if (counter == 0) {
              tableData2[counter] = [[shortIndicatorName], tableData[shortIndicatorName]];
            } else {
              tableData2[counter + 1] = [[shortIndicatorName], tableData[shortIndicatorName]];
            }
          }
        });
      });
      // console.log(indicatorRelatives, 'indicatorRelatives');
      // console.log(tableData2, 'indicatorRelatives');
      this.$emit("indicatorRelatives", indicatorRelatives);

      this.indicatorRelativeValues = tableData2;
      //this.indicatorRelativeValues =this.indicatorRelativeValues.slice(1,4)

      this.indicatorRelativeValuese[0] = this.indicatorRelativeValues[0];
      this.indicatorRelativeValues = this.indicatorRelativeValues.slice(1, 4);
      var indicatorValuess = this.getNhmisMonthlyData(indicatorRelatives);

      if (this.indicatorRelativeValues[0] !== undefined) {
        // if (
        //   this.indicatorValuess !== undefined &&
        //   this.indicatorValuess[0].value !== undefined
        // ) {

        if (this.indicatorRelativeValuese[0][1] !== undefined) {
          if (indicatorValuess[0] !== undefined) {
            this.indicatorRelativeValuese[0][1].unshift("<label class='ind_value'>" + (indicatorValuess[0].value ? indicatorValuess[0].value + "%" : "") + "<br/>\n              <small style=\"font-size: 11px\">" + (indicatorValuess[0].value ? indicatorValuess[0].date : "") + "</small>\n            </label>");
          } else {
            this.indicatorRelativeValuese[0][1].unshift("<label class='ind_value'>" + "-" + "<br/>\n              <small style=\"font-size: 11px\">" + "-" + "</small>\n            </label>");
          }
        }

        // }
      }
      // 2ND TABLE ROW

      if (this.indicatorRelativeValues[1] !== undefined) {
        // if (
        //   this.indicatorValuess !== undefined &&
        //   this.indicatorValuess[1].value !== undefined
        // ) {
        if (indicatorValuess[1] !== undefined) {
          this.indicatorRelativeValues[1][1].unshift("<label class=\"ind_value\">" + (indicatorValuess[1].value ? indicatorValuess[1].value + "%" : "") + "<br/>\n              <small style=\"font-size: 11px\">" + (indicatorValuess[1].value ? indicatorValuess[1].date : "") + "</small>\n            </label>");
          // }
        } else {
          this.indicatorRelativeValues[1][1].unshift("<label class='ind_value'>" + "-" + "<br/>\n              <small style=\"font-size: 11px\">" + "-" + "</small>\n            </label>");
        }
      }
      // 3RD TABLE ROW
      if (this.indicatorRelativeValues[2] !== undefined) {
        // if (
        //   this.indicatorValuess !== undefined &&
        //   this.indicatorValuess[2].value !== undefined
        // ) {
        if (indicatorValuess[2] !== undefined) {
          this.indicatorRelativeValues[2][1].unshift("<label class=\"ind_value\">" + (indicatorValuess[2].value ? indicatorValuess[2].value + "%" : "") + "<br/>\n              <small style=\"font-size: 11px\">" + (indicatorValuess[2].value ? indicatorValuess[2].date : "") + "</small>\n            </label>");
          // }
        } else {
          this.indicatorRelativeValues[2][1].unshift("<label class='ind_value'>" + "-" + "<br/>\n              <small style=\"font-size: 11px\">" + "-" + "</small>\n            </label>");
        }
      }
      // if (this.routineCounter <= 1) {
      this.routineCounter = 2; // added 1 so that NHMIS monthly can be added under routine data on the table
      // }
      //console.log(this.indicatorRelativeValues)
    },

    // getNhmisMonthlyData(indicatorRelatives) {

    //   this.nhmisMonthlyData = this.$store.state.CAR.NhmisMonthlyData; // get NHMIS Monthly data from Store
    //   console.log(this.nhmisMonthlyData, 'nhmisMonthlyData wX');
    //   let indicatorValues = [];
    //   indicatorRelatives.forEach((element) => {
    //     let index = this.nhmisMonthlyData[0].indexOf(
    //       element + " -> " + "NHMIS-DHIS2"
    //     );
    //     let latestData = this.nhmisMonthlyData.slice(-36); // get the latest data for 36 states;
    //     let curentNationalData = latestData.filter(
    //       (val) => val[1] == this.selectedState
    //     ); // "this.selectedState"
    //     if (curentNationalData[0] !== undefined) {
    //       let curentNationalDataForIndicator = curentNationalData[0][index];
    //       // get the current date of the indicator value
    //       let currentDate = curentNationalData[0][0].split("T")[0];
    //       let dataDate = currentDate;
    //       indicatorValues.push({
    //         value: curentNationalDataForIndicator,
    //         date: dataDate,
    //       });
    //     }
    //   });
    //   console.log(indicatorValues, 'nhmisMonthlyData w');
    //   return indicatorValues;

    // },

    getNigeriaRow: function getNigeriaRow(data) {
      var _this7 = this;

      return data.find(function (row) {
        return row.some(function (cell) {
          return typeof cell === "string" && cell.trim() === _this7.NhmisMonthlySelectedState;
        });
      });
    },
    getNhmisMonthlyData: function getNhmisMonthlyData(indicatorRelatives) {
      var nhmisMonthlyData = this.$store.state.CAR.NhmisMonthlyData; // Get NHMIS Monthly data from store
      // console.log(nhmisMonthlyData, "nhmisMonthlyData wX");

      if (!nhmisMonthlyData || nhmisMonthlyData.length === 0) {
        return []; // Return early if no data is available
      }

      var latestData = nhmisMonthlyData.slice(-36); // Get the latest data for 36 states
      // const stateData = latestData.find((val) => val[1] === this.selectedState); // Get data for the selected state
      // console.log(stateData, "stateData");
      var stateData = this.getNigeriaRow(latestData);

      if (!stateData) {
        return []; // Return early if no data for the selected state
      }

      var indicatorValues = indicatorRelatives.map(function (element) {
        var index = nhmisMonthlyData[0].indexOf(element + " -> NHMIS-DHIS2");
        if (index === -1) {
          return null; // Skip if indicator is not found
        }

        var value = stateData[index];
        var date = stateData[0].split("T")[0]; // Extract the date

        return { value: value, date: date };
      }).filter(Boolean); // Remove null values

      return indicatorValues;
    },


    /**
     * Gets the short name for each indicator clicked and then runs this.dataSourceClicked() using the first data source
     * in this.availableSources array
     */
    viewMetadata: function viewMetadata(fieldVal) {
      var shortNames = this.$store.state.CAR.shortIndicatorNames;
      for (var i in shortNames) {
        if (shortNames[i] === fieldVal) this.indicatorMetaDataToShow = i;
      }

      this.isComponentModalActive = true;
      this.dataSourceClicked(this.availableSources[0]); // Computes meta data info for the first available source
    },
    dataSourceClicked: function dataSourceClicked(i) {
      var _this8 = this;

      this.computeMetaData();
      this.sourceIndicatorInfo = {};
      this.dataAvailable = {
        National: "grey",
        State: "grey",
        Senatorial: "grey",
        Zonal: "grey",
        LGA: "grey"
      };

      this.isActive = i;
      this.dataSourceName = i;

      var dataAvailable = this.indicatorInfo[i + " - dataAvailable"].replace(/\s/g, "");
      var dataAvailable = dataAvailable.split(",");

      dataAvailable.map(function (elem) {
        _this8.dataAvailable[elem] = "green"; //change the value in the gloabal dataAvailable object
      });

      this.sourceIndicatorInfo.name = this.indicatorInfo[i + " - name"];
      this.sourceIndicatorInfo.numerator = this.indicatorInfo[i + " - numerator"];
      this.sourceIndicatorInfo.denominator = this.indicatorInfo[i + " - denominator"];
      this.sourceIndicatorInfo.frequency = this.indicatorInfo[i + " - frequency"];
      this.sourceIndicatorInfo.definition = this.indicatorInfo[i + " - definition"];
      this.sourceIndicatorInfo.shortName = this.indicatorInfo["shortName"];
      this.sourceIndicatorInfo.multiplier = this.indicatorInfo["multiplierFactor"];
      this.sourceIndicatorInfo.type = this.indicatorInfo["type"];

      this.selectedDescription = this.$store.getters.getDataSourceDescriptions(this.dataSourceName);
      this.selectedTargetGroup = this.$store.getters.getTargetGroups(this.dataSourceName);
      this.selectedSampledHouseholdData = this.$store.getters.getSampledHouseholdData(this.dataSourceName);
    },

    //Determine the meta-data to use in the info modal
    computeMetaData: function computeMetaData() {
      var _this9 = this;

      this.indicatorInfo = [];
      this.indicatorMetaData.map(function (elem) {
        if (_this9.indicatorMetaDataToShow === elem[1]) {
          _this9.indicatorInfo[elem[0] + " - name"] = elem[2];
          _this9.indicatorInfo[elem[0] + " - numerator"] = elem[3];
          _this9.indicatorInfo[elem[0] + " - denominator"] = elem[4];
          _this9.indicatorInfo[elem[0] + " - frequency"] = elem[5];
          _this9.indicatorInfo[elem[0] + " - definition"] = elem[7];
          _this9.indicatorInfo[elem[0] + " - dataAvailable"] = elem[8];
        }
      });
      this.meta_data.map(function (elem, index) {
        if (_this9.indicatorMetaDataToShow == elem[0]) {
          _this9.indicatorInfo["shortName"] = elem[1];
          _this9.indicatorInfo["multiplierFactor"] = elem[2];
          _this9.indicatorInfo["type"] = elem[5];
        }
      });
    },
    viewSourceMetadata: function viewSourceMetadata(theSource) {
      this.datasingle = theSource;
      this.datafull = this.sourceMetaData;
      //console.log(this.srcData);

      //   for (var i = 0; i < this.sourceMetaData.length; i++) {
      //     if (theSource == this.sourceMetaData[i][0]) {
      //       this.sourceInfo.name = this.sourceMetaData[i][0];
      //       this.sourceInfo.fullName = this.sourceMetaData[i][1];
      //       this.sourceInfo.description = this.sourceMetaData[i][2];
      //       this.sourceInfo.available = this.sourceMetaData[i][3];
      //       this.sourceInfo.nextAvailable = this.sourceMetaData[i][4];
      //       this.sourceInfo.links = this.sourceMetaData[i][5].replace(/\s+/g, '').split(',');
      //       // this.sourceInfo.links = this.sourceMetaData[i][5];
      //       this.sourceInfo.method = this.sourceMetaData[i][6];
      //       this.sourceInfo.subNatVal = this.sourceMetaData[i][7];
      //       // console.log(this.sourceMetaData[i][5]);

      //       var check1 = this.sourceMetaData[i][5];
      //       var check2 = check1.split(',');

      //       // console.log(check2);

      //       // var check3 = check2.split(' ');

      //       this.firstLink = check2;
      //       this.linkFirst = this.firstLink;
      //       // console.log(this.firstLink);

      //     }
      //   }

      this.isSourceMetaModalActive = true;
    },
    tableSourceClicked: function tableSourceClicked(source) {
      this.$store.dispatch("storeSourceClicked", source);
      // console.log(source);
      if (source !== "NHMIS-DHIS2") {
        this.showToggle = false;
      } else {
        this.showToggle = true;
      }
      __WEBPACK_IMPORTED_MODULE_12__main_js__["eventBus"].$emit("chartToggleEvent", this.showToggle);
      var yr;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.ndOptionsArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          //console.log(item.split(":"));
          var opt = item.split(":");
          if (opt[0] == source) {
            yr = opt[1];
            //console.log(yr);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.selectedSource = source;
      //this.selectedYear = yr;
      this.ndSelected = this.selectedSource + ":" + this.selectedYear;
      //this.ndSelectedOption();

      //Remove background color for other sources
      var tableSources = document.querySelectorAll(".table_sources");
      tableSources.forEach(function (sources, index) {
        // if (sources.style.background === "rgb(39, 81, 80)") {
        sources.childNodes[2].style.background = "#41918e";
        sources.childNodes[2].style.fill = "#DDD";
        sources.style.background = "";
        sources.style.color = "#333";
        // }
      });

      //Add background and text color to selected source
      var tableSource = document.getElementById(source);
      var table = document.getElementById("source_table");

      if (tableSource.id === "NHMIS-DHIS2") {
        tableSource.childNodes[2].style.background = "#DDD";
        tableSource.childNodes[2].style.fill = "#41918e";
        tableSource.style.background = "rgb(54, 117, 116)";
        tableSource.style.color = "#FFF";
        table.rows[2].cells[2].style.background = "rgb(54, 117, 116)";
        table.rows[2].cells[2].style.borderBottomColor = "rgb(54, 117, 116)";
        table.rows[1].cells[2].style.borderBottomColor = "rgb(54, 117, 116)";
      } else {
        tableSource.childNodes[2].style.background = "#DDD";
        tableSource.childNodes[2].style.fill = "#41918e";
        tableSource.style.background = "#41918e";
        tableSource.style.color = "#FFF";
        table.rows[2].cells[2].style.background = "#41918e";
        table.rows[2].cells[2].style.borderBottomColor = "#DDD";
        table.rows[1].cells[2].style.borderBottomColor = "#DDD";
      }

      // ---FORMER CODE----///

      //Remove background color for other sources
      // let tableSources = document.querySelectorAll(".table_sources");
      // tableSources.forEach((sources, index) => {
      //   if (sources.style.background === "rgb(39, 81, 80)") {
      //     sources.childNodes[2].style.background = "#275150";
      //     sources.childNodes[2].style.fill = "#DDD";
      //     sources.style.background = "";
      //     sources.style.color = "#333";
      //   }
      // });

      //Add background and text color to selected source
      // let tableSource = document.getElementById(source);
      // tableSource.childNodes[2].style.background = "#DDD";
      // tableSource.childNodes[2].style.fill = "#275150";
      // tableSource.style.background = "#275150";
      // tableSource.style.color = "#FFF";

      // ---FORMER CODE END-----////
    },
    confirmUncertaintyData: function confirmUncertaintyData() {
      var _this10 = this;

      this.isUncertaintyAvailable = {};
      // var data = this.estimatesData.slice(0);
      var data = this.uncertaintyData.slice(0);
      this.sourceList.map(function (source, index) {
        var indicatorWithSource = _this10.selectedIndicator + " -> " + source;
        var indicatorNameArray = data[0];
        var indexOfIndicator = indicatorNameArray.indexOf(indicatorWithSource);
        if (indexOfIndicator > -1) {
          _this10.isUncertaintyAvailable[source] = true;
        }
      });
    },
    plotUncertainty: function plotUncertainty(truthVal, source, index) {
      this.dataSourceUncertainty[index].uncertainty = !this.dataSourceUncertainty[index].uncertainty;
      this.$emit("toggleClicked", [this.dataSourceUncertainty[index].uncertainty, source]);
    },
    handleScroll: function handleScroll() {
      var mq = window.matchMedia("(max-width: 700px)");
      if (mq.matches) {
        if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
          document.getElementById("scrollLeft").style.display = "none";
          document.getElementById("scrollRight").style.display = "none";
        } else {
          document.getElementById("scrollRight").style.display = "block";
        }
      }
    },
    getIndicators: function getIndicators() {
      var programAreasToIndicators = this.$store.state.CAR.programAreasToIndicators;
      var options = [],
          temp = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(programAreasToIndicators).map(function (elem, index) {
        temp.programArea = elem;
        temp.indicators = [];
        var tempName = {};
        programAreasToIndicators[elem].forEach(function (element) {
          temp.indicators.push({
            name: element
          });
        });
        options.push(temp);
        temp = {};
      });
      // this.options = options;
      this.optionIndicators = options;
    },
    multiselectSearch: function multiselectSearch() {
      this.collapsible = false;
    },
    openedMultiselect: function openedMultiselect() {
      //this.multiselectPlaceholder = 'Search Indicator';
      this.collapsible = true;
    },
    closedMultiselect: function closedMultiselect(e, index) {
      this.multiselectPlaceholder[index] = e;

      this.collapsible = true;
    },
    multiselectPlaceholderM: function multiselectPlaceholderM(e) {
      if (e >= 0) {
        var placeholder = this.selectIndicatorRelative[e].name;
        return placeholder;
      }
    }
  }, "getDS", function getDS() {
    var result = [];
    var DSMeta = JSON.parse(this.$ls.get("source_meta_dataset"));
    var DSMeta2 = DSMeta.slice(1);
    DSMeta2.map(function (el) {
      result.push([el[0] + " : " + el[1]]);
    });
    // get the sourcelist data
    var ds = DSMeta2.map(function (el) {
      return el[0];
    });
    this.sourceList = ds;

    // get the datasource fullnames data
    var dsFullNames = result.map(function (el) {
      return el.map(function (keyVal) {
        return keyVal.split(":").map(function (_) {
          return _.trim();
        });
      }).reduce(function (accumulator, currentValue) {
        accumulator[currentValue[0]] = currentValue[1];
        return accumulator;
      }, {});
    });

    this.sourceFullName = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(dsFullNames)));

    // get classifications
    var results = [];
    DSMeta2.map(function (el) {
      results.push([el[0] + " : " + el[8]]);
    });

    var reOrderedDs = results.filter(function (el) {
      if (el[0].split(":")[0].trim() !== "NHMIS-DHIS2") {
        return el;
      }
    });
    reOrderedDs.unshift(["NHMIS-DHIS2 : Routine"]);

    var dsClassification = reOrderedDs.map(function (el) {
      return el.map(function (keyVal) {
        return keyVal.split(":").map(function (_) {
          return _.trim();
        });
      }).reduce(function (accumulator, currentValue) {
        accumulator[currentValue[0]] = currentValue[1];
        return accumulator;
      }, {});
    });

    this.dataSourceClass = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(dsClassification)));
  }),
  updated: function updated() {},

  computed: {
    /**
     * Sets the selected indicator based on the value gotten from car.js
     * and gets the short name for the selected indicator
     */
    indicatorSelected: function indicatorSelected() {
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;
      var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
      return __WEBPACK_IMPORTED_MODULE_9__assets_js_on_strlimit___default()(temp, 80);
    },

    // Return the selected state from the store
    stateSelected: function stateSelected() {
      this.selectedState = this.$store.getters.getSelectedState;
      return this.selectedState;
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var indicatorRelatives;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // this.getDS()
              // eventBus.$on("selectedYear", (data) => {
              //   this.selectedYear = data
              //   this.ndSelectedOption();
              // })
              // eventBus.$on("computeNd", data => {
              //   this.selectedYear = data;
              //   //console.log(data)
              //   this.ndSelected = `${this.selectedSource}:${data}`;
              //   this.ndSelectedOption();
              //   //console.log(this.selectedYear);
              // });
              _this11.selectedSource = "NHMIS-DHIS2";
              //console.log(this.indicatorMetaData)
              // this.selectedSource = "NHMIS"
              //  this.selectedIndicator = "Skilled attendance at delivery or birth"
              //  this.selectedState = "National"
              // await this.getDS();
              _context4.next = 3;
              return _this11.getIdb();

            case 3:
              _this11.lsNdStateData = _context4.sent;

              _this11.lsNdLgaData = JSON.parse(_this11.$ls.get("nd_lga_data"));

              //console.log(this.lsNdLgaData)
              _this11.ndSelectedOption();
              //eventbus from columnchart.vue
              __WEBPACK_IMPORTED_MODULE_12__main_js__["eventBus"].$on("ndOptionsEvent", function (data) {
                _this11.ndOptions = data;
                //maps through ndOptions and returns source:year
                _this11.ndOptionsArray = _this11.ndOptions.map(function (val) {
                  return val.years[0].name;
                });
                //console.log(this.ndOptionsArray);
              });

              /*listen to SelectedSource been fired from barChartComponent*/
              __WEBPACK_IMPORTED_MODULE_12__main_js__["eventBus"].$on("barSourceEvent", function (data) {
                // this.tableSourceClicked(data);
                // if (data == 'NHMIS') this.showToggle = true
                // else this.showToggle = false
                _this11.$store.dispatch("storeSourceClicked", data);
              });

              if (_this11.appData) {
                _this11.sourceClass = _this11.getAvailbleSourcesByIndicator(_this11.selectedIndicator, _this11.selectedState)[0];
                _this11.availableSources = _this11.getAvailbleSourcesByIndicator(_this11.selectedIndicator, _this11.selectedState)[1];
                _this11.indicatorRelativesObject = _this11.$store.state.CAR.indicatorsAndRelative;
                indicatorRelatives = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], _this11.indicatorRelativesObject[_this11.selectedIndicator]);

                indicatorRelatives.unshift(_this11.selectedIndicator);
                _this11.computeTableData(indicatorRelatives);
                _this11.confirmUncertaintyData();
                _this11.$store.dispatch("storeSourceClicked", _this11.availableSources);
                _this11.$store.dispatch("storeMultipleSourceData", {
                  list: _this11.lsData
                });
                _this11.getIndicators();
              }

              window.addEventListener("scroll", _this11.handleScroll);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this11);
    }))();
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },


  watch: {
    selectedIndicator56: function selectedIndicator56(val) {
      this.selectedIndicator = this.ndSelectedOption();
      this.ndSelectedOption();
    },
    selectedYear: function selectedYear(val) {
      if (val == undefined || val == "2021") {
        this.numerator = "Unavailable";
        this.denominator = "Unavailable";
        this.numValue = "";
        this.denValue = "";
      }

      //this.ndSelectedOption();
      this.ndSelected = "" + this.selectedSource + ":" + val;
      // this.ndSelectedOption();
    },
    ndSelected: function ndSelected(val) {
      //console.log(val);
      this.ndYear = val.split(":");
      //console.log(this.ndYear);

      this.selectedYear = this.ndYear[1];
      this.selectedSource = this.ndYear[0];
      this.selectedIndicator = this.$store.getters.getSelectedIndicator;
      // this.tableSourceClicked(this.selectedSource);
      this.ndSelectedOption();
    },
    selectedSource: function selectedSource(val) {
      this.ndSelectedOption();
      //this.ndSelected = `${val}:${this.selectedYear}`;
    },
    selectedIndicator: function selectedIndicator(val) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var indicatorRelatives, tableSources;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // await this.getDS();
                _this12.ndSelectedOption();
                if (_this12.appData) {
                  _this12.sourceClass = _this12.getAvailbleSourcesByIndicator(val, _this12.selectedState)[0];
                  _this12.availableSources = _this12.getAvailbleSourcesByIndicator(val, _this12.selectedState)[1];
                  _this12.$store.dispatch("storeSourceClicked", _this12.availableSources);
                  _this12.indicatorRelativesObject = _this12.$store.state.CAR.indicatorsAndRelative;
                  indicatorRelatives = [];

                  indicatorRelatives = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], _this12.indicatorRelativesObject[val]);
                  indicatorRelatives.unshift(val);

                  _this12.computeTableData(indicatorRelatives);
                  // Change multiselect v-model
                  _this12.selectIndicatorRelative = [];
                  indicatorRelatives.map(function (el, i) {
                    if (i > 0) {
                      _this12.selectIndicatorRelative.push({
                        name: el
                      });
                    }
                  });
                  _this12.ndSelectedOption();
                  _this12.confirmUncertaintyData();
                }
                //Remove background color for all sources
                tableSources = document.querySelectorAll(".table_sources");

                tableSources.forEach(function (sources, index) {
                  if (sources.style.background === "rgb(65, 145, 142)") {
                    sources.childNodes[2].style.background = "#41918E";
                    sources.childNodes[2].style.fill = "#DDD";
                    sources.style.background = "";
                    sources.style.color = "#333";
                  }
                });
                _this12.showToggle = false;

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this12);
      }))();
    },
    selectIndicatorRelative: function selectIndicatorRelative(name) {
      var indicatorRelatives = [];
      name.map(function (relative, index) {
        indicatorRelatives.push(relative.name);
      });
      indicatorRelatives.unshift(this.selectedIndicator);
      // console.log(indicatorRelatives);
      this.computeTableData(indicatorRelatives);
    },
    uncertaintyData: function uncertaintyData(val) {
      // this.estimatesData = val;
      this.uncertaintyData = val;
    },
    meta_data: function meta_data(val) {
      this.meta_data = val;
    },
    sourceMetaData: function sourceMetaData(val) {
      this.sourceMetaData = val;
    },
    appData: function appData(val) {
      if (val) {
        this.lsData = val;
        this.sourceClass = this.getAvailbleSourcesByIndicator(this.selectedIndicator, this.selectedState)[0];
        this.availableSources = this.getAvailbleSourcesByIndicator(this.selectedIndicator, this.selectedState)[1];
        this.indicatorRelativesObject = this.$store.state.CAR.indicatorsAndRelative;
        var indicatorRelatives = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], this.indicatorRelativesObject[this.selectedIndicator]);
        indicatorRelatives.unshift(this.selectedIndicator);
        this.computeTableData(indicatorRelatives);
        this.confirmUncertaintyData();
        this.$store.dispatch("storeSourceClicked", this.availableSources);
        this.$store.dispatch("storeMultipleSourceData", {
          list: this.lsData
        });
        this.getIndicators();
      }
      this.ndSelectedOption();
    },
    selectedState: function selectedState(val) {
      if (this.appData) {
        this.sourceClass = this.getAvailbleSourcesByIndicator(this.selectedIndicator, val)[0];
        this.availableSources = this.getAvailbleSourcesByIndicator(this.selectedIndicator, val)[1];
        this.indicatorRelativesObject = this.$store.state.CAR.indicatorsAndRelative;
        var indicatorRelatives = [];
        indicatorRelatives = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], this.indicatorRelativesObject[this.selectedIndicator]);
        indicatorRelatives.unshift(this.selectedIndicator);

        this.computeTableData(indicatorRelatives);
        this.ndSelectedOption();
      }
      this.ndSelectedOption();
    }
  }
});

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(824);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {(function () {
  "use strict";

  function btoa(str) {
    var buffer;

    if (str instanceof Buffer) {
      buffer = str;
    } else {
      buffer = Buffer.from(str.toString(), 'binary');
    }

    return buffer.toString('base64');
  }

  module.exports = btoa;
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5).Buffer))

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(890);
module.exports = __webpack_require__(8).Object.values;


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(65);
var toIObject = __webpack_require__(34);
var isEnum = __webpack_require__(90).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(17);
var $values = __webpack_require__(889)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "div[class^=col][data-v-276c3ccc]{padding-left:7px;padding-right:7px}.rowlTop[data-v-276c3ccc]{margin-bottom:-30px!important}.rowlBot[data-v-276c3ccc]{margin-top:-30px!important}span#span-extra[data-v-276c3ccc]{background-color:#222;border-radius:50%;display:inline-block;width:12px;height:12px}.noSubDataMockUp[data-v-276c3ccc]{top:21%}.infoi[data-v-276c3ccc],.noSubDataMockUp[data-v-276c3ccc]{width:55%;height:50%;position:absolute;left:25%;text-align:center;font-size:13px;font-weight:200;padding:4%}.infoi[data-v-276c3ccc]{top:22%;border-style:groove}p#imp[data-v-276c3ccc]{display:none;font-size:12px;font-weight:600;font-family:Open Sans,sans-serif;color:#333}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/barChartComponent.vue"],"names":[],"mappings":"AACA,iCACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACE,6BAAgC,CACjC,AACD,0BACE,0BAA6B,CAC9B,AACD,iCACE,sBAA0B,AAC1B,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,WAAa,CACd,AACD,kCAIE,OAAS,CAQV,AACD,0DAZE,UAAW,AACX,WAAY,AACZ,kBAAmB,AAEnB,SAAU,AAEV,kBAAmB,AAEnB,eAAgB,AAChB,gBAAiB,AACjB,UAAY,CAcb,AAZD,wBAIE,QAAS,AAIT,mBAAqB,CAItB,AACD,uBACE,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,iCAAqC,AACrC,UAAe,CAChB","file":"barChartComponent.vue","sourcesContent":["\ndiv[class^=\"col\"][data-v-276c3ccc] {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n.rowlTop[data-v-276c3ccc] {\n  margin-bottom: -30px !important;\n}\n.rowlBot[data-v-276c3ccc] {\n  margin-top: -30px !important;\n}\nspan#span-extra[data-v-276c3ccc] {\n  background-color: #222222;\n  border-radius: 50%;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n}\n.noSubDataMockUp[data-v-276c3ccc] {\n  width: 55%;\n  height: 50%;\n  position: absolute;\n  top: 21%;\n  left: 25%;\n  /* border:10px 2; */\n  text-align: center;\n\n  font-size: 13px;\n  font-weight: 200;\n  padding: 4%;\n}\n.infoi[data-v-276c3ccc] {\n  width: 55%;\n  height: 50%;\n  position: absolute;\n  top: 22%;\n  left: 25%;\n  /* border:10px 2; */\n  text-align: center;\n  border-style: groove;\n  font-size: 13px;\n  font-weight: 200;\n  padding: 4%;\n}\np#imp[data-v-276c3ccc] {\n  display: none;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: \"Open Sans\", sans-serif;\n  color: #333333;\n}\n\n/* Some styles live in App.vue file*/\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "div[class^=col][data-v-327c1a3c]{padding-left:7px;padding-right:7px}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/chartTypes/line.vue"],"names":[],"mappings":"AACA,iCAAmC,iBAAiB,AAAC,iBAAkB,CACtE","file":"line.vue","sourcesContent":["\ndiv[class^=\"col\"][data-v-327c1a3c]{padding-left:7px; padding-right:7px;\n}\n /* Some styles live in App.vue file*/\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "div[class^=col][data-v-3afc5964]{padding-left:7px;padding-right:7px}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/lineChart.vue"],"names":[],"mappings":"AACA,iCACE,iBAAkB,AAClB,iBAAmB,CACpB","file":"lineChart.vue","sourcesContent":["\ndiv[class^=\"col\"][data-v-3afc5964] {\n  padding-left: 7px;\n  padding-right: 7px;\n}\n\n/* Some styles live in App.vue file*/\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"states.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, ".mid-align[data-v-520a7422]{position:absolute;top:20%;left:12.5%}.mid-alignl[data-v-520a7422]{position:absolute;top:25%;left:12.5%}div#browserSupport[data-v-520a7422]{position:fixed;margin:5px 5px 0 0;background-color:#fff3cd;color:#583e03;top:0;border:.5px solid #583e03;font-size:12px;-webkit-box-shadow:-3px 5px 10px #00000029;box-shadow:-3px 5px 10px #00000029;right:0;border-radius:5px;z-index:900}div#browserSupport img[data-v-520a7422]{width:34px;height:30px}.alertBold[data-v-520a7422]{color:#583e03}div[class^=col][data-v-520a7422]{padding-left:7px;padding-right:7px}div[class^=row][data-v-520a7422]{padding-left:-3px;padding-right:-3px}.rowlTop[data-v-520a7422]{margin-bottom:-30px!important}.rowlBot[data-v-520a7422]{margin-top:-30px!important}.fade-enter-active[data-v-520a7422],.fade-leave-active[data-v-520a7422]{-webkit-transition:opacity .3s;transition:opacity .3s}.fade-enter[data-v-520a7422],.fade-leave-to[data-v-520a7422]{opacity:0}#toptab>li:nth-child(5)>a[data-v-520a7422]{background-color:#007d53!important;color:#fff!important}#toptab>li:first-child > a[data-v-520a7422],#toptab>li:nth-child(2)>a[data-v-520a7422],#toptab>li:nth-child(3)>a[data-v-520a7422],#toptab>li:nth-child(4)>a[data-v-520a7422]{background-color:#275150!important;color:#fff!important}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/MainCarDashboard.vue"],"names":[],"mappings":"AACA,4BACE,kBAAmB,AACnB,QAAS,AACT,UAAY,CACb,AACD,6BACE,kBAAmB,AACnB,QAAS,AACT,UAAY,CACb,AACD,oCACE,eAAgB,AAChB,mBAAoB,AACpB,yBAA0B,AAC1B,cAAe,AACf,MAAO,AACP,0BAA4B,AAC5B,eAAgB,AAChB,2CAA4C,AACpC,mCAAoC,AAC5C,QAAS,AACT,kBAAmB,AACnB,WAAa,CACd,AACD,wCACE,WAAY,AACZ,WAAa,CACd,AACD,4BACE,aAAe,CAChB,AACD,iCACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,iCACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,0BACE,6BAAgC,CACjC,AACD,0BACE,0BAA6B,CAC9B,AAED,wEAEE,+BAAiC,AACjC,sBAAyB,CAC1B,AACD,6DACE,SAAW,CACZ,AACD,2CACE,mCAAsC,AACtC,oBAAyB,CAC1B,AAaD,6KACE,mCAA8C,AAC9C,oBAAyB,CAC1B","file":"MainCarDashboard.vue","sourcesContent":["\n.mid-align[data-v-520a7422] {\n  position: absolute;\n  top: 20%;\n  left: 12.5%;\n}\n.mid-alignl[data-v-520a7422] {\n  position: absolute;\n  top: 25%;\n  left: 12.5%;\n}\ndiv#browserSupport[data-v-520a7422] {\n  position: fixed;\n  margin: 5px 5px 0 0;\n  background-color: #fff3cd;\n  color: #583e03;\n  top: 0;\n  border: 0.5px solid #583e03;\n  font-size: 12px;\n  -webkit-box-shadow: -3px 5px 10px #00000029;\n          box-shadow: -3px 5px 10px #00000029;\n  right: 0;\n  border-radius: 5px;\n  z-index: 900;\n}\ndiv#browserSupport img[data-v-520a7422] {\n  width: 34px;\n  height: 30px;\n}\n.alertBold[data-v-520a7422] {\n  color: #583e03;\n}\ndiv[class^=\"col\"][data-v-520a7422] {\n  padding-left: 7px;\n  padding-right: 7px;\n}\ndiv[class^=\"row\"][data-v-520a7422] {\n  padding-left: -3px;\n  padding-right: -3px;\n}\n.rowlTop[data-v-520a7422] {\n  margin-bottom: -30px !important;\n}\n.rowlBot[data-v-520a7422] {\n  margin-top: -30px !important;\n}\n/* Some styles live in App.vue file*/\n.fade-enter-active[data-v-520a7422],\n.fade-leave-active[data-v-520a7422] {\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n.fade-enter[data-v-520a7422], .fade-leave-to[data-v-520a7422] /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n#toptab > li:nth-child(5) > a[data-v-520a7422] {\n  background-color: #007d53 !important ;\n  color: white !important ;\n}\n#toptab > li:nth-child(4) > a[data-v-520a7422] {\n  background-color: rgb(39, 81, 80) !important ;\n  color: white !important ;\n}\n#toptab > li:nth-child(3) > a[data-v-520a7422] {\n  background-color: rgb(39, 81, 80) !important ;\n  color: white !important ;\n}\n#toptab > li:nth-child(2) > a[data-v-520a7422] {\n  background-color: rgb(39, 81, 80) !important ;\n  color: white !important ;\n}\n#toptab > li:nth-child(1) > a[data-v-520a7422] {\n  background-color: rgb(39, 81, 80) !important ;\n  color: white !important ;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border-color:#41b883 transparent transparent;border-style:solid;border-width:2px;-webkit-box-shadow:0 0 0 1px transparent;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{-webkit-animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.multiselect__spinner:after{-webkit-animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{-webkit-transition:opacity .4s ease-in-out;transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{-webkit-box-sizing:content-box;box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{-webkit-box-sizing:border-box;box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;-webkit-transition:border .1s ease;transition:border .1s ease;margin-bottom:8px;vertical-align:top}.multiselect__input,.multiselect__single,.multiselect_input{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box}.multiselect_input{border:none;outline:none;display:inline;width:50%;bottom:10px}.multiselect__input::-webkit-input-placeholder{color:#35495e}.multiselect__input:-ms-input-placeholder,.multiselect__input::-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;-webkit-transition:all .2s ease;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 12px 0;padding-right:30px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;-webkit-box-sizing:border-box;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-style:solid;border-width:5px 5px 0;border-color:#999 transparent transparent;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top;overflow:hidden}.multiselect__collapsible-group{background:#e7e7e7;color:#a6a6a6;cursor:pointer;-webkit-transition:all .2s;transition:all .2s;position:relative}.multiselect__collapsible-group:hover{background:#ccc;color:#fff}.multiselect__collapsible-toggle-icon{line-height:1;display:none;position:absolute;-webkit-box-sizing:border-box;box-sizing:border-box;width:40px;height:40px;right:0;top:0;padding:0;margin:0;text-decoration:none;text-align:center;cursor:pointer;-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease;z-index:1}.multiselect__collapsible-toggle-icon:before{position:relative;right:0;top:65%;color:#e4dede;margin-top:4px;border-style:solid;border-width:5px 5px 0;border-color:#999 transparent transparent;content:\"\"}.multiselect__collapsible-group .multiselect__collapsible-toggle-icon{display:block}.multiselect__collapsible-group .multiselect__option:after{right:30px}.multiselect__collapsible-group .multiselect__option:not(.multiselect__option--group-selected):not(.multiselect__option--highlight):after{content:attr(data-collapse);top:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px;color:#a4a4ec}.multiselect__collapsible-group.multiselect__collapsible-expanded .multiselect__option:not(.multiselect__option--highlight):not(.multiselect__option--group-selected):after{content:attr(data-expand);color:#ec9898}.multiselect__collapsible-group.multiselect__collapsible-expanded .multiselect__collapsible-toggle-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg);overflow:hidden}.multiselect__collapsible .multiselect__element{-webkit-transition:all .2s;-webkit-transition:all .15s;transition:all .15s}.collapsible-slide-toggle-enter-active,.collapsible-slide-toggle-leave-active{-webkit-transition:height .15s ease;transition:height .15s ease}.collapsible-slide-toggle-enter-active{overflow:hidden;height:40px}.collapsible-slide-toggle-enter,.collapsible-slide-toggle-leave-active{height:0;overflow:hidden}.collapsible-slide-toggle-leave{height:40px}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--group-selected{font-weight:700}.multiselect__option--group-selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled{background:#ededed;pointer-events:none}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select,.multiselect__option--disabled{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{-webkit-transition:all .15s ease;transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@-webkit-keyframes spinning{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(2turn);transform:rotate(2turn)}}@keyframes spinning{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(2turn);transform:rotate(2turn)}}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/assets/js-on/vue-multiselect/Multiselect.vue"],"names":[],"mappings":"AACA,gCACE,mBAAqB,CACtB,AACD,sBACE,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,aAAe,CAChB,AACD,yDAEE,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,SAAU,AACV,qBAAsB,AACtB,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,6CAA8C,AAC9C,mBAAoB,AACpB,iBAAkB,AAClB,yCAA0C,AAClC,gCAAkC,CAC3C,AACD,6BACE,6DAAqE,AAC7D,qDAA6D,AACrE,2CAA4C,AACpC,kCAAoC,CAC7C,AACD,4BACE,6DAAqE,AAC7D,qDAA6D,AACrE,2CAA4C,AACpC,kCAAoC,CAC7C,AACD,sEAEE,2CAA6C,AAC7C,mCAAqC,AACrC,SAAW,CACZ,AACD,+DAEE,SAAW,CACZ,AACD,sDAGE,oBAAqB,AACrB,eAAgB,AAChB,8BAA+B,AAC3B,yBAA2B,CAChC,AACD,aACE,+BAAgC,AACxB,uBAAwB,AAChC,cAAe,AACf,kBAAmB,AACnB,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,aAAe,CAChB,AACD,eACE,8BAA+B,AACvB,qBAAuB,CAChC,AACD,mBACE,YAAc,CACf,AACD,uBAEE,UAAa,CACd,AACD,qBACE,UAAY,CACb,AACD,uMAGE,4BAA6B,AAC7B,4BAA8B,CAC/B,AACD,0CACE,iCAAmC,AAC3B,wBAA2B,CACpC,AACD,qLAGE,yBAA0B,AAC1B,yBAA2B,CAC5B,AACD,yCAGE,qBAAsB,AACtB,gBAAiB,AACjB,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,gBAAiB,AACjB,kBAAmB,AACnB,WAAkB,AAClB,mCAAqC,AACrC,2BAA6B,AAG7B,kBAAmB,AACnB,kBAAoB,CACrB,AACD,4DAhBE,kBAAmB,AAWnB,8BAA+B,AACvB,qBAAuB,CAchC,AAVD,mBACE,YAAa,AACb,aAAc,AAId,eAAgB,AAChB,UAAW,AAEX,WAAa,CACd,AACD,+CACE,aAAe,CAChB,AAID,qFACE,aAAe,CAChB,AACD,iCACE,aAAe,CAChB,AACD,6EAEE,UAAY,CACb,AACD,qDAEE,oBAAsB,CACvB,AACD,qDAEE,qBAAsB,AACtB,YAAc,CACf,AACD,qBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,wBACE,cAAgB,CACjB,AACD,mBACE,gBAAiB,AACjB,cAAe,AACf,uBAAwB,AACxB,kBAAmB,AACnB,yBAA0B,AAC1B,gBAAiB,AACjB,cAAgB,CACjB,AACD,kBACE,kBAAmB,AACnB,qBAAsB,AACtB,0BAA2B,AAC3B,kBAAmB,AACnB,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,mBAAoB,AACpB,gBAAiB,AACjB,eAAgB,AAChB,sBAAwB,CACzB,AACD,uBACE,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,SAAU,AACV,gBAAiB,AACjB,kBAAoB,AACpB,WAAY,AACZ,kBAAmB,AACnB,iBAAkB,AAClB,gCAAkC,AAClC,wBAA0B,AAC1B,iBAAmB,CACpB,AACD,6BACE,cAAa,AACb,cAAe,AACf,cAAgB,CACjB,AACD,0DAEE,kBAAoB,CACrB,AACD,sEAEE,UAAa,CACd,AACD,sBAEE,gBAAiB,AAIjB,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,mBAAoB,AAGpB,kBAAmB,AACnB,wBAA0B,CAE3B,AACD,2CAfE,iBAAkB,AAElB,8BAA+B,AACvB,sBAAuB,AAC/B,cAAe,AAKf,SAAU,AACV,qBAAsB,AAGtB,cAAgB,CAqBjB,AAnBD,qBAGE,kBAAmB,AAGnB,WAAY,AACZ,YAAa,AACb,UAAW,AACX,QAAS,AACT,gBAAiB,AAGjB,kBAAmB,AAEnB,8CAAgD,AAChD,sCAAwC,AACxC,8BAAgC,AAChC,wDAA6D,CAC9D,AACD,4BACE,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,WAAY,AACZ,eAAgB,AAChB,mBAAoB,AACpB,uBAA4B,AAC5B,0CAA0D,AAC1D,UAAY,CACb,AACD,0BACE,cAAe,AACf,qBAAsB,AACtB,mBAAoB,AACpB,eAAiB,CAClB,AACD,+CACE,YAAc,CACf,AACD,8BACE,kBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,WAAY,AACZ,iBAAkB,AAClB,cAAe,AACf,yBAA0B,AAC1B,gBAAiB,AACjB,8BAA+B,AAC/B,+BAAgC,AAChC,WAAY,AACZ,gCAAkC,CACnC,AACD,sBACE,gBAAiB,AACjB,qBAAsB,AACtB,UAAW,AACX,SAAU,AACV,eAAgB,AAChB,mBAAoB,AACpB,eAAiB,CAClB,AACD,gCACE,mBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,2BAA6B,AAC7B,mBAAqB,AACrB,iBAAmB,CACpB,AACD,sCACE,gBAAoB,AACpB,UAAe,CAChB,AACD,sCACE,cAAe,AACf,aAAc,AACd,kBAAmB,AACnB,8BAA+B,AACvB,sBAAuB,AAC/B,WAAY,AACZ,YAAa,AACb,QAAS,AACT,MAAO,AACP,UAAW,AACX,SAAU,AACV,qBAAsB,AACtB,kBAAmB,AACnB,eAAgB,AAChB,8CAAgD,AAChD,sCAAwC,AACxC,8BAAgC,AAChC,yDAA6D,AAC7D,SAAW,CACZ,AACD,6CACE,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,uBAA4B,AAC5B,0CAA0D,AAC1D,UAAY,CACb,AACD,sEACE,aAAe,CAChB,AACD,2DACE,UAAY,CACb,AACD,0IAEE,4BAA6B,AAC7B,MAAO,AACP,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAChB,AACD,4KAEE,0BAA2B,AAC3B,aAAe,CAChB,AACD,wGAEE,iCAAkC,AAClC,yBAA2B,AAC3B,eAAiB,CAClB,AACD,gDACE,2BAA6B,AAC7B,4BAA8B,AAC9B,mBAAsB,CACvB,AACD,8EAEE,oCAAsC,AACtC,2BAA8B,CAC/B,AACD,uCACE,gBAAiB,AACjB,WAAa,CACd,AACD,uEAEE,SAAU,AACV,eAAiB,CAClB,AACD,gCACE,WAAa,CACd,AACD,kDACE,YAAa,AACb,4BAA6B,AAC7B,6BAA8B,AAC9B,2BAA4B,AAC5B,4BAA6B,AAC7B,mBAAoB,AACpB,4BAA8B,CAC/B,AACD,wCACE,YAAc,CACf,AACD,sBACE,aAAe,CAChB,AACD,qBACE,cAAe,AACf,aAAc,AACd,gBAAiB,AACjB,iBAAkB,AAClB,qBAAsB,AACtB,oBAAqB,AACrB,kBAAmB,AACnB,eAAgB,AAChB,kBAAoB,CACrB,AACD,2BACE,MAAO,AACP,QAAS,AACT,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACjB,AACD,gCACE,mBAAoB,AACpB,aAAc,AACd,UAAa,CACd,AACD,sCACE,0BAA2B,AAC3B,mBAAoB,AACpB,UAAa,CACd,AACD,+BACE,mBAAoB,AACpB,cAAe,AACf,eAAkB,CACnB,AACD,qCACE,4BAA6B,AAC7B,YAAc,CACf,AACD,qCACE,eAAkB,CACnB,AACD,2CACE,4BAA6B,AAC7B,YAAc,CACf,AACD,8DACE,mBAAoB,AACpB,UAAY,CACb,AACD,oEACE,mBAAoB,AACpB,4BAA6B,AAC7B,UAAY,CACb,AACD,uBACE,mBAAoB,AACpB,mBAAqB,CACtB,AAMD,wHAHE,mBAAoB,AACpB,aAAe,CAOhB,AALD,+BAGE,YAAa,AACb,mBAAqB,CACtB,AACD,4BACE,mBAAoB,AACpB,aAAe,CAChB,AACD,2DACE,mBAAoB,AACpB,UAAY,CACb,AACD,iEACE,kBAAoB,CACrB,AACD,8DACE,kBAAoB,CACrB,AACD,oEACE,mBAAoB,AACpB,UAAY,CACb,AACD,0EACE,mBAAoB,AACpB,4BAA6B,AAC7B,UAAY,CACb,AACD,oDAEE,iCAAmC,AACnC,wBAA2B,CAC5B,AACD,6CAEE,SAAW,CACZ,AACD,qBACE,kBAAmB,AACnB,iBAAkB,AAClB,qBAAsB,AACtB,kBAAoB,CACrB,AACD,uBACE,gBAAkB,CACnB,AACD,+BACE,WAAY,AACZ,QAAU,CACX,AACD,6BACE,sBAA0B,CAC3B,AACD,gCACE,gBAAkB,CACnB,AACD,qCACE,WAAY,AACZ,MAAQ,CACT,AACD,8BACE,WAAY,AACZ,SAAW,CACZ,AACD,gCACE,WAAY,AACZ,QAAU,CACX,AACD,4BACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA,AACD,oBACA,GACI,4BAA6B,AACrB,mBAAqB,CAChC,AACD,GACI,gCAAiC,AACzB,uBAAyB,CACpC,CACA","file":"Multiselect.vue","sourcesContent":["\nfieldset[disabled] .multiselect {\n  pointer-events: none;\n}\n.multiselect__spinner {\n  position: absolute;\n  right: 1px;\n  top: 1px;\n  width: 48px;\n  height: 35px;\n  background: #fff;\n  display: block;\n}\n.multiselect__spinner:before,\n.multiselect__spinner:after {\n  position: absolute;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -8px 0 0 -8px;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  border-color: #41b883 transparent transparent;\n  border-style: solid;\n  border-width: 2px;\n  -webkit-box-shadow: 0 0 0 1px transparent;\n          box-shadow: 0 0 0 1px transparent;\n}\n.multiselect__spinner:before {\n  -webkit-animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);\n          animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.multiselect__spinner:after {\n  -webkit-animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);\n          animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.multiselect__loading-enter-active,\n.multiselect__loading-leave-active {\n  -webkit-transition: opacity 0.4s ease-in-out;\n  transition: opacity 0.4s ease-in-out;\n  opacity: 1;\n}\n.multiselect__loading-enter,\n.multiselect__loading-leave-active {\n  opacity: 0;\n}\n.multiselect,\n.multiselect__input,\n.multiselect__single {\n  font-family: inherit;\n  font-size: 16px;\n  -ms-touch-action: manipulation;\n      touch-action: manipulation;\n}\n.multiselect {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  display: block;\n  position: relative;\n  width: 100%;\n  min-height: 40px;\n  text-align: left;\n  color: #35495e;\n}\n.multiselect * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.multiselect:focus {\n  outline: none;\n}\n.multiselect--disabled {\n  pointer-events: none;\n  opacity: 0.6;\n}\n.multiselect--active {\n  z-index: 50;\n}\n.multiselect--active:not(.multiselect--above) .multiselect__current,\n.multiselect--active:not(.multiselect--above) .multiselect__input,\n.multiselect--active:not(.multiselect--above) .multiselect__tags {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.multiselect--active .multiselect__select {\n  -webkit-transform: rotateZ(180deg);\n          transform: rotateZ(180deg);\n}\n.multiselect--above.multiselect--active .multiselect__current,\n.multiselect--above.multiselect--active .multiselect__input,\n.multiselect--above.multiselect--active .multiselect__tags {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.multiselect__input,\n.multiselect__single {\n  position: relative;\n  display: inline-block;\n  min-height: 20px;\n  line-height: 20px;\n  border: none;\n  border-radius: 5px;\n  background: #fff;\n  padding: 0 0 0 5px;\n  width: calc(100%);\n  -webkit-transition: border 0.1s ease;\n  transition: border 0.1s ease;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-bottom: 8px;\n  vertical-align: top;\n}\n.multiselect_input {\n  border: none;\n  outline: none;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  /* padding-top: 6px; */\n  display: inline;\n  width: 50%;\n  position: relative;\n  bottom: 10px;\n}\n.multiselect__input::-webkit-input-placeholder {\n  color: #35495e;\n}\n.multiselect__input:-ms-input-placeholder {\n  color: #35495e;\n}\n.multiselect__input::-ms-input-placeholder {\n  color: #35495e;\n}\n.multiselect__input::placeholder {\n  color: #35495e;\n}\n.multiselect__tag ~ .multiselect__input,\n.multiselect__tag ~ .multiselect__single {\n  width: auto;\n}\n.multiselect__input:hover,\n.multiselect__single:hover {\n  border-color: #cfcfcf;\n}\n.multiselect__input:focus,\n.multiselect__single:focus {\n  border-color: #a8a8a8;\n  outline: none;\n}\n.multiselect__single {\n  padding-left: 5px;\n  margin-bottom: 8px;\n}\n.multiselect__tags-wrap {\n  display: inline;\n}\n.multiselect__tags {\n  min-height: 40px;\n  display: block;\n  padding: 8px 40px 0 8px;\n  border-radius: 5px;\n  border: 1px solid #e8e8e8;\n  background: #fff;\n  font-size: 14px;\n}\n.multiselect__tag {\n  position: relative;\n  display: inline-block;\n  padding: 4px 26px 4px 10px;\n  border-radius: 5px;\n  margin-right: 10px;\n  color: #fff;\n  line-height: 1;\n  background: #41b883;\n  margin-bottom: 5px;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 100%;\n  text-overflow: ellipsis;\n}\n.multiselect__tag-icon {\n  cursor: pointer;\n  margin-left: 7px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  font-weight: 700;\n  font-style: initial;\n  width: 22px;\n  text-align: center;\n  line-height: 22px;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  border-radius: 5px;\n}\n.multiselect__tag-icon:after {\n  content: \"×\";\n  color: #266d4d;\n  font-size: 14px;\n}\n.multiselect__tag-icon:focus,\n.multiselect__tag-icon:hover {\n  background: #369a6e;\n}\n.multiselect__tag-icon:focus:after,\n.multiselect__tag-icon:hover:after {\n  color: white;\n}\n.multiselect__current {\n  line-height: 16px;\n  min-height: 40px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: block;\n  overflow: hidden;\n  padding: 8px 12px 0;\n  padding-right: 30px;\n  white-space: nowrap;\n  margin: 0;\n  text-decoration: none;\n  border-radius: 5px;\n  border: 1px solid #e8e8e8;\n  cursor: pointer;\n}\n.multiselect__select {\n  line-height: 16px;\n  display: block;\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 40px;\n  height: 38px;\n  right: 1px;\n  top: 1px;\n  padding: 4px 8px;\n  margin: 0;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  -webkit-transition: -webkit-transform 0.2s ease;\n  transition: -webkit-transform 0.2s ease;\n  transition: transform 0.2s ease;\n  transition: transform 0.2s ease, -webkit-transform 0.2s ease;\n}\n.multiselect__select:before {\n  position: relative;\n  right: 0;\n  top: 65%;\n  color: #999;\n  margin-top: 4px;\n  border-style: solid;\n  border-width: 5px 5px 0 5px;\n  border-color: #999999 transparent transparent transparent;\n  content: \"\";\n}\n.multiselect__placeholder {\n  color: #adadad;\n  display: inline-block;\n  margin-bottom: 10px;\n  padding-top: 2px;\n}\n.multiselect--active .multiselect__placeholder {\n  display: none;\n}\n.multiselect__content-wrapper {\n  position: absolute;\n  display: block;\n  background: #fff;\n  width: 100%;\n  max-height: 240px;\n  overflow: auto;\n  border: 1px solid #e8e8e8;\n  border-top: none;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  z-index: 50;\n  -webkit-overflow-scrolling: touch;\n}\n.multiselect__content {\n  list-style: none;\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  min-width: 100%;\n  vertical-align: top;\n  overflow: hidden;\n}\n.multiselect__collapsible-group {\n  background: #e7e7e7;\n  color: #a6a6a6;\n  cursor: pointer;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n  position: relative;\n}\n.multiselect__collapsible-group:hover {\n  background: #cccccc;\n  color: #ffffff;\n}\n.multiselect__collapsible-toggle-icon {\n  line-height: 1;\n  display: none;\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 40px;\n  height: 40px;\n  right: 0;\n  top: 0;\n  padding: 0;\n  margin: 0;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n  -webkit-transition: -webkit-transform 0.2s ease;\n  transition: -webkit-transform 0.2s ease;\n  transition: transform 0.2s ease;\n  transition: transform 0.2s ease, -webkit-transform 0.2s ease;\n  z-index: 1;\n}\n.multiselect__collapsible-toggle-icon:before {\n  position: relative;\n  right: 0;\n  top: 65%;\n  color: #e4dede;\n  margin-top: 4px;\n  border-style: solid;\n  border-width: 5px 5px 0 5px;\n  border-color: #999999 transparent transparent transparent;\n  content: \"\";\n}\n.multiselect__collapsible-group .multiselect__collapsible-toggle-icon {\n  display: block;\n}\n.multiselect__collapsible-group .multiselect__option:after {\n  right: 30px;\n}\n.multiselect__collapsible-group\n  .multiselect__option:not(.multiselect__option--group-selected):not(.multiselect__option--highlight):after {\n  content: attr(data-collapse);\n  top: 0;\n  position: absolute;\n  line-height: 40px;\n  padding-right: 12px;\n  padding-left: 20px;\n  font-size: 13px;\n  color: #a4a4ec;\n}\n.multiselect__collapsible-group.multiselect__collapsible-expanded\n  .multiselect__option:not(.multiselect__option--highlight):not(.multiselect__option--group-selected):after {\n  content: attr(data-expand);\n  color: #ec9898;\n}\n.multiselect__collapsible-group.multiselect__collapsible-expanded\n  .multiselect__collapsible-toggle-icon {\n  -webkit-transform: rotate(180deg);\n  transform: rotateZ(180deg);\n  overflow: hidden;\n}\n.multiselect__collapsible .multiselect__element {\n  -webkit-transition: all 0.2s;\n  -webkit-transition: all 0.15s;\n  transition: all 0.15s;\n}\n.collapsible-slide-toggle-enter-active,\n.collapsible-slide-toggle-leave-active {\n  -webkit-transition: height 0.15s ease;\n  transition: height 0.15s ease;\n}\n.collapsible-slide-toggle-enter-active {\n  overflow: hidden;\n  height: 40px;\n}\n.collapsible-slide-toggle-enter,\n.collapsible-slide-toggle-leave-active {\n  height: 0;\n  overflow: hidden;\n}\n.collapsible-slide-toggle-leave {\n  height: 40px;\n}\n.multiselect--above .multiselect__content-wrapper {\n  bottom: 100%;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border-bottom: none;\n  border-top: 1px solid #e8e8e8;\n}\n.multiselect__content::webkit-scrollbar {\n  display: none;\n}\n.multiselect__element {\n  display: block;\n}\n.multiselect__option {\n  display: block;\n  padding: 12px;\n  min-height: 40px;\n  line-height: 16px;\n  text-decoration: none;\n  text-transform: none;\n  position: relative;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.multiselect__option:after {\n  top: 0;\n  right: 0;\n  position: absolute;\n  line-height: 40px;\n  padding-right: 12px;\n  padding-left: 20px;\n  font-size: 13px;\n}\n.multiselect__option--highlight {\n  background: #41b883;\n  outline: none;\n  color: white;\n}\n.multiselect__option--highlight:after {\n  content: attr(data-select);\n  background: #41b883;\n  color: white;\n}\n.multiselect__option--selected {\n  background: #f3f3f3;\n  color: #35495e;\n  font-weight: bold;\n}\n.multiselect__option--selected:after {\n  content: attr(data-selected);\n  color: silver;\n}\n.multiselect__option--group-selected {\n  font-weight: bold;\n}\n.multiselect__option--group-selected:after {\n  content: attr(data-selected);\n  color: silver;\n}\n.multiselect__option--selected.multiselect__option--highlight {\n  background: #ff6a6a;\n  color: #fff;\n}\n.multiselect__option--selected.multiselect__option--highlight:after {\n  background: #ff6a6a;\n  content: attr(data-deselect);\n  color: #fff;\n}\n.multiselect--disabled {\n  background: #ededed;\n  pointer-events: none;\n}\n.multiselect--disabled .multiselect__current,\n.multiselect--disabled .multiselect__select {\n  background: #ededed;\n  color: #a6a6a6;\n}\n.multiselect__option--disabled {\n  background: #ededed;\n  color: #a6a6a6;\n  cursor: text;\n  pointer-events: none;\n}\n.multiselect__option--group {\n  background: #ededed;\n  color: #35495e;\n}\n.multiselect__option--group.multiselect__option--highlight {\n  background: #35495e;\n  color: #fff;\n}\n.multiselect__option--group.multiselect__option--highlight:after {\n  background: #35495e;\n}\n.multiselect__option--disabled.multiselect__option--highlight {\n  background: #dedede;\n}\n.multiselect__option--group-selected.multiselect__option--highlight {\n  background: #ff6a6a;\n  color: #fff;\n}\n.multiselect__option--group-selected.multiselect__option--highlight:after {\n  background: #ff6a6a;\n  content: attr(data-deselect);\n  color: #fff;\n}\n.multiselect-enter-active,\n.multiselect-leave-active {\n  -webkit-transition: all 0.15s ease;\n  transition: all 0.15s ease;\n}\n.multiselect-enter,\n.multiselect-leave-active {\n  opacity: 0;\n}\n.multiselect__strong {\n  margin-bottom: 8px;\n  line-height: 20px;\n  display: inline-block;\n  vertical-align: top;\n}\n*[dir=\"rtl\"] .multiselect {\n  text-align: right;\n}\n*[dir=\"rtl\"] .multiselect__select {\n  right: auto;\n  left: 1px;\n}\n*[dir=\"rtl\"] .multiselect__tags {\n  padding: 8px 8px 0px 40px;\n}\n*[dir=\"rtl\"] .multiselect__content {\n  text-align: right;\n}\n*[dir=\"rtl\"] .multiselect__option:after {\n  right: auto;\n  left: 0;\n}\n*[dir=\"rtl\"] .multiselect__clear {\n  right: auto;\n  left: 12px;\n}\n*[dir=\"rtl\"] .multiselect__spinner {\n  right: auto;\n  left: 1px;\n}\n@-webkit-keyframes spinning {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(2turn);\n            transform: rotate(2turn);\n}\n}\n@keyframes spinning {\nfrom {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n}\nto {\n    -webkit-transform: rotate(2turn);\n            transform: rotate(2turn);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, ".color-head[data-v-976f9cb6]{border-bottom-color:#275150!important}.color-light[data-v-976f9cb6]{border-bottom-color:#41918e!important}.border_top[data-v-976f9cb6]{border-bottom-color:#275150!important}.table_sources:hover svg[data-v-976f9cb6]{background:#fff!important;fill:#41918e!important}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/tableComponent.vue"],"names":[],"mappings":"AACA,6BACE,qCAAwC,CACzC,AACD,8BACE,qCAAwC,CACzC,AACD,6BACE,qCAAwC,CACzC,AACD,0CACE,0BAA4B,AAC5B,sBAAyB,CAC1B","file":"tableComponent.vue","sourcesContent":["\n.color-head[data-v-976f9cb6] {\n  border-bottom-color: #275150 !important;\n}\n.color-light[data-v-976f9cb6] {\n  border-bottom-color: #41918e !important;\n}\n.border_top[data-v-976f9cb6] {\n  border-bottom-color: #275150 !important;\n}\n.table_sources:hover svg[data-v-976f9cb6] {\n  background: #fff !important;\n  fill: #41918e !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"regions.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(893);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("1052b946", content, true, {});

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(895);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("4c337ee2", content, true, {});

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(899);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("7ddd28fe", content, true, {});

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(900);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("87f78540", content, true, {});

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(903);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("1a18e8e1", content, true, {});

/***/ }),

/***/ 927:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(906);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("2d07ae57", content, true, {});

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(909);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("a823a7bc", content, true, {});

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(910);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("51e7f238", content, true, {});

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
;(function() {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = (objectTypes[typeof window] && window) || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4':  '10 Technical Preview',
      '6.3':  '8.1',
      '6.2':  '8',
      '6.1':  'Server 2008 R2 / 7',
      '6.0':  'Server 2008 / Vista',
      '5.2':  'Server 2003 / XP 64-bit',
      '5.1':  'XP',
      '5.01': '2000 SP1',
      '5.0':  '2000',
      '4.0':  'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
        (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(
      os.replace(/ ce$/i, ' CE')
        .replace(/\bhpw/i, 'web')
        .replace(/\bMacintosh\b/, 'Mac OS')
        .replace(/_PowerPC\b/i, ' OS')
        .replace(/\b(OS X) [^ \d]+/i, '$1')
        .replace(/\bMac (OS X)\b/, '$1')
        .replace(/\/(\d)/, ' $1')
        .replace(/_/g, '.')
        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
        .replace(/\bx86\.64\b/gi, 'x86_64')
        .replace(/\b(Windows Phone) OS\b/, '$1')
        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
        .split(' on ')[0]
    );

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return /^(?:webOS|i(?:OS|P))/.test(string)
      ? string
      : capitalize(string);
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null
      ? capitalize(value)
      : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? typeof object[property] : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
      (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function(value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext
      ? !!nav.likeChrome
      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03b1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03b2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
      ? operaClass
      : (opera = null);

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([
      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
      'Trident',
      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
      'iCab',
      'Presto',
      'NetFront',
      'Tasman',
      'KHTML',
      'Gecko'
    ]);

    /* Detectable browser names (order is important). */
    var name = getName([
      'Adobe AIR',
      'Arora',
      'Avant Browser',
      'Breach',
      'Camino',
      'Electron',
      'Epiphany',
      'Fennec',
      'Flock',
      'Galeon',
      'GreenBrowser',
      'iCab',
      'Iceweasel',
      'K-Meleon',
      'Konqueror',
      'Lunascape',
      'Maxthon',
      { 'label': 'Microsoft Edge', 'pattern': '(?:Edge|Edg|EdgA|EdgiOS)' },
      'Midori',
      'Nook Browser',
      'PaleMoon',
      'PhantomJS',
      'Raven',
      'Rekonq',
      'RockMelt',
      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
      'SeaMonkey',
      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Sleipnir',
      'SlimBrowser',
      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
      'Sunrise',
      'Swiftfox',
      'Vivaldi',
      'Waterfox',
      'WebPositive',
      { 'label': 'Yandex Browser', 'pattern': 'YaBrowser' },
      { 'label': 'UC Browser', 'pattern': 'UCBrowser' },
      'Opera Mini',
      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
      'Opera',
      { 'label': 'Opera', 'pattern': 'OPR' },
      'Chromium',
      'Chrome',
      { 'label': 'Chrome', 'pattern': '(?:HeadlessChrome)' },
      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
      { 'label': 'IE', 'pattern': 'IEMobile' },
      { 'label': 'IE', 'pattern': 'MSIE' },
      'Safari'
    ]);

    /* Detectable products (order is important). */
    var product = getProduct([
      { 'label': 'BlackBerry', 'pattern': 'BB10' },
      'BlackBerry',
      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
      'Google TV',
      'Lumia',
      'iPad',
      'iPod',
      'iPhone',
      'Kindle',
      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
      'Nexus',
      'Nook',
      'PlayBook',
      'PlayStation Vita',
      'PlayStation',
      'TouchPad',
      'Transformer',
      { 'label': 'Wii U', 'pattern': 'WiiU' },
      'Wii',
      'Xbox One',
      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
      'Xoom'
    ]);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Alcatel': {},
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'Huawei': {},
      'Lenovo': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Oppo': {},
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 },
      'Xiaomi': { 'Mi': 1, 'Redmi': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS([
      'Windows Phone',
      'KaiOS',
      'Android',
      'CentOS',
      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
      'Debian',
      { 'label': 'DragonFly BSD', 'pattern': 'DragonFly' },
      'Fedora',
      'FreeBSD',
      'Gentoo',
      'Haiku',
      'Kubuntu',
      'Linux Mint',
      'OpenBSD',
      'Red Hat',
      'SuSE',
      'Ubuntu',
      'Xubuntu',
      'Cygwin',
      'Symbian OS',
      'hpwOS',
      'webOS ',
      'webOS',
      'Tablet OS',
      'Tizen',
      'Linux',
      'Mac OS X',
      'Macintosh',
      'Mac',
      'Windows 98;',
      'Windows '
    ]);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function(result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (
          value[product] ||
          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
        ) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function(result, guess) {
        return result || RegExp('\\b' + (
          guess.pattern || qualify(guess)
        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
            )) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function(result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result =
              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
            )) {
          // Split by forward slash and append product version if needed.
          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0]
            .replace(RegExp(pattern, 'i'), guess)
            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function(result, pattern) {
        return result || (RegExp(pattern +
          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect Android products.
    // Browsers on Android devices typically provide their product IDS after "Android;"
    // up to "Build" or ") AppleWebKit".
    // Example:
    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
    if (/\bAndroid\b/.test(os) && !product &&
        (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
      product = trim(data[1])
        // Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '')
        || null;
    }
    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    } else if (manufacturer && product) {
      product = product
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ')
        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
    }
    // Clean up Google TV.
    if ((data = /\bGoogle TV\b/.exec(product))) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
      name || (name = 'Safari');
      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
        ? ' ' + data[1].replace(/_/g, '.')
        : '');
    }
    // Detect Kubuntu.
    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
      os = 'Kubuntu';
    }
    // Detect Android browsers.
    else if ((manufacturer && manufacturer != 'Google' &&
        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
      name = 'Android Browser';
      os = /\bAndroid\b/.test(os) ? os : 'Android';
    }
    // Detect Silk desktop/accelerated modes.
    else if (name == 'Silk') {
      if (!/\bMobi/i.test(ua)) {
        os = 'Android';
        description.unshift('desktop mode');
      }
      if (/Accelerated *= *true/i.test(ua)) {
        description.unshift('accelerated');
      }
    }
    // Detect UC Browser speed mode.
    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
      description.push('speed mode');
    }
    // Detect PaleMoon identifying as Firefox.
    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
      description.push('identifying as Firefox ' + data[1]);
    }
    // Detect Firefox OS and products running Firefox.
    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
      os || (os = 'Firefox OS');
      product || (product = data[1]);
    }
    // Detect false positives for Firefox/Safari.
    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
      // Escape the `/` for Firefox 1.
      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
        // Clear name of false positives.
        name = null;
      }
      // Reassign a generic name.
      if ((data = product || manufacturer || os) &&
          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
      }
    }
    // Add Chrome version to description for Electron.
    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
      description.push('Chromium ' + data);
    }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion([
        '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
        'Version',
        qualify(name),
        '(?:Firefox|Minefield|NetFront)'
      ]);
    }
    // Detect stubborn layout engines.
    if ((data =
          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
        )) {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
      name = 'IE Mobile';
      os = 'Windows Phone 8.x';
      description.unshift('desktop mode');
      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
    }
    // Detect IE 11 identifying as other browsers.
    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
      if (name) {
        description.push('identifying as ' + name + (version ? ' ' + version : ''));
      }
      name = 'IE';
      version = data[1];
    }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (rhino) {
          try {
            version = context.require('ringo/engine').version.join('.');
            name = 'RingoJS';
          } catch(e) {
            if ((data = context.system) && data.global.system == context.system) {
              name = 'Narwhal';
              os || (os = data[0].os || null);
            }
          }
          if (!name) {
            name = 'Rhino';
          }
        }
        else if (
          typeof context.process == 'object' && !context.process.browser &&
          (data = context.process)
        ) {
          if (typeof data.versions == 'object') {
            if (typeof data.versions.electron == 'string') {
              description.push('Node ' + data.versions.node);
              name = 'Electron';
              version = data.versions.electron;
            } else if (typeof data.versions.nw == 'string') {
              description.push('Chromium ' + version, 'Node ' + data.versions.node);
              name = 'NW.js';
              version = data.versions.nw;
            }
          }
          if (!name) {
            name = 'Node.js';
            arch = data.arch;
            os = data.platform;
            version = /[\d.]+/.exec(data.version);
            version = version ? version[0] : null;
          }
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
        name = 'Adobe AIR';
        os = data.flash.system.Capabilities.os;
      }
      // Detect PhantomJS.
      else if (getClassOf((data = context.phantom)) == phantomClass) {
        name = 'PhantomJS';
        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
      }
      // Detect IE compatibility modes.
      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
        // We're in compatibility mode when the Trident version + 4 doesn't
        // equal the document mode.
        version = [version, doc.documentMode];
        if ((data = +data[1] + 4) != version[1]) {
          description.push('IE ' + version[1] + ' mode');
          layout && (layout[1] = '');
          version[1] = data;
        }
        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
      }
      // Detect IE 11 masking as other browsers.
      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
        description.push('masking as ' + name + ' ' + version);
        name = 'IE';
        version = '11.0';
        layout = ['Trident'];
        os = 'Windows';
      }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data =
          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
          /\bMinefield\b/i.test(ua) && 'a'
        )) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') +
        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
      version = version.replace(/\.[\d.]+/, '.x');
    }
    // Detect Xbox 360 and Xbox One.
    else if (/\bXbox\b/i.test(product)) {
      if (product == 'Xbox 360') {
        os = null;
      }
      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
        description.unshift('mobile mode');
      }
    }
    // Add mobile postfix.
    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
        (os == 'Windows CE' || /Mobi/i.test(ua))) {
      name += ' Mobile';
    }
    // Detect IE platform preview.
    else if (name == 'IE' && useFeatures) {
      try {
        if (context.external === null) {
          description.unshift('platform preview');
        }
      } catch(e) {
        description.unshift('embedded');
      }
    }
    // Detect BlackBerry OS version.
    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
          version
        )) {
      data = [data, /BB10/.test(ua)];
      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
      version = null;
    }
    // Detect Opera identifying/masking itself as another browser.
    // http://www.opera.com/support/kb/view/843/
    else if (this != forOwn && product != 'Wii' && (
          (useFeatures && opera) ||
          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
          (name == 'IE' && (
            (os && !/^Win/.test(os) && version > 5.5) ||
            /\bWindows XP\b/.test(os) && version > 8 ||
            version == 8 && !/\bTrident\b/.test(ua)
          ))
        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
      // When "identifying", the UA contains both Opera and the other browser's name.
      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
      if (reOpera.test(name)) {
        if (/\bIE\b/.test(data) && os == 'Mac OS') {
          os = null;
        }
        data = 'identify' + data;
      }
      // When "masking", the UA contains only the other browser's name.
      else {
        data = 'mask' + data;
        if (operaClass) {
          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
        } else {
          name = 'Opera';
        }
        if (/\bIE\b/.test(data)) {
          os = null;
        }
        if (!useFeatures) {
          version = null;
        }
      }
      layout = ['Presto'];
      description.push(data);
    }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] ||
          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
        version = null;
      }
      // Use the full Chrome version when available.
      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || (!likeChrome && !data[1])) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
        description.unshift('headless');
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
      description.unshift('desktop mode');
      name = 'Chrome Mobile';
      version = null;

      if (/\bOS X\b/.test(os)) {
        manufacturer = 'Apple';
        os = 'iOS 4.3+';
      } else {
        os = null;
      }
    }
    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
    else if (/\bSRWare Iron\b/.test(name) && !version) {
      version = getVersion('Chrome');
    }
    // Strip incorrect OS versions.
    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
        ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Ensure OS does not include the browser name.
    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
        /Browser|Lunascape|Maxthon/.test(name) ||
        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function() {
          var version = this.version;
          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (
          name && (/\bWOW64\b/i.test(ua) ||
          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
      ) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (
        os && /^OS X/.test(os.family) &&
        name == 'Chrome' && parseFloat(version) >= 39
    ) {
      os.architecture = 64;
    }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function() { return 'null'; }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if (true) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return platform;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for CommonJS support.
    forOwn(platform, function(value, key) {
      freeExports[key] = value;
    });
  }
  else {
    // Export to the global object.
    root.platform = platform;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)(module), __webpack_require__(6)))

/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window === "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,
		lastDownEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		R_SPACE = /\s+/g,
		R_FLOAT = /left|right|inline/,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,
		setTimeout = win.setTimeout,

		$ = __webpack_provided_window_dot_jQuery || win.Zepto,
		Polymer = win.Polymer,

		captureMode = false,
		passiveMode = false,

		supportDraggable = ('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/(?:Trident.*rv[ :]?11\.|msie)/i)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,

		savedInputChecked = [],
		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var _this = rootEl[expando],
					el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);
			group.revertClone = originalGroup.revertClone;

			options.group = group;
		}
	;

	// Detect support a passive mode
	try {
		window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
			get: function () {
				// `false`, because everything starts to work incorrectly and instead of d'n'd,
				// begins the page has scrolled.
				passiveMode = false;
				captureMode = {
					capture: false,
					passive: passiveMode
				};
			}
		}));
	} catch (err) {}

	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;

		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			preventOnFilter: true,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0},
			supportPointer: Sortable.supportPointer !== false
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);
		options.supportPointer && _on(el, 'pointerdown', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				preventOnFilter = options.preventOnFilter,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0]) || target,
				filter = options.filter,
				startIndex;

			_saveInputCheckedState(el);


			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			// cancel dnd if original target is content editable
			if (originalTarget.isContentEditable) {
				return;
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			if (lastDownEl === target) {
				// Ignoring duplicate `down`
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, el, startIndex);
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, el, startIndex);
						return true;
					}
				});

				if (filter) {
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				lastDownEl = target;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'all';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(evt, touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);
				_on(ownerDocument, 'selectstart', _this);
				options.supportPointer && _on(ownerDocument, 'pointercancel', _this._onDrop);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
					options.supportPointer && _on(ownerDocument, 'pointermove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}


			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
			_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Event */evt, /** Touch */touch) {
			touch = touch || (evt.pointerType == 'touch' ? evt : null);

			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					_nextTick(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, rootEl, oldIndex);
			} else {
				this._nulling();
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
				var parent = target;
				var i = touchDragOverListeners.length;

				if (target && target.shadowRoot) {
					target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
					parent = target;
				}

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var _this = this;
			var dataTransfer = evt.dataTransfer;
			var options = _this.options;

			_this._offUpEvents();

			if (activeGroup.checkPull(_this, _this, dragEl, evt)) {
				cloneEl = _clone(dragEl);

				cloneEl.draggable = false;
				cloneEl.style['will-change'] = '';

				_css(cloneEl, 'display', 'none');
				_toggleClass(cloneEl, _this.options.chosenClass, false);

				// #1143: IFrame support workaround
				_this._cloneId = _nextTick(function () {
					rootEl.insertBefore(cloneEl, dragEl);
					_dispatchEvent(_this, rootEl, 'clone', dragEl);
				});
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', _this._onTouchMove);
					_on(document, 'touchend', _this._onDrop);
					_on(document, 'touchcancel', _this._onDrop);

					if (options.supportPointer) {
						_on(document, 'pointermove', _this._onTouchMove);
						_on(document, 'pointerup', _this._onDrop);
					}
				} else {
					// Old brwoser
					_on(document, 'mousemove', _this._onTouchMove);
					_on(document, 'mouseup', _this._onDrop);
				}

				_this._loopId = setInterval(_this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(_this, dataTransfer, dragEl);
				}

				_on(document, 'drop', _this);

				// #1143: Бывает элемент с IFrame внутри блокирует `drop`,
				// поэтому если вызвался `mouseover`, значит надо отменять весь d'n'd.
				// Breaking Chrome 62+
				// _on(document, 'mouseover', _this);

				_this._dragStartId = _nextTick(_this._dragStarted);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				isMovingBetweenSortable = false,
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			if (dragEl.animated) {
				return;
			}

			moved = true;

			if (activeSortable && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						(
							(activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) &&
							group.checkPut(this, activeSortable, dragEl, evt)
						)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();

				if (putSortable !== this) {
					putSortable = this;
					isMovingBetweenSortable = true;
				}

				if (revert) {
					_cloneHide(activeSortable, true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (_ghostIsLast(el, evt))
				) {
					//assign target only if condition is true
					if (el.children.length !== 0 && el.children[0] !== ghostEl && el === evt.target) {
						target = el.lastElementChild;
					}

					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(activeSortable, isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						after = false
					;

					if (floating) {
						var elTop = dragEl.offsetTop,
							tgTop = target.offsetTop;

						if (elTop === tgTop) {
							after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
						}
						else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
							after = (evt.clientY - targetRect.top) / height > 0.5;
						} else {
							after = tgTop > elTop;
						}
						} else if (!isMovingBetweenSortable) {
						after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
					}

					var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

					if (moveVector !== false) {
						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}

						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(activeSortable, isOwner);

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				if (prevRect.nodeType === 1) {
					prevRect = prevRect.getBoundingClientRect();
				}

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(document, 'pointermove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'pointerup', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
			_off(ownerDocument, 'pointercancel', this._onDrop);
			_off(ownerDocument, 'selectstart', this);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			_cancelNextTick(this._cloneId);
			_cancelNextTick(this._dragStartId);

			// Unbind events
			_off(document, 'mouseover', this);
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

				if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
					// Remove clone
					cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
				}

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					// Drag stop event
					_dispatchEvent(this, rootEl, 'unchoose', dragEl, parentEl, rootEl, oldIndex);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {
							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, parentEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, parentEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, parentEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, parentEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =
			lastDownEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;

			savedInputChecked.forEach(function (el) {
				el.checked = true;
			});
			savedInputChecked.length = 0;
		},

		handleEvent: function (/**Event*/evt) {
			switch (evt.type) {
				case 'drop':
				case 'dragend':
					this._onDrop(evt);
					break;

				case 'dragover':
				case 'dragenter':
					if (dragEl) {
						this._onDragOver(evt);
						_globalDragOver(evt);
					}
					break;

				case 'mouseover':
					this._onDrop(evt);
					break;

				case 'selectstart':
					evt.preventDefault();
					break;
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);
			_off(el, 'pointerdown', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(sortable, state) {
		if (sortable.lastPullMode !== 'clone') {
			state = true;
		}

		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');

			if (!state) {
				if (cloneEl.state) {
					if (sortable.options.group.revertClone) {
						rootEl.insertBefore(cloneEl, nextEl);
						sortable._animate(dragEl, cloneEl);
					} else {
						rootEl.insertBefore(cloneEl, dragEl);
					}
				}
			}

			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, captureMode);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, captureMode);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, toEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = toEl || rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt, willInsertAfter) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();
		evt.willInsertAfter = willInsertAfter;

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.left + rect.width) > 5);
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		if (Polymer && Polymer.dom) {
			return Polymer.dom(el).cloneNode(true);
		}
		else if ($) {
			return $(el).clone(true)[0];
		}
		else {
			return el.cloneNode(true);
		}
	}

	function _saveInputCheckedState(root) {
		var inputs = root.getElementsByTagName('input');
		var idx = inputs.length;

		while (idx--) {
			var el = inputs[idx];
			el.checked && savedInputChecked.push(el);
		}
	}

	function _nextTick(fn) {
		return setTimeout(fn, 0);
	}

	function _cancelNextTick(id) {
		return clearTimeout(id);
	}

	// Fixed #973:
	_on(document, 'touchmove', function (evt) {
		if (Sortable.active) {
			evt.preventDefault();
		}
	});

	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index,
		nextTick: _nextTick,
		cancelNextTick: _cancelNextTick
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.7.0';
	return Sortable;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(416)))

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(927)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(972),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(969),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(961),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-276c3ccc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-327c1a3c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(920)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3afc5964",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(976),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(975),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-976f9cb6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 952:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDataLoadedFirstTime),
      expression: "!isDataLoadedFirstTime"
    }],
    staticClass: "text-xs-center justify-content-center",
    staticStyle: {
      "margin-top": "14em",
      "margin-left": "15em",
      "position": "fixed",
      "z-index": "10000"
    }
  }, [_c('v-progress-circular', {
    staticStyle: {
      "right": "20px"
    },
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "teal"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBarChart),
      expression: "showBarChart"
    }],
    staticClass: "row bg-primary"
  }, [_c('div', {
    staticClass: "col-xs-12 bg-primary barchart-head"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-12 col-lg-4 barchart-header"
  }, [_c('label', {
    staticClass: "barchart-label"
  }, [_vm._v("Distribution of\n          "), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.selectedIndicatorShortName))]), _vm._v(" across " + _vm._s(_vm.theStateName) + "\n          " + _vm._s(_vm.sourceClicked) + "\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.indicatorSelected))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-12 col-lg-8 d-flex flex-row flex-md-column justify-content-md-around",
    staticStyle: {
      "height": "auto",
      "margin": "0",
      "padding": "0"
    }
  }, [_c('multi-select', {
    staticStyle: {
      "transform": "scale(0.7)",
      "min-width": "57%"
    },
    attrs: {
      "options": _vm.sourceOptions,
      "hide-selected": false,
      "searchable": true,
      "allow-empty": false,
      "show-labels": false,
      "placeholder": ""
    },
    model: {
      value: (_vm.selectedSource),
      callback: function($$v) {
        _vm.selectedSource = $$v
      },
      expression: "selectedSource"
    }
  }), _vm._v(" "), _c('multi-select', {
    staticStyle: {
      "transform": "scale(0.7)",
      "min-width": "43%"
    },
    attrs: {
      "options": _vm.optionYear,
      "hide-selected": false,
      "searchable": true,
      "allow-empty": false,
      "show-labels": false,
      "placeholder": ""
    },
    model: {
      value: (_vm.selectedYear),
      callback: function($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBarChart),
      expression: "showBarChart"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chart-wrapper",
    staticStyle: {
      "border-top": "none",
      "border-bottom": "none",
      "border-right": "none"
    }
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [(_vm.showToggle) ? _c('div', [_c('b-switch', {
    attrs: {
      "true-value": "ON",
      "false-value": "OFF",
      "type": "is-success"
    },
    model: {
      value: (_vm.ndSwitch),
      callback: function($$v) {
        _vm.ndSwitch = $$v
      },
      expression: "ndSwitch"
    }
  }, [_c('small', {
    staticStyle: {
      "font-size": "smaller",
      "color": "black"
    }
  }, [_vm._v("\n              Show numerator data")])])], 1) : _vm._e(), _vm._v(" "), _c('highcharts', {
    ref: "highcharts",
    attrs: {
      "options": _vm.highchart_options
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Click to see target information'),
      expression: "'Click to see target information'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "targetInfo active_car_icon indicator_meta",
    on: {
      "click": function($event) {
        _vm.showTargetInfo = !_vm.showTargetInfo
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
    }
  })])]), _vm._v(" "), (_vm.nodata) ? _c('div', {
    staticClass: "infoi"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "src": "static/img/noSubnationalData.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("NO SUB-NATIONAL LEVEL DATA")]), _vm._v(" "), _c('p', [_vm._v("\n            There is no sub-national data available for the indicator, data\n            source and period you have selected. Try selecting another data\n            source or period\n          ")])]) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.showTargetInfo,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.showTargetInfo = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-title-text"
  }, [_vm._v("Information on Target Lines")]), _vm._v(" "), _c('span', {
    staticClass: "close-year-modal is-danger pull-right",
    on: {
      "click": function($event) {
        _vm.showTargetInfo = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n              National Target - " + _vm._s(_vm.nationalTarget) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(_vm.nationalTargetInfo))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("SDG Target - " + _vm._s(_vm.sdgTarget))]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(_vm.SDGTargetInfo))])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "extra small text-center",
    attrs: {
      "id": "imp"
    }
  }, [_c('span', {
    staticClass: "mr-2",
    attrs: {
      "id": "span-extra"
    }
  }), _vm._v("National Target (NT)\n        ")])
}]}

/***/ }),

/***/ 954:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-8 col-md-12 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorOptions.slice(0),
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "placeholder": _vm.indicatorMultiselectOpened ? _vm.indicatorOpenedPlaceholder : _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": true,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-12 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionSources,
      "group-select": false,
      "hide-selected": false,
      "placeholder": _vm.sourceMultiselectOpened ? _vm.sourceOpenedPlaceholder : _vm.sourcePlaceholder,
      "allow-empty": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedSourceMultiselect,
      "close": _vm.closedSourceMultiselect
    },
    model: {
      value: (_vm.selectedSource),
      callback: function($$v) {
        _vm.selectedSource = $$v
      },
      expression: "selectedSource"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('line-chart', {
    attrs: {
      "sourceClicked": _vm.sourceSelected,
      "relativeIndicator": _vm.relativeIndicator,
      "selectedIndicator": _vm.selectedIndicator.name,
      "selectedYear": _vm.selectedYear,
      "appData": _vm.appData,
      "selectedState": _vm.selectedState,
      "chartType": _vm.chartType,
      "indicatorClicked": _vm.indicatorClicked
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.expandedView,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.expandedView = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-8 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorOptions.slice(0),
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "hide-selected": false,
      "placeholder": _vm.indicatorMultiselectOpened ? _vm.indicatorOpenedPlaceholder : _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": true,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionSources,
      "group-select": false,
      "hide-selected": false,
      "placeholder": _vm.sourceMultiselectOpened ? _vm.sourceOpenedPlaceholder : _vm.sourcePlaceholder,
      "show-labels": true
    },
    on: {
      "open": _vm.openedSourceMultiselect,
      "close": _vm.closedSourceMultiselect
    },
    model: {
      value: (_vm.selectedSource),
      callback: function($$v) {
        _vm.selectedSource = $$v
      },
      expression: "selectedSource"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  })]), _vm._v(" "), _c('section', [_c('line-chart', {
    attrs: {
      "sourceClicked": _vm.sourceSelected,
      "relativeIndicator": _vm.relativeIndicator,
      "selectedIndicator": _vm.selectedIndicator.name,
      "selectedYear": _vm.selectedYear,
      "appData": _vm.appData,
      "selectedState": _vm.selectedState,
      "chartType": _vm.chartType,
      "indicatorClicked": _vm.indicatorClicked
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeExpandedBool
    }
  }, [_vm._v("CLOSE")])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 955:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.chartHasNoData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highcharts', {
    ref: "highcharts",
    attrs: {
      "options": _vm.highchart_options
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 957:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isFullscreen ? [_vm.fullscreenClass] : [],
    style: (_vm.isFullscreen ? [_vm.wrapperStyle] : []),
    on: {
      "click": function($event) {
        _vm.shadeClick($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 959:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chart-wrapper",
    attrs: {
      "id": "comparison-chart"
    }
  }, [_c('div', {
    staticClass: "chart-title"
  }, [_c('div', {
    staticClass: "col-md-12 bg-primary"
  }, [_c('div', {
    staticClass: "col-md-12 text-center car_table_header"
  }, [_c('label', {
    staticClass: "table-label",
    staticStyle: {
      "font-weight": "normal",
      "flex-basis": "80%",
      "padding-left": "15px"
    }
  }, [_vm._v("\n            Comparison of "), _c('b', [_vm._v(_vm._s(_vm.indicatorSelected))]), _vm._v(" in "), _c('b', [_vm._v(" " + _vm._s(_vm.theName) + " ")]), _vm._v("  across different data sources\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 web-features line-chart-options",
    attrs: {
      "data-step": "6",
      "data-intro": "<b>Changing Chart view</b><p>Click on your preferred chart type</p>"
    }
  }, [_c('div', {
    staticClass: "col-xs-6 line-chart-option",
    class: {
      'chart-option-selected': _vm.lineSelected
    },
    on: {
      "click": function($event) {
        _vm.changeChart('line')
      }
    }
  }, [_c('span', {}, [_vm._v("LINE")]), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("show_chart")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 line-chart-option",
    class: {
      'chart-option-selected': _vm.columnSelected
    },
    on: {
      "click": function($event) {
        _vm.changeChart('column')
      }
    }
  }, [_c('span', {}, [_vm._v("COLUMN")]), _vm._v(" "), _c('v-icon', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("bar_chart")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chart-title title_placement",
    staticStyle: {
      "background": "#DFF3F3"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "lineLabelToggle"
    }
  }, [_c('div', {
    staticClass: "hidden"
  }, [_vm._v("\n                  " + _vm._s(_vm.sourceClicked) + " " + _vm._s(_vm.stateSelected) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden"
  }, [_vm._v("\n          " + _vm._s(_vm.sourceClicked) + " " + _vm._s(_vm.stateSelected) + "\n        ")])])]), _vm._v(" "), (_vm.nhmisMonthlyAlert) ? _c('div', {
    staticStyle: {
      "border": "2px #24397D dashed",
      "border-radius": "7px",
      "margin-top": "40px",
      "margin-left": "30px",
      "margin-right": "30px",
      "background": "#F3F9FF 0% 0% no-repeat padding-box"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "padding": "7px",
      "font-family": "Open Sans"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.nhmisMonthlyAlert = false
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "120%"
    }
  }, [_vm._v("close")])], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chart-stage"
  }, [_c('div', {
    staticClass: "arrow-placement",
    attrs: {
      "data-step": "7",
      "data-intro": "<b>Downloading Charts</b><p>Click on this icon to download a chart from any section</p>"
    }
  }), _vm._v(" "), _c('highcharts', {
    ref: "highcharts",
    attrs: {
      "options": _vm.highchart_options
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "static\\img\\icons\\nhmis-analysis.svg",
      "alt": "",
      "width": "22.5px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#24397D",
      "font-weight": "600"
    }
  }, [_vm._v("For more detailed NHMIS monthly data analysis, please visit the\n          "), _c('a', {
    staticStyle: {
      "text-decoration": "underline",
      "font": "Bold 12px Open Sans",
      "letter-spacing": "0.16px",
      "color": "#24397D"
    },
    attrs: {
      "href": "https://msdat.fmohconnect.gov.ng/covid19_health_service_uptake/index.html"
    }
  }, [_vm._v("Health service uptake Dashboard.")])])
}]}

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreFeatures),
      expression: "showMoreFeatures"
    }],
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row web-features",
    staticStyle: {
      "border": "1px solid #1E70EC",
      "font-family": "'Roboto', 'Open Sans', sans-serif"
    }
  }, [_c('span', _vm._l((_vm.widgets), function(indicator_value, key) {
    return _c('div', {
      key: key,
      staticClass: "col-xs-12 col-sm-6 col-md-4"
    }, [_c('div', {
      staticClass: "panel panel-primary widget",
      attrs: {
        "id": 'widget_' + key
      }
    }, [_c('div', {
      staticClass: "panel-heading bg-primary"
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: ('drag'),
        expression: "'drag'",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "glyphicon glyphicon-stats",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pull-right widget-tools"
    })]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    })])])
  })), _vm._v(" "), _c('v-speed-dial', {
    attrs: {
      "top": false,
      "bottom": true,
      "right": true,
      "left": false,
      "fixed": false,
      "absolute": false,
      "direction": 'top',
      "open-on-hover": false,
      "transition": _vm.transition
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "indigo darken-2",
      "dark": "",
      "fab": "",
      "ripple": false
    },
    on: {
      "click": function($event) {
        _vm.addWidget()
      }
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bg-primary"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('h4', [_vm._v("\n          Micro level analysis "), _c('small', [_vm._v("create a widget to make analysis")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Indicator selection here\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Data source selection here\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Select period here\n      ")])])])
}]}

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.chartHasNoData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highmaps', {
    ref: "highmaps",
    attrs: {
      "options": _vm.options
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "main_car_dashboard"
    }
  }, [_c('fullscreen', {
    ref: "fullscreen",
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    on: {
      "change": _vm.fullscreenChange,
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    }
  }, [(_vm.firstTimeNotification) ? _c('div', {
    attrs: {
      "id": "first-load-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "first-load-content"
    }
  }, [_c('img', {
    attrs: {
      "id": "first-time-image",
      "src": "/static/img/About-Dashboard-image.png",
      "alt": "First time load",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "first-time-load-info"
    }
  }, [_c('h3', [_vm._v("Initializing...")]), _vm._v(" "), _c('p', [_vm._v("\n            Getting the platform ready for the first time takes longer, so you\n            can have seamless offline access to it later.\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartRendered),
      expression: "!isChartRendered"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDataLoadedFirstTime),
      expression: "!isDataLoadedFirstTime"
    }],
    staticClass: "text-xs-center",
    staticStyle: {
      "margin-top": "13em"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "purple"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "nav_cpanel",
    staticClass: "top_navigation_cpanel row",
    attrs: {
      "id": "nav_cpanel"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "car_top_selector_container"
    }
  }, [_c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "top_of_page"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 title_placement",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('h4', [_vm._v("ANALYSIS OF KEY HEALTH INDICATORS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-7 top-navbar"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 compare-multiselect"
  }, [_c('label', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.multiselectPlaceholderComputed))]), _vm._v(" "), _c('span', {}, [_c('multi-select', {
    attrs: {
      "data-step": "2",
      "data-intro": "<b>Select Indicator</b><p>You can select a health indicator by clicking on this drop-down menu</p>",
      "options": _vm.optionIndicators,
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "show-labels": true,
      "group-collapsible": _vm.collapsible,
      "group-collapsible-expanded": false,
      "allow-empty": false,
      "placeholder": _vm.multiselectPlaceholder,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "close": function($event) {
        _vm.closedMultiselect(_vm.selectedIndicator.name)
      },
      "open": _vm.openedMultiselect,
      "search-change": _vm.multiselectSearch
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "data-step": "3",
      "data-position": "left",
      "data-intro": "<b>Select Location </b><p>Click here to select your desired location from the drop-down menu</p>",
      "options": _vm.optionStates,
      "hide-selected": false,
      "searchable": true,
      "allow-empty": false,
      "show-labels": false,
      "placeholder": _vm.statePlaceholder
    },
    on: {
      "close": function($event) {
        _vm.closedStateMultiselect(_vm.selectedState)
      },
      "open": _vm.openedStateMultiselect
    },
    model: {
      value: (_vm.selectedState),
      callback: function($$v) {
        _vm.selectedState = $$v
      },
      expression: "selectedState"
    }
  })], 1)])]), _vm._v(" "), _c('keep-alive', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "warning",
      "outline": ""
    },
    model: {
      value: (_vm.alertMobile),
      callback: function($$v) {
        _vm.alertMobile = $$v
      },
      expression: "alertMobile"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-icon', [_vm._v("phone_iphone")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('b', [_vm._v("Mobile device detected")]), _c('br'), _c('br'), _vm._v("For the best experience,\n            please use this platform on your laptop/desktop.\n          ")])], 1)])], 1), _vm._v(" "), (_vm.detect) ? _c('div', {
    staticClass: "col-lg-4 col-md-7 col-sm-6 col-xs-12",
    attrs: {
      "id": "browserSupport"
    }
  }, [_c('button', {
    staticClass: "close mt-2",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "#browserSupport"
    },
    on: {
      "click": function($event) {
        _vm.closeAlert()
      }
    }
  }, [_c('span', {
    staticClass: "mb-4 mt-4 pt-4 pr-4",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "mt-4 pl-2"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/browser.png"
    }
  }), _c('strong', {
    staticClass: "alertBold"
  }, [_vm._v("Unsupported Browser!\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-4 pl-2"
  }, [_vm._v("\n        Looks like you are using a browser that is not supported, so you may\n        experience some problems.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "pb-4 pl-2"
  }, [_vm._v("\n        Please use "), _c('strong', {
    staticClass: "alertBold"
  }, [_vm._v("Google Chrome")]), _vm._v(" browser\n        for the best experience with "), _c('br'), _vm._v("\n        MSDAT Platform.\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataLoadedFirstTime),
      expression: "isDataLoadedFirstTime"
    }],
    staticClass: "row",
    attrs: {
      "id": "firstRow"
    }
  }, [_c('div', {
    class: {
      'col-xs-12 col-md-11': _vm.barChartHidden,
      'col-sm-12 col-md-8': !_vm.barChartHidden,
    },
    attrs: {
      "id": "firstRow_sec1a"
    }
  }, [_c('table-component', {
    attrs: {
      "selectedIndicator56": _vm.selectedIndicator.name,
      "uncertaintyData": _vm.estimatesData,
      "meta_data": _vm.metaData,
      "indicatorMetaData": _vm.indicatorMetaData,
      "sourceMetaData": _vm.sourceMetaData,
      "appData": _vm.lsData
    },
    on: {
      "dataSourceForChart": _vm.chartSourceData,
      "toggleClicked": _vm.toggleClicked,
      "IHMEtoggleClicked": _vm.IHMEtoggleClicked,
      "indicatorRelatives": _vm.indicatorRelatives,
      "plotUncertainty": _vm.plotUncertainty
    }
  }), _vm._v(" "), _c('line-chart', {
    attrs: {
      "uncertaintyData": _vm.estimatesData,
      "appData": _vm.lsData,
      "isToggleClickedVal": _vm.isToggleClicked,
      "isIHMEtoggleClickedVal": _vm.isIHMEtoggleClicked,
      "meta_data": _vm.metaData
    },
    on: {
      "chartRendered": _vm.chartRendered,
      "compareIndicators": _vm.compareIndicators
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    class: {
      'col-sm-12 col-md-4': !_vm.barChartHidden,
      'col-sm-1 col-md-1': _vm.barChartHidden,
    },
    staticStyle: {
      "box-sizing": "border-box"
    },
    attrs: {
      "id": "firstRow_sec1b"
    }
  }, [_c('bar-chart-component', {
    attrs: {
      "appData": _vm.lsData,
      "metaData": _vm.metaData,
      "stateClicked": _vm.selectedState,
      "sourceOptions": _vm.zonalSourcesOptions,
      "lgaData": _vm.lgaData,
      "dashboardStateOptions": _vm.dashboardStateOptionsArray
    },
    on: {
      "optionYear": _vm.regionalChartYearOptions,
      "selectedYear": _vm.changeDashboardState,
      "plotData": _vm.getMapPlotData,
      "callerName": _vm.getCallerComponent,
      "barChartBoolValue": _vm.hideBarChartClicked
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-60px"
    },
    attrs: {
      "id": "zonalChart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center web-features zonal-section"
  }, [_c('div', {
    attrs: {
      "id": "zonal-title"
    }
  }, [_c('h5', [_vm._v("ZONAL SECTION")])]), _vm._v(" "), _c('div', {
    staticClass: "zonal-hide-button"
  }, [_c('button', {
    staticClass: "material-button-raised pull-left",
    staticStyle: {
      "box-shadow": "0 0 5px gray",
      "color": "black",
      "border-radius": "0",
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        _vm.showMore('zonal')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px",
      "font-family": "'Open Sans'"
    }
  }, [_vm._v("Click to " + _vm._s(_vm.showMoreMsg))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-breaker"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreFeatures),
      expression: "showMoreFeatures"
    }],
    staticClass: "row web-features"
  }, [_c('div', {
    attrs: {
      "data-v-step": "7"
    }
  }, [_c('regions-chart', {
    attrs: {
      "appData": _vm.lsData,
      "lgaData": _vm.lgaData,
      "yearOptions": _vm.regionalChartYearOptionsData,
      "selectedIndicator": _vm.selectedIndicator,
      "meta_data": _vm.metaData,
      "dashboardStateOptions": _vm.dashboardStateOptionsArray,
      "sources": _vm.optionSources
    },
    on: {
      "regionsChartYear": _vm.changeDashboardState,
      "callerName": _vm.getCallerComponent
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "compare-section-container row web-features",
    class: {
      'compare-dataset-heading': _vm.compareSectionColorClass
    },
    attrs: {
      "id": "compare-section"
    }
  }, [_c('div', {
    staticClass: "compare-heading col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('span', {}, [_c('label', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.isElementToCompareIndicator ?
    " Multi-Dataset Comparison Section" :
    "Multi-Source Indicator Comparison Section"))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComponents),
      expression: "showComponents"
    }],
    staticClass: "col-md-12"
  }, [_c('multi-select', {
    staticStyle: {
      "transform": "scale(0.9)"
    },
    attrs: {
      "options": _vm.optionStates,
      "hide-selected": false,
      "searchable": true,
      "allow-empty": false,
      "show-labels": false,
      "placeholder": _vm.comparisonSelectedStatePlaceholder
    },
    on: {
      "open": function($event) {
        _vm.openedCompareStateMultiselect()
      },
      "close": function($event) {
        _vm.closedCompareStateMultiselect(_vm.$store.state.CAR.selectedState)
      }
    },
    model: {
      value: (_vm.$store.state.CAR.selectedState),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.CAR, "selectedState", $$v)
      },
      expression: "$store.state.CAR.selectedState"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "material-button-raised pull-left",
    staticStyle: {
      "box-shadow": "0 0 5px gray",
      "color": "black",
      "border-radius": "0"
    },
    on: {
      "click": function($event) {
        _vm.showMore('compare')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("Click to " + _vm._s(_vm.showCompareMsg))])])])]), _vm._v(" "), _c('div', {
    staticClass: "web-features",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComponents),
      expression: "showComponents"
    }],
    class: {
      'compare-dataset': _vm.compareSectionColorClass
    }
  }, [(_vm.getRelatedIndicators.length) ? _c('span', _vm._l((_vm.getRelatedIndicators), function(relatedIndicator, index) {
    return _c('CompareSec', {
      key: index,
      attrs: {
        "relatedIndicator": relatedIndicator
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-60px"
    },
    attrs: {
      "id": "datasets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "web-features row",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "bottom_of_page"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12",
    attrs: {
      "data-v-step": "9"
    }
  }, [_c('column-chart', {
    attrs: {
      "optionsIndicator": _vm.optionIndicators,
      "optionSources": _vm.optionSources,
      "appData": _vm.lsData,
      "meta_data": _vm.metaData,
      "dashboardStateOptions": _vm.dashboardStateOptionsArray,
      "contextSelectedIndicator": _vm.selectedIndicator
    },
    on: {
      "columnChartSource": _vm.changeDashboardState,
      "columnChartIndicator": _vm.changeDashboardState,
      "callerName": _vm.getCallerComponent
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row web-features"
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.shareButtonClicked,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.shareButtonClicked = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("SHARE PLATFORM")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(!_vm.loadingURLIcon && !_vm.errorFetchingURL) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12 share-copybox"
  }, [_c('p', [_vm._v("\n                  COPY LINK:\n                  "), (_vm.linkCopied) ? _c('span', {
    staticStyle: {
      "color": "#3478b6"
    }
  }, [_vm._v("LINK COPIED")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field row"
  }, [_c('div', {
    staticClass: "control has-icons-left col-xs-10"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "id": "urlInput",
      "type": "text",
      "placeholder": "Share URL",
      "readonly": ""
    },
    domProps: {
      "value": _vm.shareURL
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('v-icon', [_vm._v("fas fa-link")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "share-clipboard-button col-xs-2"
  }, [_c('button', {
    attrs: {
      "title": "Copy to clipboard"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyURL($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("fas fa-clipboard")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12 share-socialicons"
  }, [_c('p', [_vm._v("SHARE VIA")]), _vm._v(" "), _c('div', {
    staticClass: "share-icons col-sm-12 row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    on: {
      "click": _vm.shareViaLinkedin
    }
  }, [_c('a', {
    staticClass: "fab fa-linkedin icon-linkedin vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    attrs: {
      "id": "icon-email"
    },
    on: {
      "click": _vm.shareViaEmail
    }
  }, [_c('a', {
    staticClass: "fas fa-envelope icon-email vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    attrs: {
      "id": "icon-twitter"
    },
    on: {
      "click": _vm.shareViaTwitter
    }
  }, [_c('a', {
    staticClass: "fab fa-twitter icon-twitter vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    attrs: {
      "id": "icon-facebook"
    },
    on: {
      "click": _vm.shareViaFacebook
    }
  }, [_c('a', {
    staticClass: "fab fa-facebook-square icon-facebook vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])])])])]) : (_vm.loadingURLIcon && !_vm.errorFetchingURL) ? _c('div', {
    staticStyle: {
      "width": "57px",
      "margin": "0 auto"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "width": 4,
      "color": "blue"
    }
  })], 1) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v("Something went wrong.")]), _c('br'), _vm._v("Please check your internet\n                connection and try again\n              ")])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.shareButtonClicked = false
      }
    }
  }, [_vm._v("\n              CLOSE\n            ")])])])])])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTourActive),
      expression: "!isTourActive"
    }, {
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Go to top of page'),
      expression: "'Go to top of page'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "material-button-raised goto-top-of-page",
    attrs: {
      "id": "scrollToTopButton"
    },
    on: {
      "click": function($event) {
        _vm.scrollup()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mid-align",
    attrs: {
      "left": "",
      "dark": "",
      "large": "",
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTourActive),
      expression: "!isTourActive"
    }, {
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Go to bottom of page'),
      expression: "'Go to bottom of page'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "material-button-raised goto-top-of-page",
    attrs: {
      "id": "scrollToButtomButton"
    },
    on: {
      "click": function($event) {
        _vm.scrolldown()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mid-align",
    attrs: {
      "left": "",
      "dark": "",
      "large": "",
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.firstTimeNotification),
      expression: "!firstTimeNotification"
    }]
  }, [_c('b-modal', {
    attrs: {
      "has-modal-card": "",
      "active": _vm.isTourActive
    },
    on: {
      "update:active": function($event) {
        _vm.isTourActive = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', {
    staticClass: "modal-card-head styleBody"
  }, [_c('span', {
    staticClass: "close-year-modal is-danger pull-right"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.isTourActive = false
      }
    }
  }, [_c('a', {
    staticClass: "fas fa-times-circle vc_icon_element_close",
    attrs: {
      "color": "#ff3860"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-body styleBody"
  }, [_c('div', {}, [_c('carousel', {
    attrs: {
      "items": 1,
      "margin": 10,
      "autoplay": false,
      "autoplayTimeout": 5000,
      "dots": true,
      "nav": true,
      "lazyLoad": true,
      "navText": _vm.owlNavText
    }
  }, [_c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('p', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "45%",
      "height": "30%"
    },
    attrs: {
      "src": "static/img/tourIcons/Group441.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Welcome to")]), _vm._v(" "), _c('p', {
    staticClass: "my-0 pb-2",
    staticStyle: {
      "font-size": "1.4em"
    }
  }, [_c('strong', [_vm._v("The Multi-Source Data "), _c('br'), _vm._v("\n                            Analytics and Triangulation Platform\n                          ")])]), _vm._v(" "), _c('p', [_vm._v("\n                          The Multi-Source Data Analytics and Triangulation\n                          (MSDAT) Platform is owned by the Federal Ministry of\n                          Health and was developed to provide a single\n                          transparent view of key health indicators against\n                          multiple data sources - routine, non-routine and\n                          estimates.\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-2 mb-0 pb-0"
  }, [_c('strong', [_vm._v("Watch tutorial video")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/watch?v=k75zoZ1SXgk"
    }
  }, [_c('strong', [_vm._v("youtube.com/watch?v=k75zoZ1SXgk")])]), _vm._v(" "), _c('p', {
    staticClass: "nanleHr"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "styleBody"
  }, [_c('section', [_c('div', {
    staticClass: "row nanleModal2"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "text-left"
  }, [_vm._v("\n                          This platform contains four main sections:\n                        ")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("i. Overview Section")]), _vm._v(" "), _c('p', [_vm._v("ii. Zonal Section")]), _vm._v(" "), _c('p', [_vm._v("\n                            iii. Multi-Source Indicator Comparison Section\n                          ")]), _vm._v(" "), _c('p', [_vm._v("iv. Multi-Dataset Comparison Section")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "float": "right",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "35%",
      "height": "35%"
    },
    attrs: {
      "src": "static/img/tourIcons/Group-1.png"
    }
  })])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/main_section_.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nanleModal"
  }, [_c('p', [_vm._v("Section 1:")]), _vm._v(" "), _c('h1', [_vm._v("Overview Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/zonal_section.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Section 2:")]), _vm._v(" "), _c('h1', [_vm._v("Zonal Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/multi_indicator_comparison.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Section 3:")]), _vm._v(" "), _c('h1', [_vm._v("Multi-Source Indicator Comparison Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/multi_dataset.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Section 4:")]), _vm._v(" "), _c('h1', [_vm._v("Multi-Dataset Comparison Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "35%",
      "height": "35%"
    },
    attrs: {
      "src": "static/img/tourIcons/Group472.png"
    }
  })]), _vm._v(" "), _c('div', {}, [_c('h2', [_vm._v("We value your feedback")]), _vm._v(" "), _c('p', [_vm._v("\n                            Click on the icon situated on the right side of\n                            the page to send us your feedback.\n                          ")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "50%"
    },
    attrs: {
      "src": "static/img/tourIcons/msdat_tourguide_help.jpg"
    }
  })]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n                            You can always play the tour guide "), _c('br'), _vm._v("\n                            from the menu bar and also visit the help page for\n                            more tips.\n                          ")]), _vm._v(" "), _c('h2', [_vm._v("Congratulations")]), _vm._v(" "), _c('p', [_vm._v("Have a wonderful experience")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.isTourActive = false
      }
    }
  }, [_vm._v("\n                            Skip Tour Guide\n                          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#007d53",
      "color": "white"
    },
    on: {
      "click": function($event) {
        (_vm.isTourStarts = true), (_vm.isTourActive = false)
      }
    }
  }, [_vm._v("\n                            Start Tour Guide\n                          ")])])])])])])], 1)])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "has-modal-card": "",
      "active": _vm.isTourStarts
    },
    on: {
      "update:active": function($event) {
        _vm.isTourStarts = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', {
    staticClass: "modal-card-body modal-sm",
    staticStyle: {
      "width": "50%",
      "margin-left": "26%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8 col-md-8"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("Welcome!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                  For a quick tour of the MSDAT platform key functions,\n                  "), _c('b', [_vm._v("click Next")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.startTour()
      }
    }
  }, [_vm._v("Next >")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-4"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tour/group_410.png"
    }
  })])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "has-modal-card": "",
      "active": _vm.contactForm,
      "id": "contactForm"
    },
    on: {
      "update:active": function($event) {
        _vm.contactForm = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card",
    on: {
      "click": function($event) {
        _vm.stopTimer()
      }
    }
  }, [_c('div', {
    staticClass: "modal-card-body",
    staticStyle: {
      "max-width": "450.75px",
      "margin": "auto",
      "padding-top": "15px",
      "border-radius": "7px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', [_c('button', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.contactForm = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h6', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Nice to Meet You!")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "12px",
      "padding-bottom": "15px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                  Welcome to the Multi-Source Data Analytics and\n                  Triangulation"), _c('br'), _vm._v("(MSDAT) Platform. Would you like to\n                  "), _c('b', [_vm._v("stay informed about the platform by receiving the latest\n                    updates?")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.conformSend()
      }
    }
  }, [_c('div', [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "100",
      "font-size": "13px"
    }
  }, [_vm._v("\n                          Leave us a few details to make that happen.\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nofields),
      expression: "nofields"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                          The following fields are required: Name, Email\n                          Address and Profession\n                        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successmessage),
      expression: "successmessage"
    }],
    staticClass: "alert alert-success"
  }, [_vm._v("\n                          Thank you. We will keep you informed about the\n                          latest updates to the MSDAT Platform.\n                        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errormessage),
      expression: "errormessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                          An error occured, please try again later.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.name),
      expression: "contactFormFields.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name *",
      "required": "",
      "minlength": "4"
    },
    domProps: {
      "value": (_vm.contactFormFields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.email),
      expression: "contactFormFields.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email address *",
      "required": "",
      "email": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.profession),
      expression: "contactFormFields.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Profession or Field or Work/Study *",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "profession", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.organization),
      expression: "contactFormFields.organization"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Organization"
    },
    domProps: {
      "value": (_vm.contactFormFields.organization)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "organization", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "13px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "12px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.newsletter),
      expression: "contactFormFields.newsletter"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.contactFormFields.newsletter) ? _vm._i(_vm.contactFormFields.newsletter, null) > -1 : _vm._q(_vm.contactFormFields.newsletter, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contactFormFields.newsletter,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contactFormFields, "newsletter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contactFormFields, "newsletter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contactFormFields, "newsletter", $$c)
        }
      }
    }
  }), _vm._v("\n                            I would also like to help improve the platform by\n                            giving my opinion and suggestions from time to\n                            time.\n                          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "animated preFadeInUp fadeInUp",
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": "static/img/ajax-loader.gif"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007d53",
      "color": "white",
      "box-shadow": "0px 7px 15px rgba(0, 0, 0, 0.4)",
      "border-color": "#007d53",
      "width": "127.5px",
      "height": "41px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                            Submit\n                          ")]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "#707070",
      "font-weight": "300",
      "font-size": "15px",
      "padding-top": "15px"
    },
    on: {
      "click": function($event) {
        _vm.contactForm = false
      }
    }
  }, [_vm._v("Maybe next time")])])])])])])])])])])])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 966:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.chartHasNoData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.options
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head bg-primary"
  }, [_c('span', {
    staticClass: "modal-card-title",
    staticStyle: {
      "color": "white"
    }
  }, [_c('span', [_vm._v("FEEDBACK")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right drag_pointer"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("apps")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('h3', [_vm._v("\n                  Comments\n                ")]), _vm._v(" "), _vm._l((_vm.userComments.slice(0, 5)), function(comment, idx) {
    return _c('span', {
      key: idx
    }, [_c('label', [_vm._v(_vm._s(comment.fullName) + " -- "), _c('em', [_vm._v(_vm._s(comment.organization))])]), _vm._v(" "), _c('p', {
      staticClass: "black--text"
    }, [_vm._v(_vm._s(comment.comment))]), _vm._v(" "), _c('br')])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column is-6 form"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postComment()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Full Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "fullName",
      "required": ""
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Organization:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization),
      expression: "organization"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "organization",
      "required": ""
    },
    domProps: {
      "value": (_vm.organization)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "Type your comment here ...",
      "id": "comment",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("How has your experience on this platform been")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("It was easy to navigate and find what I needed")]), _vm._v(" "), _c('li', [_vm._v("It took me sometime but I found what I needed")]), _vm._v(" "), _c('li', [_vm._v("It took me a very long time to find what I needed")]), _vm._v(" "), _c('li', [_vm._v("I couldn't find what I needed")]), _vm._v(" "), _c('li', [_vm._v("I don't even understand the platform")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "dark": "",
      "color": "blue"
    }
  }, [_vm._v("Submit")])], 1)])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = false
      }
    }
  }, [_vm._v("CLOSE")])])])])]), _vm._v(" "), _c('v-speed-dial', {
    attrs: {
      "top": false,
      "bottom": true,
      "right": true,
      "left": false,
      "fixed": true,
      "absolute": false,
      "direction": 'top',
      "open-on-hover": false,
      "transition": _vm.transition
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "indigo darken-2",
      "dark": "",
      "fab": "",
      "ripple": false,
      "id": "comments-button"
    },
    on: {
      "click": function($event) {
        _vm.loadCommentModal(_vm.isComponentModalActive)
      }
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("fas fa-comment")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-12 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorOptions.slice(0),
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "placeholder": _vm.indicatorMultiselectOpened ? _vm.indicatorOpenedPlaceholder : _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": true,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionSources,
      "group-select": false,
      "hide-selected": false,
      "placeholder": _vm.sourceMultiselectOpened ? _vm.sourceOpenedPlaceholder : _vm.sourcePlaceholder,
      "allow-empty": false,
      "show-labels": false
    },
    on: {
      "open": _vm.openedSourceMultiselect,
      "close": _vm.closedSourceMultiselect
    },
    model: {
      value: (_vm.selectedSource),
      callback: function($$v) {
        _vm.selectedSource = $$v
      },
      expression: "selectedSource"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionYear,
      "hide-selected": false,
      "allow-empty": false,
      "placeholder": _vm.yearMultiselectPlaceholder,
      "show-labels": false
    },
    on: {
      "open": _vm.openedYearMultiselect,
      "close": function($event) {
        _vm.closedYearMultiselect(_vm.selectedYear)
      }
    },
    model: {
      value: (_vm.selectedYear),
      callback: function($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('states-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapType === 'states'),
      expression: "mapType==='states'"
    }],
    attrs: {
      "sourceClicked": _vm.selectedSource,
      "relativeIndicator": _vm.relativeIndicator,
      "selectedIndicator": _vm.selectedIndicator.name,
      "yearClicked": _vm.selectedYear,
      "appData": _vm.appData,
      "indicatorClicked": _vm.indicatorClicked
    }
  }), _vm._v(" "), _c('zones-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapType === 'zones'),
      expression: "mapType==='zones'"
    }],
    attrs: {
      "sourceClicked": _vm.selectedSource,
      "relativeIndicator": _vm.relativeIndicator,
      "selectedIndicator": _vm.selectedIndicator.name,
      "yearClicked": _vm.selectedYear,
      "appData": _vm.appData,
      "indicatorClicked": _vm.indicatorClicked
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.expandedView,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.expandedView = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "custom-row ms-compare-container"
  }, [_c('div', {
    staticClass: "col-xs-6 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.indicatorOptions.slice(0),
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "group-collapsible-expanded": false,
      "hide-selected": false,
      "placeholder": _vm.indicatorMultiselectOpened ? _vm.indicatorOpenedPlaceholder : _vm.indicatorPlaceholder,
      "allow-empty": false,
      "show-labels": true,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "open": _vm.openedIndicatorMultiselect,
      "close": _vm.closedIndicatorMultiselect
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionSources,
      "group-select": false,
      "hide-selected": false,
      "placeholder": _vm.sourceMultiselectOpened ? _vm.sourceOpenedPlaceholder : _vm.sourcePlaceholder,
      "allow-empty": false,
      "show-labels": true
    },
    on: {
      "open": _vm.openedSourceMultiselect,
      "close": _vm.closedSourceMultiselect
    },
    model: {
      value: (_vm.selectedSource),
      callback: function($$v) {
        _vm.selectedSource = $$v
      },
      expression: "selectedSource"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.optionYear,
      "hide-selected": false,
      "allow-empty": false,
      "placeholder": _vm.yearMultiselectPlaceholder,
      "show-labels": false
    },
    on: {
      "open": _vm.openedYearMultiselect,
      "close": function($event) {
        _vm.closedYearMultiselect(_vm.selectedYear)
      }
    },
    model: {
      value: (_vm.selectedYear),
      callback: function($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear"
    }
  })], 1)])]), _vm._v(" "), _c('section', [_c('states-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapType === 'states'),
      expression: "mapType==='states'"
    }],
    attrs: {
      "sourceClicked": _vm.selectedSource,
      "relativeIndicator": _vm.relativeIndicator,
      "selectedIndicator": _vm.selectedIndicator.name,
      "yearClicked": _vm.selectedYear,
      "appData": _vm.appData,
      "indicatorClicked": _vm.indicatorClicked
    }
  }), _vm._v(" "), _c('zones-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapType === 'zones'),
      expression: "mapType==='zones'"
    }],
    attrs: {
      "sourceClicked": _vm.selectedSource,
      "relativeIndicator": _vm.relativeIndicator,
      "appData": _vm.appData,
      "yearClicked": _vm.selectedYear,
      "selectedIndicator": _vm.selectedIndicator.name,
      "indicatorClicked": _vm.indicatorClicked
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeExpandedBool
    }
  }, [_vm._v("CLOSE")])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 972:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiselect",
    class: {
      'multiselect--active': _vm.isOpen,
      'multiselect--disabled': _vm.disabled,
      'multiselect--above': _vm.isAbove,
    },
    attrs: {
      "tabindex": _vm.searchable ? -1 : _vm.tabindex
    },
    on: {
      "focus": function($event) {
        _vm.activate()
      },
      "blur": function($event) {
        _vm.searchable ? false : _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.deactivate()
      }
    }
  }, [_vm._t("caret", [_c('div', {
    staticClass: "multiselect__select",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggle()
      }
    }
  })], {
    toggle: _vm.toggle
  }), _vm._v(" "), _vm._t("clear", null, {
    search: _vm.search
  }), _vm._v(" "), _c('div', {
    ref: "tags",
    staticClass: "multiselect__tags"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visibleValues.length > 0),
      expression: "visibleValues.length > 0"
    }],
    staticClass: "multiselect__tags-wrap"
  }, [_vm._l((_vm.visibleValues), function(option, index) {
    return [_vm._t("tag", [_c('span', {
      key: index,
      staticClass: "multiselect__tag"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.getOptionLabel(option))
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "multiselect__tag-icon",
      attrs: {
        "aria-hidden": "true",
        "tabindex": "1"
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          _vm.removeElement(option)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.removeElement(option)
        }
      }
    })])], {
      option: option,
      search: _vm.search,
      remove: _vm.removeElement
    })]
  })], 2), _vm._v(" "), (_vm.internalValue && _vm.internalValue.length > _vm.limit) ? [_vm._t("limit", [_c('strong', {
    staticClass: "multiselect__strong",
    domProps: {
      "textContent": _vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))
    }
  })])] : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect__loading"
    }
  }, [_vm._t("loading", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "multiselect__spinner"
  })])], 2), _vm._v(" "), (_vm.searchable) ? _c('input', {
    ref: "search",
    class: _vm.showInput ? 'multiselect__input' : 'multiselect_input',
    style: (_vm.inputStyle),
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "type": "text",
      "autocomplete": "off",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "tabindex": _vm.tabindex
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function($event) {
        _vm.updateSearch($event.target.value)
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.activate()
      },
      "blur": function($event) {
        $event.preventDefault();
        _vm.deactivate()
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        _vm.pointerForward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        _vm.pointerBackward()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.addPointerElement($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) { return null; }
        $event.stopPropagation();
        _vm.removeLastElement()
      }]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSingleLabelVisible) ? _c('span', {
    staticClass: "multiselect__single",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_vm._t("singleLabel", [
    [_vm._v(_vm._s(_vm.currentOptionLabel))]
  ], {
    option: _vm.singleValue
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isPlaceholderVisible) ? _c('span', {
    staticClass: "multiselect__placeholder",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggle($event)
      }
    }
  }, [_vm._t("placeholder", [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n      ")])], 2) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "list",
    staticClass: "multiselect__content-wrapper",
    style: ({
      maxHeight: _vm.optimizedHeight + 'px'
    }),
    on: {
      "focus": _vm.activate,
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "multiselect__content",
    class: {
      multiselect__collapsible: _vm.groupCollapsible
    },
    style: (_vm.contentStyle)
  }, [_vm._t("beforeList"), _vm._v(" "), (_vm.multiple && _vm.max === _vm.internalValue.length) ? _c('li', [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("maxElements", [_vm._v("Maximum of " + _vm._s(_vm.max) + " options selected. First remove a selected\n              option to select another.")])], 2)]) : _vm._e(), _vm._v(" "), (!_vm.max || _vm.internalValue.length < _vm.max) ? _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "multiselect__element",
      class: {
        'multiselect__collapsible-group':
        _vm.groupCollapsible && option.$isLabel,
          'multiselect__collapsible-expanded':
          _vm.groupCollapsible && _vm.isGroupCollapsibleOptionExpanded(option),
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.groupCollapsibleToggle(option)
        }
      }
    }, [(option.$isLabel) ? _vm._t("caret-collapsible", [_c('div', {
      staticClass: "multiselect__collapsible-toggle-icon",
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.groupCollapsibleToggle(option, true)
        }
      }
    })], {
      toggle: _vm.groupCollapsibleToggle
    }) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "collapsible-slide-toggle"
      }
    }, [(!_vm.groupCollapsible ||
      option.$isLabel ||
      _vm.isGroupCollapsibleOptionExpanded(option)
    ) ? _c('div', [(!(option && (option.$isLabel || option.$isDisabled))) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.optionHighlight(index, option),
      attrs: {
        "data-select": option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.deselectLabelText,
        "data-collapsed": _vm.collapsedGroupLabelText,
        "data-expanded": _vm.expandedGroupLabelText
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(option)
        },
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.pointerSet(index)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e(), _vm._v(" "), (option && (option.$isLabel || option.$isDisabled)) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.groupHighlight(index, option),
      attrs: {
        "data-select": _vm.groupSelect && _vm.selectGroupLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.groupSelect && _vm.deselectGroupLabelText,
        "data-collapse": _vm.groupCollapsible ? _vm.expandedGroupLabelText : '',
        "data-expand": _vm.groupCollapsible ? _vm.collapsedGroupLabelText : ''
      },
      on: {
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.groupSelect && _vm.pointerSet(index)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.selectGroup(option)
        }
      }
    }, [_vm._t("option", [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])], {
      option: option,
      search: _vm.search
    })], 2) : _vm._e()]) : _vm._e()])], 2)
  }) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.showNoResults &&
        _vm.filteredOptions.length === 0 &&
        _vm.search &&
        !_vm.loading
      ),
      expression: "\n            showNoResults &&\n            filteredOptions.length === 0 &&\n            search &&\n            !loading\n          "
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noResult", [_vm._v("No elements found. Consider changing the search query.")])], 2)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.showNoOptions && _vm.options.length === 0 && !_vm.search && !_vm.loading
      ),
      expression: "\n            showNoOptions && options.length === 0 && !search && !loading\n          "
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noOptions", [_vm._v("List is empty.")])], 2)]), _vm._v(" "), _vm._t("afterList")], 2)])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "chart-wrapper"
  }, [_c('label', {
    staticClass: "hidden",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.indicatorSelected))]), _vm._v(" "), _c('label', {
    staticClass: "hidden",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.stateSelected))]), _vm._v(" "), _c('div', {
    staticClass: "chart-title"
  }, [_c('div', {
    staticClass: "col-md-12 bg-primary",
    staticStyle: {
      "max-height": "40px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 text-center car_table_header"
  }, [_c('label', {
    staticClass: "table-label"
  }, [_vm._v("\n            " + _vm._s(_vm.indicatorSelected) + "\n            "), _c('span', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("and related indicators (with year of latest values)\n              " + _vm._s(_vm.$store.state.CAR.stateNameLookUpTable[_vm.selectedState]) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "chart-stage col-xs-12",
    staticStyle: {
      "overflow-x": "auto",
      "width": "100%"
    },
    attrs: {
      "id": "scrollTable"
    }
  }, [_c('table', {
    staticClass: "my_custom_table",
    attrs: {
      "id": "source_table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "custom_header"
  }, [_c('td'), _vm._v(" "), (_vm.routineCounter > 0) ? _c('td', {
    attrs: {
      "colspan": _vm.routineCounter
    }
  }, [_vm._v("\n              Routine\n            ")]) : _vm._e(), _vm._v(" "), (_vm.surveyCounter > 0) ? _c('td', {
    attrs: {
      "colspan": _vm.surveyCounter
    }
  }, [_vm._v("Surveys")]) : _vm._e(), _vm._v(" "), (_vm.estimatesCounter > 0) ? _c('td', {
    attrs: {
      "colspan": _vm.estimatesCounter
    }
  }, [_vm._v("\n              Estimates\n            ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {}, [_c('span', {
    staticClass: "refresh_sources_icon"
  }, [_vm._v("\n                INDICATORS\n                "), _c('v-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Show all sources'),
      expression: "'Show all sources'",
      modifiers: {
        "top": true
      }
    }],
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.refreshSources
    }
  }, [_vm._v("refresh")])], 1)]), _vm._v(" "), _vm._l((_vm.dataSourceUncertainty), function(source, index) {
    return _c('td', {
      key: index,
      staticClass: "table_sources",
      attrs: {
        "id": source.name
      },
      on: {
        "click": function($event) {
          _vm.tableSourceClicked(source.name)
        }
      }
    }, [(source.name == 'NHMIS-DHIS2') ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (_vm.sourceFullName[source.name]),
        expression: "sourceFullName[source.name]",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "source_name",
      attrs: {
        "data-step": "4",
        "data-intro": "<b>Select Data Source </b><p>Click on any of these data sources to change the currently visualized data source</p>"
      }
    }, [_vm._v(_vm._s(source.name))]) : (source.name == 'NHMIS-DHIS2 (monthly)') ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (_vm.sourceFullName[source.name]),
        expression: "sourceFullName[source.name]",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "source_name",
      attrs: {
        "data-step": "4",
        "data-intro": "<b>Select Data Source </b><p>Click on any of these data sources to change the currently visualized data source</p>"
      }
    }, [_vm._v("NHMIS-DHIS2"), _c('br'), _vm._v("(monthly)")]) : _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: (_vm.sourceFullName[source.name]),
        expression: "sourceFullName[source.name]",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "source_name"
    }, [_vm._v(_vm._s(source.name))]), _vm._v(" "), (source.name == 'NHMIS-DHIS2 (monthly)') ? _c('svg', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see source definition'),
        expression: "'Click to see source definition'",
        modifiers: {
          "right": true
        }
      }],
      staticStyle: {
        "width": "13px",
        "height": "13px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.viewSourceMetadata('NHMIS')
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })]) : _c('svg', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see source definition'),
        expression: "'Click to see source definition'",
        modifiers: {
          "right": true
        }
      }],
      staticStyle: {
        "width": "13px",
        "height": "13px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.viewSourceMetadata(source.name)
        }
      }
    }, [_c('path', {
      attrs: {
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })]), _vm._v(" "), (_vm.isUncertaintyAvailable[source.name] === true) ? _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.top",
        value: ('See confidence range'),
        expression: "'See confidence range'",
        modifiers: {
          "top": true
        }
      }],
      staticClass: "web-features",
      staticStyle: {
        "top": "0"
      }
    }, [_c('b-switch', {
      attrs: {
        "type": "is-success"
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.plotUncertainty(source.uncertainty, source.name, index)
        }
      },
      model: {
        value: (source.uncertainty),
        callback: function($$v) {
          _vm.$set(source, "uncertainty", $$v)
        },
        expression: "source.uncertainty"
      }
    })], 1) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.indicatorRelativeValuese), function(indicator, count) {
    return _c('tr', {
      key: count + Math.random(),
      staticStyle: {
        "max-height": "80px"
      }
    }, [_c('td', {
      staticStyle: {
        "word-wrap": "break-word",
        "text-align": "left",
        "cursor": "default"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count !== 1 && count !== 0),
        expression: "count !== 1 && count !== 0"
      }]
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see metadata definition'),
        expression: "'Click to see metadata definition'",
        modifiers: {
          "right": true
        }
      }],
      staticClass: "table_info_icon",
      staticStyle: {
        "background": "#41918e",
        "margin-right": "4px"
      },
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#FFF",
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "table-multiselect"
    }, [_c('multi-select', {
      ref: 'relative' + count - 1,
      refInFor: true,
      attrs: {
        "data-step": "5",
        "data-intro": "<b>Change Related Indicator</b><p>Click here to select your preferred related indicator from the drop-down menu</p>",
        "options": _vm.optionIndicators,
        "group-values": "indicators",
        "group-label": "programArea",
        "group-collapsible": _vm.collapsible,
        "group-select": false,
        "group-collapsible-expanded": false,
        "allow-empty": false,
        "show-labels": false,
        "placeholder": _vm.multiselectPlaceholderM(count - 1),
        "track-by": "name",
        "label": "name"
      },
      on: {
        "open": _vm.openedMultiselect,
        "search-change": _vm.multiselectSearch,
        "close": function($event) {
          _vm.closedMultiselect(indicator[0][0], count - 1)
        }
      },
      model: {
        value: (_vm.selectIndicatorRelative[count - 1]),
        callback: function($$v) {
          _vm.$set(_vm.selectIndicatorRelative, count - 1, $$v)
        },
        expression: "selectIndicatorRelative[count - 1]"
      }
    }, [_c('span', {
      attrs: {
        "slot": "noResult"
      },
      slot: "noResult"
    }, [_vm._v("\n                        Oops! No elements found. Change the search query.\n                      ")])])], 1)]), _vm._v(" "), _c('span', {
      staticClass: "display-factor",
      staticStyle: {
        "color": "black"
      },
      domProps: {
        "innerHTML": _vm._s('(' + _vm.displayFactor[count] + ')')
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count === 1),
        expression: "count === 1"
      }]
    }, [_vm._v(_vm._s(indicator[0][0]))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count === 0),
        expression: "count === 0"
      }]
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see metadata definition'),
        expression: "'Click to see metadata definition'",
        modifiers: {
          "right": true
        }
      }],
      staticClass: "table_info_icon1",
      staticStyle: {
        "background": "#fff",
        "margin-right": "8px"
      },
      attrs: {
        "data-v-step": "2"
      },
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#41918E",
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })])]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_vm._v(_vm._s(indicator[0][0]))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "display-factor",
      staticStyle: {
        "color": "white"
      },
      domProps: {
        "innerHTML": _vm._s('(' + _vm.displayFactor[count] + ')')
      }
    })])]), _vm._v(" "), _vm._l((indicator[1]), function(item, counter) {
      return _c('td', {
        key: counter,
        domProps: {
          "innerHTML": _vm._s(item)
        }
      })
    })], 2)
  }), _vm._v(" "), (_vm.showToggle) ? _c('tr', {
    attrs: {
      "id": "nhmis-hidden-bar"
    }
  }, [_c('td', {
    staticStyle: {
      "background-color": "#367574",
      "margin-bottom": "#367574",
      "max-height": "45px"
    },
    attrs: {
      "colspan": _vm.spanning + 2
    }
  }, [_c('div', {
    staticClass: "row numden"
  }, [_c('div', {
    staticClass: "numden1"
  }, [_c('div', {
    staticClass: "py-2",
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold",
      "letter-spacing": "0",
      "font-size": "14px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.ndSelected) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "numden2 py-2 border",
    staticStyle: {
      "background-color": "#fff",
      "border-radius": "4px",
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-6 col-sm-6 mr-3 text-wrap"
  }, [_c('strong', [_vm._v("Numerator")]), _vm._v(" : " + _vm._s(_vm.numerator) + ":\n                    " + _vm._s(_vm.thousandSeperator(_vm.numValue)) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-5 col-sm-5 ml-3 text-wrap"
  }, [_c('strong', [_vm._v("Denominator")]), _vm._v(" : " + _vm._s(_vm.denominator) + ":\n                    " + _vm._s(_vm.thousandSeperator(_vm.denValue)) + "\n                  ")])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.indicatorRelativeValues), function(indicator, count) {
    return _c('tr', {
      key: count
    }, [_c('td', {
      staticStyle: {
        "word-wrap": "break-word",
        "text-align": "left",
        "cursor": "default"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count == 1 || count == 2),
        expression: "count == 1 || count == 2"
      }]
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Click to see metadata definition'),
        expression: "'Click to see metadata definition'",
        modifiers: {
          "right": true
        }
      }],
      staticClass: "table_info_icon",
      staticStyle: {
        "background": "#41918e",
        "margin-right": "4px"
      },
      on: {
        "click": function($event) {
          _vm.viewMetadata(indicator[0][0])
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#FFF",
        "d": "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "table-multiselect"
    }, [_c('multi-select', {
      ref: 'relative' + count,
      refInFor: true,
      attrs: {
        "data-step": "5",
        "data-intro": "<b>Change Related Indicator</b><p>Click here to select your preferred related indicator from the drop-down menu</p>",
        "options": _vm.optionIndicators,
        "group-values": "indicators",
        "group-label": "programArea",
        "group-collapsible": _vm.collapsible,
        "group-select": false,
        "group-collapsible-expanded": false,
        "allow-empty": false,
        "show-labels": false,
        "placeholder": _vm.multiselectPlaceholderM(count - 1),
        "track-by": "name",
        "label": "name"
      },
      on: {
        "open": _vm.openedMultiselect,
        "search-change": _vm.multiselectSearch,
        "close": function($event) {
          _vm.closedMultiselect(indicator[0][0], count - 1)
        }
      },
      model: {
        value: (_vm.selectIndicatorRelative[count - 1]),
        callback: function($$v) {
          _vm.$set(_vm.selectIndicatorRelative, count - 1, $$v)
        },
        expression: "selectIndicatorRelative[count - 1]"
      }
    }, [_c('span', {
      attrs: {
        "slot": "noResult"
      },
      slot: "noResult"
    }, [_vm._v("\n                        Oops! No elements found. Change the search query.\n                      ")])])], 1)]), _vm._v(" "), _c('span', {
      staticClass: "display-factor",
      staticStyle: {
        "color": "black"
      },
      domProps: {
        "innerHTML": _vm._s('(' + _vm.displayFactor[count + 1] + ')')
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (count === 0),
        expression: "count === 0"
      }]
    }, [_vm._v(_vm._s(indicator[0][0]))])]), _vm._v(" "), _vm._l((indicator[1]), function(item, counter) {
      return _c('td', {
        key: counter,
        domProps: {
          "innerHTML": _vm._s(item)
        }
      })
    })], 2)
  })], 2)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_c('b', [_vm._v("INDICATOR: ")]), _vm._v(" " + _vm._s(this.indicatorMetaDataToShow) + "\n            ")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "tabs is-boxed is-right"
  }, [_c('ul', _vm._l((_vm.availableSources), function(i) {
    return _c('li', {
      key: i,
      class: {
        'is-active': i == _vm.isActive
      },
      attrs: {
        "value": i
      },
      on: {
        "click": function($event) {
          _vm.dataSourceClicked(i)
        }
      }
    }, [_c('a', [_c('span', [_vm._v(_vm._s(i))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("INDICATOR NAME")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("INDICATOR SHORT NAME")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceIndicatorInfo.shortName))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("INDICATOR DEFINITION")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceIndicatorInfo.definition))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("MEASUREMENT")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("Numerator: ")]), _c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.numerator))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("Denominator: ")]), _c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.denominator))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("MULTIPLIER FACTOR")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.multiplier))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("FREQUENCY")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceIndicatorInfo.frequency))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("TYPE OF INDICATOR")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceIndicatorInfo.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Level of Data Available")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v("National\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.National
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Geopolitical Zone\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.Zonal
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("State Level\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.State
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Senatorial Zone\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.Senatorial
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Local Govt Area\n                  "), _c('v-icon', {
    attrs: {
      "color": this.dataAvailable.LGA
    }
  }, [_vm._v("check_circle")])], 1)])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = false
      }
    }
  }, [_vm._v("\n              CLOSE\n            ")])])])])])], 1), _vm._v(" "), (_vm.isSourceMetaModalActive) ? _c('div', [_c('table-modal', {
    attrs: {
      "src": _vm.datasingle,
      "sourceMetaData": _vm.datafull
    },
    on: {
      "switchOff": _vm.clearModal
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.chartHasNoData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highmaps', {
    ref: "highmaps",
    attrs: {
      "options": _vm.options
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  "use strict";

  if (!Array.from) {
    Array.from = function (object) {
      return [].slice.call(object);
    };
  }

  function buildAttribute(object, propName, value) {
    if (value == undefined) {
      return object;
    }
    object = object == null ? {} : object;
    object[propName] = value;
    return object;
  }

  function buildDraggable(Sortable) {
    function removeNode(node) {
      node.parentElement.removeChild(node);
    }

    function insertNodeAt(fatherNode, node, position) {
      var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
      fatherNode.insertBefore(node, refNode);
    }

    function computeVmIndex(vnodes, element) {
      return vnodes.map(function (elt) {
        return elt.elm;
      }).indexOf(element);
    }

    function _computeIndexes(slots, children, isTransition) {
      if (!slots) {
        return [];
      }

      var elmFromNodes = slots.map(function (elt) {
        return elt.elm;
      });
      var rawIndexes = [].concat(_toConsumableArray(children)).map(function (elt) {
        return elmFromNodes.indexOf(elt);
      });
      return isTransition ? rawIndexes.filter(function (ind) {
        return ind !== -1;
      }) : rawIndexes;
    }

    function emit(evtName, evtData) {
      var _this = this;

      this.$nextTick(function () {
        return _this.$emit(evtName.toLowerCase(), evtData);
      });
    }

    function delegateAndEmit(evtName) {
      var _this2 = this;

      return function (evtData) {
        if (_this2.realList !== null) {
          _this2['onDrag' + evtName](evtData);
        }
        emit.call(_this2, evtName, evtData);
      };
    }

    var eventsListened = ['Start', 'Add', 'Remove', 'Update', 'End'];
    var eventsToEmit = ['Choose', 'Sort', 'Filter', 'Clone'];
    var readonlyProperties = ['Move'].concat(eventsListened, eventsToEmit).map(function (evt) {
      return 'on' + evt;
    });
    var draggingElement = null;

    var props = {
      options: Object,
      list: {
        type: Array,
        required: false,
        default: null
      },
      value: {
        type: Array,
        required: false,
        default: null
      },
      noTransitionOnDrag: {
        type: Boolean,
        default: false
      },
      clone: {
        type: Function,
        default: function _default(original) {
          return original;
        }
      },
      element: {
        type: String,
        default: 'div'
      },
      move: {
        type: Function,
        default: null
      },
      componentData: {
        type: Object,
        required: false,
        default: null
      }
    };

    var draggableComponent = {
      name: 'draggable',

      props: props,

      data: function data() {
        return {
          transitionMode: false,
          noneFunctionalComponentMode: false,
          init: false
        };
      },
      render: function render(h) {
        var slots = this.$slots.default;
        if (slots && slots.length === 1) {
          var child = slots[0];
          if (child.componentOptions && child.componentOptions.tag === "transition-group") {
            this.transitionMode = true;
          }
        }
        var children = slots;
        var footer = this.$slots.footer;

        if (footer) {
          children = slots ? [].concat(_toConsumableArray(slots), _toConsumableArray(footer)) : [].concat(_toConsumableArray(footer));
        }
        var attributes = null;
        var update = function update(name, value) {
          attributes = buildAttribute(attributes, name, value);
        };
        update('attrs', this.$attrs);
        if (this.componentData) {
          var _componentData = this.componentData,
              on = _componentData.on,
              _props = _componentData.props;

          update('on', on);
          update('props', _props);
        }
        return h(this.element, attributes, children);
      },
      mounted: function mounted() {
        var _this3 = this;

        this.noneFunctionalComponentMode = this.element.toLowerCase() !== this.$el.nodeName.toLowerCase();
        if (this.noneFunctionalComponentMode && this.transitionMode) {
          throw new Error('Transition-group inside component is not supported. Please alter element value or remove transition-group. Current element value: ' + this.element);
        }
        var optionsAdded = {};
        eventsListened.forEach(function (elt) {
          optionsAdded['on' + elt] = delegateAndEmit.call(_this3, elt);
        });

        eventsToEmit.forEach(function (elt) {
          optionsAdded['on' + elt] = emit.bind(_this3, elt);
        });

        var options = _extends({}, this.options, optionsAdded, { onMove: function onMove(evt, originalEvent) {
            return _this3.onDragMove(evt, originalEvent);
          } });
        !('draggable' in options) && (options.draggable = '>*');
        this._sortable = new Sortable(this.rootContainer, options);
        this.computeIndexes();
      },
      beforeDestroy: function beforeDestroy() {
        this._sortable.destroy();
      },


      computed: {
        rootContainer: function rootContainer() {
          return this.transitionMode ? this.$el.children[0] : this.$el;
        },
        isCloning: function isCloning() {
          return !!this.options && !!this.options.group && this.options.group.pull === 'clone';
        },
        realList: function realList() {
          return !!this.list ? this.list : this.value;
        }
      },

      watch: {
        options: {
          handler: function handler(newOptionValue) {
            for (var property in newOptionValue) {
              if (readonlyProperties.indexOf(property) == -1) {
                this._sortable.option(property, newOptionValue[property]);
              }
            }
          },

          deep: true
        },

        realList: function realList() {
          this.computeIndexes();
        }
      },

      methods: {
        getChildrenNodes: function getChildrenNodes() {
          if (!this.init) {
            this.noneFunctionalComponentMode = this.noneFunctionalComponentMode && this.$children.length == 1;
            this.init = true;
          }

          if (this.noneFunctionalComponentMode) {
            return this.$children[0].$slots.default;
          }
          var rawNodes = this.$slots.default;
          return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
        },
        computeIndexes: function computeIndexes() {
          var _this4 = this;

          this.$nextTick(function () {
            _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode);
          });
        },
        getUnderlyingVm: function getUnderlyingVm(htmlElt) {
          var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
          if (index === -1) {
            //Edge case during move callback: related element might be
            //an element different from collection
            return null;
          }
          var element = this.realList[index];
          return { index: index, element: element };
        },
        getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
          var __vue__ = _ref.__vue__;

          if (!__vue__ || !__vue__.$options || __vue__.$options._componentTag !== "transition-group") {
            return __vue__;
          }
          return __vue__.$parent;
        },
        emitChanges: function emitChanges(evt) {
          var _this5 = this;

          this.$nextTick(function () {
            _this5.$emit('change', evt);
          });
        },
        alterList: function alterList(onList) {
          if (!!this.list) {
            onList(this.list);
          } else {
            var newList = [].concat(_toConsumableArray(this.value));
            onList(newList);
            this.$emit('input', newList);
          }
        },
        spliceList: function spliceList() {
          var _arguments = arguments;

          var spliceList = function spliceList(list) {
            return list.splice.apply(list, _arguments);
          };
          this.alterList(spliceList);
        },
        updatePosition: function updatePosition(oldIndex, newIndex) {
          var updatePosition = function updatePosition(list) {
            return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
          };
          this.alterList(updatePosition);
        },
        getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
          var to = _ref2.to,
              related = _ref2.related;

          var component = this.getUnderlyingPotencialDraggableComponent(to);
          if (!component) {
            return { component: component };
          }
          var list = component.realList;
          var context = { list: list, component: component };
          if (to !== related && list && component.getUnderlyingVm) {
            var destination = component.getUnderlyingVm(related);
            if (destination) {
              return _extends(destination, context);
            }
          }

          return context;
        },
        getVmIndex: function getVmIndex(domIndex) {
          var indexes = this.visibleIndexes;
          var numberIndexes = indexes.length;
          return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
        },
        getComponent: function getComponent() {
          return this.$slots.default[0].componentInstance;
        },
        resetTransitionData: function resetTransitionData(index) {
          if (!this.noTransitionOnDrag || !this.transitionMode) {
            return;
          }
          var nodes = this.getChildrenNodes();
          nodes[index].data = null;
          var transitionContainer = this.getComponent();
          transitionContainer.children = [];
          transitionContainer.kept = undefined;
        },
        onDragStart: function onDragStart(evt) {
          this.context = this.getUnderlyingVm(evt.item);
          evt.item._underlying_vm_ = this.clone(this.context.element);
          draggingElement = evt.item;
        },
        onDragAdd: function onDragAdd(evt) {
          var element = evt.item._underlying_vm_;
          if (element === undefined) {
            return;
          }
          removeNode(evt.item);
          var newIndex = this.getVmIndex(evt.newIndex);
          this.spliceList(newIndex, 0, element);
          this.computeIndexes();
          var added = { element: element, newIndex: newIndex };
          this.emitChanges({ added: added });
        },
        onDragRemove: function onDragRemove(evt) {
          insertNodeAt(this.rootContainer, evt.item, evt.oldIndex);
          if (this.isCloning) {
            removeNode(evt.clone);
            return;
          }
          var oldIndex = this.context.index;
          this.spliceList(oldIndex, 1);
          var removed = { element: this.context.element, oldIndex: oldIndex };
          this.resetTransitionData(oldIndex);
          this.emitChanges({ removed: removed });
        },
        onDragUpdate: function onDragUpdate(evt) {
          removeNode(evt.item);
          insertNodeAt(evt.from, evt.item, evt.oldIndex);
          var oldIndex = this.context.index;
          var newIndex = this.getVmIndex(evt.newIndex);
          this.updatePosition(oldIndex, newIndex);
          var moved = { element: this.context.element, oldIndex: oldIndex, newIndex: newIndex };
          this.emitChanges({ moved: moved });
        },
        computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
          if (!relatedContext.element) {
            return 0;
          }
          var domChildren = [].concat(_toConsumableArray(evt.to.children)).filter(function (el) {
            return el.style['display'] !== 'none';
          });
          var currentDOMIndex = domChildren.indexOf(evt.related);
          var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
          var draggedInList = domChildren.indexOf(draggingElement) != -1;
          return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
        },
        onDragMove: function onDragMove(evt, originalEvent) {
          var onMove = this.move;
          if (!onMove || !this.realList) {
            return true;
          }

          var relatedContext = this.getRelatedContextFromMoveEvent(evt);
          var draggedContext = this.context;
          var futureIndex = this.computeFutureIndex(relatedContext, evt);
          _extends(draggedContext, { futureIndex: futureIndex });
          _extends(evt, { relatedContext: relatedContext, draggedContext: draggedContext });
          return onMove(evt, originalEvent);
        },
        onDragEnd: function onDragEnd(evt) {
          this.computeIndexes();
          draggingElement = null;
        }
      }
    };
    return draggableComponent;
  }

  if (true) {
    var Sortable = __webpack_require__(934);
    module.exports = buildDraggable(Sortable);
  } else if (typeof define == "function" && define.amd) {
    define(['sortablejs'], function (Sortable) {
      return buildDraggable(Sortable);
    });
  } else if (window && window.Vue && window.Sortable) {
    var draggable = buildDraggable(window.Sortable);
    Vue.component('draggable', draggable);
  }
})();

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.bcfea34c8c4b8fe9ec67.js